export const FIELDERS_ENGLOAD_JOBS = {
    FTLC01346: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.432191547259624,
        BeamResults: {
            ",": "0.331891409581977=Bending Moment",
            "FB2,": "0.0666914640573752=Vertical Shear",
            "R2,": "0.0125514272681507=Vertical Shear",
            "FB1,": "0.331891409581977=Bending Moment",
            "R1,": "0.0334704727150685=Vertical Shear",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C2: "0.413=Deflection (20.6mm)",
            C5: "0.047=Deflection (2.4mm)",
            C1: "0.413=Deflection (20.6mm)",
            C4: "0.047=Deflection (2.4mm)",
            C3: "0.432=Deflection (21.6mm)",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = C3 CR=0.432 - Deflection (21.6mm)",
        AreaMaxResults: {
            0: {
                MaxResult: 0.432191547259624,
                FasciaMax: 0.331891409581977,
                NumRafters: 2,
                NumColumns: 5,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C3 CR=0.432 - Deflection (21.6mm)",
                NumPurlins: 0,
                ColumnsMax: 0.432191547259624,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C3 CR=0.432 - Deflection (21.6mm)",
                RafterMax: 0.0334704727150685,
                NumFasciaBeams: 2,
                JoinBeamMax: 0,
                OtherMax: 0.331891409581977,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 3140,
                total_compression_kn: 2.45441701250781,
                total_tension_kn: -1.57164051561914,
                max_strength: 0.0414263257212977,
                max_deflection_mm: 50,
                max_deflection: 0.412685219040132,
                max_capacity_ratio: 0.412685219040132,
                max_capacity_ratio_limit_state: "Deflection (20.6mm)",
            },
            C5: {
                ref: "C5",
                area: 0,
                type: "Column",
                member_size: "50x50x3.0",
                embedment: 500,
                height: 1200,
                total_compression_kn: 0,
                total_tension_kn: 0,
                max_strength: 0,
                max_deflection_mm: 50,
                max_deflection: 0.0470202092307692,
                max_capacity_ratio: 0.0470202092307692,
                max_capacity_ratio_limit_state: "Deflection (2.4mm)",
            },
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 3140,
                total_compression_kn: 2.69875146332781,
                total_tension_kn: -1.72809555985708,
                max_strength: 0.0458307863650412,
                max_deflection_mm: 50,
                max_deflection: 0.412685219040132,
                max_capacity_ratio: 0.412685219040132,
                max_capacity_ratio_limit_state: "Deflection (20.6mm)",
            },
            C4: {
                ref: "C4",
                area: 0,
                type: "Column",
                member_size: "50x50x3.0",
                embedment: 500,
                height: 1200,
                total_compression_kn: 0,
                total_tension_kn: 0,
                max_strength: 0,
                max_deflection_mm: 50,
                max_deflection: 0.0470202092307692,
                max_capacity_ratio: 0.0470202092307692,
                max_capacity_ratio_limit_state: "Deflection (2.4mm)",
            },
            C3: {
                ref: "C3",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 3186,
                total_compression_kn: 0.925556970682143,
                total_tension_kn: -0.592663278988393,
                max_strength: 0.0150492014302351,
                max_deflection_mm: 50,
                max_deflection: 0.432191547259624,
                max_capacity_ratio: 0.432191547259624,
                max_capacity_ratio_limit_state: "Deflection (21.6mm)",
            },
        },
        "BeamResults.TestValueChecksum": 43.0113310900011,
        BeamPointLoadPeakCalcs: [],
        ProcessedLoadData: {
            Beams: {
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3220,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        W1: {
                            Name: "W1",
                            End: 2,
                            Side: 0,
                            Location: 3242.49,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Wall",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "3302",
                    },
                },
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 5810,
                    PointLoadData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 5820,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 5820,
                            Bracket: "BK2",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 5820,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "5950",
                    },
                },
                FB2: {
                    Name: "FB2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3254,
                    PointLoadData: {
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK46",
                        },
                        C3: {
                            Name: "C3",
                            End: 1,
                            Side: 0,
                            Location: 6.64,
                            Bracket: "BK46",
                        },
                        W1: {
                            Name: "W1",
                            End: 2,
                            Side: 0,
                            Location: 3267.96,
                            Bracket: "BK46",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Wall",
                        FA_1: "53.31",
                        FA_2: "-53.31",
                        X: "5931",
                        PARENT_LEN: "3181",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 1254,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 2,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 1,
                            Side: 0,
                            Location: 1276.29,
                            Bracket: "BK46",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C2: {
                            Name: "C2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 1276.29,
                            Bracket: "BK2",
                        },
                        C3: {
                            Name: "C3",
                            End: 2,
                            Side: 0,
                            Location: 1276.29,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5918",
                        PARENT_LEN: "3302",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 3140,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 3140,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C3: {
                    Name: "C3",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 3186,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C4: {
                    Name: "C4",
                    AreaIndex: 0,
                    ColumnType: "50mm x 50mm x 3mm P/C",
                    Height: 1200,
                    TopBracket: "ECCP ",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C5: {
                    Name: "C5",
                    AreaIndex: 0,
                    ColumnType: "50mm x 50mm x 3mm P/C",
                    Height: 1200,
                    TopBracket: "ECCP ",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
            },
        },
    },
    FTNC00199: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.777755725902869,
        BeamResults: {
            "P2,": "0.192485877686359=Deflection-W UP (-6.9mm)",
            "PO3,PO4,": "0.557271976990099=Bending Moment",
            "EB3,": "0.228833809075283=Vertical Shear",
            "EB2a,": "0.0701010727224954=Vertical Shear",
            "P3a,P3b,P4b,P4c,": "0.324860864279356=Deflection-W UP (-11.6mm)",
            "P3,": "0.324860864279356=Deflection-W UP (-11.6mm)",
            "EB3b,": "0.228833809075283=Vertical Shear",
            "EB3c,EB3d,EB3e,EB3f,EB3g,EB3h,": "0.00463831413073245=Vertical Shear",
            "PR1,PR2,": "0.365523606367645=Deflection-W UP (-29.2mm)",
            "P1c,P2a,": "0.0017007347301949=Vertical Shear",
            "P3c,P4a,": "0.00287035163827081=Vertical Shear",
            "EB3a,EB3j,": "0.000724906908798373=Vertical Shear",
            "EB3i,": "0.228574041892383=Vertical Shear",
            "PO1,PO2,": "0.327277911791179=Bending Moment",
            "EB1b,": "0.0699806661416912=Vertical Shear",
            "P4,": "0.324860864279356=Deflection-W UP (-11.6mm)",
            ",": "0.557271976990099=Bending Moment",
            "P1,": "0.192485877686359=Deflection-W UP (-6.9mm)",
            "EB1a,EB2b,": "0.069409295834998=Vertical Shear",
            "P1a,P1b,P2b,P2c,": "0.192485877686359=Deflection-W UP (-6.9mm)",
            "EB2,": "0.0701010727224954=Vertical Shear",
            "EB1,": "0.0699806661416912=Vertical Shear",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            PC4: "0.778=Strength",
            PC2: "0.375=Strength",
            PC3: "0.778=Strength",
            PC1: "0.375=Strength",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = PC3 CR=0.778 - Strength",
        AreaMaxResults: {
            0: {
                MaxResult: 0.777755725902869,
                PurlinMax: 0.324860864279356,
                NumRafters: 3,
                NumColumns: 4,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = PC3 CR=0.778 - Strength",
                NumPurlins: 8,
                ColumnsMax: 0.777755725902869,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC3 CR=0.778 - Strength",
                RafterMax: 0.557271976990099,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.228833809075283,
                JoinBeamMax: 0,
                OtherMax: 0.557271976990099,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            PC4: {
                ref: "PC4",
                area: 0,
                type: "Portal Column",
                member_size: "1586510",
                embedment: 500,
                height: 2204,
                total_compression_kn: 7.03296122048863,
                total_tension_kn: -6.75186391260564,
                max_strength: 0.777755725902869,
                max_deflection_mm: 50,
                max_deflection: 0,
                max_capacity_ratio: 0.777755725902869,
                max_capacity_ratio_limit_state: "Strength",
            },
            PC2: {
                ref: "PC2",
                area: 0,
                type: "Portal Column",
                member_size: "1586510",
                embedment: 500,
                height: 2204,
                total_compression_kn: 4.1873528575346,
                total_tension_kn: -4.07148193677389,
                max_strength: 0.374655012568961,
                max_deflection_mm: 50,
                max_deflection: 0,
                max_capacity_ratio: 0.374655012568961,
                max_capacity_ratio_limit_state: "Strength",
            },
            PC3: {
                ref: "PC3",
                area: 0,
                type: "Portal Column",
                member_size: "1586510",
                embedment: 500,
                height: 2204,
                total_compression_kn: 7.03152599705886,
                total_tension_kn: -6.75050786903078,
                max_strength: 0.777755725902869,
                max_deflection_mm: 50,
                max_deflection: 0,
                max_capacity_ratio: 0.777755725902869,
                max_capacity_ratio_limit_state: "Strength",
            },
            PC1: {
                ref: "PC1",
                area: 0,
                type: "Portal Column",
                member_size: "1586510",
                embedment: 500,
                height: 2204,
                total_compression_kn: 4.1873528575346,
                total_tension_kn: -4.07148193677389,
                max_strength: 0.374655012568961,
                max_deflection_mm: 50,
                max_deflection: 0,
                max_capacity_ratio: 0.374655012568961,
                max_capacity_ratio_limit_state: "Strength",
            },
        },
        "BeamResults.TestValueChecksum": 16.3769503502313,
        BeamPointLoadPeakCalcs: [
            {
                BeamName: "PO1,PO2,",
                BeamType: "Portal Rafter",
                Length: 7514,
                Column: "I",
                PointLoads: [
                    {
                        Name: "P3a",
                        Location: 1812,
                    },
                    {
                        Name: "P1a",
                        Location: 3625,
                    },
                    {
                        Name: "P2c",
                        Location: 3893,
                    },
                    {
                        Name: "P4c",
                        Location: 5706,
                    },
                ],
            },
            {
                BeamName: "PO3,PO4,",
                BeamType: "Portal Rafter",
                Length: 7514,
                Column: "J",
                PointLoads: [
                    {
                        Name: "P3a",
                        Location: 1812,
                    },
                    {
                        Name: "P3b",
                        Location: 1812,
                    },
                    {
                        Name: "P1a",
                        Location: 3625,
                    },
                    {
                        Name: "P1b",
                        Location: 3625,
                    },
                    {
                        Name: "P2b",
                        Location: 3893,
                    },
                    {
                        Name: "P2c",
                        Location: 3893,
                    },
                    {
                        Name: "P4b",
                        Location: 5706,
                    },
                    {
                        Name: "P4c",
                        Location: 5706,
                    },
                ],
            },
            {
                BeamName: "PR1,PR2,",
                BeamType: "Welded Rafter",
                Length: 7134,
                Column: "K",
                PointLoads: [
                    {
                        Name: "P3b",
                        Location: 1622,
                    },
                    {
                        Name: "P3c",
                        Location: 1622,
                    },
                    {
                        Name: "P1b",
                        Location: 3435,
                    },
                    {
                        Name: "P1c",
                        Location: 3435,
                    },
                    {
                        Name: "P2a",
                        Location: 3703,
                    },
                    {
                        Name: "P2b",
                        Location: 3703,
                    },
                    {
                        Name: "P4a",
                        Location: 5516,
                    },
                    {
                        Name: "P4b",
                        Location: 5516,
                    },
                ],
            },
        ],
        ProcessedLoadData: {
            Beams: {
                PO1: {
                    Name: "PO1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3757,
                    PointLoadData: {
                        P3: {
                            Name: "P3",
                            End: 0,
                            Side: 0,
                            Location: 1812.95,
                            Bracket: "",
                        },
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 3625.9,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        PC1: {
                            Name: "PC1",
                            End: 1,
                            Side: 0,
                            Location: 84.07,
                            Bracket: "CON3",
                        },
                        PO2: {
                            Name: "PO2",
                            End: 2,
                            Side: 0,
                            Location: 3761.87,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "3762",
                    },
                },
                PO2: {
                    Name: "PO2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3757,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                        P4: {
                            Name: "P4",
                            End: 0,
                            Side: 0,
                            Location: 1948.92,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        PO1: {
                            Name: "PO1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        PC2: {
                            Name: "PC2",
                            End: 2,
                            Side: 0,
                            Location: 3677.8,
                            Bracket: "CON3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "3762",
                    },
                },
                PO3: {
                    Name: "PO3",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3757,
                    PointLoadData: {
                        P3: {
                            Name: "P3",
                            End: 0,
                            Side: 0,
                            Location: 1812.95,
                            Bracket: "",
                        },
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 3625.9,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        PC3: {
                            Name: "PC3",
                            End: 1,
                            Side: 0,
                            Location: 84.07,
                            Bracket: "CON3",
                        },
                        PO4: {
                            Name: "PO4",
                            End: 2,
                            Side: 0,
                            Location: 3761.87,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2853",
                        PARENT_LEN: "3762",
                    },
                },
                PO4: {
                    Name: "PO4",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3757,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                        P4: {
                            Name: "P4",
                            End: 0,
                            Side: 0,
                            Location: 1948.92,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        PO3: {
                            Name: "PO3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        PC4: {
                            Name: "PC4",
                            End: 2,
                            Side: 0,
                            Location: 3677.8,
                            Bracket: "CON3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2853",
                        PARENT_LEN: "3762",
                    },
                },
                PR1: {
                    Name: "PR1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3567,
                    PointLoadData: {
                        P3: {
                            Name: "P3",
                            End: 0,
                            Side: 0,
                            Location: 1622.9,
                            Bracket: "",
                        },
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 3435.85,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        EB3: {
                            Name: "EB3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK33",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 3571.82,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5623",
                        PARENT_LEN: "3572",
                    },
                },
                PR2: {
                    Name: "PR2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3567,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                        P4: {
                            Name: "P4",
                            End: 0,
                            Side: 0,
                            Location: 1948.92,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        EB3: {
                            Name: "EB3",
                            End: 2,
                            Side: 0,
                            Location: 3571.82,
                            Bracket: "BK33",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5623",
                        PARENT_LEN: "3572",
                    },
                },
                IF1: {
                    Name: "IF1",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 7160,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "7170",
                    },
                },
                U1: {
                    Name: "U1",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 1568,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "1378",
                    },
                },
                U2: {
                    Name: "U2",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 1496,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5623",
                        PARENT_LEN: "1306",
                    },
                },
                EB1: {
                    Name: "EB1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 5700,
                    PointLoadData: {
                        EB3: {
                            Name: "EB3",
                            End: 2,
                            Side: 0,
                            Location: 5622.5,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        PC1: {
                            Name: "PC1",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "BK21",
                        },
                        PC3: {
                            Name: "PC3",
                            End: 0,
                            Side: 0,
                            Location: 2852.5,
                            Bracket: "BK21",
                        },
                        W1: {
                            Name: "W1",
                            End: 2,
                            Side: 0,
                            Location: 5705,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "To Wall",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "5705",
                    },
                },
                U3: {
                    Name: "U3",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 5705,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "5705",
                    },
                },
                EB2: {
                    Name: "EB2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 5700,
                    PointLoadData: {
                        EB3: {
                            Name: "EB3",
                            End: 1,
                            Side: 0,
                            Location: 82.5,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        W1: {
                            Name: "W1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        PC4: {
                            Name: "PC4",
                            End: 0,
                            Side: 0,
                            Location: 2852.5,
                            Bracket: "BK21",
                        },
                        PC2: {
                            Name: "PC2",
                            End: 0,
                            Side: 0,
                            Location: 5672.5,
                            Bracket: "BK21",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Wall",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5705",
                        PARENT_LEN: "5705",
                    },
                },
                U4: {
                    Name: "U4",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 5705,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5705",
                        PARENT_LEN: "5705",
                    },
                },
                EB3: {
                    Name: "EB3",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 7060,
                    PointLoadData: {
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 178.59,
                            Bracket: "BK33",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 6891.41,
                            Bracket: "BK33",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        EB2: {
                            Name: "EB2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        BK25_1: {
                            Name: "BK25_1",
                            End: 0,
                            Side: 0,
                            Location: 132.5,
                            Bracket: "",
                        },
                        BK25_2: {
                            Name: "BK25_2",
                            End: 0,
                            Side: 0,
                            Location: 983.13,
                            Bracket: "",
                        },
                        BK25_3: {
                            Name: "BK25_3",
                            End: 0,
                            Side: 0,
                            Location: 1833.75,
                            Bracket: "",
                        },
                        BK25_4: {
                            Name: "BK25_4",
                            End: 0,
                            Side: 0,
                            Location: 2684.38,
                            Bracket: "",
                        },
                        BK25_5: {
                            Name: "BK25_5",
                            End: 0,
                            Side: 0,
                            Location: 3535,
                            Bracket: "",
                        },
                        BK25_6: {
                            Name: "BK25_6",
                            End: 0,
                            Side: 0,
                            Location: 4385.63,
                            Bracket: "",
                        },
                        BK25_7: {
                            Name: "BK25_7",
                            End: 0,
                            Side: 0,
                            Location: 5236.25,
                            Bracket: "",
                        },
                        BK25_8: {
                            Name: "BK25_8",
                            End: 0,
                            Side: 0,
                            Location: 6086.88,
                            Bracket: "",
                        },
                        BK25_9: {
                            Name: "BK25_9",
                            End: 0,
                            Side: 0,
                            Location: 6937.5,
                            Bracket: "",
                        },
                        EB1: {
                            Name: "EB1",
                            End: 2,
                            Side: 0,
                            Location: 7070,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 11,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5623",
                        PARENT_LEN: "7070",
                    },
                },
                U5: {
                    Name: "U5",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 7070,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5623",
                        PARENT_LEN: "7070",
                    },
                },
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 5700,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PO1: {
                            Name: "PO1",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PO3: {
                            Name: "PO3",
                            End: 0,
                            Side: 0,
                            Location: 2852.5,
                            Bracket: "",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 0,
                            Side: 0,
                            Location: 5622.5,
                            Bracket: "",
                        },
                        W1: {
                            Name: "W1",
                            End: 2,
                            Side: 0,
                            Location: 5705,
                            Bracket: "",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "To Wall",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "5705",
                    },
                },
                P2: {
                    Name: "P2",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 5700,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        W1: {
                            Name: "W1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 0,
                            Side: 0,
                            Location: 82.5,
                            Bracket: "",
                        },
                        PO4: {
                            Name: "PO4",
                            End: 0,
                            Side: 0,
                            Location: 2852.5,
                            Bracket: "",
                        },
                        PO2: {
                            Name: "PO2",
                            End: 0,
                            Side: 0,
                            Location: 5672.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Wall",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5705",
                        PARENT_LEN: "5705",
                    },
                },
                P3: {
                    Name: "P3",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 5700,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PO1: {
                            Name: "PO1",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PO3: {
                            Name: "PO3",
                            End: 0,
                            Side: 0,
                            Location: 2852.5,
                            Bracket: "",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 0,
                            Side: 0,
                            Location: 5622.5,
                            Bracket: "",
                        },
                        W1: {
                            Name: "W1",
                            End: 2,
                            Side: 0,
                            Location: 5705,
                            Bracket: "",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "To Wall",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "5705",
                    },
                },
                P4: {
                    Name: "P4",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 5700,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        W1: {
                            Name: "W1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 0,
                            Side: 0,
                            Location: 82.5,
                            Bracket: "",
                        },
                        PO4: {
                            Name: "PO4",
                            End: 0,
                            Side: 0,
                            Location: 2852.5,
                            Bracket: "",
                        },
                        PO2: {
                            Name: "PO2",
                            End: 0,
                            Side: 0,
                            Location: 5672.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Wall",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5705",
                        PARENT_LEN: "5705",
                    },
                },
            },
            Cols: {
                PC1: {
                    Name: "PC1",
                    AreaIndex: 0,
                    ColumnType: "1586510",
                    Height: 2204,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                PC2: {
                    Name: "PC2",
                    AreaIndex: 0,
                    ColumnType: "1586510",
                    Height: 2204,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                PC3: {
                    Name: "PC3",
                    AreaIndex: 0,
                    ColumnType: "1586510",
                    Height: 2204,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                PC4: {
                    Name: "PC4",
                    AreaIndex: 0,
                    ColumnType: "1586510",
                    Height: 2204,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
            },
        },
    },
    FIRC00048: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.437205383179385,
        BeamResults: {
            "R1,": "0.00400250414306986=Vertical Shear",
            "R2,": "0.00810633750495162=Vertical Shear",
            "FB1b,": "0.32592469014153=Bending Moment",
            "FB2b,FB2c,FB2d,FB2e,FB2f,FB2g,FB2h,FB2i,FB2j,FB2k,FB2l,FB2m,FB2n,FB2o,FB2p,FB2q,FB2r,FB2s,FB2t,FB2u,FB2v,FB2w,FB2x,FB2y,":
                "0.00794796344869488=Vertical Shear",
            "FB1d,FB1e,": "0.234530672998889=Bending Moment",
            "FB2a,": "0.016059688046573=Vertical Shear",
            "FB2z,": "0.0120946925384998=Vertical Shear",
            "FB1,": "0.350471800040829=Deflection-G (8.8mm)",
            "FB2,": "0.016059688046573=Vertical Shear",
            "FB1c,": "0.350471800040829=Deflection-G (8.8mm)",
            ",": "0.350471800040829=Deflection-G (8.8mm)",
            "FB1a,": "0.00104706859438958=Vertical Shear",
            "R1a,": "0.000337764062706318=Vertical Shear",
            "R1b,": "0.00400250414306986=Vertical Shear",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C6: "0.385=Deflection (19.3mm)",
            C2: "0.437=Deflection (21.9mm)",
            C1: "0.437=Deflection (21.9mm)",
            C3: "0.385=Deflection (19.3mm)",
            C4: "0.385=Deflection (19.3mm)",
            C5: "0.437=Deflection (21.9mm)",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = C1 CR=0.437 - Deflection (21.9mm)",
        AreaMaxResults: {
            0: {
                MaxResult: 0.437205383179385,
                FasciaMax: 0.350471800040829,
                NumRafters: 4,
                NumColumns: 6,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C1 CR=0.437 - Deflection (21.9mm)",
                NumPurlins: 0,
                ColumnsMax: 0.437205383179385,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.437 - Deflection (21.9mm)",
                RafterMax: 0.00810633750495162,
                NumFasciaBeams: 9,
                JoinBeamMax: 0,
                OtherMax: 0.350471800040829,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C6: {
                ref: "C6",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 0,
                height: 2771,
                total_compression_kn: 2.02330153247268,
                total_tension_kn: -1.02528207189549,
                max_strength: 0.232648753349107,
                max_deflection_mm: 50,
                max_deflection: 0.385267487367513,
                max_capacity_ratio: 0.385267487367513,
                max_capacity_ratio_limit_state: "Deflection (19.3mm)",
            },
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 0,
                height: 2879,
                total_compression_kn: 1.28724072164094,
                total_tension_kn: -0.652292707206796,
                max_strength: 0.217372767208656,
                max_deflection_mm: 50,
                max_deflection: 0.437205383179385,
                max_capacity_ratio: 0.437205383179385,
                max_capacity_ratio_limit_state: "Deflection (21.9mm)",
            },
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 0,
                height: 2879,
                total_compression_kn: 0.024331509785175,
                total_tension_kn: -0.0123296801611188,
                max_strength: 0.168410555301712,
                max_deflection_mm: 50,
                max_deflection: 0.437205383179385,
                max_capacity_ratio: 0.437205383179385,
                max_capacity_ratio_limit_state: "Deflection (21.9mm)",
            },
            C3: {
                ref: "C3",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 0,
                height: 2771,
                total_compression_kn: 2.42242434341099,
                total_tension_kn: -1.22753243150426,
                max_strength: 0.247194939218911,
                max_deflection_mm: 50,
                max_deflection: 0.385267487367513,
                max_capacity_ratio: 0.385267487367513,
                max_capacity_ratio_limit_state: "Deflection (19.3mm)",
            },
            C4: {
                ref: "C4",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 0,
                height: 2771,
                total_compression_kn: 2.2414898955853,
                total_tension_kn: -1.13584622331102,
                max_strength: 0.240600712990309,
                max_deflection_mm: 50,
                max_deflection: 0.385267487367513,
                max_capacity_ratio: 0.385267487367513,
                max_capacity_ratio_limit_state: "Deflection (19.3mm)",
            },
            C5: {
                ref: "C5",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 0,
                height: 2879,
                total_compression_kn: 1.15407911619834,
                total_tension_kn: -0.584814773476244,
                max_strength: 0.212210173823207,
                max_deflection_mm: 50,
                max_deflection: 0.437205383179385,
                max_capacity_ratio: 0.437205383179385,
                max_capacity_ratio_limit_state: "Deflection (21.9mm)",
            },
        },
        "BeamResults.TestValueChecksum": 0.14818909756245,
        BeamPointLoadPeakCalcs: [],
        ProcessedLoadData: {
            Beams: {
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 1185,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C2: {
                            Name: "C2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 1207.31,
                            Bracket: "",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "1332",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 1185,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 2,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C5: {
                            Name: "C5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 1207.31,
                            Bracket: "",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "24165",
                        PARENT_LEN: "1332",
                    },
                },
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 24090,
                    PointLoadData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 24099.5,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C2: {
                            Name: "C2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C3: {
                            Name: "C3",
                            End: 0,
                            Side: 0,
                            Location: 6482.5,
                            Bracket: "BK",
                        },
                        C4: {
                            Name: "C4",
                            End: 0,
                            Side: 0,
                            Location: 13167.5,
                            Bracket: "BK",
                        },
                        C6: {
                            Name: "C6",
                            End: 0,
                            Side: 0,
                            Location: 18666,
                            Bracket: "BK",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 24099.5,
                            Bracket: "BK2",
                        },
                        C5: {
                            Name: "C5",
                            End: 2,
                            Side: 0,
                            Location: 24099.5,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 8,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "24197",
                    },
                },
                FB2: {
                    Name: "FB2",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 24197,
                    PointLoadData: {
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 24164.5,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        BK25_27: {
                            Name: "BK25_27",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        BK25_26: {
                            Name: "BK25_26",
                            End: 0,
                            Side: 0,
                            Location: 960.65,
                            Bracket: "",
                        },
                        BK25_25: {
                            Name: "BK25_25",
                            End: 0,
                            Side: 0,
                            Location: 1888.81,
                            Bracket: "",
                        },
                        BK25_24: {
                            Name: "BK25_24",
                            End: 0,
                            Side: 0,
                            Location: 2816.96,
                            Bracket: "",
                        },
                        BK25_23: {
                            Name: "BK25_23",
                            End: 0,
                            Side: 0,
                            Location: 3745.12,
                            Bracket: "",
                        },
                        BK25_22: {
                            Name: "BK25_22",
                            End: 0,
                            Side: 0,
                            Location: 4673.27,
                            Bracket: "",
                        },
                        BK25_21: {
                            Name: "BK25_21",
                            End: 0,
                            Side: 0,
                            Location: 5601.42,
                            Bracket: "",
                        },
                        BK25_20: {
                            Name: "BK25_20",
                            End: 0,
                            Side: 0,
                            Location: 6529.58,
                            Bracket: "",
                        },
                        BK25_19: {
                            Name: "BK25_19",
                            End: 0,
                            Side: 0,
                            Location: 7457.73,
                            Bracket: "",
                        },
                        BK25_18: {
                            Name: "BK25_18",
                            End: 0,
                            Side: 0,
                            Location: 8385.88,
                            Bracket: "",
                        },
                        BK25_17: {
                            Name: "BK25_17",
                            End: 0,
                            Side: 0,
                            Location: 9314.04,
                            Bracket: "",
                        },
                        BK25_16: {
                            Name: "BK25_16",
                            End: 0,
                            Side: 0,
                            Location: 10242.19,
                            Bracket: "",
                        },
                        BK25_15: {
                            Name: "BK25_15",
                            End: 0,
                            Side: 0,
                            Location: 11170.35,
                            Bracket: "",
                        },
                        BK25_14: {
                            Name: "BK25_14",
                            End: 0,
                            Side: 0,
                            Location: 12098.5,
                            Bracket: "",
                        },
                        BK25_13: {
                            Name: "BK25_13",
                            End: 0,
                            Side: 0,
                            Location: 13026.65,
                            Bracket: "",
                        },
                        BK25_12: {
                            Name: "BK25_12",
                            End: 0,
                            Side: 0,
                            Location: 13954.81,
                            Bracket: "",
                        },
                        BK25_11: {
                            Name: "BK25_11",
                            End: 0,
                            Side: 0,
                            Location: 14882.96,
                            Bracket: "",
                        },
                        BK25_10: {
                            Name: "BK25_10",
                            End: 0,
                            Side: 0,
                            Location: 15811.12,
                            Bracket: "",
                        },
                        BK25_9: {
                            Name: "BK25_9",
                            End: 0,
                            Side: 0,
                            Location: 16739.27,
                            Bracket: "",
                        },
                        BK25_8: {
                            Name: "BK25_8",
                            End: 0,
                            Side: 0,
                            Location: 17667.42,
                            Bracket: "",
                        },
                        BK25_7: {
                            Name: "BK25_7",
                            End: 0,
                            Side: 0,
                            Location: 18595.58,
                            Bracket: "",
                        },
                        BK25_6: {
                            Name: "BK25_6",
                            End: 0,
                            Side: 0,
                            Location: 19523.73,
                            Bracket: "",
                        },
                        BK25_5: {
                            Name: "BK25_5",
                            End: 0,
                            Side: 0,
                            Location: 20451.88,
                            Bracket: "",
                        },
                        BK25_4: {
                            Name: "BK25_4",
                            End: 0,
                            Side: 0,
                            Location: 21380.04,
                            Bracket: "",
                        },
                        BK25_3: {
                            Name: "BK25_3",
                            End: 0,
                            Side: 0,
                            Location: 22308.19,
                            Bracket: "",
                        },
                        BK25_2: {
                            Name: "BK25_2",
                            End: 0,
                            Side: 0,
                            Location: 23236.35,
                            Bracket: "",
                        },
                        BK25_1: {
                            Name: "BK25_1",
                            End: 0,
                            Side: 0,
                            Location: 24164.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 27,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "24197",
                        PARENT_LEN: "24197",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2879,
                    TopBracket: "",
                    GroundConnection: "Bolt to Slab",
                    Embedment: 0,
                    ExternalConnector: "0",
                    BaseConnector: "BK16",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2879,
                    TopBracket: "",
                    GroundConnection: "Bolt to Slab",
                    Embedment: 0,
                    ExternalConnector: "0",
                    BaseConnector: "BK16",
                },
                C3: {
                    Name: "C3",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2771,
                    TopBracket: "BK",
                    GroundConnection: "Bolt to Slab",
                    Embedment: 0,
                    ExternalConnector: "0",
                    BaseConnector: "BK16",
                },
                C4: {
                    Name: "C4",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2771,
                    TopBracket: "BK",
                    GroundConnection: "Bolt to Slab",
                    Embedment: 0,
                    ExternalConnector: "0",
                    BaseConnector: "BK16",
                },
                C5: {
                    Name: "C5",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2879,
                    TopBracket: "",
                    GroundConnection: "Bolt to Slab",
                    Embedment: 0,
                    ExternalConnector: "0",
                    BaseConnector: "BK16",
                },
                C6: {
                    Name: "C6",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2771,
                    TopBracket: "BK",
                    GroundConnection: "Bolt to Slab",
                    Embedment: 0,
                    ExternalConnector: "0",
                    BaseConnector: "BK16",
                },
            },
        },
    },
    ZAPC00248: {
        AttachmentBracketResults: {
            BK34D_4: "0.155=Shear",
            BK34D_3: "0.195=Shear",
            BK34D_2: "0.195=Shear",
            BK34D_1: "0.155=Shear",
        },
        MaxResultOverAll: 0.267090557202381,
        BeamResults: {
            "P2,": "0.183199464790975=Deflection-W UP (-6.9mm)",
            "PR5,PR6,": "0.0748403384389872=End 1 (CON3)",
            "P1a,P1b,P2a,P2b,": "0.183199464790975=Deflection-W UP (-6.9mm)",
            "EB2a,": "0.104372517604592=Vertical Shear",
            "EB1a,EB1b,": "0.0504597533721347=Vertical Shear",
            "PR1,PR2,": "0.0748403384389872=End 1 (CON3)",
            "EB2c,": "0.104372517604592=Vertical Shear",
            "EB2b,": "0.12651678299374=Vertical Shear",
            "P1,": "0.183199464790975=Deflection-W UP (-6.9mm)",
            "PR3,PR4,": "0.144737185077744=End 1 (CON3)",
            "EB2,": "0.12651678299374=Vertical Shear",
            "EB1,": "0.0504597533721347=Vertical Shear",
            ",": "0.183199464790975=Deflection-W UP (-6.9mm)",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            PC2: "0.267=Deflection (13.4mm)",
            PC3: "0.267=Deflection (13.4mm)",
            PC1: "0.267=Deflection (13.4mm)",
        },
        AttachmentBracketResultsDetailed: {
            BK34D_4: {
                ref: "BK34D_4",
                area: 0,
                type: "BK34D",
                max_shear: 0.155295669505941,
                max_shear_kn: 1.21907100562164,
                max_uplift: 0.153724298319272,
                max_uplift_kn: -1.20673574180629,
                max_area_capacity: 0.263112786079079,
                area_m2_roofload: 2.32328590107826,
                max_capacity_ratio: 0.155295669505941,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB2a",
            },
            BK34D_3: {
                ref: "BK34D_3",
                area: 0,
                type: "BK34D",
                max_shear: 0.194804340526374,
                max_shear_kn: 1.52921407313204,
                max_uplift: 0.19283319781058,
                max_uplift_kn: -1.51374060281305,
                max_area_capacity: 0.331573389432785,
                area_m2_roofload: 2.92779302869149,
                max_capacity_ratio: 0.194804340526374,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB2b",
            },
            BK34D_2: {
                ref: "BK34D_2",
                area: 0,
                type: "BK34D",
                max_shear: 0.194804340526374,
                max_shear_kn: 1.52921407313204,
                max_uplift: 0.19283319781058,
                max_uplift_kn: -1.51374060281305,
                max_area_capacity: 0.331573389432785,
                area_m2_roofload: 2.92779302869149,
                max_capacity_ratio: 0.194804340526374,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB2b",
            },
            BK34D_1: {
                ref: "BK34D_1",
                area: 0,
                type: "BK34D",
                max_shear: 0.155295669505941,
                max_shear_kn: 1.21907100562164,
                max_uplift: 0.153724298319272,
                max_uplift_kn: -1.20673574180629,
                max_area_capacity: 0.263112786079079,
                area_m2_roofload: 2.32328590107826,
                max_capacity_ratio: 0.155295669505941,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB2c",
            },
        },
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "BK34D_3",
                area: 0,
                type: "BK34D",
                max_shear: 0.194804340526374,
                max_shear_kn: 1.52921407313204,
                max_uplift: 0.19283319781058,
                max_uplift_kn: -1.51374060281305,
                max_area_capacity: 0.331573389432785,
                area_m2_roofload: 2.92779302869149,
                max_capacity_ratio: 0.194804340526374,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB2b",
            },
        },
        maxResultOverAllText: "Limiting Member = PC1 CR=0.267 - Deflection (13.4mm)",
        AreaMaxResults: {
            0: {
                MaxResult: 0.267090557202381,
                PurlinMax: 0.183199464790975,
                NumRafters: 3,
                NumColumns: 3,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = PC1 CR=0.267 - Deflection (13.4mm)",
                NumPurlins: 3,
                ColumnsMax: 0.267090557202381,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.267 - Deflection (13.4mm)",
                RafterMax: 0.144737185077744,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.12651678299374,
                JoinBeamMax: 0,
                OtherMax: 0.183199464790975,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            PC2: {
                ref: "PC2",
                area: 0,
                type: "Column",
                member_size: "1086510",
                embedment: 500,
                height: 2424,
                total_compression_kn: 2.64484239205575,
                total_tension_kn: -2.69138183601997,
                max_strength: 0.188472978462863,
                max_deflection_mm: 50,
                max_deflection: 0.267090557202381,
                max_capacity_ratio: 0.267090557202381,
                max_capacity_ratio_limit_state: "Deflection (13.4mm)",
            },
            PC3: {
                ref: "PC3",
                area: 0,
                type: "Column",
                member_size: "1086510",
                embedment: 500,
                height: 2424,
                total_compression_kn: 1.41168530274909,
                total_tension_kn: -1.43851478256594,
                max_strength: 0.167087451630596,
                max_deflection_mm: 50,
                max_deflection: 0.267090557202381,
                max_capacity_ratio: 0.267090557202381,
                max_capacity_ratio_limit_state: "Deflection (13.4mm)",
            },
            PC1: {
                ref: "PC1",
                area: 0,
                type: "Column",
                member_size: "1086510",
                embedment: 500,
                height: 2424,
                total_compression_kn: 1.41168530274909,
                total_tension_kn: -1.43851478256594,
                max_strength: 0.167087451630596,
                max_deflection_mm: 50,
                max_deflection: 0.267090557202381,
                max_capacity_ratio: 0.267090557202381,
                max_capacity_ratio_limit_state: "Deflection (13.4mm)",
            },
        },
        "BeamResults.TestValueChecksum": 53.1961157685428,
        BeamPointLoadPeakCalcs: [
            {
                BeamName: "PR1,PR2,",
                BeamType: "Welded Rafter",
                Length: 2951,
                Column: "F",
                PointLoads: [
                    {
                        Name: "P1a",
                        Location: 1324,
                    },
                    {
                        Name: "P2b",
                        Location: 1592,
                    },
                ],
            },
            {
                BeamName: "PR3,PR4,",
                BeamType: "Welded Rafter",
                Length: 2951,
                Column: "G",
                PointLoads: [
                    {
                        Name: "P1a",
                        Location: 1324,
                    },
                    {
                        Name: "P1b",
                        Location: 1324,
                    },
                    {
                        Name: "P2a",
                        Location: 1592,
                    },
                    {
                        Name: "P2b",
                        Location: 1592,
                    },
                ],
            },
            {
                BeamName: "PR5,PR6,",
                BeamType: "Welded Rafter",
                Length: 2951,
                Column: "H",
                PointLoads: [
                    {
                        Name: "P1b",
                        Location: 1324,
                    },
                    {
                        Name: "P2a",
                        Location: 1592,
                    },
                ],
            },
        ],
        ProcessedLoadData: {
            Beams: {
                PR1: {
                    Name: "PR1",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 1456,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 1324.61,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        PC1: {
                            Name: "PC1",
                            End: 1,
                            Side: 0,
                            Location: 57.47,
                            Bracket: "CON3",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 1460.58,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "1461",
                    },
                },
                PR2: {
                    Name: "PR2",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 1495,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 1499.89,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "1500",
                    },
                },
                PR3: {
                    Name: "PR3",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 1456,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 1324.61,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        PC2: {
                            Name: "PC2",
                            End: 1,
                            Side: 0,
                            Location: 57.47,
                            Bracket: "CON3",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 1460.58,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "3000",
                        PARENT_LEN: "1461",
                    },
                },
                PR4: {
                    Name: "PR4",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 1495,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        PR3: {
                            Name: "PR3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 1499.89,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "3000",
                        PARENT_LEN: "1500",
                    },
                },
                PR5: {
                    Name: "PR5",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 1456,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 1324.61,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        PC3: {
                            Name: "PC3",
                            End: 1,
                            Side: 0,
                            Location: 57.47,
                            Bracket: "CON3",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 2,
                            Side: 0,
                            Location: 1460.58,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5968",
                        PARENT_LEN: "1461",
                    },
                },
                PR6: {
                    Name: "PR6",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 1495,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        PR5: {
                            Name: "PR5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 1499.89,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5968",
                        PARENT_LEN: "1500",
                    },
                },
                IF1: {
                    Name: "IF1",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 2835,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "2845",
                    },
                },
                U1: {
                    Name: "U1",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 746,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "556",
                    },
                },
                IF2: {
                    Name: "IF2",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 2835,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5968",
                        PARENT_LEN: "2845",
                    },
                },
                U2: {
                    Name: "U2",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 746,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5968",
                        PARENT_LEN: "556",
                    },
                },
                EB1: {
                    Name: "EB1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 6000,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PC1: {
                            Name: "PC1",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "BK21",
                        },
                        PC2: {
                            Name: "PC2",
                            End: 0,
                            Side: 0,
                            Location: 3000,
                            Bracket: "BK21",
                        },
                        PC3: {
                            Name: "PC3",
                            End: 0,
                            Side: 0,
                            Location: 5967.5,
                            Bracket: "BK21",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "6000",
                    },
                },
                EB2: {
                    Name: "EB2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 6000,
                    PointLoadData: {
                        PR6: {
                            Name: "PR6",
                            End: 2,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "BK3",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 3000,
                            Bracket: "BK3",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 5967.5,
                            Bracket: "BK3",
                        },
                    },
                    NumPointLoads: 3,
                    SupportData: {
                        BK34D_4: {
                            Name: "BK34D_4",
                            End: 0,
                            Side: 0,
                            Location: 132.5,
                            Bracket: "",
                        },
                        BK34D_3: {
                            Name: "BK34D_3",
                            End: 0,
                            Side: 0,
                            Location: 2044.17,
                            Bracket: "",
                        },
                        BK34D_2: {
                            Name: "BK34D_2",
                            End: 0,
                            Side: 0,
                            Location: 3955.83,
                            Bracket: "",
                        },
                        BK34D_1: {
                            Name: "BK34D_1",
                            End: 0,
                            Side: 0,
                            Location: 5867.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "6000",
                        PARENT_LEN: "6000",
                    },
                },
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 6000,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 0,
                            Side: 0,
                            Location: 3000,
                            Bracket: "",
                        },
                        PR5: {
                            Name: "PR5",
                            End: 0,
                            Side: 0,
                            Location: 5967.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "6000",
                    },
                },
                P2: {
                    Name: "P2",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 6000,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR6: {
                            Name: "PR6",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 0,
                            Side: 0,
                            Location: 3000,
                            Bracket: "",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 0,
                            Side: 0,
                            Location: 5967.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "6000",
                        PARENT_LEN: "6000",
                    },
                },
            },
            Cols: {
                PC1: {
                    Name: "PC1",
                    AreaIndex: 0,
                    ColumnType: "1086510",
                    Height: 2424,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                PC2: {
                    Name: "PC2",
                    AreaIndex: 0,
                    ColumnType: "1086510",
                    Height: 2424,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                PC3: {
                    Name: "PC3",
                    AreaIndex: 0,
                    ColumnType: "1086510",
                    Height: 2424,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
            },
        },
    },
    FTLC00440: {
        AttachmentBracketResults: {
            BK34S_10: "0.071=Uplift",
            BK34S_11: "0.723=Uplift",
            BK34S_14: "0.278=Uplift",
            BK34S_16: "0.066=Uplift",
            BK34S_12: "1.407=Uplift",
            BK34S_8: "0.969=Uplift",
            BK34S_9: "0.103=Uplift",
            BK34S_13: "0.185=Uplift",
            BK34S_15: "0.154=Uplift",
            BK34S_2: "0.078=Uplift",
            BK34S_1: "0.078=Uplift",
            BK34S_17: "0.066=Uplift",
            BK34S_3: "0.832=Uplift",
            BK34S_4: "1.311=Uplift",
            BK34S_5: "0.078=Uplift",
            BK34S_6: "0.108=Uplift",
            BK34S_7: "0.837=Uplift",
        },
        BeamResults: {
            "EB2c,EB2e,EB2f,": "0.023786281395106=Vertical Shear",
            "EB2g,": "0.651209659903122=Vertical Shear",
            "P5,": "0.395865359806851=Deflection-W UP (-15.5mm)",
            "P2,": "0.229642409327166=Deflection-W UP (-9.0mm)",
            "P3,": "0.229642409327166=Deflection-W UP (-9.0mm)",
            "PR3,PR4,": "1.33667012551231=Vertical Shear",
            "EB2b,": "0.212798816589901=Vertical Shear",
            "R1,": "0.0446638837230308=Vertical Shear",
            "PO1,PO2,": "0.137538251526543=Bending Moment",
            "EB2d,": "1.33667012551231=Vertical Shear",
            "P9,": "0.395865359806851=Deflection-W UP (-15.5mm)",
            "EB1d,": "1.33538299969758=Vertical Shear",
            ",": "1.33667012551231=Vertical Shear",
            "R2,": "0.0446638837230308=Vertical Shear",
            "P6,P10,": "0.395865359806851=Deflection-W UP (-15.5mm)",
            "EB1,": "1.33538299969758=Vertical Shear",
            "EB2a,": "0.00646584491746308=Deflection (0.1mm)",
            "EB3c,EB3d,EB3e,": "0.0220431678407992=Vertical Shear",
            "P8,P12,": "0.396243454680843=Deflection-W UP (-15.6mm)",
            "EB3a,": "0.120093033397122=Vertical Shear",
            "P8,": "0.396243454680843=Deflection-W UP (-15.6mm)",
            "EB1a,": "0.562226622644072=Vertical Shear",
            "P11,": "0.395865359806851=Deflection-W UP (-15.5mm)",
            "EB3b,": "0.120093033397122=Vertical Shear",
            "FB1b,": "0.150913211143877=Vertical Shear",
            "FB1,": "0.151412097792286=Vertical Shear",
            "P12,": "0.396243454680843=Deflection-W UP (-15.6mm)",
            "P10,": "0.395865359806851=Deflection-W UP (-15.5mm)",
            "P5,P9,": "0.395865359806851=Deflection-W UP (-15.5mm)",
            "EB3,": "0.120093033397122=Vertical Shear",
            "PR1,PR2,": "0.619885946787031=Vertical Shear",
            "EB1b,EB1c,EB1e,EB1f,EB1g,": "0.0261089803162112=Vertical Shear",
            "P4,": "0.229642409327166=Deflection-W UP (-9.0mm)",
            "P1,P2,": "0.229642409327166=Deflection-W UP (-9.0mm)",
            "P3,P4,": "0.229642409327166=Deflection-W UP (-9.0mm)",
            "P7,P11,": "0.395865359806851=Deflection-W UP (-15.5mm)",
            "FB1a,": "0.151412097792286=Vertical Shear",
            "EB2,": "1.33667012551231=Vertical Shear",
            "P1,": "0.229642409327166=Deflection-W UP (-9.0mm)",
            "P6,": "0.395865359806851=Deflection-W UP (-15.5mm)",
            "P7,": "0.395865359806851=Deflection-W UP (-15.5mm)",
        },
        ColumnResults: {
            C3: "0.083=Base Connection",
            C2: "0.080=Strength",
            PC2: "0.114=Deflection (5.7mm)",
            C1: "0.083=Base Connection",
            PC1: "0.243=Strength",
        },
        BeamAttachmentBracketResults: {
            EB1: {
                ref: "BK34S_4",
                area: 0,
                type: "BK34S",
                max_shear: 0.58409862377251,
                max_shear_kn: 4.5851741966142,
                max_uplift: 1.31074513396554,
                max_uplift_kn: -10.2893493016295,
                max_area_capacity: 0.627671501092597,
                area_m2_roofload: 5.54233935464763,
                max_capacity_ratio: 1.31074513396554,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB1d",
            },
            EB3: {
                ref: "BK34S_14",
                area: 0,
                type: "BK34S",
                max_shear: 0.120759628395478,
                max_shear_kn: 0.947963082904503,
                max_uplift: 0.277563707682047,
                max_uplift_kn: -2.17887510530407,
                max_area_capacity: 0.232135360655377,
                area_m2_roofload: 2.04975523458697,
                max_capacity_ratio: 0.277563707682047,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3a",
            },
            EB2: {
                ref: "BK34S_12",
                area: 0,
                type: "BK34S",
                max_shear: 0.626883734822211,
                max_shear_kn: 4.92103731835435,
                max_uplift: 1.40721057174669,
                max_uplift_kn: -11.0466029882115,
                max_area_capacity: 0.670812754350665,
                area_m2_roofload: 5.92327662091637,
                max_capacity_ratio: 1.40721057174669,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2d",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 1.33667012551231,
        AreaMaxResults: {
            0: {
                MaxResult: 1.33667012551231,
                PurlinMax: 0.396243454680843,
                NumRafters: 3,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 18,
                ColumnsMax: 0.242662081123844,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.243 - Strength",
                RafterMax: 1.33667012551231,
                NumFasciaBeams: 0,
                EdgeBeamMax: 1.33667012551231,
                JoinBeamMax: 0,
                OtherMax: 1.33667012551231,
                AttachmentBracketsMax: -1,
            },
            1: {
                MaxResult: 0.151412097792286,
                FasciaMax: 0.151412097792286,
                NumRafters: 2,
                NumColumns: 3,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 0,
                ColumnsMax: 0.0832178947080745,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.083 - Base Connection",
                RafterMax: 0.0446638837230308,
                NumFasciaBeams: 3,
                JoinBeamMax: 0,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 418.633691360872,
    },
    FGRC00073: {
        AttachmentBracketResults: {
            BK34S_10: "0.399=Uplift",
            BK34S_20: "0.122=Uplift",
            BK34S_6: "0.614=Uplift",
            BK34S_11: "0.085=Uplift",
            BK34S_14: "0.127=Uplift",
            BK34S_13: "0.603=Uplift",
            BK34S_16: "0.024=Uplift",
            BK34S_8: "0.062=Uplift",
            BK34S_18: "0.024=Uplift",
            BK34S_12: "0.622=Uplift",
            BK34S_15: "0.024=Uplift",
            BK34S_2: "0.082=Uplift",
            BK34S_1: "0.540=Uplift",
            BK34S_17: "0.024=Uplift",
            BK34S_3: "0.399=Uplift",
            BK34S_4: "0.830=Uplift",
            BK34S_5: "0.062=Uplift",
            BK34S_9: "0.830=Uplift",
            BK34S_7: "0.614=Uplift",
            BK34S_19: "0.024=Uplift",
        },
        MaxResultOverAll: 0.790053557255535,
        BeamResults: {
            "EB2f,": "0.742964694631435=Vertical Shear",
            "EB3h,": "0.405715071722347=Vertical Shear",
            "EB3b,EB3c,EB3d,EB3e,EB3f,EB3g,": "0.00803289992359996=Vertical Shear",
            "P2,": "0.132478864487478=Deflection-W UP (-4.2mm)",
            "EB2i,": "0.742964694631435=Vertical Shear",
            "P3,": "0.213338866446758=Deflection-W UP (-6.8mm)",
            "PR9,PR10,": "0.411411760548377=Vertical Shear",
            "EB2c,": "0.742964694631435=Vertical Shear",
            ",": "0.790053557255535=End 1 (CON3)",
            "EB2b,EB2d,EB2e,EB2g,EB2h,EB2j,": "0.0207092604787024=Vertical Shear",
            "EB3,": "0.405715071722347=Vertical Shear",
            "EB2,": "0.742964694631435=Vertical Shear",
            "EB1,": "0.0588482418475641=Vertical Shear",
            "EB2a,": "0.418082766103917=Vertical Shear",
            "P1a,P1b,P1c,P1d,P2a,P2b,P2c,P2d,": "0.132478864487478=Deflection-W UP (-4.2mm)",
            "P5,": "0.213338866446758=Deflection-W UP (-6.8mm)",
            "P8,": "0.213338866446758=Deflection-W UP (-6.8mm)",
            "EB2k,": "0.362852766672255=Vertical Shear",
            "PR7,PR8,": "0.790053557255535=End 1 (CON3)",
            "PR5,PR6,": "0.790053557255535=End 1 (CON3)",
            "PR1,PR2,": "0.585796670810423=Bending Moment",
            "P3a,P3b,P3c,P3d,P4a,P4b,P4c,P4d,P5a,P5b,P5c,P5d,P6a,P6b,P6c,P6d,P7a,P7b,P7c,P7d,P8a,P8b,P8c,P8d,":
                "0.213338866446758=Deflection-W UP (-6.8mm)",
            "EB3a,": "0.405451885533606=Vertical Shear",
            "PR3,PR4,": "0.790053557255535=End 1 (CON3)",
            "EB1a,EB1b,EB1c,EB1d,": "0.0588482418475641=Vertical Shear",
            "P4,": "0.213338866446758=Deflection-W UP (-6.8mm)",
            "P1,": "0.132478864487478=Deflection-W UP (-4.2mm)",
            "P6,": "0.213338866446758=Deflection-W UP (-6.8mm)",
            "P7,": "0.213338866446758=Deflection-W UP (-6.8mm)",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            PC4: "0.415=Top Connection",
            PC2: "0.412=Top Connection",
            PC3: "0.415=Top Connection",
            PC1: "0.415=Top Connection",
        },
        AttachmentBracketResultsDetailed: {
            BK34S_10: {
                ref: "BK34S_10",
                area: 0,
                type: "BK34S",
                max_shear: 0.239174433892574,
                max_shear_kn: 1.8775193060567,
                max_uplift: 0.399197316713021,
                max_uplift_kn: -3.13369893619722,
                max_area_capacity: 0.391365710863833,
                area_m2_roofload: 3.81972933803101,
                max_capacity_ratio: 0.399197316713021,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2c",
            },
            BK34S_20: {
                ref: "BK34S_20",
                area: 0,
                type: "BK34S",
                max_shear: 0.0729576838303831,
                max_shear_kn: 0.572717818068507,
                max_uplift: 0.12177100681157,
                max_uplift_kn: -0.955902403470822,
                max_area_capacity: 0.121872417480551,
                area_m2_roofload: 1.18947479461018,
                max_capacity_ratio: 0.12177100681157,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3h",
            },
            BK34S_11: {
                ref: "BK34S_11",
                area: 0,
                type: "BK34S",
                max_shear: 0.0510238739311793,
                max_shear_kn: 0.400537410359757,
                max_uplift: 0.0851620853873492,
                max_uplift_kn: -0.668522370290691,
                max_area_capacity: 0.0758713565396567,
                area_m2_roofload: 0.74050443982705,
                max_capacity_ratio: 0.0851620853873492,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2a",
            },
            BK34S_14: {
                ref: "BK34S_14",
                area: 0,
                type: "BK34S",
                max_shear: 0.075817466168902,
                max_shear_kn: 0.595167109425881,
                max_uplift: 0.126544165118418,
                max_uplift_kn: -0.993371696179581,
                max_area_capacity: 0.126649550864798,
                area_m2_roofload: 1.23609961644043,
                max_capacity_ratio: 0.126544165118418,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3a",
            },
            BK34S_9: {
                ref: "BK34S_9",
                area: 0,
                type: "BK34S",
                max_shear: 0.496999951226571,
                max_shear_kn: 3.90144961712858,
                max_uplift: 0.829524475953238,
                max_uplift_kn: -6.51176713623292,
                max_area_capacity: 0.8220512457654,
                area_m2_roofload: 8.0232201586703,
                max_capacity_ratio: 0.829524475953238,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2c",
            },
            BK34S_3: {
                ref: "BK34S_3",
                area: 0,
                type: "BK34S",
                max_shear: 0.239174433892574,
                max_shear_kn: 1.8775193060567,
                max_uplift: 0.399197316713021,
                max_uplift_kn: -3.13369893619722,
                max_area_capacity: 0.391365710863833,
                area_m2_roofload: 3.81972933803101,
                max_capacity_ratio: 0.399197316713021,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2i",
            },
            BK34S_16: {
                ref: "BK34S_16",
                area: 0,
                type: "BK34S",
                max_shear: 0.0143219673519669,
                max_shear_kn: 0.11242744371294,
                max_uplift: 0.0239042728936682,
                max_uplift_kn: -0.187648542215295,
                max_area_capacity: 0.0239241803278689,
                area_m2_roofload: 0.2335,
                max_capacity_ratio: 0.0239042728936682,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3d",
            },
            BK34S_8: {
                ref: "BK34S_8",
                area: 0,
                type: "BK34S",
                max_shear: 0.0369228242951187,
                max_shear_kn: 0.289844170716682,
                max_uplift: 0.061626538188852,
                max_uplift_kn: -0.483768324782488,
                max_area_capacity: 0.0616778606557377,
                area_m2_roofload: 0.60197592,
                max_capacity_ratio: 0.061626538188852,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2e",
            },
            BK34S_18: {
                ref: "BK34S_18",
                area: 0,
                type: "BK34S",
                max_shear: 0.0143219673519669,
                max_shear_kn: 0.11242744371294,
                max_uplift: 0.0239042728936682,
                max_uplift_kn: -0.187648542215295,
                max_area_capacity: 0.0239241803278689,
                area_m2_roofload: 0.2335,
                max_capacity_ratio: 0.0239042728936682,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3f",
            },
            BK34S_13: {
                ref: "BK34S_13",
                area: 0,
                type: "BK34S",
                max_shear: 0.361442861397143,
                max_shear_kn: 2.83732646196757,
                max_uplift: 0.603271085736627,
                max_uplift_kn: -4.73567802303252,
                max_area_capacity: 0.603773488779711,
                area_m2_roofload: 5.89282925048998,
                max_capacity_ratio: 0.603271085736627,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3a",
            },
            BK34S_15: {
                ref: "BK34S_15",
                area: 0,
                type: "BK34S",
                max_shear: 0.0143219673519669,
                max_shear_kn: 0.11242744371294,
                max_uplift: 0.0239042728936682,
                max_uplift_kn: -0.187648542215295,
                max_area_capacity: 0.0239241803278689,
                area_m2_roofload: 0.2335,
                max_capacity_ratio: 0.0239042728936682,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3c",
            },
            BK34S_2: {
                ref: "BK34S_2",
                area: 0,
                type: "BK34S",
                max_shear: 0.0494288035091915,
                max_shear_kn: 0.388016107547154,
                max_uplift: 0.0824998115729505,
                max_uplift_kn: -0.647623520847662,
                max_area_capacity: 0.0732068655885553,
                area_m2_roofload: 0.7144990081443,
                max_capacity_ratio: 0.0824998115729505,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2k",
            },
            BK34S_1: {
                ref: "BK34S_1",
                area: 0,
                type: "BK34S",
                max_shear: 0.323467585011438,
                max_shear_kn: 2.53922054233979,
                max_uplift: 0.539887938182412,
                max_uplift_kn: -4.23812031473193,
                max_area_capacity: 0.530975904182881,
                area_m2_roofload: 5.18232482482492,
                max_capacity_ratio: 0.539887938182412,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2k",
            },
            BK34S_17: {
                ref: "BK34S_17",
                area: 0,
                type: "BK34S",
                max_shear: 0.0143219673519669,
                max_shear_kn: 0.11242744371294,
                max_uplift: 0.0239042728936682,
                max_uplift_kn: -0.187648542215295,
                max_area_capacity: 0.0239241803278689,
                area_m2_roofload: 0.2335,
                max_capacity_ratio: 0.0239042728936682,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3e",
            },
            BK34S_12: {
                ref: "BK34S_12",
                area: 0,
                type: "BK34S",
                max_shear: 0.372702746424661,
                max_shear_kn: 2.92571655943359,
                max_uplift: 0.622064548801752,
                max_uplift_kn: -4.88320670809375,
                max_area_capacity: 0.613220951331373,
                area_m2_roofload: 5.9850364849942,
                max_capacity_ratio: 0.622064548801752,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2a",
            },
            BK34S_4: {
                ref: "BK34S_4",
                area: 0,
                type: "BK34S",
                max_shear: 0.496999951226571,
                max_shear_kn: 3.90144961712858,
                max_uplift: 0.829524475953239,
                max_uplift_kn: -6.51176713623292,
                max_area_capacity: 0.8220512457654,
                area_m2_roofload: 8.02322015867031,
                max_capacity_ratio: 0.829524475953239,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2i",
            },
            BK34S_5: {
                ref: "BK34S_5",
                area: 0,
                type: "BK34S",
                max_shear: 0.0369228242951187,
                max_shear_kn: 0.289844170716682,
                max_uplift: 0.061626538188852,
                max_uplift_kn: -0.483768324782488,
                max_area_capacity: 0.0616778606557377,
                area_m2_roofload: 0.60197592,
                max_capacity_ratio: 0.061626538188852,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2h",
            },
            BK34S_6: {
                ref: "BK34S_6",
                area: 0,
                type: "BK34S",
                max_shear: 0.368086988114255,
                max_shear_kn: 2.8894828566969,
                max_uplift: 0.614360555100914,
                max_uplift_kn: -4.82273035754218,
                max_area_capacity: 0.606708227189577,
                area_m2_roofload: 5.92147229737027,
                max_capacity_ratio: 0.614360555100914,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2f",
            },
            BK34S_7: {
                ref: "BK34S_7",
                area: 0,
                type: "BK34S",
                max_shear: 0.368086988114255,
                max_shear_kn: 2.8894828566969,
                max_uplift: 0.614360555100914,
                max_uplift_kn: -4.82273035754218,
                max_area_capacity: 0.606708227189577,
                area_m2_roofload: 5.92147229737027,
                max_capacity_ratio: 0.614360555100914,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2f",
            },
            BK34S_19: {
                ref: "BK34S_19",
                area: 0,
                type: "BK34S",
                max_shear: 0.0143219673519669,
                max_shear_kn: 0.11242744371294,
                max_uplift: 0.0239042728936682,
                max_uplift_kn: -0.187648542215295,
                max_area_capacity: 0.0239241803278689,
                area_m2_roofload: 0.2335,
                max_capacity_ratio: 0.0239042728936682,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3g",
            },
        },
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {
            EB3: {
                ref: "BK34S_13",
                area: 0,
                type: "BK34S",
                max_shear: 0.361442861397143,
                max_shear_kn: 2.83732646196757,
                max_uplift: 0.603271085736627,
                max_uplift_kn: -4.73567802303252,
                max_area_capacity: 0.603773488779711,
                area_m2_roofload: 5.89282925048998,
                max_capacity_ratio: 0.603271085736627,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3a",
            },
            EB2: {
                ref: "BK34S_9",
                area: 0,
                type: "BK34S",
                max_shear: 0.496999951226571,
                max_shear_kn: 3.90144961712858,
                max_uplift: 0.829524475953238,
                max_uplift_kn: -6.51176713623292,
                max_area_capacity: 0.8220512457654,
                area_m2_roofload: 8.0232201586703,
                max_capacity_ratio: 0.829524475953238,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2c",
            },
        },
        maxResultOverAllText: "",
        AreaMaxResults: {
            0: {
                MaxResult: 0.790053557255535,
                PurlinMax: 0.213338866446758,
                NumRafters: 5,
                NumColumns: 4,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 10,
                ColumnsMax: 0.41539537339148,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.415 - Top Connection",
                RafterMax: 0.790053557255535,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.742964694631435,
                JoinBeamMax: 0,
                OtherMax: 0.790053557255535,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            PC4: {
                ref: "PC4",
                area: 0,
                type: "Column",
                member_size: "1586510",
                embedment: 500,
                height: 2504,
                total_compression_kn: 3.29084953458021,
                total_tension_kn: -5.49263682798459,
                max_strength: 0.112096158672034,
                max_deflection_mm: 50,
                max_deflection: 0.0961439945411197,
                max_capacity_ratio: 0.41539537339148,
                max_capacity_ratio_limit_state: "Top Connection",
            },
            PC2: {
                ref: "PC2",
                area: 0,
                type: "Column",
                member_size: "1586510",
                embedment: 500,
                height: 2504,
                total_compression_kn: 6.0831182641722,
                total_tension_kn: -10.1531106347103,
                max_strength: 0.158082372604832,
                max_deflection_mm: 50,
                max_deflection: 0.0961439945411197,
                max_capacity_ratio: 0.412211221917626,
                max_capacity_ratio_limit_state: "Top Connection",
            },
            PC3: {
                ref: "PC3",
                area: 0,
                type: "Column",
                member_size: "1586510",
                embedment: 500,
                height: 2504,
                total_compression_kn: 6.0831182641722,
                total_tension_kn: -10.1531106347103,
                max_strength: 0.158082372604832,
                max_deflection_mm: 50,
                max_deflection: 0.0961439945411197,
                max_capacity_ratio: 0.41539537339148,
                max_capacity_ratio_limit_state: "Top Connection",
            },
            PC1: {
                ref: "PC1",
                area: 0,
                type: "Column",
                member_size: "1586510",
                embedment: 500,
                height: 2504,
                total_compression_kn: 6.0831182641722,
                total_tension_kn: -10.1531106347103,
                max_strength: 0.158082372604832,
                max_deflection_mm: 50,
                max_deflection: 0.0961439945411197,
                max_capacity_ratio: 0.41539537339148,
                max_capacity_ratio_limit_state: "Top Connection",
            },
        },
        "BeamResults.TestValueChecksum": 489.679904494908,
        BeamPointLoadPeakCalcs: [
            {
                BeamName: "PR1,PR2,",
                BeamType: "Welded Rafter",
                Length: 7846,
                Column: "G",
                PointLoads: [
                    {
                        Name: "P7a",
                        Location: 709,
                    },
                    {
                        Name: "P5a",
                        Location: 1801,
                    },
                    {
                        Name: "P3a",
                        Location: 2892,
                    },
                    {
                        Name: "P1a",
                        Location: 3792,
                    },
                    {
                        Name: "P2d",
                        Location: 4059,
                    },
                    {
                        Name: "P4d",
                        Location: 4959,
                    },
                    {
                        Name: "P6d",
                        Location: 6050,
                    },
                    {
                        Name: "P8d",
                        Location: 7141,
                    },
                ],
            },
            {
                BeamName: "PR3,PR4,",
                BeamType: "Welded Rafter",
                Length: 8284,
                Column: "H",
                PointLoads: [
                    {
                        Name: "P7a",
                        Location: 900,
                    },
                    {
                        Name: "P7b",
                        Location: 900,
                    },
                    {
                        Name: "P5a",
                        Location: 1991,
                    },
                    {
                        Name: "P5b",
                        Location: 1991,
                    },
                    {
                        Name: "P3a",
                        Location: 3082,
                    },
                    {
                        Name: "P3b",
                        Location: 3082,
                    },
                    {
                        Name: "P1a",
                        Location: 3982,
                    },
                    {
                        Name: "P1b",
                        Location: 3982,
                    },
                    {
                        Name: "P2c",
                        Location: 4249,
                    },
                    {
                        Name: "P2d",
                        Location: 4249,
                    },
                    {
                        Name: "P4c",
                        Location: 5149,
                    },
                    {
                        Name: "P4d",
                        Location: 5149,
                    },
                    {
                        Name: "P6c",
                        Location: 6240,
                    },
                    {
                        Name: "P6d",
                        Location: 6240,
                    },
                    {
                        Name: "P8c",
                        Location: 7331,
                    },
                    {
                        Name: "P8d",
                        Location: 7331,
                    },
                ],
            },
            {
                BeamName: "PR5,PR6,",
                BeamType: "Welded Rafter",
                Length: 8284,
                Column: "I",
                PointLoads: [
                    {
                        Name: "P7b",
                        Location: 900,
                    },
                    {
                        Name: "P7c",
                        Location: 900,
                    },
                    {
                        Name: "P5b",
                        Location: 1991,
                    },
                    {
                        Name: "P5c",
                        Location: 1991,
                    },
                    {
                        Name: "P3b",
                        Location: 3082,
                    },
                    {
                        Name: "P3c",
                        Location: 3082,
                    },
                    {
                        Name: "P1b",
                        Location: 3982,
                    },
                    {
                        Name: "P1c",
                        Location: 3982,
                    },
                    {
                        Name: "P2b",
                        Location: 4249,
                    },
                    {
                        Name: "P2c",
                        Location: 4249,
                    },
                    {
                        Name: "P4b",
                        Location: 5149,
                    },
                    {
                        Name: "P4c",
                        Location: 5149,
                    },
                    {
                        Name: "P6b",
                        Location: 6240,
                    },
                    {
                        Name: "P6c",
                        Location: 6240,
                    },
                    {
                        Name: "P8b",
                        Location: 7331,
                    },
                    {
                        Name: "P8c",
                        Location: 7331,
                    },
                ],
            },
            {
                BeamName: "PR7,PR8,",
                BeamType: "Welded Rafter",
                Length: 8284,
                Column: "J",
                PointLoads: [
                    {
                        Name: "P7c",
                        Location: 900,
                    },
                    {
                        Name: "P7d",
                        Location: 900,
                    },
                    {
                        Name: "P5c",
                        Location: 1991,
                    },
                    {
                        Name: "P5d",
                        Location: 1991,
                    },
                    {
                        Name: "P3c",
                        Location: 3082,
                    },
                    {
                        Name: "P3d",
                        Location: 3082,
                    },
                    {
                        Name: "P1c",
                        Location: 3982,
                    },
                    {
                        Name: "P1d",
                        Location: 3982,
                    },
                    {
                        Name: "P2a",
                        Location: 4249,
                    },
                    {
                        Name: "P2b",
                        Location: 4249,
                    },
                    {
                        Name: "P4a",
                        Location: 5149,
                    },
                    {
                        Name: "P4b",
                        Location: 5149,
                    },
                    {
                        Name: "P6a",
                        Location: 6240,
                    },
                    {
                        Name: "P6b",
                        Location: 6240,
                    },
                    {
                        Name: "P8a",
                        Location: 7331,
                    },
                    {
                        Name: "P8b",
                        Location: 7331,
                    },
                ],
            },
            {
                BeamName: "PR9,PR10,",
                BeamType: "Welded Rafter",
                Length: 8284,
                Column: "K",
                PointLoads: [
                    {
                        Name: "P7d",
                        Location: 900,
                    },
                    {
                        Name: "P5d",
                        Location: 1991,
                    },
                    {
                        Name: "P3d",
                        Location: 3082,
                    },
                    {
                        Name: "P1d",
                        Location: 3982,
                    },
                    {
                        Name: "P2a",
                        Location: 4249,
                    },
                    {
                        Name: "P4a",
                        Location: 5149,
                    },
                    {
                        Name: "P6a",
                        Location: 6240,
                    },
                    {
                        Name: "P8a",
                        Location: 7331,
                    },
                ],
            },
            {
                BeamName: "EB3a,",
                BeamType: "Edge Beam",
                Length: 1066.87,
                Column: "N",
                PointLoads: [
                    {
                        Name: "EB1a",
                        Location: 0,
                    },
                    {
                        Name: "PR1",
                        Location: 178,
                    },
                ],
            },
        ],
        ProcessedLoadData: {
            Beams: {
                PR1: {
                    Name: "PR1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3923,
                    PointLoadData: {
                        P7: {
                            Name: "P7",
                            End: 0,
                            Side: 0,
                            Location: 709.95,
                            Bracket: "",
                        },
                        P5: {
                            Name: "P5",
                            End: 0,
                            Side: 0,
                            Location: 1801.15,
                            Bracket: "",
                        },
                        P3: {
                            Name: "P3",
                            End: 0,
                            Side: 0,
                            Location: 2892.35,
                            Bracket: "",
                        },
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 3792.35,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        EB3: {
                            Name: "EB3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK33",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 3928.32,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "158",
                        PARENT_LEN: "3928",
                    },
                },
                PR2: {
                    Name: "PR2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3923,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                        P4: {
                            Name: "P4",
                            End: 0,
                            Side: 0,
                            Location: 1035.97,
                            Bracket: "",
                        },
                        P6: {
                            Name: "P6",
                            End: 0,
                            Side: 0,
                            Location: 2127.17,
                            Bracket: "",
                        },
                        P8: {
                            Name: "P8",
                            End: 0,
                            Side: 0,
                            Location: 3218.37,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        EB3: {
                            Name: "EB3",
                            End: 2,
                            Side: 0,
                            Location: 3928.32,
                            Bracket: "BK33",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "158",
                        PARENT_LEN: "3928",
                    },
                },
                PR3: {
                    Name: "PR3",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4113,
                    PointLoadData: {
                        P7: {
                            Name: "P7",
                            End: 0,
                            Side: 0,
                            Location: 900,
                            Bracket: "",
                        },
                        P5: {
                            Name: "P5",
                            End: 0,
                            Side: 0,
                            Location: 1991.2,
                            Bracket: "",
                        },
                        P3: {
                            Name: "P3",
                            End: 0,
                            Side: 0,
                            Location: 3082.4,
                            Bracket: "",
                        },
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 3982.4,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PC1: {
                            Name: "PC1",
                            End: 1,
                            Side: 0,
                            Location: 84.07,
                            Bracket: "CON3",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 4118.37,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2691",
                        PARENT_LEN: "4118",
                    },
                },
                PR4: {
                    Name: "PR4",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4171,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                        P4: {
                            Name: "P4",
                            End: 0,
                            Side: 0,
                            Location: 1035.97,
                            Bracket: "",
                        },
                        P6: {
                            Name: "P6",
                            End: 0,
                            Side: 0,
                            Location: 2127.17,
                            Bracket: "",
                        },
                        P8: {
                            Name: "P8",
                            End: 0,
                            Side: 0,
                            Location: 3218.37,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR3: {
                            Name: "PR3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 4175.88,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2691",
                        PARENT_LEN: "4176",
                    },
                },
                PR5: {
                    Name: "PR5",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4113,
                    PointLoadData: {
                        P7: {
                            Name: "P7",
                            End: 0,
                            Side: 0,
                            Location: 900,
                            Bracket: "",
                        },
                        P5: {
                            Name: "P5",
                            End: 0,
                            Side: 0,
                            Location: 1991.2,
                            Bracket: "",
                        },
                        P3: {
                            Name: "P3",
                            End: 0,
                            Side: 0,
                            Location: 3082.4,
                            Bracket: "",
                        },
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 3982.4,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PC2: {
                            Name: "PC2",
                            End: 1,
                            Side: 0,
                            Location: 84.07,
                            Bracket: "CON3",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 2,
                            Side: 0,
                            Location: 4118.37,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5225",
                        PARENT_LEN: "4118",
                    },
                },
                PR6: {
                    Name: "PR6",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4171,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                        P4: {
                            Name: "P4",
                            End: 0,
                            Side: 0,
                            Location: 1035.97,
                            Bracket: "",
                        },
                        P6: {
                            Name: "P6",
                            End: 0,
                            Side: 0,
                            Location: 2127.17,
                            Bracket: "",
                        },
                        P8: {
                            Name: "P8",
                            End: 0,
                            Side: 0,
                            Location: 3218.37,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR5: {
                            Name: "PR5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 4175.88,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5225",
                        PARENT_LEN: "4176",
                    },
                },
                PR7: {
                    Name: "PR7",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4113,
                    PointLoadData: {
                        P7: {
                            Name: "P7",
                            End: 0,
                            Side: 0,
                            Location: 900,
                            Bracket: "",
                        },
                        P5: {
                            Name: "P5",
                            End: 0,
                            Side: 0,
                            Location: 1991.2,
                            Bracket: "",
                        },
                        P3: {
                            Name: "P3",
                            End: 0,
                            Side: 0,
                            Location: 3082.4,
                            Bracket: "",
                        },
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 3982.4,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PC3: {
                            Name: "PC3",
                            End: 1,
                            Side: 0,
                            Location: 84.07,
                            Bracket: "CON3",
                        },
                        PR8: {
                            Name: "PR8",
                            End: 2,
                            Side: 0,
                            Location: 4118.37,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "7759",
                        PARENT_LEN: "4118",
                    },
                },
                PR8: {
                    Name: "PR8",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4171,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                        P4: {
                            Name: "P4",
                            End: 0,
                            Side: 0,
                            Location: 1035.97,
                            Bracket: "",
                        },
                        P6: {
                            Name: "P6",
                            End: 0,
                            Side: 0,
                            Location: 2127.17,
                            Bracket: "",
                        },
                        P8: {
                            Name: "P8",
                            End: 0,
                            Side: 0,
                            Location: 3218.37,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR7: {
                            Name: "PR7",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 4175.88,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "7759",
                        PARENT_LEN: "4176",
                    },
                },
                PR9: {
                    Name: "PR9",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4113,
                    PointLoadData: {
                        P7: {
                            Name: "P7",
                            End: 0,
                            Side: 0,
                            Location: 900,
                            Bracket: "",
                        },
                        P5: {
                            Name: "P5",
                            End: 0,
                            Side: 0,
                            Location: 1991.2,
                            Bracket: "",
                        },
                        P3: {
                            Name: "P3",
                            End: 0,
                            Side: 0,
                            Location: 3082.4,
                            Bracket: "",
                        },
                        P1: {
                            Name: "P1",
                            End: 0,
                            Side: 0,
                            Location: 3982.4,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PC4: {
                            Name: "PC4",
                            End: 1,
                            Side: 0,
                            Location: 84.07,
                            Bracket: "CON3",
                        },
                        PR10: {
                            Name: "PR10",
                            End: 2,
                            Side: 0,
                            Location: 4118.37,
                            Bracket: "CON",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10293",
                        PARENT_LEN: "4118",
                    },
                },
                PR10: {
                    Name: "PR10",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4171,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 0,
                            Side: 0,
                            Location: 135.97,
                            Bracket: "",
                        },
                        P4: {
                            Name: "P4",
                            End: 0,
                            Side: 0,
                            Location: 1035.97,
                            Bracket: "",
                        },
                        P6: {
                            Name: "P6",
                            End: 0,
                            Side: 0,
                            Location: 2127.17,
                            Bracket: "",
                        },
                        P8: {
                            Name: "P8",
                            End: 0,
                            Side: 0,
                            Location: 3218.37,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR9: {
                            Name: "PR9",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "CON",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 4175.88,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10293",
                        PARENT_LEN: "4176",
                    },
                },
                U1: {
                    Name: "U1",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 1618,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "158",
                        PARENT_LEN: "1428",
                    },
                },
                IF1: {
                    Name: "IF1",
                    AreaIndex: 0,
                    BeamType: "1086510",
                    Length: 7830,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10293",
                        PARENT_LEN: "7840",
                    },
                },
                U2: {
                    Name: "U2",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 1690,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10293",
                        PARENT_LEN: "1500",
                    },
                },
                EB3: {
                    Name: "EB3",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 7730,
                    PointLoadData: {
                        EB1: {
                            Name: "EB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 178.59,
                            Bracket: "BK33",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 7561.41,
                            Bracket: "BK33",
                        },
                    },
                    NumPointLoads: 3,
                    SupportData: {
                        BK34S_13: {
                            Name: "BK34S_13",
                            End: 0,
                            Side: 0,
                            Location: 132.5,
                            Bracket: "",
                        },
                        BK34S_14: {
                            Name: "BK34S_14",
                            End: 0,
                            Side: 0,
                            Location: 1066.87,
                            Bracket: "",
                        },
                        BK34S_15: {
                            Name: "BK34S_15",
                            End: 0,
                            Side: 0,
                            Location: 2001.25,
                            Bracket: "",
                        },
                        BK34S_16: {
                            Name: "BK34S_16",
                            End: 0,
                            Side: 0,
                            Location: 2935.62,
                            Bracket: "",
                        },
                        BK34S_17: {
                            Name: "BK34S_17",
                            End: 0,
                            Side: 0,
                            Location: 3870,
                            Bracket: "",
                        },
                        BK34S_18: {
                            Name: "BK34S_18",
                            End: 0,
                            Side: 0,
                            Location: 4804.37,
                            Bracket: "",
                        },
                        BK34S_19: {
                            Name: "BK34S_19",
                            End: 0,
                            Side: 0,
                            Location: 5738.75,
                            Bracket: "",
                        },
                        BK34S_20: {
                            Name: "BK34S_20",
                            End: 0,
                            Side: 0,
                            Location: 6673.12,
                            Bracket: "",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 7740,
                            Bracket: "",
                        },
                    },
                    NumSupports: 9,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "158",
                        PARENT_LEN: "7740",
                    },
                },
                U3: {
                    Name: "U3",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 7740,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "158",
                        PARENT_LEN: "7740",
                    },
                },
                EB1: {
                    Name: "EB1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        EB3: {
                            Name: "EB3",
                            End: 1,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "BK",
                        },
                        PC1: {
                            Name: "PC1",
                            End: 0,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "BK21",
                        },
                        PC2: {
                            Name: "PC2",
                            End: 0,
                            Side: 0,
                            Location: 5100,
                            Bracket: "BK21",
                        },
                        PC3: {
                            Name: "PC3",
                            End: 0,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "BK21",
                        },
                        PC4: {
                            Name: "PC4",
                            End: 0,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "BK21",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "125",
                        PARENT_LEN: "10200",
                    },
                },
                U4: {
                    Name: "U4",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "125",
                        PARENT_LEN: "10200",
                    },
                },
                EB2: {
                    Name: "EB2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 10200,
                    PointLoadData: {
                        PR10: {
                            Name: "PR10",
                            End: 2,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "BK3",
                        },
                        PR8: {
                            Name: "PR8",
                            End: 2,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "BK3",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 2,
                            Side: 0,
                            Location: 5100,
                            Bracket: "BK3",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "BK3",
                        },
                        EB3: {
                            Name: "EB3",
                            End: 2,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 5,
                    SupportData: {
                        BK34S_12: {
                            Name: "BK34S_12",
                            End: 0,
                            Side: 0,
                            Location: 132.5,
                            Bracket: "",
                        },
                        BK34S_11: {
                            Name: "BK34S_11",
                            End: 0,
                            Side: 0,
                            Location: 1035.68,
                            Bracket: "",
                        },
                        BK34S_10: {
                            Name: "BK34S_10",
                            End: 0,
                            Side: 0,
                            Location: 1938.86,
                            Bracket: "",
                        },
                        BK34S_9: {
                            Name: "BK34S_9",
                            End: 0,
                            Side: 0,
                            Location: 2842.05,
                            Bracket: "",
                        },
                        BK34S_8: {
                            Name: "BK34S_8",
                            End: 0,
                            Side: 0,
                            Location: 3745.23,
                            Bracket: "",
                        },
                        BK34S_7: {
                            Name: "BK34S_7",
                            End: 0,
                            Side: 0,
                            Location: 4648.41,
                            Bracket: "",
                        },
                        BK34S_6: {
                            Name: "BK34S_6",
                            End: 0,
                            Side: 0,
                            Location: 5551.59,
                            Bracket: "",
                        },
                        BK34S_5: {
                            Name: "BK34S_5",
                            End: 0,
                            Side: 0,
                            Location: 6454.77,
                            Bracket: "",
                        },
                        BK34S_4: {
                            Name: "BK34S_4",
                            End: 0,
                            Side: 0,
                            Location: 7357.95,
                            Bracket: "",
                        },
                        BK34S_3: {
                            Name: "BK34S_3",
                            End: 0,
                            Side: 0,
                            Location: 8261.14,
                            Bracket: "",
                        },
                        BK34S_2: {
                            Name: "BK34S_2",
                            End: 0,
                            Side: 0,
                            Location: 9164.32,
                            Bracket: "",
                        },
                        BK34S_1: {
                            Name: "BK34S_1",
                            End: 0,
                            Side: 0,
                            Location: 10067.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 12,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10325",
                        PARENT_LEN: "10200",
                    },
                },
                U5: {
                    Name: "U5",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10325",
                        PARENT_LEN: "10200",
                    },
                },
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 0,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "",
                        },
                        PR5: {
                            Name: "PR5",
                            End: 0,
                            Side: 0,
                            Location: 5100,
                            Bracket: "",
                        },
                        PR7: {
                            Name: "PR7",
                            End: 0,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "",
                        },
                        PR9: {
                            Name: "PR9",
                            End: 0,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "125",
                        PARENT_LEN: "10200",
                    },
                },
                P2: {
                    Name: "P2",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR10: {
                            Name: "PR10",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR8: {
                            Name: "PR8",
                            End: 0,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 0,
                            Side: 0,
                            Location: 5100,
                            Bracket: "",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 0,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 0,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10325",
                        PARENT_LEN: "10200",
                    },
                },
                P3: {
                    Name: "P3",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 0,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "",
                        },
                        PR5: {
                            Name: "PR5",
                            End: 0,
                            Side: 0,
                            Location: 5100,
                            Bracket: "",
                        },
                        PR7: {
                            Name: "PR7",
                            End: 0,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "",
                        },
                        PR9: {
                            Name: "PR9",
                            End: 0,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "125",
                        PARENT_LEN: "10200",
                    },
                },
                P4: {
                    Name: "P4",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR10: {
                            Name: "PR10",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR8: {
                            Name: "PR8",
                            End: 0,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 0,
                            Side: 0,
                            Location: 5100,
                            Bracket: "",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 0,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 0,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10325",
                        PARENT_LEN: "10200",
                    },
                },
                P5: {
                    Name: "P5",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 0,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "",
                        },
                        PR5: {
                            Name: "PR5",
                            End: 0,
                            Side: 0,
                            Location: 5100,
                            Bracket: "",
                        },
                        PR7: {
                            Name: "PR7",
                            End: 0,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "",
                        },
                        PR9: {
                            Name: "PR9",
                            End: 0,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "125",
                        PARENT_LEN: "10200",
                    },
                },
                P6: {
                    Name: "P6",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR10: {
                            Name: "PR10",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR8: {
                            Name: "PR8",
                            End: 0,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 0,
                            Side: 0,
                            Location: 5100,
                            Bracket: "",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 0,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 0,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10325",
                        PARENT_LEN: "10200",
                    },
                },
                P7: {
                    Name: "P7",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 0,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "",
                        },
                        PR5: {
                            Name: "PR5",
                            End: 0,
                            Side: 0,
                            Location: 5100,
                            Bracket: "",
                        },
                        PR7: {
                            Name: "PR7",
                            End: 0,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "",
                        },
                        PR9: {
                            Name: "PR9",
                            End: 0,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "125",
                        PARENT_LEN: "10200",
                    },
                },
                P8: {
                    Name: "P8",
                    AreaIndex: 0,
                    BeamType: "656510",
                    Length: 10200,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR10: {
                            Name: "PR10",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        PR8: {
                            Name: "PR8",
                            End: 0,
                            Side: 0,
                            Location: 2566.25,
                            Bracket: "",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 0,
                            Side: 0,
                            Location: 5100,
                            Bracket: "",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 0,
                            Side: 0,
                            Location: 7633.75,
                            Bracket: "",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 0,
                            Side: 0,
                            Location: 10167.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10325",
                        PARENT_LEN: "10200",
                    },
                },
            },
            Cols: {
                PC1: {
                    Name: "PC1",
                    AreaIndex: 0,
                    ColumnType: "1586510",
                    Height: 2504,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                PC2: {
                    Name: "PC2",
                    AreaIndex: 0,
                    ColumnType: "1586510",
                    Height: 2504,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                PC3: {
                    Name: "PC3",
                    AreaIndex: 0,
                    ColumnType: "1586510",
                    Height: 2504,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                PC4: {
                    Name: "PC4",
                    AreaIndex: 0,
                    ColumnType: "1586510",
                    Height: 2504,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
            },
        },
    },
    OLLC01364: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.752162371063717,
        BeamResults: {
            "P2,": "0.114297221916423=Bending Moment",
            "R1,": "0.752162371063717=Bending Moment",
            "FB2a,": "0.0591898503122063=Bending Moment",
            "FB2b,": "0.0589178684699296=Bending Moment",
            "P7,": "0.105485625990193=Bending Moment",
            "P6,": "0.105485625990193=Bending Moment",
            "P2,P3,P4,": "0.114297221916423=Bending Moment",
            "R3,": "0.449163193594891=Bending Moment",
            "P8,": "0.105485625990193=Bending Moment",
            "P3,": "0.114297221916423=Bending Moment",
            "FB2,": "0.0591898503122063=Bending Moment",
            "R2,": "0.368205684350325=Bending Moment",
            "FB1,": "0.692413783809702=Deflection-W UP (-55.4mm)",
            "P5,": "0.105485625990193=Bending Moment",
            "P4,": "0.114297221916423=Bending Moment",
            "P5,P6,P7,P8,": "0.105485625990193=Bending Moment",
            "P1,": "0.0827770184037114=Bending Moment",
            ",": "0.752162371063717=Bending Moment",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C2: "0.648=Deflection (32.4mm)",
            C5: "0.351=Deflection (17.6mm)",
            C1: "0.648=Deflection (32.4mm)",
            C4: "0.297=Deflection (14.9mm)",
            C3: "0.379=Deflection (19.0mm)",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "",
        AreaMaxResults: {
            0: {
                MaxResult: 0.752162371063717,
                PurlinMax: 0.114297221916423,
                FasciaMax: 0.692413783809702,
                NumRafters: 3,
                NumColumns: 5,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 10,
                ColumnsMax: 0.6475625412696701,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 4",
                ColumnsMaxText: "Limiting Member = C1 CR=0.648 - Deflection (32.4mm)",
                RafterMax: 0.752162371063717,
                NumFasciaBeams: 4,
                JoinBeamMax: 0,
                OtherMax: 0.752162371063717,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2952,
                total_compression_kn: 5.98750809275717,
                total_tension_kn: -4.57315670561961,
                max_strength: 0.108733993868453,
                max_deflection_mm: 50,
                max_deflection: 0.6475625412696701,
                max_capacity_ratio: 0.6475625412696701,
                max_capacity_ratio_limit_state: "Deflection (32.4mm)",
            },
            C5: {
                ref: "C5",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2421,
                total_compression_kn: 3.15048210417984,
                total_tension_kn: -2.06480565051474,
                max_strength: 0.0524825656331977,
                max_deflection_mm: 50,
                max_deflection: 0.351100800804612,
                max_capacity_ratio: 0.351100800804612,
                max_capacity_ratio_limit_state: "Deflection (17.6mm)",
            },
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2952,
                total_compression_kn: 6.1983966485739,
                total_tension_kn: -4.71051979509712,
                max_strength: 0.11311478220801,
                max_deflection_mm: 50,
                max_deflection: 0.6475625412696701,
                max_capacity_ratio: 0.6475625412696701,
                max_capacity_ratio_limit_state: "Deflection (32.4mm)",
            },
            C4: {
                ref: "C4",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2294,
                total_compression_kn: 5.81967189946798,
                total_tension_kn: -3.81417542611041,
                max_strength: 0.100181091556136,
                max_deflection_mm: 50,
                max_deflection: 0.297452870051428,
                max_capacity_ratio: 0.297452870051428,
                max_capacity_ratio_limit_state: "Deflection (14.9mm)",
            },
            C3: {
                ref: "C3",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2482,
                total_compression_kn: 3.25848855502018,
                total_tension_kn: -2.13559238175543,
                max_strength: 0.0544978669632731,
                max_deflection_mm: 50,
                max_deflection: 0.379069859061082,
                max_capacity_ratio: 0.379069859061082,
                max_capacity_ratio_limit_state: "Deflection (19.0mm)",
            },
        },
        "BeamResults.TestValueChecksum": 23.9615922837998,
        BeamPointLoadPeakCalcs: [
            {
                BeamName: "R1,",
                BeamType: "Rafter",
                Length: 4635,
                Column: "H",
                PointLoads: [
                    {
                        Name: "P1",
                        Location: 594,
                    },
                    {
                        Name: "P5",
                        Location: 594,
                    },
                    {
                        Name: "P2",
                        Location: 1665,
                    },
                    {
                        Name: "P6",
                        Location: 1665,
                    },
                    {
                        Name: "P3",
                        Location: 2736,
                    },
                    {
                        Name: "P7",
                        Location: 2736,
                    },
                    {
                        Name: "P4",
                        Location: 3807,
                    },
                    {
                        Name: "P8",
                        Location: 3807,
                    },
                ],
            },
            {
                BeamName: "R2,",
                BeamType: "Rafter",
                Length: 4341,
                Column: "I",
                PointLoads: [
                    {
                        Name: "P1",
                        Location: 299,
                    },
                    {
                        Name: "P2",
                        Location: 1370,
                    },
                    {
                        Name: "P3",
                        Location: 2441,
                    },
                    {
                        Name: "P4",
                        Location: 3512,
                    },
                ],
            },
            {
                BeamName: "R3,",
                BeamType: "Rafter",
                Length: 4929,
                Column: "J",
                PointLoads: [
                    {
                        Name: "P5",
                        Location: 888,
                    },
                    {
                        Name: "P6",
                        Location: 1959,
                    },
                    {
                        Name: "P7",
                        Location: 3030,
                    },
                    {
                        Name: "P8",
                        Location: 4101,
                    },
                ],
            },
        ],
        ProcessedLoadData: {
            Beams: {
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4228,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 4237.5,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "4270",
                    },
                },
                P2: {
                    Name: "P2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4228,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 4237.5,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "4270",
                    },
                },
                P3: {
                    Name: "P3",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4228,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 4237.5,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "4270",
                    },
                },
                P4: {
                    Name: "P4",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4228,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 4237.5,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "4270",
                    },
                },
                P5: {
                    Name: "P5",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4228,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 4237.5,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "4368",
                        PARENT_LEN: "4270",
                    },
                },
                P6: {
                    Name: "P6",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4228,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 4237.5,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "4368",
                        PARENT_LEN: "4270",
                    },
                },
                P7: {
                    Name: "P7",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4228,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 4237.5,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "4368",
                        PARENT_LEN: "4270",
                    },
                },
                P8: {
                    Name: "P8",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4228,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 4237.5,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "4368",
                        PARENT_LEN: "4270",
                    },
                },
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4635,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 2,
                            Side: 0,
                            Location: 594.42,
                            Bracket: "BK2",
                        },
                        P5: {
                            Name: "P5",
                            End: 1,
                            Side: 0,
                            Location: 594.42,
                            Bracket: "BK2",
                        },
                        P2: {
                            Name: "P2",
                            End: 2,
                            Side: 0,
                            Location: 1665.29,
                            Bracket: "BK2",
                        },
                        P6: {
                            Name: "P6",
                            End: 1,
                            Side: 0,
                            Location: 1665.29,
                            Bracket: "BK2",
                        },
                        P3: {
                            Name: "P3",
                            End: 2,
                            Side: 0,
                            Location: 2736.16,
                            Bracket: "BK2",
                        },
                        P7: {
                            Name: "P7",
                            End: 1,
                            Side: 0,
                            Location: 2736.16,
                            Bracket: "BK2",
                        },
                        P4: {
                            Name: "P4",
                            End: 2,
                            Side: 0,
                            Location: 3807.02,
                            Bracket: "BK2",
                        },
                        P8: {
                            Name: "P8",
                            End: 1,
                            Side: 0,
                            Location: 3807.02,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 8,
                    SupportData: {
                        FB2: {
                            Name: "FB2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK57",
                        },
                        FB1: {
                            Name: "FB1",
                            End: 2,
                            Side: 0,
                            Location: 4679.3,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "3.89",
                        FA_2: "-0.00",
                        X: "4335",
                        PARENT_LEN: "5088",
                    },
                },
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "150mm x 50mm x 5mm",
                    Length: 8530,
                    PointLoadData: {
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK3",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 4270,
                            Bracket: "BK3",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 8540,
                            Bracket: "BK3",
                        },
                    },
                    NumPointLoads: 3,
                    SupportData: {
                        R3: {
                            Name: "R3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 8540,
                            Bracket: "BK2",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 8540,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "8670",
                        PARENT_LEN: "8670",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4341,
                    PointLoadData: {
                        FB2: {
                            Name: "FB2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        P1: {
                            Name: "P1",
                            End: 1,
                            Side: 0,
                            Location: 299.93,
                            Bracket: "BK2",
                        },
                        P2: {
                            Name: "P2",
                            End: 1,
                            Side: 0,
                            Location: 1370.8,
                            Bracket: "BK2",
                        },
                        P3: {
                            Name: "P3",
                            End: 1,
                            Side: 0,
                            Location: 2441.66,
                            Bracket: "BK2",
                        },
                        P4: {
                            Name: "P4",
                            End: 1,
                            Side: 0,
                            Location: 3512.53,
                            Bracket: "BK2",
                        },
                        FB1: {
                            Name: "FB1",
                            End: 2,
                            Side: 0,
                            Location: 4384.81,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 6,
                    SupportData: {
                        FB2: {
                            Name: "FB2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK57",
                        },
                        C3: {
                            Name: "C3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK57",
                        },
                        FB1: {
                            Name: "FB1",
                            End: 2,
                            Side: 0,
                            Location: 4384.81,
                            Bracket: "BK3",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 4384.81,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "3.89",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "5088",
                    },
                },
                R3: {
                    Name: "R3",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4929,
                    PointLoadData: {
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        P5: {
                            Name: "P5",
                            End: 2,
                            Side: 0,
                            Location: 888.73,
                            Bracket: "BK2",
                        },
                        P6: {
                            Name: "P6",
                            End: 2,
                            Side: 0,
                            Location: 1959.6,
                            Bracket: "BK2",
                        },
                        P7: {
                            Name: "P7",
                            End: 2,
                            Side: 0,
                            Location: 3030.47,
                            Bracket: "BK2",
                        },
                        P8: {
                            Name: "P8",
                            End: 2,
                            Side: 0,
                            Location: 4101.33,
                            Bracket: "BK2",
                        },
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 4973.61,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 6,
                    SupportData: {
                        FB2: {
                            Name: "FB2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK57",
                        },
                        C5: {
                            Name: "C5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK57",
                        },
                        FB1: {
                            Name: "FB1",
                            End: 2,
                            Side: 0,
                            Location: 4973.61,
                            Bracket: "BK3",
                        },
                        C1: {
                            Name: "C1",
                            End: 2,
                            Side: 0,
                            Location: 4973.61,
                            Bracket: "BK3",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "3.89",
                        FA_2: "0.00",
                        X: "8638",
                        PARENT_LEN: "5088",
                    },
                },
                FB2: {
                    Name: "FB2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 8546,
                    PointLoadData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK57",
                        },
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 4276.95,
                            Bracket: "BK57",
                        },
                        R3: {
                            Name: "R3",
                            End: 1,
                            Side: 0,
                            Location: 8555.77,
                            Bracket: "BK57",
                        },
                    },
                    NumPointLoads: 3,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C3: {
                            Name: "C3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C4: {
                            Name: "C4",
                            End: 0,
                            Side: 0,
                            Location: 4277.92,
                            Bracket: "BK",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 8555.77,
                            Bracket: "BK2",
                        },
                        C5: {
                            Name: "C5",
                            End: 2,
                            Side: 0,
                            Location: 8555.77,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 5,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2",
                        PARENT_LEN: "8690",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2952,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2952,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C3: {
                    Name: "C3",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2482,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C4: {
                    Name: "C4",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2294,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C5: {
                    Name: "C5",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2421,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
            },
        },
    },
    CVSC00227: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.596806348730482,
        BeamResults: {
            "R1b,": "0.00671368315554681=Deflection (0.1mm)",
            "PA1,": "0.0276135332679859=Vertical Shear",
            "R2,": "0.47759083261829=Bending Moment",
            "FB1,": "0.296300455580168=Bending Moment",
            ",": "0.596806348730482=Bending Moment",
            "P1,": "0.596806348730482=Bending Moment",
            "R1,": "0.300917774380859=Vertical Shear",
            "R1a,": "0.300917774380859=Vertical Shear",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C2: "0.449=Deflection (22.4mm)",
            C1: "0.542=Deflection (27.1mm)",
            C4: "0.446=Deflection (22.3mm)",
            C3: "0.472=Deflection (23.6mm)",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "",
        AreaMaxResults: {
            0: {
                MaxResult: 0.596806348730482,
                PurlinMax: 0.596806348730482,
                FasciaMax: 0.296300455580168,
                NumRafters: 4,
                NumColumns: 4,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 1,
                ColumnsMax: 0.541947686952871,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 4",
                ColumnsMaxText: "Limiting Member = C1 CR=0.542 - Deflection (27.1mm)",
                RafterMax: 0.47759083261829,
                NumFasciaBeams: 1,
                JoinBeamMax: 0,
                OtherMax: 0.596806348730482,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 500,
                height: 2593,
                total_compression_kn: 1.65232500952187,
                total_tension_kn: -0.713951010414031,
                max_strength: 0.258017612343561,
                max_deflection_mm: 50,
                max_deflection: 0.44869530792248,
                max_capacity_ratio: 0.44869530792248,
                max_capacity_ratio_limit_state: "Deflection (22.4mm)",
            },
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 500,
                height: 2751,
                total_compression_kn: 0.322526068570075,
                total_tension_kn: -0.139359878482443,
                max_strength: 0.231098612356031,
                max_deflection_mm: 50,
                max_deflection: 0.541947686952871,
                max_capacity_ratio: 0.541947686952871,
                max_capacity_ratio_limit_state: "Deflection (27.1mm)",
            },
            C4: {
                ref: "C4",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 500,
                height: 2588,
                total_compression_kn: 4.0736333781795,
                total_tension_kn: -1.76017106177505,
                max_strength: 0.336348902337914,
                max_deflection_mm: 50,
                max_deflection: 0.445943144490854,
                max_capacity_ratio: 0.445943144490854,
                max_capacity_ratio_limit_state: "Deflection (22.3mm)",
            },
            C3: {
                ref: "C3",
                area: 0,
                type: "Column",
                member_size: "656510",
                embedment: 500,
                height: 2635,
                total_compression_kn: 4.38951022738071,
                total_tension_kn: -1.896657887523,
                max_strength: 0.355483880987757,
                max_deflection_mm: 50,
                max_deflection: 0.472285843029969,
                max_capacity_ratio: 0.472285843029969,
                max_capacity_ratio_limit_state: "Deflection (23.6mm)",
            },
        },
        "BeamResults.TestValueChecksum": 147.203180131263,
        BeamPointLoadPeakCalcs: [],
        ProcessedLoadData: {
            Beams: {
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 6860,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 6870,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "33",
                        PARENT_LEN: "6935",
                    },
                },
                PA1: {
                    Name: "PA1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 1180,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C2: {
                            Name: "C2",
                            End: 0,
                            Side: 0,
                            Location: 1152.5,
                            Bracket: "BK",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "1250",
                        PARENT_LEN: "1250",
                    },
                },
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3363,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        P1: {
                            Name: "P1",
                            End: 1,
                            Side: 0,
                            Location: 985.03,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK46",
                        },
                        C3: {
                            Name: "C3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK46",
                        },
                        C2: {
                            Name: "C2",
                            End: 0,
                            Side: 0,
                            Location: 3221.39,
                            Bracket: "BK",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "10.99",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "4788",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 4705,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 2,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        P1: {
                            Name: "P1",
                            End: 2,
                            Side: 0,
                            Location: 2333.22,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK46",
                        },
                        C4: {
                            Name: "C4",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK46",
                        },
                        W1: {
                            Name: "W1",
                            End: 2,
                            Side: 0,
                            Location: 4727.18,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Wall",
                        FA_1: "10.99",
                        FA_2: "0.00",
                        X: "6968",
                        PARENT_LEN: "4788",
                    },
                },
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 6978,
                    PointLoadData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK46",
                        },
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 6987.81,
                            Bracket: "BK46",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C3: {
                            Name: "C3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 6987.81,
                            Bracket: "BK2",
                        },
                        C4: {
                            Name: "C4",
                            End: 2,
                            Side: 0,
                            Location: 6987.81,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "6",
                        PARENT_LEN: "7131",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2751,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2593,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                C3: {
                    Name: "C3",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2635,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
                C4: {
                    Name: "C4",
                    AreaIndex: 0,
                    ColumnType: "656510",
                    Height: 2588,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "CON1",
                },
            },
        },
    },
    FTLC01383: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.387344662083303,
        BeamResults: {
            ",": "0.158720742632126=Bending Moment",
            "FB1a,FB1b,FB1c,FB1d,": "0.158720742632126=Bending Moment",
            "FB1,": "0.158720742632126=Bending Moment",
            "R2,": "0.0438650925389323=Bending Moment",
            "R1,": "0.0438650925389323=Bending Moment",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C2: "0.387=Deflection (19.4mm)",
            C5: "0.161=Deflection (8.1mm)",
            C1: "0.161=Deflection (8.1mm)",
            C4: "0.387=Deflection (19.4mm)",
            C3: "0.387=Deflection (19.4mm)",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = C2 CR=0.387 - Deflection (19.4mm)",
        AreaMaxResults: {
            0: {
                MaxResult: 0.387344662083303,
                FasciaMax: 0.158720742632126,
                NumRafters: 2,
                NumColumns: 5,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C2 CR=0.387 - Deflection (19.4mm)",
                NumPurlins: 0,
                ColumnsMax: 0.387344662083303,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C2 CR=0.387 - Deflection (19.4mm)",
                RafterMax: 0.0438650925389323,
                NumFasciaBeams: 2,
                JoinBeamMax: 0,
                OtherMax: 0.158720742632126,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2861,
                total_compression_kn: 3.60647806655675,
                total_tension_kn: -2.14199910356644,
                max_strength: 0.0617412454393867,
                max_deflection_mm: 50,
                max_deflection: 0.387344662083303,
                max_capacity_ratio: 0.387344662083303,
                max_capacity_ratio_limit_state: "Deflection (19.4mm)",
            },
            C5: {
                ref: "C5",
                area: 0,
                type: "Column",
                member_size: "90x90x3.5",
                embedment: 500,
                height: 3019,
                total_compression_kn: 2.26861448983637,
                total_tension_kn: -1.34740045936472,
                max_strength: 0.0170099191156452,
                max_deflection_mm: 50,
                max_deflection: 0.161409380041811,
                max_capacity_ratio: 0.161409380041811,
                max_capacity_ratio_limit_state: "Deflection (8.1mm)",
            },
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "90x90x3.5",
                embedment: 500,
                height: 3019,
                total_compression_kn: 2.26861448983637,
                total_tension_kn: -1.34740045936472,
                max_strength: 0.0170099191156452,
                max_deflection_mm: 50,
                max_deflection: 0.161409380041811,
                max_capacity_ratio: 0.161409380041811,
                max_capacity_ratio_limit_state: "Deflection (8.1mm)",
            },
            C4: {
                ref: "C4",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2861,
                total_compression_kn: 3.60647806655675,
                total_tension_kn: -2.14199910356644,
                max_strength: 0.0617412454393867,
                max_deflection_mm: 50,
                max_deflection: 0.387344662083303,
                max_capacity_ratio: 0.387344662083303,
                max_capacity_ratio_limit_state: "Deflection (19.4mm)",
            },
            C3: {
                ref: "C3",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2861,
                total_compression_kn: 3.60647806655675,
                total_tension_kn: -2.14199910356644,
                max_strength: 0.0617412454393867,
                max_deflection_mm: 50,
                max_deflection: 0.387344662083303,
                max_capacity_ratio: 0.387344662083303,
                max_capacity_ratio_limit_state: "Deflection (19.4mm)",
            },
        },
        "BeamResults.TestValueChecksum": 8.27490465049321,
        BeamPointLoadPeakCalcs: [],
        ProcessedLoadData: {
            Beams: {
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3808,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        W1: {
                            Name: "W1",
                            End: 2,
                            Side: 0,
                            Location: 3830.35,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Wall",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "3902",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 3808,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 2,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C5: {
                            Name: "C5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        W1: {
                            Name: "W1",
                            End: 2,
                            Side: 0,
                            Location: 3830.35,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Wall",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "14438",
                        PARENT_LEN: "3902",
                    },
                },
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 14305,
                    PointLoadData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 14315,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C2: {
                            Name: "C2",
                            End: 0,
                            Side: 0,
                            Location: 3556.25,
                            Bracket: "BK",
                        },
                        C3: {
                            Name: "C3",
                            End: 0,
                            Side: 0,
                            Location: 7157.5,
                            Bracket: "BK",
                        },
                        C4: {
                            Name: "C4",
                            End: 0,
                            Side: 0,
                            Location: 10758.75,
                            Bracket: "BK",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 14315,
                            Bracket: "BK2",
                        },
                        C5: {
                            Name: "C5",
                            End: 2,
                            Side: 0,
                            Location: 14315,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 7,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "14470",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "90mm x 90mm x 3.5mm P/C",
                    Height: 3019,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2861,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C3: {
                    Name: "C3",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2861,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C4: {
                    Name: "C4",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2861,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C5: {
                    Name: "C5",
                    AreaIndex: 0,
                    ColumnType: "90mm x 90mm x 3.5mm P/C",
                    Height: 3019,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
            },
        },
    },
    ZAPC00156: {
        AttachmentBracketResults: {},
        BeamResults: {
            "P2,": "0.608955742735615=Deflection-W UP (-34.3mm)",
            "R1,": "0.196679145170348=Bending Moment",
            "PR1,PR2,": "0.189717978214426=Bending Moment",
            "PA1,": "0.0237771790639529=Vertical Shear",
            "R2,": "0.109833691851207=Bending Moment",
            "PB2,": "0.18615718930963=Vertical Shear",
            "PB1,": "0.184903554305561=Vertical Shear",
            "P3,": "0.573690560314817=Deflection-W UP (-32.3mm)",
            "CB1a,": "0.139363699042845=Vertical Shear",
            "FB1,": "0.151101899333926=Vertical Shear",
            "FB2,": "0.0359180010323579=Vertical Shear",
            "P4,": "0.573679286279516=Deflection-W UP (-32.3mm)",
            ",": "0.608967016770916=Deflection-W UP (-34.3mm)",
            "P5,": "0.10164189313363=Vertical Shear",
            "P1,": "0.608967016770916=Deflection-W UP (-34.3mm)",
            "CB1c,": "0.140660759223092=Vertical Shear",
            "PR3,PR4,": "0.176769311426151=Bending Moment",
            "CB1,": "0.140660759223092=Vertical Shear",
            "CB1b,": "0.0109128384382936=Vertical Shear",
        },
        ColumnResults: {
            C2: "0.390=Deflection (19.5mm)",
            C1: "0.390=Deflection (19.5mm)",
            C4: "0.767=Deflection (38.3mm)",
            C3: "0.884=Deflection (44.2mm)",
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = C3 CR=0.884 - Deflection (44.2mm)",
        MaxResultOverAll: 0.88375321641488,
        AreaMaxResults: {
            0: {
                MaxResult: 0.608967016770916,
                PurlinMax: 0.608967016770916,
                FasciaMax: 0.140660759223092,
                NumRafters: 2,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 4,
                ColumnsMax: 0.389517103336075,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 4",
                ColumnsMaxText: "Limiting Member = C1 CR=0.390 - Deflection (19.5mm)",
                RafterMax: 0.189717978214426,
                NumFasciaBeams: 5,
                EdgeBeamMax: 0.18615718930963,
                JoinBeamMax: 0,
                OtherMax: 0.608967016770916,
                AttachmentBracketsMax: -1,
            },
            1: {
                MaxResult: 0.88375321641488,
                PurlinMax: 0.10164189313363,
                FasciaMax: 0.151101899333926,
                NumRafters: 2,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C3 CR=0.884 - Deflection (44.2mm)",
                NumPurlins: 1,
                ColumnsMax: 0.88375321641488,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 4",
                ColumnsMaxText: "Limiting Member = C3 CR=0.884 - Deflection (44.2mm)",
                RafterMax: 0.196679145170348,
                NumFasciaBeams: 1,
                JoinBeamMax: 0,
                OtherMax: 0.0237771790639529,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 39.7352865520077,
    },
    OLCC00019: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 1.1822164660377,
        BeamResults: {
            ",": "0.319778002690217=Bending Moment",
            "FB2a,FB2b,FB2c,FB2d,FB2e,FB2f,FB2g,FB2h,": "0.212361525813368=Bending Moment",
            "FB1,": "0.319778002690217=Bending Moment",
            "FB2,": "0.212361525813368=Bending Moment",
            "R2,": "0.018827140902226=Vertical Shear",
            "R1,": "0.018827140902226=Vertical Shear",
            "FB1a,FB1b,FB1c,FB1d,FB1e,FB1f,": "0.319778002690217=Bending Moment",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C1: "0.141=Deflection (7.0mm)",
            C4: "0.402=Deflection (20.1mm)",
            C2: "0.155=Deflection (7.8mm)",
            C5: "0.501=Deflection (25.1mm)",
            C8: "0.112=Deflection (5.6mm)",
            C9: "0.124=Deflection (6.2mm)",
            C6: "0.549=Deflection (27.5mm)",
            C13: "0.124=Deflection (6.2mm)",
            C11: "0.112=Deflection (5.6mm)",
            C10: "0.124=Deflection (6.2mm)",
            C3: "1.182=Deflection (59.1mm)",
            C12: "0.112=Deflection (5.6mm)",
            C15: "0.124=Deflection (6.2mm)",
            C14: "0.124=Deflection (6.2mm)",
            C16: "0.124=Deflection (6.2mm)",
            C7: "0.124=Deflection (6.2mm)",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = C3 CR=1.182 - Deflection (59.1mm)",
        AreaMaxResults: {
            0: {
                MaxResult: 0.319778002690217,
                FasciaMax: 0.319778002690217,
                NumRafters: 1,
                NumColumns: 12,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 0,
                ColumnsMax: 0.155038849495345,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C2 CR=0.155 - Deflection (7.8mm)",
                RafterMax: 0.018827140902226,
                NumFasciaBeams: 2,
                JoinBeamMax: 0,
                OtherMax: 0.319778002690217,
                AttachmentBracketsMax: -1,
            },
            1: {
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                JoinBeamMax: 0,
                NumRafters: 0,
                NumFasciaBeams: 0,
                AttachmentBracketsMaxText: "",
                ColumnsMaxText: "Limiting Member = C3 CR=1.182 - Deflection (59.1mm)",
                NumColumns: 1,
                MaxResult: 1.1822164660377,
                ColumnsMax: 1.1822164660377,
                MaxResultText: "Limiting Member = C3 CR=1.182 - Deflection (59.1mm)",
                NumPurlins: 0,
                AttachmentBracketsMax: -1,
            },
            2: {
                MaxResult: 0.549485142395164,
                FasciaMax: 0.212361525813368,
                NumRafters: 1,
                NumColumns: 3,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C6 CR=0.549 - Deflection (27.5mm)",
                NumPurlins: 0,
                ColumnsMax: 0.549485142395164,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C6 CR=0.549 - Deflection (27.5mm)",
                RafterMax: 0.018827140902226,
                NumFasciaBeams: 2,
                JoinBeamMax: 0,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2275,
                total_compression_kn: 2.08816294481027,
                total_tension_kn: -0.999699835732297,
                max_strength: 0.0341138762974948,
                max_deflection_mm: 50,
                max_deflection: 0.140881143635549,
                max_capacity_ratio: 0.140881143635549,
                max_capacity_ratio_limit_state: "Deflection (7.0mm)",
            },
            C4: {
                ref: "C4",
                area: 2,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2117,
                total_compression_kn: 3.73652387814454,
                total_tension_kn: -1.78884618007159,
                max_strength: 0.0620522299579341,
                max_deflection_mm: 50,
                max_deflection: 0.402492117787144,
                max_capacity_ratio: 0.402492117787144,
                max_capacity_ratio_limit_state: "Deflection (20.1mm)",
            },
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2345,
                total_compression_kn: 1.88128862054436,
                total_tension_kn: -0.900659562797729,
                max_strength: 0.0306918258563354,
                max_deflection_mm: 50,
                max_deflection: 0.155038849495345,
                max_capacity_ratio: 0.155038849495345,
                max_capacity_ratio_limit_state: "Deflection (7.8mm)",
            },
            C5: {
                ref: "C5",
                area: 2,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2275,
                total_compression_kn: 2.08816294481027,
                total_tension_kn: -0.999699835732297,
                max_strength: 0.0341138762974948,
                max_deflection_mm: 50,
                max_deflection: 0.501047830321121,
                max_capacity_ratio: 0.501047830321121,
                max_capacity_ratio_limit_state: "Deflection (25.1mm)",
            },
            C8: {
                ref: "C8",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2117,
                total_compression_kn: 3.73652387814454,
                total_tension_kn: -1.78884618007159,
                max_strength: 0.0620522299579341,
                max_deflection_mm: 50,
                max_deflection: 0.112275743759339,
                max_capacity_ratio: 0.112275743759339,
                max_capacity_ratio_limit_state: "Deflection (5.6mm)",
            },
            C9: {
                ref: "C9",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2187,
                total_compression_kn: 3.32277522961272,
                total_tension_kn: -1.59076563420246,
                max_strength: 0.0550339575535693,
                max_deflection_mm: 50,
                max_deflection: 0.124393100539053,
                max_capacity_ratio: 0.124393100539053,
                max_capacity_ratio_limit_state: "Deflection (6.2mm)",
            },
            C6: {
                ref: "C6",
                area: 2,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2345,
                total_compression_kn: 1.88128862054436,
                total_tension_kn: -0.900659562797729,
                max_strength: 0.0306918258563354,
                max_deflection_mm: 50,
                max_deflection: 0.549485142395164,
                max_capacity_ratio: 0.549485142395164,
                max_capacity_ratio_limit_state: "Deflection (27.5mm)",
            },
            C13: {
                ref: "C13",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2187,
                total_compression_kn: 3.32277522961272,
                total_tension_kn: -1.59076563420246,
                max_strength: 0.0550339575535693,
                max_deflection_mm: 50,
                max_deflection: 0.124393100539053,
                max_capacity_ratio: 0.124393100539053,
                max_capacity_ratio_limit_state: "Deflection (6.2mm)",
            },
            C11: {
                ref: "C11",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2117,
                total_compression_kn: 3.73652387814454,
                total_tension_kn: -1.78884618007159,
                max_strength: 0.0620522299579341,
                max_deflection_mm: 50,
                max_deflection: 0.112275743759339,
                max_capacity_ratio: 0.112275743759339,
                max_capacity_ratio_limit_state: "Deflection (5.6mm)",
            },
            C10: {
                ref: "C10",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2187,
                total_compression_kn: 3.32277522961272,
                total_tension_kn: -1.59076563420246,
                max_strength: 0.0550339575535693,
                max_deflection_mm: 50,
                max_deflection: 0.124393100539053,
                max_capacity_ratio: 0.124393100539053,
                max_capacity_ratio_limit_state: "Deflection (6.2mm)",
            },
            C3: {
                ref: "C3",
                area: 1,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2117,
                total_compression_kn: 3.73652387814454,
                total_tension_kn: -1.78884618007159,
                max_strength: 0.0620522299579341,
                max_deflection_mm: 50,
                max_deflection: 1.1822164660377,
                max_capacity_ratio: 1.1822164660377,
                max_capacity_ratio_limit_state: "Deflection (59.1mm)",
            },
            C12: {
                ref: "C12",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2117,
                total_compression_kn: 3.73652387814454,
                total_tension_kn: -1.78884618007159,
                max_strength: 0.0620522299579341,
                max_deflection_mm: 50,
                max_deflection: 0.112275743759339,
                max_capacity_ratio: 0.112275743759339,
                max_capacity_ratio_limit_state: "Deflection (5.6mm)",
            },
            C15: {
                ref: "C15",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2187,
                total_compression_kn: 3.32277522961272,
                total_tension_kn: -1.59076563420246,
                max_strength: 0.0550339575535693,
                max_deflection_mm: 50,
                max_deflection: 0.124393100539053,
                max_capacity_ratio: 0.124393100539053,
                max_capacity_ratio_limit_state: "Deflection (6.2mm)",
            },
            C14: {
                ref: "C14",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2187,
                total_compression_kn: 3.32277522961272,
                total_tension_kn: -1.59076563420246,
                max_strength: 0.0550339575535693,
                max_deflection_mm: 50,
                max_deflection: 0.124393100539053,
                max_capacity_ratio: 0.124393100539053,
                max_capacity_ratio_limit_state: "Deflection (6.2mm)",
            },
            C16: {
                ref: "C16",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2187,
                total_compression_kn: 3.32277522961272,
                total_tension_kn: -1.59076563420246,
                max_strength: 0.0550339575535693,
                max_deflection_mm: 50,
                max_deflection: 0.124393100539053,
                max_capacity_ratio: 0.124393100539053,
                max_capacity_ratio_limit_state: "Deflection (6.2mm)",
            },
            C7: {
                ref: "C7",
                area: 0,
                type: "Column",
                member_size: "65x65x3.0",
                embedment: 500,
                height: 2187,
                total_compression_kn: 3.32277522961272,
                total_tension_kn: -1.59076563420246,
                max_strength: 0.0550339575535693,
                max_deflection_mm: 50,
                max_deflection: 0.124393100539053,
                max_capacity_ratio: 0.124393100539053,
                max_capacity_ratio_limit_state: "Deflection (6.2mm)",
            },
        },
        "BeamResults.TestValueChecksum": 3.39993234192468,
        BeamPointLoadPeakCalcs: [],
        ProcessedLoadData: {
            Beams: {
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 1855,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 1876.66,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 1876.66,
                            Bracket: "BK2",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 1876.66,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "33",
                        PARENT_LEN: "2001",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 2,
                    BeamType: "1586510",
                    Length: 1855,
                    PointLoadData: {
                        FB1: {
                            Name: "FB1",
                            End: 2,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 1,
                            Side: 0,
                            Location: 1876.66,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C5: {
                            Name: "C5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 1876.66,
                            Bracket: "BK2",
                        },
                        C6: {
                            Name: "C6",
                            End: 2,
                            Side: 0,
                            Location: 1876.66,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "13896",
                        PARENT_LEN: "2001",
                    },
                },
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "1586510",
                    Length: 41694,
                    PointLoadData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 41704,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C8: {
                            Name: "C8",
                            End: 0,
                            Side: 0,
                            Location: 6915.25,
                            Bracket: "BK",
                        },
                        C3: {
                            Name: "C3",
                            End: 0,
                            Side: 0,
                            Location: 13895.5,
                            Bracket: "IBLC ",
                        },
                        C11: {
                            Name: "C11",
                            End: 0,
                            Side: 0,
                            Location: 20884.5,
                            Bracket: "BK",
                        },
                        C4: {
                            Name: "C4",
                            End: 0,
                            Side: 0,
                            Location: 27873.5,
                            Bracket: "IBLC ",
                        },
                        C12: {
                            Name: "C12",
                            End: 0,
                            Side: 0,
                            Location: 34821.25,
                            Bracket: "BK",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 41704,
                            Bracket: "BK2",
                        },
                        C5: {
                            Name: "C5",
                            End: 2,
                            Side: 0,
                            Location: 41704,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 9,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "13928",
                    },
                },
                FB2: {
                    Name: "FB2",
                    AreaIndex: 2,
                    BeamType: "1586510",
                    Length: 41694,
                    PointLoadData: {
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 41704,
                            Bracket: "BK2",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C6: {
                            Name: "C6",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "BK2",
                        },
                        C13: {
                            Name: "C13",
                            End: 0,
                            Side: 0,
                            Location: 5164.25,
                            Bracket: "BK",
                        },
                        C9: {
                            Name: "C9",
                            End: 0,
                            Side: 0,
                            Location: 10393.5,
                            Bracket: "BK",
                        },
                        C14: {
                            Name: "C14",
                            End: 0,
                            Side: 0,
                            Location: 15622.75,
                            Bracket: "BK",
                        },
                        C7: {
                            Name: "C7",
                            End: 0,
                            Side: 0,
                            Location: 20852,
                            Bracket: "BK",
                        },
                        C15: {
                            Name: "C15",
                            End: 0,
                            Side: 0,
                            Location: 26081.25,
                            Bracket: "BK",
                        },
                        C10: {
                            Name: "C10",
                            End: 0,
                            Side: 0,
                            Location: 31310.5,
                            Bracket: "BK",
                        },
                        C16: {
                            Name: "C16",
                            End: 0,
                            Side: 0,
                            Location: 36539.75,
                            Bracket: "BK",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 41704,
                            Bracket: "BK2",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 41704,
                            Bracket: "BK2",
                        },
                    },
                    NumSupports: 11,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "13928",
                        PARENT_LEN: "13928",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2275,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2345,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C3: {
                    Name: "C3",
                    AreaIndex: 1,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2117,
                    TopBracket: "IBLC ",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C4: {
                    Name: "C4",
                    AreaIndex: 2,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2117,
                    TopBracket: "IBLC ",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C5: {
                    Name: "C5",
                    AreaIndex: 2,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2275,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C6: {
                    Name: "C6",
                    AreaIndex: 2,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2345,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C7: {
                    Name: "C7",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2187,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C8: {
                    Name: "C8",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2117,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C9: {
                    Name: "C9",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2187,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C10: {
                    Name: "C10",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2187,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C11: {
                    Name: "C11",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2117,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C12: {
                    Name: "C12",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2117,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C13: {
                    Name: "C13",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2187,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C14: {
                    Name: "C14",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2187,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C15: {
                    Name: "C15",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2187,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C16: {
                    Name: "C16",
                    AreaIndex: 0,
                    ColumnType: "65mm x 65mm x 3mm P/C",
                    Height: 2187,
                    TopBracket: "BK",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
            },
        },
    },
    BIGC00286: {
        AttachmentBracketResults: {
            BK34D_1: "0.503=Uplift",
            BK34D_8: "0.508=Uplift",
            BK34D_7: "0.034=Uplift",
            BK34D_6: "0.036=Uplift",
            BK34D_5: "0.113=Uplift",
            BK34D_4: "0.113=Uplift",
            BK34D_3: "0.036=Uplift",
            BK34D_2: "0.039=Uplift",
        },
        BeamResults: {
            "EB3g,": "0.341252496404056=Vertical Shear",
            "EB1,": "0.525624007833364=Bending Moment",
            "P5a,P5b,P5c,P5d,P6a,P6b,P6c,P6d,": "0.0319074541102704=Bending Moment",
            "EB3a,": "0.338135872978319=Vertical Shear",
            "P2,": "0.0247999513933381=Bending Moment",
            "P3,": "0.038451817438406=Bending Moment",
            "EB2b,": "0.401949632426516=Bending Moment",
            "PR1,PR2,": "0.609188659447446=Deflection-W UP (-48.7mm)",
            "PO1,PO2,": "0.251395210132181=Bending Moment",
            "P7a,P7b,P9a,P9b,": "0.0232043042829216=Bending Moment",
            "P9,": "0.0232043042829216=Bending Moment",
            "EB1b,": "0.525624007833364=Bending Moment",
            "EB3b,EB3c,EB3e,EB3f,": "0.0122075652805063=Vertical Shear",
            ",": "0.762183681102281=Deflection-W UP (-61.0mm)",
            "HR3,": "0.258142539821897=Vertical Shear",
            "EB2,": "0.526011549419634=Bending Moment",
            "HR1,": "0.16772700425012=Bending Moment",
            "EB3,": "0.341252496404056=Vertical Shear",
            "P3b,P3c,P4b,P4c,": "0.038451817438406=Bending Moment",
            "HR4,": "0.258258314685479=Vertical Shear",
            "EB2a,": "0.526011549419634=Bending Moment",
            "P5,": "0.0319074541102704=Bending Moment",
            "P8,": "0.0814279312179728=Deflection-W UP (-2.3mm)",
            "EB1a,": "0.401992718417=Bending Moment",
            "EB3d,": "0.103715239920421=Vertical Shear",
            "P8a,P8b,P10a,P10b,": "0.0814279312179728=Deflection-W UP (-2.3mm)",
            "JR1,": "0.244651414572905=Bending Moment",
            "JR2,": "0.244651414572905=Bending Moment",
            "P10,": "0.0814279312179728=Deflection-W UP (-2.3mm)",
            "P1a,P1b,P2a,P2b,": "0.0247999513933381=Bending Moment",
            "P3a,": "0.031013587919997=Vertical Shear",
            "P3d,": "0.0311048235716189=Vertical Shear",
            "PR3,PR4,": "0.762183681102281=Deflection-W UP (-61.0mm)",
            "HR2,": "0.167857447577813=Bending Moment",
            "P4a,": "0.031013587919997=Vertical Shear",
            "P4,": "0.038451817438406=Bending Moment",
            "HB1,": "0.373501031345328=Bending Moment",
            "P4d,": "0.0311048235716189=Vertical Shear",
            "P1,": "0.0247999513933381=Bending Moment",
            "P6,": "0.0319074541102704=Bending Moment",
            "P7,": "0.0232043042829216=Bending Moment",
        },
        ColumnResults: {
            PC4: "0.489=Deflection (24.5mm)",
            PC2: "0.326=Strength",
            PC3: "0.489=Deflection (24.5mm)",
            PC1: "0.326=Strength",
        },
        BeamAttachmentBracketResults: {
            EB3: {
                ref: "BK34D_8",
                area: 0,
                type: "BK34D",
                max_shear: 0.476885378758326,
                max_shear_kn: 3.74355022325286,
                max_uplift: 0.507748937324761,
                max_uplift_kn: -3.98582915799937,
                max_area_capacity: 0.743690554218798,
                area_m2_roofload: 7.25841980917547,
                max_capacity_ratio: 0.507748937324761,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3g",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.762183681102281,
        AreaMaxResults: {
            0: {
                MaxResult: 0.762183681102281,
                PurlinMax: 0.0814279312179728,
                NumColumns: 4,
                NumRafters: 3,
                HipRafterMax: 0.258258314685479,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 19,
                ColumnsMax: 0.489165699384517,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC3 CR=0.489 - Deflection (24.5mm)",
                RafterMax: 0.762183681102281,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.526011549419634,
                JoinBeamMax: 0,
                OtherMax: 0.762183681102281,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 193.761334177747,
    },
    FTNC00118: {
        AttachmentBracketResults: {
            BK34S_2: "0.335=Uplift",
            BK34S_3: "0.293=Uplift",
            BK34S_4: "0.455=Uplift",
            BK34S_5: "0.602=Uplift",
            BK34S_6: "0.090=Uplift",
            BK34S_7: "0.382=Uplift",
            BK34S_8: "0.278=Uplift",
            BK34S_9: "0.268=Uplift",
            BK34S_1: "0.237=Uplift",
        },
        BeamResults: {
            "KP1,": "0.0181383551142143=Bending Moment",
            "EB4c,": "0.028338896765278=Vertical Shear",
            "P10c,": "0.037025906412473=Bending Moment",
            "EB3a,": "0.246634287650044=Vertical Shear",
            "P2,": "0.0529736866362429=Bending Moment",
            "P3,": "0.0529736866362429=Bending Moment",
            "PR3,PR4,": "0.193661507384104=Bending Moment",
            "EB4a,": "0.180052105160334=Vertical Shear",
            "EB2b,": "0.252505624255715=Vertical Shear",
            "PR1,PR2,": "0.0855651996150157=Vertical Shear",
            "EB2c,": "0.252505624255715=Vertical Shear",
            "EB2d,": "0.159296893350007=Vertical Shear",
            "P9,": "0.410009423056073=Deflection-W UP (-17.7mm)",
            "PR9,PR10,": "0.281306729186725=Bending Moment",
            "EB1b,": "0.101680258661655=Vertical Shear",
            "RI1,": "0.0574350206752201=Vertical Shear",
            ",": "0.886214753104699=Bending Moment",
            "HR1,": "0.11529652032559=Vertical Shear",
            "EB3,": "0.404896393089073=Bending Moment",
            "EB2,": "0.404710639193032=Vertical Shear",
            "EB1,": "0.886214753104699=Bending Moment",
            "EB2a,": "0.404710639193032=Vertical Shear",
            "P5,": "0.0529736866362429=Bending Moment",
            "EB4b,": "0.322577547900318=Vertical Shear",
            "P8,": "0.0411614104949971=Bending Moment",
            "P5,P6,": "0.0529736866362429=Bending Moment",
            "VR1,": "0.0791620278967358=Bending Moment",
            "VR2,": "0.0761283220985219=Bending Moment",
            "EB3b,": "0.404896393089073=Bending Moment",
            "EB4,": "0.322577547900318=Vertical Shear",
            "EB4d,": "0.188599177682554=Vertical Shear",
            "PR7,PR8,": "0.150027927559794=End 1 (CON3)",
            "EB1a,": "0.886214753104699=Bending Moment",
            "P10a,P10b,": "0.0863602448109876=Bending Moment",
            "PR5,PR6,": "0.193661507384104=Bending Moment",
            "P10,": "0.0863602448109876=Bending Moment",
            "KR1,": "0.0413010920111847=Vertical Shear",
            "P9b,": "0.0828402348693438=Bending Moment",
            "PR13,PR14,": "0.192445794933853=Bending Moment",
            "P9a,": "0.410009423056073=Deflection-W UP (-17.7mm)",
            "P4,": "0.0529736866362429=Bending Moment",
            "P1,P2,": "0.0529736866362429=Bending Moment",
            "P3,P4,": "0.0529736866362429=Bending Moment",
            "PR11,PR12,": "0.10517222158725=End 1 (CON3)",
            "KF1,": "0.182620379936203=Vertical Shear",
            "P1,": "0.0529736866362429=Bending Moment",
            "P6,": "0.0529736866362429=Bending Moment",
            "P7,": "0.0466135056822963=Bending Moment",
        },
        ColumnResults: {
            PC4: "0.103=Strength",
            PC2: "0.317=Deflection (15.8mm)",
            PC3: "0.099=Strength",
            C1: "0.108=Strength",
            PC1: "0.317=Deflection (15.8mm)",
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "BK34S_5",
                area: 0,
                type: "BK34S",
                max_shear: 0.376268852429011,
                max_shear_kn: 2.95371049156774,
                max_uplift: 0.602168186722881,
                max_uplift_kn: -4.72702026577462,
                max_area_capacity: 0.580219383251054,
                area_m2_roofload: 6.2881275659833,
                max_capacity_ratio: 0.602168186722881,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2a",
            },
            EB4: {
                ref: "BK34S_7",
                area: 0,
                type: "BK34S",
                max_shear: 0.241603355360501,
                max_shear_kn: 1.89658633957993,
                max_uplift: 0.381777396160429,
                max_uplift_kn: -2.99695255985937,
                max_area_capacity: 0.25069809162878,
                area_m2_roofload: 2.71694056802691,
                max_capacity_ratio: 0.381777396160429,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB4b",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.886214753104699,
        AreaMaxResults: {
            0: {
                MaxResult: 0.886214753104699,
                PurlinMax: 0.0529736866362429,
                NumColumns: 2,
                NumRafters: 5,
                HipRafterMax: 0.11529652032559,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 11,
                ColumnsMax: 0.316750355463003,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.317 - Deflection (15.8mm)",
                RafterMax: 0.193661507384104,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.886214753104699,
                JoinBeamMax: 0,
                OtherMax: 0.886214753104699,
                AttachmentBracketsMax: -1,
            },
            1: {
                MaxResult: 0.410009423056073,
                PurlinMax: 0.410009423056073,
                NumRafters: 3,
                NumColumns: 3,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 6,
                ColumnsMax: 0.108401527318521,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.108 - Strength",
                RafterMax: 0.281306729186725,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.404896393089073,
                JoinBeamMax: 0,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 152.374505064391,
    },
    DPPC01305: {
        AttachmentBracketResults: {
            BK34D_4: "0.158=Shear",
            BK34D_3: "0.053=Shear",
            BK34D_2: "0.053=Shear",
            BK34D_1: "0.158=Shear",
        },
        BeamResults: {
            ",": "0.499441523681063=Deflection-W UP (-30.3mm)",
            "FB1b,": "0.0166682647246832=Vertical Shear",
            "R2,": "0.0912542959568275=Vertical Shear",
            "FB1,": "0.106483905916764=Vertical Shear",
            "FB2a,FB2b,": "0.0178172195432002=Vertical Shear",
            "FB1a,": "0.106483905916764=Vertical Shear",
            "P2,": "0.499441523681063=Deflection-W UP (-30.3mm)",
            "FB1c,": "0.106483905916764=Vertical Shear",
            "P1,P2,": "0.499441523681063=Deflection-W UP (-30.3mm)",
            "P1,": "0.499441523681063=Deflection-W UP (-30.3mm)",
            "FB2,": "0.0178172195432002=Vertical Shear",
            "R1,": "0.0912542959568275=Vertical Shear",
        },
        ColumnResults: {
            C2: "0.330=Deflection (16.5mm)",
            C1: "0.397=Deflection (19.8mm)",
            C3: "0.397=Deflection (19.8mm)",
        },
        BeamAttachmentBracketResults: {
            FB1: {
                ref: "BK34D_4",
                area: 0,
                type: "BK34D",
                max_shear: 0.158437200141122,
                max_shear_kn: 1.24373202110781,
                max_uplift: 0.127276260439258,
                max_uplift_kn: -0.999118644448175,
                max_area_capacity: 0.206258495612992,
                area_m2_roofload: 2.6798135042518,
                max_capacity_ratio: 0.158437200141122,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "FB1a",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.499441523681063,
        AreaMaxResults: {
            0: {
                MaxResult: 0.499441523681063,
                PurlinMax: 0.499441523681063,
                FasciaMax: 0.106483905916764,
                NumRafters: 2,
                NumColumns: 3,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 3,
                ColumnsMax: 0.39691480918861,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 4",
                ColumnsMaxText: "Limiting Member = C1 CR=0.397 - Deflection (19.8mm)",
                RafterMax: 0.0912542959568275,
                NumFasciaBeams: 6,
                JoinBeamMax: 0,
                OtherMax: 0.499441523681063,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 21.7598434494677,
    },
    FTLC00954: {
        AttachmentBracketResults: {
            BK34D_1: "0.060=Shear",
            BK34D_3: "0.058=Shear",
            BK34D_8: "0.058=Shear",
            BK34D_9: "0.058=Shear",
            BK34D_7: "0.058=Shear",
            BK34D_10: "0.060=Shear",
            BK34D_6: "0.058=Shear",
            BK34D_5: "0.058=Shear",
            BK34D_4: "0.058=Shear",
            BK34D_11: "0.048=Shear",
            BK34D_2: "0.060=Shear",
        },
        BeamResults: {
            ",": "0.0548116897860472=Vertical Shear",
            "FB1,": "0.04038163268387=Vertical Shear",
            "FB1j,": "0.04038163268387=Vertical Shear",
            "FB1b,FB1c,FB1d,FB1e,FB1f,FB1g,FB1h,FB1i,": "0.0194858247435459=Vertical Shear",
            "FB1a,": "0.0322930495869928=Vertical Shear",
            "FB2b,": "0.0542447222193831=Vertical Shear",
            "R2,": "0.0125514272681507=Vertical Shear",
            "FB2a,": "0.0548116897860472=Vertical Shear",
            "FB2,": "0.0548116897860472=Vertical Shear",
            "R1,": "0.0209190454469178=Vertical Shear",
            "FB2c,": "0.0548078530322894=Vertical Shear",
        },
        ColumnResults: {
            C2: "0.086=Deflection (4.3mm)",
            C1: "0.086=Deflection (4.3mm)",
            C4: "0.082=Deflection (4.1mm)",
            C3: "0.084=Deflection (4.2mm)",
        },
        BeamAttachmentBracketResults: {
            FB1: {
                ref: "BK34D_1",
                area: 0,
                type: "BK34D",
                max_shear: 0.0600837541079748,
                max_shear_kn: 0.471657469747602,
                max_uplift: 0.0293411356446444,
                max_uplift_kn: -0.230327914810458,
                max_area_capacity: 0.0688312501916642,
                area_m2_roofload: 0.894290018115197,
                max_capacity_ratio: 0.0600837541079748,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "FB1j",
            },
        },
        maxResultOverAllText: "Limiting Member = C1 CR=0.086 - Deflection (4.3mm)",
        MaxResultOverAll: 0.0858635278750932,
        AreaMaxResults: {
            0: {
                MaxResult: 0.0858635278750932,
                FasciaMax: 0.0548116897860472,
                NumRafters: 2,
                NumColumns: 4,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C1 CR=0.086 - Deflection (4.3mm)",
                NumPurlins: 0,
                ColumnsMax: 0.0858635278750932,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.086 - Deflection (4.3mm)",
                RafterMax: 0.0209190454469178,
                NumFasciaBeams: 8,
                JoinBeamMax: 0,
                OtherMax: 0.0548116897860472,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 0,
    },
    BIGC00504: {
        AttachmentBracketResults: {},
        BeamResults: {
            ",": "0.218252464215864=Bending Moment",
            "R4,": "0.0292866636256849=Vertical Shear",
            "R1,": "0.0313785681703767=Vertical Shear",
            "FB1,": "0.218252464215864=Bending Moment",
            "FB2,": "0.156931978985789=Bending Moment",
            "FB3,": "0.142745658293081=Bending Moment",
            "R2,": "0.0313785681703767=Vertical Shear",
            "R3,": "0.0292866636256849=Vertical Shear",
        },
        ColumnResults: {
            C6: "0.152=Deflection (7.6mm)",
            C2: "0.299=Deflection (15.0mm)",
            C1: "0.299=Deflection (15.0mm)",
            C3: "0.128=Deflection (6.4mm)",
            C4: "0.128=Deflection (6.4mm)",
            C5: "0.152=Deflection (7.6mm)",
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = C1 CR=0.299 - Deflection (15.0mm)",
        MaxResultOverAll: 0.299425847803341,
        AreaMaxResults: {
            0: {
                MaxResult: 0.299425847803341,
                FasciaMax: 0.218252464215864,
                NumRafters: 2,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C1 CR=0.299 - Deflection (15.0mm)",
                NumPurlins: 0,
                ColumnsMax: 0.299425847803341,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.299 - Deflection (15.0mm)",
                RafterMax: 0.0313785681703767,
                NumFasciaBeams: 1,
                JoinBeamMax: 0,
                OtherMax: 0.218252464215864,
                AttachmentBracketsMax: -1,
            },
            1: {
                MaxResult: 0.156931978985789,
                FasciaMax: 0.156931978985789,
                NumRafters: 2,
                NumColumns: 4,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 0,
                ColumnsMax: 0.15228408581878,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C5 CR=0.152 - Deflection (7.6mm)",
                RafterMax: 0.0292866636256849,
                NumFasciaBeams: 2,
                JoinBeamMax: 0,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 87.188834002521,
    },
    OLLC00215: {
        AttachmentBracketResults: {
            BK34S_2: "1.004=Uplift",
            BK34S_3: "0.803=Uplift",
            BK34S_4: "0.059=Uplift",
            BK34S_5: "0.080=Uplift",
            BK34S_6: "0.735=Uplift",
            BK34S_7: "0.170=Uplift",
            BK34S_8: "0.045=Uplift",
            BK34S_9: "0.163=Uplift",
            BK34S_10: "0.835=Uplift",
            BK34S_1: "0.095=Uplift",
        },
        BeamResults: {
            "EB3a,": "0.549006685178466=Vertical Shear",
            "EB1f,": "0.0439379754752651=Vertical Shear",
            "P3,": "0.630496157553633=Deflection-W UP (-33.2mm)",
            "R1,": "0.0401989199550617=Bending Moment",
            "PO1,PO2,": "0.161425248960141=Bending Moment",
            "EB2a,EB2b,": "0.0880709748697254=Bending Moment",
            "EB1d,": "1.13565196033617=Vertical Shear",
            ",": "1.1500627281247=Vertical Shear",
            "P3a,P3b,P4a,P4b,P5a,P5b,P6a,P6b,": "0.630496157553633=Deflection-W UP (-33.2mm)",
            "EB3,": "0.56143430808766=Vertical Shear",
            "EB2,": "0.0880709748697254=Bending Moment",
            "EB1,": "1.13565196033617=Vertical Shear",
            "P5,": "0.630496157553633=Deflection-W UP (-33.2mm)",
            "EB1a,": "0.493855624004176=Vertical Shear",
            "FB1b,": "0.712722079331308=Vertical Shear",
            "FB1,": "0.712722079331308=Vertical Shear",
            "P1a,P1b,P2a,P2b,": "0.448440259133694=Deflection-W UP (-23.6mm)",
            "PR1,PR2,": "0.549639456197954=Vertical Shear",
            "P4,": "0.630496157553633=Deflection-W UP (-33.2mm)",
            "PR3,PR4,": "1.1500627281247=Vertical Shear",
            "FB1a,": "0.139314825974673=Bending Moment",
            "EB1b,EB1c,EB1e,": "0.019667066485904=Vertical Shear",
            "EB3b,EB3c,": "0.0152730006560634=Vertical Shear",
            "P1,": "0.448440259133694=Deflection-W UP (-23.6mm)",
            "P6,": "0.630496157553633=Deflection-W UP (-33.2mm)",
            "P2,": "0.448440259133694=Deflection-W UP (-23.6mm)",
            "EB3d,": "0.56143430808766=Vertical Shear",
        },
        ColumnResults: {
            C2: "0.313=Base Connection",
            PC3: "0.225=Strength",
            C1: "0.341=Base Connection",
            PC2: "0.225=Strength",
            PC1: "0.207=Strength",
        },
        BeamAttachmentBracketResults: {
            EB1: {
                ref: "BK34S_2",
                area: 0,
                type: "BK34S",
                max_shear: 0.695320683094241,
                max_shear_kn: 5.45826736228979,
                max_uplift: 1.00356842966787,
                max_uplift_kn: -7.87801217289276,
                max_area_capacity: 0.549351172928823,
                area_m2_roofload: 6.54551922544692,
                max_capacity_ratio: 1.00356842966787,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB1d",
            },
            EB3: {
                ref: "BK34S_10",
                area: 0,
                type: "BK34S",
                max_shear: 0.58015068125225,
                max_shear_kn: 4.55418284783016,
                max_uplift: 0.835357034199219,
                max_uplift_kn: -6.55755271846387,
                max_area_capacity: 0.552859430534019,
                area_m2_roofload: 6.58732011481283,
                max_capacity_ratio: 0.835357034199219,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3d",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 1.1500627281247,
        AreaMaxResults: {
            0: {
                MaxResult: 0.712722079331308,
                FasciaMax: 0.712722079331308,
                NumRafters: 1,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 0,
                ColumnsMax: 0.341028707378882,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.341 - Base Connection",
                RafterMax: 0.0401989199550617,
                NumFasciaBeams: 3,
                JoinBeamMax: 0,
                AttachmentBracketsMax: -1,
            },
            1: {
                MaxResult: 1.1500627281247,
                PurlinMax: 0.630496157553633,
                NumRafters: 3,
                NumColumns: 3,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 8,
                ColumnsMax: 0.225435498497871,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC2 CR=0.225 - Strength",
                RafterMax: 1.1500627281247,
                NumFasciaBeams: 0,
                EdgeBeamMax: 1.13565196033617,
                JoinBeamMax: 0,
                OtherMax: 1.1500627281247,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 121.7240664944,
    },
    FTLC00957: {
        AttachmentBracketResults: {
            BK34S_10: "0.061=Shear",
            BK34S_14: "0.061=Shear",
            BK34S_13: "0.061=Shear",
            BK34S_11: "0.518=Shear",
            BK34S_8: "0.061=Shear",
            BK34S_9: "0.061=Shear",
            BK34S_12: "0.459=Shear",
            BK34S_15: "0.085=Shear",
            BK34S_1: "0.453=Shear",
            BK34S_2: "0.078=Shear",
            BK34S_3: "0.061=Shear",
            BK34S_4: "0.061=Shear",
            BK34S_5: "0.061=Shear",
            BK34S_6: "0.762=Shear",
            BK34S_7: "0.215=Shear",
        },
        BeamResults: {
            "P2,": "0.606687688820215=Deflection-W UP (-37.2mm)",
            "P5,": "0.606687688820215=Deflection-W UP (-37.2mm)",
            "PR1,PR2,": "0.231103134056322=End 1 (CON3)",
            "P1,P2,": "0.606687688820215=Deflection-W UP (-37.2mm)",
            "P6,": "0.606687688820215=Deflection-W UP (-37.2mm)",
            "EB1e,": "0.574840437815977=Vertical Shear",
            "EB1a,": "0.0364612487695212=Vertical Shear",
            "P3,": "0.606687688820215=Deflection-W UP (-37.2mm)",
            "EB1o,": "0.304461061260993=Vertical Shear",
            "PR5,PR6,": "0.460191625537853=End 1 (CON3)",
            "P5,P6,": "0.606687688820215=Deflection-W UP (-37.2mm)",
            "PO1,PO2,": "0.18515609454445=Bending Moment",
            "P4,": "0.606687688820215=Deflection-W UP (-37.2mm)",
            ",": "0.606687688820215=Deflection-W UP (-37.2mm)",
            "EB1j,": "0.574840437815977=Vertical Shear",
            "EB1,": "0.574840437815977=Vertical Shear",
            "P1,": "0.606687688820215=Deflection-W UP (-37.2mm)",
            "PR3,PR4,": "0.460191625537853=End 1 (CON3)",
            "EB2a,EB2b,EB2c,": "0.157299757562326=Bending Moment",
            "P3,P4,": "0.606687688820215=Deflection-W UP (-37.2mm)",
            "EB1b,EB1c,EB1d,EB1f,EB1g,EB1h,EB1i,EB1k,EB1l,EB1m,EB1n,": "0.0204139651357438=Vertical Shear",
            "EB2,": "0.157299757562326=Bending Moment",
        },
        ColumnResults: {
            PC5: "0.306=Strength",
            PC4: "0.306=Strength",
            PC2: "0.413=Deflection (20.6mm)",
            PC3: "0.413=Deflection (20.6mm)",
            PC1: "0.413=Deflection (20.6mm)",
        },
        BeamAttachmentBracketResults: {
            EB1: {
                ref: "BK34S_6",
                area: 0,
                type: "BK34S",
                max_shear: 0.762199321373497,
                max_shear_kn: 5.98326467278195,
                max_uplift: 0.496904201708555,
                max_uplift_kn: -3.90069798341216,
                max_area_capacity: 0.884562067946661,
                area_m2_roofload: 8.63332578315941,
                max_capacity_ratio: 0.762199321373497,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB1j",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.606687688820215,
        AreaMaxResults: {
            0: {
                MaxResult: 0.606687688820215,
                PurlinMax: 0.606687688820215,
                NumRafters: 4,
                NumColumns: 5,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 9,
                ColumnsMax: 0.412762981939513,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.413 - Deflection (20.6mm)",
                RafterMax: 0.460191625537853,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.574840437815977,
                JoinBeamMax: 0,
                OtherMax: 0.606687688820215,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 343.175472550666,
    },
    RHMC00004: {
        AttachmentBracketResults: {
            BK34D_8: "0.949=Uplift",
            BK34D_7: "0.087=Uplift",
            BK34D_6: "0.054=Uplift",
            BK34D_5: "0.992=Uplift",
            BK34D_4: "0.992=Uplift",
            BK34D_3: "0.054=Uplift",
            BK34D_2: "0.084=Uplift",
            BK34D_1: "0.852=Uplift",
            BK34S_1: "0.937=Uplift",
            BK34S_2: "0.163=Uplift",
            BK34S_3: "0.043=Uplift",
            BK34S_4: "0.043=Uplift",
            BK34S_5: "0.043=Uplift",
            BK34S_6: "0.154=Uplift",
        },
        BeamResults: {
            "P2,": "0.305383731786782=Deflection-W UP (-13.0mm)",
            "P5,": "0.45138582081652=Deflection-W UP (-19.2mm)",
            "EB3,": "0.629544768119247=Vertical Shear",
            "P1a,P1b,P2a,P2b,": "0.305383731786782=Deflection-W UP (-13.0mm)",
            "EB2a,": "0.638094877315478=Vertical Shear",
            "P6,": "0.45138582081652=Deflection-W UP (-19.2mm)",
            "EB3f,": "0.625473616611214=Vertical Shear",
            "P3,": "0.45138582081652=Deflection-W UP (-19.2mm)",
            "P1,": "0.305383731786782=Deflection-W UP (-13.0mm)",
            "EB1a,EB1b,": "0.0665124114328896=Vertical Shear",
            "PR1,PR2,": "0.843258146925965=Bending Moment",
            "EB3a,": "0.629544768119247=Vertical Shear",
            "PR5,PR6,": "0.640174864170743=Vertical Shear",
            "EB2d,": "1.26044003999227=Vertical Shear",
            "EB3b,EB3c,EB3d,EB3e,": "0.0143346701176644=Vertical Shear",
            "P4,": "0.45138582081652=Deflection-W UP (-19.2mm)",
            ",": "1.26758848736188=Vertical Shear",
            "EB2b,EB2c,EB2e,EB2f,": "0.0182567792085585=Vertical Shear",
            "EB2g,": "0.572433031226992=Vertical Shear",
            "P3a,P3b,P4a,P4b,P5a,P5b,P6a,P6b,": "0.45138582081652=Deflection-W UP (-19.2mm)",
            "PR3,PR4,": "1.26758848736188=Vertical Shear",
            "EB2,": "1.26044003999227=Vertical Shear",
            "EB1,": "0.0665124114328896=Vertical Shear",
        },
        ColumnResults: {
            PC1: "0.522=Top Connection",
            PC2: "0.224=Top Connection",
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "BK34D_4",
                area: 0,
                type: "BK34D",
                max_shear: 0.595733537048769,
                max_shear_kn: 4.67650826583283,
                max_uplift: 0.99204380638404,
                max_uplift_kn: -7.78754388011472,
                max_area_capacity: 0.58472166194292,
                area_m2_roofload: 5.7068834205629,
                max_capacity_ratio: 0.99204380638404,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2d",
            },
            EB3: {
                ref: "BK34S_1",
                area: 0,
                type: "BK34S",
                max_shear: 0.553039194554455,
                max_shear_kn: 4.34135767725248,
                max_uplift: 0.936698457532841,
                max_uplift_kn: -7.3530828916328,
                max_area_capacity: 0.654351052420113,
                area_m2_roofload: 6.3864662716203,
                max_capacity_ratio: 0.936698457532841,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3a",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 1.26758848736188,
        AreaMaxResults: {
            0: {
                MaxResult: 1.26758848736188,
                PurlinMax: 0.45138582081652,
                NumRafters: 3,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 8,
                ColumnsMax: 0.521958671010961,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.522 - Top Connection",
                RafterMax: 1.26758848736188,
                NumFasciaBeams: 0,
                EdgeBeamMax: 1.26044003999227,
                JoinBeamMax: 0,
                OtherMax: 1.26758848736188,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 131.181938334769,
    },
    CVSC00208: {
        AttachmentBracketResults: {
            BK34S_10: "0.058=Shear",
            BK34S_14: "0.044=Shear",
            BK34S_13: "0.029=Shear",
            BK34S_11: "0.849=Shear",
            BK34S_8: "0.029=Shear",
            BK34S_9: "0.029=Shear",
            BK34S_12: "0.029=Shear",
            BK34S_1: "0.431=Shear",
            BK34S_2: "0.044=Shear",
            BK34S_3: "0.029=Shear",
            BK34S_4: "0.029=Shear",
            BK34S_5: "0.091=Shear",
            BK34S_6: "0.817=Shear",
            BK34S_7: "0.029=Shear",
        },
        BeamResults: {
            "P2,": "0.285002071111286=Deflection-W UP (-16.2mm)",
            "PR5,PR6,": "0.429188592514278=End 1 (CON3)",
            "EB2,": "0.0646222328537649=Bending Moment",
            "EB1b,EB1c,EB1d,EB1f,EB1g,EB1h,EB1i,EB1k,EB1l,EB1m,": "0.00965961972008604=Vertical Shear",
            "P3,": "0.40498110677117=Deflection-W UP (-23.1mm)",
            "EB1a,": "0.0197006815981955=Vertical Shear",
            "PR1,PR2,": "0.215398268443147=End 1 (CON3)",
            "P1a,P1b,P1c,P2a,P2b,P2c,": "0.285002071111286=Deflection-W UP (-16.2mm)",
            "EB1j,": "0.571296417778155=Vertical Shear",
            "PO1,PO2,": "0.18515609454445=Bending Moment",
            "EB1n,": "0.289867754510192=Vertical Shear",
            "P4,": "0.40498110677117=Deflection-W UP (-23.1mm)",
            ",": "0.571296417778155=Vertical Shear",
            "P3a,P3b,P3c,P4a,P4b,P4c,": "0.40498110677117=Deflection-W UP (-23.1mm)",
            "P1,": "0.285002071111286=Deflection-W UP (-16.2mm)",
            "PR3,PR4,": "0.429188592514278=End 1 (CON3)",
            "EB2a,EB2b,EB2c,": "0.0646222328537649=Bending Moment",
            "EB1,": "0.571296417778155=Vertical Shear",
            "EB1e,": "0.571296417778155=Vertical Shear",
        },
        ColumnResults: {
            PC5: "0.252=Strength",
            PC4: "0.252=Strength",
            PC2: "0.379=Deflection (19.0mm)",
            PC3: "0.379=Deflection (19.0mm)",
            PC1: "0.445=Deflection (22.2mm)",
        },
        BeamAttachmentBracketResults: {
            EB1: {
                ref: "BK34S_11",
                area: 0,
                type: "BK34S",
                max_shear: 0.849434405810433,
                max_shear_kn: 6.6680600856119,
                max_uplift: 0.552621829023524,
                max_uplift_kn: -4.33808135783466,
                max_area_capacity: 0.738932723406566,
                area_m2_roofload: 8.00818338991866,
                max_capacity_ratio: 0.849434405810433,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB1e",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.571296417778155,
        AreaMaxResults: {
            0: {
                MaxResult: 0.571296417778155,
                PurlinMax: 0.40498110677117,
                NumRafters: 4,
                NumColumns: 5,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 6,
                ColumnsMax: 0.444908328777631,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.445 - Deflection (22.2mm)",
                RafterMax: 0.429188592514278,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.571296417778155,
                JoinBeamMax: 0,
                OtherMax: 0.571296417778155,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 274.846300170221,
    },
    BIGC00476: {
        AttachmentBracketResults: {
            BK34S_2: "0.105=Shear",
            BK34S_3: "0.102=Shear",
            BK34S_4: "0.102=Shear",
            BK34S_5: "0.102=Shear",
            BK34S_6: "0.102=Shear",
            BK34S_7: "0.102=Shear",
            BK34S_8: "0.103=Shear",
            BK34S_9: "0.077=Shear",
            BK34S_12: "0.089=Shear",
            BK34S_11: "0.146=Shear",
            BK34S_10: "0.146=Shear",
            BK34S_1: "0.062=Shear",
        },
        BeamResults: {
            "JB1b,": "0.00103058215248288=Vertical Shear",
            "P12,": "0.0551071033527769=Vertical Shear",
            "FB1h,": "0.0450825895322899=Vertical Shear",
            "FB1i,": "0.0509616515872309=Vertical Shear",
            "P3,": "0.0450825895322899=Vertical Shear",
            "FB2c,": "0.0570110212930659=Vertical Shear",
            "FB2b,": "0.0551071033527769=Vertical Shear",
            "JB1a,": "0.0278257181170377=Vertical Shear",
            "P9,": "0.0223766221663283=Vertical Shear",
            "FB2d,": "0.00265910806983632=Vertical Shear",
            ",": "0.71663921569891=Bending Moment",
            "FB1e,": "0.0450825895322899=Vertical Shear",
            "FB1f,": "0.0450825895322899=Vertical Shear",
            "FB1g,": "0.0450825895322899=Vertical Shear",
            "FB2a,": "0.0601501853644949=Vertical Shear",
            "P8,": "0.0450825895322899=Vertical Shear",
            "JB1,": "0.0278257181170377=Vertical Shear",
            "FB4,": "0.202847170209954=Bending Moment",
            "FB2,": "0.0601501853644949=Vertical Shear",
            "FB1b,": "0.050090795540969=Vertical Shear",
            "FB1,": "0.0509616515872309=Vertical Shear",
            "FB1c,": "0.0450825895322899=Vertical Shear",
            "FB3,": "0.71663921569891=Bending Moment",
            "FB1d,": "0.0450825895322899=Vertical Shear",
            "P13,": "0.0265746738304957=Vertical Shear",
            "P10,": "0.0551071033527769=Vertical Shear",
            "P11,": "0.0551071033527769=Vertical Shear",
            "P14,": "0.0279080987319785=Vertical Shear",
            "P15,": "0.0336707678530596=Vertical Shear",
            "P4,": "0.0450825895322899=Vertical Shear",
            "P5,": "0.0450825895322899=Vertical Shear",
            "FB1a,": "0.00302599531612022=Vertical Shear",
            "P1,": "0.0453520537865353=Vertical Shear",
            "P6,": "0.0450825895322899=Vertical Shear",
            "P2,": "0.0450825895322899=Vertical Shear",
            "P7,": "0.0450825895322899=Vertical Shear",
        },
        ColumnResults: {
            C2: "0.271=Deflection (13.6mm)",
            C1: "0.176=Deflection (8.8mm)",
            C4: "0.023=Deflection (1.2mm)",
            C3: "0.203=Deflection (10.2mm)",
        },
        BeamAttachmentBracketResults: {
            FB2: {
                ref: "BK34S_10",
                area: 0,
                type: "BK34S",
                max_shear: 0.146097334104289,
                max_shear_kn: 1.14686407271867,
                max_uplift: 0.0855269450301489,
                max_uplift_kn: -0.671386518486669,
                max_area_capacity: 0.184614142739074,
                area_m2_roofload: 2.39859924953742,
                max_capacity_ratio: 0.146097334104289,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "FB2c",
            },
            FB1: {
                ref: "BK34S_2",
                area: 0,
                type: "BK34S",
                max_shear: 0.104710691823271,
                max_shear_kn: 0.821978930812677,
                max_uplift: 0.0612987611207535,
                max_uplift_kn: -0.481195274797915,
                max_area_capacity: 0.131505244015454,
                area_m2_roofload: 1.70858188287078,
                max_capacity_ratio: 0.104710691823271,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "FB1i",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.71663921569891,
        AreaMaxResults: {
            0: {
                MaxResult: 0.71663921569891,
                PurlinMax: 0.0453520537865353,
                FasciaMax: 0.71663921569891,
                NumRafters: 0,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 10,
                ColumnsMax: 0.271392525189041,
                ColumnsMaxText: "Limiting Member = C2 CR=0.271 - Deflection (13.6mm)",
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 3",
                NumFasciaBeams: 11,
                JoinBeamMax: 0.0278257181170377,
                OtherMax: 0.71663921569891,
                AttachmentBracketsMax: -1,
            },
            1: {
                MaxResult: 0.203442124441331,
                PurlinMax: 0.0551071033527769,
                FasciaMax: 0.202847170209954,
                NumRafters: 0,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C3 CR=0.203 - Deflection (10.2mm)",
                NumPurlins: 5,
                ColumnsMax: 0.203442124441331,
                ColumnsMaxText: "Limiting Member = C3 CR=0.203 - Deflection (10.2mm)",
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 3",
                NumFasciaBeams: 6,
                JoinBeamMax: 0,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 164.013291307906,
    },
    FTLC00189: {
        AttachmentBracketResults: {
            BK34D_1: "0.249=Shear",
            BK34D_9: "0.249=Shear",
            BK34D_8: "0.061=Shear",
            BK34D_7: "0.474=Shear",
            BK34D_6: "0.025=Shear",
            BK34D_5: "0.500=Shear",
            BK34D_4: "0.025=Shear",
            BK34D_3: "0.474=Shear",
            BK34D_2: "0.061=Shear",
        },
        BeamResults: {
            "P2,": "0.039820045763835=Bending Moment",
            "PR5,PR6,": "0.336177304323318=Deflection-W UP (-17.4mm)",
            "EB1b,": "0.319163321223664=Vertical Shear",
            "P6,": "0.039820045763835=Bending Moment",
            "EB2a,EB2b,EB2c,EB2d,": "0.0178036826576412=Vertical Shear",
            "PR7,PR8,": "0.336177304323318=Deflection-W UP (-17.4mm)",
            "P3,": "0.039820045763835=Bending Moment",
            "PR9,PR10,": "0.149629342657004=End 2 (CON3)",
            "EB1a,": "0.167045090852304=Vertical Shear",
            "PR1,PR2,": "0.149629342657004=End 2 (CON3)",
            "EB1g,": "0.319163321223664=Vertical Shear",
            "EB1h,": "0.167045234086205=Vertical Shear",
            "EB1c,EB1d,EB1f,": "0.00851112063591097=Vertical Shear",
            "P5,": "0.039820045763835=Bending Moment",
            "P4,": "0.039820045763835=Bending Moment",
            ",": "0.336177304323318=Deflection-W UP (-17.4mm)",
            "P1a,P1b,P1c,P1d,P2a,P2b,P2c,P2d,P3a,P3b,P3c,P3d,P4a,P4b,P4c,P4d,P5a,P5b,P5c,P5d,P6a,P6b,P6c,P6d,":
                "0.039820045763835=Bending Moment",
            "P1,": "0.039820045763835=Bending Moment",
            "PR3,PR4,": "0.336177304323318=Deflection-W UP (-17.4mm)",
            "EB2,": "0.0178036826576412=Vertical Shear",
            "EB1,": "0.327677925393464=Vertical Shear",
            "EB1e,": "0.327677925393464=Vertical Shear",
        },
        ColumnResults: {
            PC5: "0.288=Deflection (14.4mm)",
            PC4: "0.288=Deflection (14.4mm)",
            PC2: "0.288=Deflection (14.4mm)",
            PC3: "0.288=Deflection (14.4mm)",
            PC1: "0.288=Deflection (14.4mm)",
        },
        BeamAttachmentBracketResults: {
            EB1: {
                ref: "BK34D_5",
                area: 0,
                type: "BK34D",
                max_shear: 0.500215039187655,
                max_shear_kn: 3.9266880576231,
                max_uplift: 0.489423760671273,
                max_uplift_kn: -3.84197652126949,
                max_area_capacity: 0.628811695831341,
                area_m2_roofload: 5.55240727419074,
                max_capacity_ratio: 0.500215039187655,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB1e",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.336177304323318,
        AreaMaxResults: {
            0: {
                MaxResult: 0.336177304323318,
                PurlinMax: 0.039820045763835,
                NumRafters: 5,
                NumColumns: 5,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 7,
                ColumnsMax: 0.288487913355695,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.288 - Deflection (14.4mm)",
                RafterMax: 0.336177304323318,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.327677925393464,
                JoinBeamMax: 0,
                OtherMax: 0.336177304323318,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 189.877608385279,
    },
    RFOINC2081: {
        AttachmentBracketResults: {
            BK34S_4: "0.095=Uplift",
            BK34S_5: "0.771=Uplift",
            BK34S_1: "0.065=Uplift",
            BK34S_2: "0.541=Uplift",
            BK34S_3: "1.087=Uplift",
        },
        BeamResults: {
            "P2,": "0.235666388852338=Deflection-W UP (-9.8mm)",
            "P5,": "0.342966863271844=Deflection-W UP (-14.3mm)",
            "P1a,P1b,P2a,P2b,": "0.235666388852338=Deflection-W UP (-9.8mm)",
            "EB2a,": "0.51836732412243=Vertical Shear",
            "P6,": "0.342966863271844=Deflection-W UP (-14.3mm)",
            "P3,": "0.342966863271844=Deflection-W UP (-14.3mm)",
            "P1,": "0.235666388852338=Deflection-W UP (-9.8mm)",
            "EB1a,EB1b,": "0.0611168159734028=Vertical Shear",
            "EB2b,EB2d,": "0.0253473952563376=Vertical Shear",
            "PR1,PR2,": "1.00195206874651=Vertical Shear",
            "EB2e,": "0.018426949778447=Vertical Shear",
            "PO1,PO2,": "0.182884311043412=Bending Moment",
            "EB2c,": "0.992767464803018=Vertical Shear",
            "P4,": "0.342966863271844=Deflection-W UP (-14.3mm)",
            ",": "1.00195206874651=Vertical Shear",
            "P3a,P3b,P4a,P4b,P5a,P5b,P6a,P6b,": "0.342966863271844=Deflection-W UP (-14.3mm)",
            "PR3,PR4,": "0.505963520693571=Vertical Shear",
            "EB2,": "0.992767464803018=Vertical Shear",
            "EB1,": "0.0611168159734028=Vertical Shear",
        },
        ColumnResults: {
            PC4: "0.189=Deflection (9.5mm)",
            PC2: "0.217=Strength",
            PC3: "0.247=Strength",
            PC1: "0.217=Strength",
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "BK34S_3",
                area: 0,
                type: "BK34S",
                max_shear: 0.763991198085901,
                max_shear_kn: 5.99733090497432,
                max_uplift: 1.08651730657033,
                max_uplift_kn: -8.52916085657709,
                max_area_capacity: 0.619246672686364,
                area_m2_roofload: 7.37832410505803,
                max_capacity_ratio: 1.08651730657033,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2c",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 1.00195206874651,
        AreaMaxResults: {
            0: {
                MaxResult: 1.00195206874651,
                PurlinMax: 0.342966863271844,
                NumRafters: 3,
                NumColumns: 4,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 8,
                ColumnsMax: 0.246999419474575,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC3 CR=0.247 - Strength",
                RafterMax: 1.00195206874651,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.992767464803018,
                JoinBeamMax: 0,
                OtherMax: 1.00195206874651,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 79.8840330239763,
    },
    OLLC00177: {
        AttachmentBracketResults: {
            BK34S_2: "0.047=Shear",
            BK34S_3: "0.727=Shear",
            BK34S_4: "0.199=Shear",
            BK34S_5: "0.047=Shear",
            BK34S_6: "0.771=Shear",
            BK34S_7: "0.155=Shear",
            BK34S_8: "0.059=Shear",
            BK34S_9: "0.436=Shear",
            BK34S_1: "0.042=Shear",
        },
        BeamResults: {
            "P2,": "0.243832195000081=Deflection-W UP (-12.0mm)",
            "PR5,PR6,": "0.235799417036357=End 1 (CON3)",
            "EB2a,": "0.293020849029582=Vertical Shear",
            "EB1a,EB1b,EB1c,": "0.053718070996043=Bending Moment",
            "P3,": "0.357912186474798=Deflection-W UP (-17.6mm)",
            "PR1,PR2,": "0.469526947499107=End 1 (CON3)",
            "EB2b,EB2d,EB2e,EB2g,EB2h,": "0.0159405664995196=Vertical Shear",
            "P1a,P1b,P1c,P2a,P2b,P2c,": "0.243832195000081=Deflection-W UP (-12.0mm)",
            "EB2f,": "0.558511111508899=Vertical Shear",
            "PO1,PO2,": "0.18515609454445=Bending Moment",
            "EB2c,": "0.558511111508899=Vertical Shear",
            "P4,": "0.357912186474798=Deflection-W UP (-17.6mm)",
            ",": "0.558511111508899=Vertical Shear",
            "P3a,P3b,P3c,P4a,P4b,P4c,": "0.357912186474798=Deflection-W UP (-17.6mm)",
            "EB2i,": "0.0125798944555255=Vertical Shear",
            "P1,": "0.243832195000081=Deflection-W UP (-12.0mm)",
            "PR3,PR4,": "0.469526947499107=End 1 (CON3)",
            "EB2,": "0.558511111508899=Vertical Shear",
            "EB1,": "0.053718070996043=Bending Moment",
        },
        ColumnResults: {
            PC5: "0.541=Deflection (27.1mm)",
            PC4: "0.541=Deflection (27.1mm)",
            PC2: "0.307=Strength",
            PC3: "0.541=Deflection (27.1mm)",
            PC1: "0.307=Strength",
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "BK34S_6",
                area: 0,
                type: "BK34S",
                max_shear: 0.77133205365979,
                max_shear_kn: 6.05495662122935,
                max_uplift: 0.635873112630575,
                max_uplift_kn: -4.99160393415001,
                max_area_capacity: 0.8263018499774,
                area_m2_roofload: 7.29624533530045,
                max_capacity_ratio: 0.77133205365979,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB2c",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.558511111508899,
        AreaMaxResults: {
            0: {
                MaxResult: 0.558511111508899,
                PurlinMax: 0.357912186474798,
                NumRafters: 4,
                NumColumns: 5,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 6,
                ColumnsMax: 0.541310695179258,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC3 CR=0.541 - Deflection (27.1mm)",
                RafterMax: 0.469526947499107,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.558511111508899,
                JoinBeamMax: 0,
                OtherMax: 0.558511111508899,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 249.787877506355,
    },
    OLLC00632: {
        AttachmentBracketResults: {
            BK34S_2: "0.057=Uplift",
            BK34S_3: "0.041=Uplift",
            BK34S_4: "0.838=Uplift",
            BK34S_5: "0.041=Uplift",
            BK34S_6: "0.055=Uplift",
            BK34S_7: "0.376=Uplift",
            BK34S_8: "0.090=Uplift",
            BK34S_9: "0.081=Uplift",
            BK34S_10: "0.897=Uplift",
            BK34S_1: "0.410=Uplift",
        },
        BeamResults: {
            "P2,": "0.133544975847495=Deflection-W UP (-4.6mm)",
            "PR5,PR6,": "0.203213082886745=Bending Moment",
            "EB2d,": "0.549861879604363=Vertical Shear",
            "EB3,": "0.603056901096402=Vertical Shear",
            "P1a,P1b,P2a,P2b,": "0.133544975847495=Deflection-W UP (-4.6mm)",
            "EB2a,": "0.25245135115062=Vertical Shear",
            "P3,": "0.189592693209646=Deflection-W UP (-6.5mm)",
            "EB3c,": "0.603056901096402=Vertical Shear",
            "PR1,PR2,": "0.201895522866568=End 1 (CON3)",
            "EB3a,": "0.256870204419104=Vertical Shear",
            "EB3b,": "0.0146650542271961=Vertical Shear",
            "P3a,P3b,P4a,P4b,": "0.189592693209646=Deflection-W UP (-6.5mm)",
            "EB2b,EB2c,EB2e,": "0.0136325889180047=Vertical Shear",
            "P4,": "0.189592693209646=Deflection-W UP (-6.5mm)",
            ",": "0.991749940274788=Bending Moment",
            "EB2f,": "0.275431493341552=Vertical Shear",
            "P1,": "0.133544975847495=Deflection-W UP (-4.6mm)",
            "PR3,PR4,": "0.477304478731292=Bending Moment",
            "EB2,": "0.549861879604363=Vertical Shear",
            "EB1,": "0.991749940274788=Bending Moment",
        },
        ColumnResults: {
            PC1: "0.793=Base Connection",
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "BK34S_4",
                area: 0,
                type: "BK34S",
                max_shear: 0.545523155053822,
                max_shear_kn: 4.2823567671725,
                max_uplift: 0.838422342973409,
                max_uplift_kn: -6.58161539234126,
                max_area_capacity: 0.449130716633626,
                area_m2_roofload: 5.35139248868965,
                max_capacity_ratio: 0.838422342973409,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2d",
            },
            EB3: {
                ref: "BK34S_10",
                area: 0,
                type: "BK34S",
                max_shear: 0.588083383451736,
                max_shear_kn: 4.61645456009613,
                max_uplift: 0.897287210803309,
                max_uplift_kn: -7.04370460480598,
                max_area_capacity: 0.558968156962635,
                area_m2_roofload: 6.66010559020979,
                max_capacity_ratio: 0.897287210803309,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB3c",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.991749940274788,
        AreaMaxResults: {
            0: {
                MaxResult: 0.991749940274788,
                PurlinMax: 0.189592693209646,
                NumRafters: 3,
                NumColumns: 1,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 6,
                ColumnsMax: 0.792896971870795,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.793 - Base Connection",
                RafterMax: 0.477304478731292,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.991749940274788,
                JoinBeamMax: 0,
                OtherMax: 0.991749940274788,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 36.8049853459859,
    },
    FTLC00054: {
        AttachmentBracketResults: {
            BK34S_10: "0.547=Shear",
            BK34S_16: "0.027=Shear",
            BK34S_14: "0.032=Shear",
            BK34S_13: "0.030=Shear",
            BK34S_11: "0.032=Shear",
            BK34S_17: "0.552=Shear",
            BK34S_8: "0.058=Shear",
            BK34S_9: "0.476=Shear",
            BK34S_12: "0.030=Shear",
            BK34S_15: "0.030=Shear",
            BK34S_1: "0.474=Shear",
            BK34S_2: "0.058=Shear",
            BK34S_3: "0.040=Shear",
            BK34S_4: "0.040=Shear",
            BK34S_5: "0.917=Shear",
            BK34S_6: "0.040=Shear",
            BK34S_7: "0.040=Shear",
        },
        BeamResults: {
            "EB2e,": "0.602706555170907=Vertical Shear",
            "EB3a,": "0.36736830582681=Vertical Shear",
            "P2,": "0.221721385842407=Deflection-W UP (-10.2mm)",
            "P3,": "0.221721385842407=Deflection-W UP (-10.2mm)",
            "PR3,PR4,": "0.506810612789899=End 1 (CON3)",
            "EB4a,": "0.0115210017341685=Vertical Shear",
            "EB2b,EB2c,EB2d,EB2f,EB2g,": "0.0135040864916949=Vertical Shear",
            "EB1b,": "0.355847304092642=Vertical Shear",
            ",": "0.602706555170907=Vertical Shear",
            "EB4,": "0.3707327771429=Vertical Shear",
            "EB3,": "0.36736830582681=Vertical Shear",
            "EB2,": "0.602706555170907=Vertical Shear",
            "EB1,": "0.355847304092642=Vertical Shear",
            "EB2a,": "0.320024177719235=Vertical Shear",
            "P5,": "0.388513301848856=Deflection-W UP (-17.9mm)",
            "P8,": "0.388513301848856=Deflection-W UP (-17.9mm)",
            "EB1a,": "0.355847304092642=Vertical Shear",
            "EB4d,": "0.3707327771429=Vertical Shear",
            "EB3b,EB3c,EB3d,EB4b,EB4c,": "0.010041521221268=Vertical Shear",
            "PR5,PR6,": "0.308999116132015=Bending Moment",
            "EB2h,": "0.318590278116966=Vertical Shear",
            "PR1,PR2,": "0.308999116132015=Bending Moment",
            "P4,": "0.221721385842407=Deflection-W UP (-10.2mm)",
            "P1,P2,": "0.221721385842407=Deflection-W UP (-10.2mm)",
            "P3,P4,": "0.221721385842407=Deflection-W UP (-10.2mm)",
            "P1,": "0.221721385842407=Deflection-W UP (-10.2mm)",
            "P6,": "0.388513301848856=Deflection-W UP (-17.9mm)",
            "P7,": "0.388513301848856=Deflection-W UP (-17.9mm)",
        },
        ColumnResults: {
            PC1: "0.351=Top Connection",
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "BK34S_5",
                area: 0,
                type: "BK34S",
                max_shear: 0.916858636257221,
                max_shear_kn: 7.19734029461919,
                max_uplift: 0.894714949713541,
                max_uplift_kn: -7.0235123552513,
                max_area_capacity: 0.946450055552244,
                area_m2_roofload: 8.35715399052632,
                max_capacity_ratio: 0.916858636257221,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB2e",
            },
            EB3: {
                ref: "BK34S_10",
                area: 0,
                type: "BK34S",
                max_shear: 0.546606600262057,
                max_shear_kn: 4.29086181205715,
                max_uplift: 0.528580469827754,
                max_uplift_kn: -4.14935668814787,
                max_area_capacity: 0.599243061631996,
                area_m2_roofload: 5.29131623421053,
                max_capacity_ratio: 0.546606600262057,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB3a",
            },
            EB4: {
                ref: "BK34S_17",
                area: 0,
                type: "BK34S",
                max_shear: 0.551612590704341,
                max_shear_kn: 4.33015883702907,
                max_uplift: 0.533437983281458,
                max_uplift_kn: -4.18748816875944,
                max_area_capacity: 0.604527456721122,
                area_m2_roofload: 5.3379774428475,
                max_capacity_ratio: 0.551612590704341,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB4d",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.602706555170907,
        AreaMaxResults: {
            0: {
                MaxResult: 0.602706555170907,
                PurlinMax: 0.388513301848856,
                NumRafters: 3,
                NumColumns: 1,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 10,
                ColumnsMax: 0.351223132009051,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.351 - Top Connection",
                RafterMax: 0.506810612789899,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.602706555170907,
                JoinBeamMax: 0,
                OtherMax: 0.602706555170907,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 88.2852596191127,
    },
    ZAPC00196: {
        AttachmentBracketResults: {},
        BeamResults: {
            ",": "0.23223361383502=Bending Moment",
            "R2,": "0.0292866636256849=Vertical Shear",
            "FB1,": "0.23223361383502=Bending Moment",
            "R1,": "0.0292866636256849=Vertical Shear",
        },
        ColumnResults: {
            C1: "0.291=Base Connection",
            C2: "0.291=Base Connection",
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = C1 CR=0.291 - Base Connection",
        MaxResultOverAll: 0.290707783322236,
        AreaMaxResults: {
            0: {
                MaxResult: 0.290707783322236,
                FasciaMax: 0.23223361383502,
                NumRafters: 2,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C1 CR=0.291 - Base Connection",
                NumPurlins: 0,
                ColumnsMax: 0.290707783322236,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.291 - Base Connection",
                RafterMax: 0.0292866636256849,
                NumFasciaBeams: 1,
                JoinBeamMax: 0,
                OtherMax: 0.23223361383502,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 19.3329103319602,
    },
    CHRC00095: {
        AttachmentBracketResults: {
            BK34D_1: "0.671=Uplift",
            BK34D_10: "0.512=Uplift",
            BK34D_9: "0.192=Uplift",
            BK34D_8: "0.514=Uplift",
            BK34D_7: "1.660=Uplift",
            BK34D_6: "0.183=Uplift",
            BK34D_5: "0.138=Uplift",
            BK34D_4: "1.343=Uplift",
            BK34D_3: "0.138=Uplift",
            BK34D_2: "0.160=Uplift",
        },
        BeamResults: {
            "EB4b,": "0.345411523491272=Vertical Shear",
            "EB2f,": "0.451261142925457=Vertical Shear",
            "EB3a,": "0.00611343087732029=Vertical Shear",
            "P2,": "0.708742468612818=Deflection-W UP (-34.0mm)",
            "EB2b,EB2c,EB2e,": "0.046475579198142=Vertical Shear",
            "P3,": "0.708742468612818=Deflection-W UP (-34.0mm)",
            "PR3,PR4,": "0.83795310050092=End 1 (CON3)",
            "EB4a,": "0.344076739087234=Vertical Shear",
            "EB2d,": "0.856328925649963=Vertical Shear",
            "PR9,PR10,": "0.252953874096862=End 1 (CON3)",
            "EB1b,": "0.162040983129025=Bending Moment",
            ",": "1.11544946444939=Vertical Shear",
            "EB5,": "0.0696285469079208=Bending Moment",
            "EB4,": "0.345411523491272=Vertical Shear",
            "EB3,": "0.108104529344389=Bending Moment",
            "EB2,": "1.11544946444939=Vertical Shear",
            "EB1,": "0.164695117514634=Bending Moment",
            "EB2a,": "1.11544946444939=Vertical Shear",
            "P5,": "0.392228785319006=Deflection-W UP (-16.4mm)",
            "P5,P6,": "0.392228785319006=Deflection-W UP (-16.4mm)",
            "EB1a,": "0.164695117514634=Bending Moment",
            "EB3b,": "0.108104529344389=Bending Moment",
            "PR7,PR8,": "0.509794600522853=Vertical Shear",
            "PR5,PR6,": "0.724168841642028=Vertical Shear",
            "PR1,PR2,": "0.421272838751338=End 1 (CON3)",
            "P4,": "0.708742468612818=Deflection-W UP (-34.0mm)",
            "P1,P2,": "0.708742468612818=Deflection-W UP (-34.0mm)",
            "P3,P4,": "0.708742468612818=Deflection-W UP (-34.0mm)",
            "HB1,": "0.123264137914224=Vertical Shear",
            "P1,": "0.708742468612818=Deflection-W UP (-34.0mm)",
            "P6,": "0.392228785319006=Deflection-W UP (-16.4mm)",
        },
        ColumnResults: {
            PC4: "0.671=Deflection (33.5mm)",
            PC2: "0.415=Deflection (20.8mm)",
            PC3: "0.280=Deflection (14.0mm)",
            C1: "0.231=Deflection (11.5mm)",
            PC1: "0.415=Deflection (20.8mm)",
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "BK34D_7",
                area: 0,
                type: "BK34D",
                max_shear: 1.1311916775069,
                max_shear_kn: 8.87985466842914,
                max_uplift: 1.65967512672215,
                max_uplift_kn: -13.0284497447689,
                max_area_capacity: 1.1065817279798,
                area_m2_roofload: 11.992579476981,
                max_capacity_ratio: 1.65967512672215,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2a",
            },
            EB4: {
                ref: "BK34D_8",
                area: 0,
                type: "BK34D",
                max_shear: 0.341106726337926,
                max_shear_kn: 2.67768780175272,
                max_uplift: 0.513937145780644,
                max_uplift_kn: -4.03440659437806,
                max_area_capacity: 0.355663841154447,
                area_m2_roofload: 3.85450687851132,
                max_capacity_ratio: 0.513937145780644,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB4b",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 1.11544946444939,
        AreaMaxResults: {
            0: {
                MaxResult: 1.11544946444939,
                PurlinMax: 0.708742468612818,
                NumRafters: 3,
                NumColumns: 4,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 6,
                ColumnsMax: 0.415227115568884,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.415 - Deflection (20.8mm)",
                RafterMax: 0.83795310050092,
                NumFasciaBeams: 0,
                EdgeBeamMax: 1.11544946444939,
                JoinBeamMax: 0,
                OtherMax: 1.11544946444939,
                AttachmentBracketsMax: -1,
            },
            1: {
                MaxResult: 0.670626655501516,
                PurlinMax: 0.392228785319006,
                NumRafters: 2,
                NumColumns: 1,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = PC4 CR=0.671 - Deflection (33.5mm)",
                NumPurlins: 3,
                ColumnsMax: 0.670626655501516,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC4 CR=0.671 - Deflection (33.5mm)",
                RafterMax: 0.509794600522853,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.345411523491272,
                JoinBeamMax: 0,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 347.004670865453,
    },
    FTLC01022: {
        AttachmentBracketResults: {},
        BeamResults: {
            ",": "0.601155802416901=Bending Moment",
            "FB1,": "0.601155802416901=Bending Moment",
            "FB1a,FB1b,FB2a,FB2b,": "0.601155802416901=Bending Moment",
            "R2,": "0.0360435153050394=Vertical Shear",
            "FB2,": "0.601155802416901=Bending Moment",
            "R1,": "0.0360435153050394=Vertical Shear",
        },
        ColumnResults: {
            C6: "0.345=Deflection (17.2mm)",
            C2: "0.358=Deflection (17.9mm)",
            C1: "0.358=Deflection (17.9mm)",
            C3: "0.416=Deflection (20.8mm)",
            C4: "0.416=Deflection (20.8mm)",
            C5: "0.294=Deflection (14.7mm)",
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "",
        MaxResultOverAll: 0.601155802416901,
        AreaMaxResults: {
            0: {
                MaxResult: 0.601155802416901,
                FasciaMax: 0.601155802416901,
                NumRafters: 2,
                NumColumns: 6,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 0,
                ColumnsMax: 0.41644913379072,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C3 CR=0.416 - Deflection (20.8mm)",
                RafterMax: 0.0360435153050394,
                NumFasciaBeams: 3,
                JoinBeamMax: 0,
                OtherMax: 0.601155802416901,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 7.07318863077327,
    },
    FTLC01014: {
        AttachmentBracketResults: {
            BK34S_2: "0.052=Shear",
            BK34S_3: "0.034=Shear",
            BK34S_4: "0.034=Shear",
            BK34S_5: "0.052=Shear",
            BK34S_6: "0.529=Shear",
            BK34S_1: "0.529=Shear",
        },
        BeamResults: {
            "P4,": "0.809556528263548=Deflection-W UP (-51.6mm)",
            "PR1,PR2,": "0.292407880189892=End 1 (CON3)",
            "EB2e,": "0.355675305291517=Vertical Shear",
            "EB1,": "0.0880861000663864=Bending Moment",
            "PR3,PR4,": "0.292407880189892=End 1 (CON3)",
            ",": "0.809556528263548=Deflection-W UP (-51.6mm)",
            "P2,": "0.553539421650422=Deflection-W UP (-35.3mm)",
            "EB2a,": "0.355675305291517=Vertical Shear",
            "P1,": "0.553539421650422=Deflection-W UP (-35.3mm)",
            "EB2,": "0.355675305291517=Vertical Shear",
            "P3,": "0.809556528263548=Deflection-W UP (-51.6mm)",
            "EB2b,EB2c,EB2d,": "0.011327446681708=Vertical Shear",
        },
        ColumnResults: {
            PC1: "0.316=Deflection (15.8mm)",
            PC2: "0.316=Deflection (15.8mm)",
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "BK34S_6",
                area: 0,
                type: "BK34S",
                max_shear: 0.529208607108907,
                max_shear_kn: 4.15428756580492,
                max_uplift: 0.468251573981552,
                max_uplift_kn: -3.67577485575518,
                max_area_capacity: 0.429559869107906,
                area_m2_roofload: 5.1182058404207,
                max_capacity_ratio: 0.529208607108907,
                max_capacity_ratio_limit_state: "Shear",
                max_input_member: "EB2a",
            },
        },
        maxResultOverAllText: "",
        MaxResultOverAll: 0.809556528263548,
        AreaMaxResults: {
            0: {
                MaxResult: 0.809556528263548,
                PurlinMax: 0.809556528263548,
                NumRafters: 2,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 4,
                ColumnsMax: 0.315578405814154,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = PC1 CR=0.316 - Deflection (15.8mm)",
                RafterMax: 0.292407880189892,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.355675305291517,
                JoinBeamMax: 0,
                OtherMax: 0.809556528263548,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 117.243916561775,
    },
};

export const LYSAGHT_ENGLOAD_JOBS = {
    VDPL00040: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 999,
        BeamResults: {
            ",": "16.4931811734441=Vertical Shear",
            "FB1b,": "0.190425048673683=Bending Moment",
            "FB1c,": "16.4931811734441=Vertical Shear",
            "FB1,": "16.4931811734441=Vertical Shear",
            "FB1a,": "16.4931811734441=Vertical Shear",
            "R2,": "9.99=Error: Cantilever Backspan Invalid",
            "P1,": "0.416421798482224=Bending Moment",
            "R1,": "9.99=Error: Cantilever Backspan Invalid",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C1: "999.000=Strength",
            C2: "999.000=Strength",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = C1 CR=999.000 - Strength",
        AreaMaxResults: {
            0: {
                MaxResult: 999,
                PurlinMax: 0.416421798482224,
                FasciaMax: 16.4931811734441,
                NumRafters: 2,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C1 CR=999.000 - Strength",
                NumPurlins: 1,
                ColumnsMax: 999,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 4",
                ColumnsMaxText: "Limiting Member = C1 CR=999.000 - Strength",
                RafterMax: 9.99,
                NumFasciaBeams: 4,
                JoinBeamMax: 0,
                OtherMax: 16.4931811734441,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2301,
                total_compression_kn: 171.293387068646,
                total_tension_kn: -84.294379785771,
                max_strength: 999,
                max_deflection_mm: 50,
                max_deflection: 0.115668201846262,
                max_capacity_ratio: 999,
                max_capacity_ratio_limit_state: "Strength",
            },
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2301,
                total_compression_kn: 171.293387068646,
                total_tension_kn: -84.294379785771,
                max_strength: 999,
                max_deflection_mm: 50,
                max_deflection: 0.115668201846262,
                max_capacity_ratio: 999,
                max_capacity_ratio_limit_state: "Strength",
            },
        },
        "BeamResults.TestValueChecksum": 0,
        BeamPointLoadPeakCalcs: [
            {
                BeamName: "R1,",
                BeamType: "Rafter",
                Length: 4887,
                Column: "F",
                PointLoads: [
                    {
                        Name: "P1",
                        Location: 2456,
                    },
                    {
                        Name: "WB1",
                        Location: 4887,
                    },
                ],
            },
            {
                BeamName: "R2,",
                BeamType: "Rafter",
                Length: 4887,
                Column: "G",
                PointLoads: [
                    {
                        Name: "P1",
                        Location: 2456,
                    },
                    {
                        Name: "WB1",
                        Location: 4887,
                    },
                ],
            },
        ],
        ProcessedLoadData: {
            Beams: {
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 5000,
                    PointLoadData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 25,
                            Bracket: "",
                        },
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 4975,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 245,
                            Bracket: "HCC",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 4755,
                            Bracket: "HCC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "5000",
                    },
                },
                WB1: {
                    Name: "WB1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 5000,
                    PointLoadData: {
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 25,
                            Bracket: "",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 4975,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5000",
                        PARENT_LEN: "5000",
                    },
                },
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 4887,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 1,
                            Side: 0,
                            Location: 2456.73,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        WB1: {
                            Name: "WB1",
                            End: 2,
                            Side: 0,
                            Location: 4908.23,
                            Bracket: "",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "25",
                        PARENT_LEN: "5003",
                    },
                },
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 4890,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 4900,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "25",
                        PARENT_LEN: "4950",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 4887,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 2,
                            Side: 0,
                            Location: 2456.73,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        WB1: {
                            Name: "WB1",
                            End: 2,
                            Side: 0,
                            Location: 4908.23,
                            Bracket: "",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "4975",
                        PARENT_LEN: "5003",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2301,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2301,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
            },
        },
    },
    LSBL00222: {
        AttachmentBracketResults: {
            UCE_1: "0.500=Uplift",
            UCE_4: "0.500=Uplift",
            UCE_2: "0.820=Uplift",
            UCE_3: "0.820=Uplift",
        },
        MaxResultOverAll: 0.514907648393385,
        BeamResults: {
            "P2,": "0.0800332596662741=Vertical Shear",
            "R1,": "0.218254582298945=Bending Moment",
            "FB2b,": "0.0659794836801913=Vertical Shear",
            "P1,P2,": "0.0800332596662741=Vertical Shear",
            "P6,": "0.0800332596662741=Vertical Shear",
            "R2,": "0.349852786041602=Bending Moment",
            "P3,": "0.0800332596662741=Vertical Shear",
            "R3,": "0.349852786041602=Bending Moment",
            "FB2a,": "0.326301172375769=Vertical Shear",
            "P5,": "0.0800332596662741=Vertical Shear",
            "P5,P6,": "0.0800332596662741=Vertical Shear",
            "FB1,": "0.514907648393385=Bending Moment",
            "FB2,": "0.326301172375769=Vertical Shear",
            "P4,": "0.0800332596662741=Vertical Shear",
            ",": "0.514907648393385=Bending Moment",
            "FB1c,": "0.23515284496323=Vertical Shear",
            "P1,": "0.0800332596662741=Vertical Shear",
            "R4,": "0.218254582298945=Bending Moment",
            "FB1a,": "0.23515284496323=Vertical Shear",
            "FB1b,": "0.514907648393385=Bending Moment",
            "P3,P4,": "0.0800332596662741=Vertical Shear",
            "FB2c,": "0.326301172375769=Vertical Shear",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C1: "0.305=Deflection (15.3mm)",
            C2: "0.305=Deflection (15.3mm)",
        },
        AttachmentBracketResultsDetailed: {
            UCE_1: {
                ref: "UCE_1",
                area: 0,
                type: "UCE",
                max_shear: 0.150824983974443,
                max_shear_kn: 1.18397612419938,
                max_uplift: 0.500124048587314,
                max_uplift_kn: -3.92597378141042,
                max_area_capacity: 0.450199013092692,
                area_m2_roofload: 2.25549705559439,
                max_capacity_ratio: 0.500124048587314,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "FB2c",
            },
            UCE_4: {
                ref: "UCE_4",
                area: 0,
                type: "UCE",
                max_shear: 0.150824983974443,
                max_shear_kn: 1.18397612419938,
                max_uplift: 0.500124048587314,
                max_uplift_kn: -3.92597378141042,
                max_area_capacity: 0.450199013092692,
                area_m2_roofload: 2.25549705559439,
                max_capacity_ratio: 0.500124048587314,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "FB2a",
            },
            UCE_2: {
                ref: "UCE_2",
                area: 0,
                type: "UCE",
                max_shear: 0.24715342539212,
                max_shear_kn: 1.94015438932814,
                max_uplift: 0.819541752779332,
                max_uplift_kn: -6.43340275931776,
                max_area_capacity: 0.761358939583117,
                area_m2_roofload: 3.81440828731141,
                max_capacity_ratio: 0.819541752779332,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "FB2c",
            },
            UCE_3: {
                ref: "UCE_3",
                area: 0,
                type: "UCE",
                max_shear: 0.24715342539212,
                max_shear_kn: 1.94015438932814,
                max_uplift: 0.819541752779332,
                max_uplift_kn: -6.43340275931776,
                max_area_capacity: 0.761358939583117,
                area_m2_roofload: 3.81440828731141,
                max_capacity_ratio: 0.819541752779332,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "FB2a",
            },
        },
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {
            FB2: {
                ref: "UCE_3",
                area: 0,
                type: "UCE",
                max_shear: 0.24715342539212,
                max_shear_kn: 1.94015438932814,
                max_uplift: 0.819541752779332,
                max_uplift_kn: -6.43340275931776,
                max_area_capacity: 0.761358939583117,
                area_m2_roofload: 3.81440828731141,
                max_capacity_ratio: 0.819541752779332,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "FB2a",
            },
        },
        maxResultOverAllText: "",
        AreaMaxResults: {
            0: {
                MaxResult: 0.514907648393385,
                PurlinMax: 0.0800332596662741,
                FasciaMax: 0.514907648393385,
                NumRafters: 4,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 9,
                ColumnsMax: 0.305397023061597,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 4",
                ColumnsMaxText: "Limiting Member = C1 CR=0.305 - Deflection (15.3mm)",
                RafterMax: 0.349852786041602,
                NumFasciaBeams: 8,
                JoinBeamMax: 0,
                OtherMax: 0.514907648393385,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2523,
                total_compression_kn: 3.46854168093925,
                total_tension_kn: -11.5014174870334,
                max_strength: 0.0592879982242033,
                max_deflection_mm: 50,
                max_deflection: 0.305397023061597,
                max_capacity_ratio: 0.305397023061597,
                max_capacity_ratio_limit_state: "Deflection (15.3mm)",
            },
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2523,
                total_compression_kn: 3.46854168093925,
                total_tension_kn: -11.5014174870334,
                max_strength: 0.0592879982242033,
                max_deflection_mm: 50,
                max_deflection: 0.305397023061597,
                max_capacity_ratio: 0.305397023061597,
                max_capacity_ratio_limit_state: "Deflection (15.3mm)",
            },
        },
        "BeamResults.TestValueChecksum": 0,
        BeamPointLoadPeakCalcs: [
            {
                BeamName: "R1,",
                BeamType: "Rafter",
                Length: 3811,
                Column: "H",
                PointLoads: [
                    {
                        Name: "P3",
                        Location: 1289,
                    },
                    {
                        Name: "P4",
                        Location: 2585,
                    },
                ],
            },
            {
                BeamName: "R2,",
                BeamType: "Rafter",
                Length: 3811,
                Column: "I",
                PointLoads: [
                    {
                        Name: "P1",
                        Location: 1289,
                    },
                    {
                        Name: "P3",
                        Location: 1289,
                    },
                    {
                        Name: "P2",
                        Location: 2585,
                    },
                    {
                        Name: "P4",
                        Location: 2585,
                    },
                ],
            },
            {
                BeamName: "R3,",
                BeamType: "Rafter",
                Length: 3811,
                Column: "J",
                PointLoads: [
                    {
                        Name: "P1",
                        Location: 1289,
                    },
                    {
                        Name: "P5",
                        Location: 1289,
                    },
                    {
                        Name: "P2",
                        Location: 2585,
                    },
                    {
                        Name: "P6",
                        Location: 2585,
                    },
                ],
            },
            {
                BeamName: "R4,",
                BeamType: "Rafter",
                Length: 3811,
                Column: "K",
                PointLoads: [
                    {
                        Name: "P5",
                        Location: 1289,
                    },
                    {
                        Name: "P6",
                        Location: 2585,
                    },
                ],
            },
            {
                BeamName: "FB1b,",
                BeamType: "Fascia Beam",
                Length: 3310,
                Column: "M",
                PointLoads: [
                    {
                        Name: "R2",
                        Location: 996,
                    },
                    {
                        Name: "R3",
                        Location: 2313,
                    },
                ],
            },
            {
                BeamName: "FB2a,",
                BeamType: "Fascia Beam",
                Length: 1344.17,
                Column: "O",
                PointLoads: [
                    {
                        Name: "R4",
                        Location: 25,
                    },
                    {
                        Name: "R3",
                        Location: 1341,
                    },
                ],
            },
            {
                BeamName: "FB2c,",
                BeamType: "Fascia Beam",
                Length: 1344.17,
                Column: "Q",
                PointLoads: [
                    {
                        Name: "R2",
                        Location: 2,
                    },
                    {
                        Name: "R1",
                        Location: 1319,
                    },
                ],
            },
        ],
        ProcessedLoadData: {
            Beams: {
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 4000,
                    PointLoadData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 25,
                            Bracket: "",
                        },
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 1341.67,
                            Bracket: "FLUB",
                        },
                        R3: {
                            Name: "R3",
                            End: 1,
                            Side: 0,
                            Location: 2658.33,
                            Bracket: "FLUB",
                        },
                        R4: {
                            Name: "R4",
                            End: 1,
                            Side: 0,
                            Location: 3975,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 345,
                            Bracket: "HCC",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 3655,
                            Bracket: "HCC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "4000",
                    },
                },
                FB2: {
                    Name: "FB2",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 4000,
                    PointLoadData: {
                        R4: {
                            Name: "R4",
                            End: 2,
                            Side: 0,
                            Location: 25,
                            Bracket: "",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 1341.67,
                            Bracket: "FLUB",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 2658.33,
                            Bracket: "FLUB",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 3975,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        BK34D_4: {
                            Name: "BK34D_4",
                            End: 0,
                            Side: 0,
                            Location: 32.5,
                            Bracket: "",
                        },
                        BK34D_3: {
                            Name: "BK34D_3",
                            End: 0,
                            Side: 0,
                            Location: 1344.17,
                            Bracket: "",
                        },
                        BK34D_2: {
                            Name: "BK34D_2",
                            End: 0,
                            Side: 0,
                            Location: 2655.83,
                            Bracket: "",
                        },
                        BK34D_1: {
                            Name: "BK34D_1",
                            End: 0,
                            Side: 0,
                            Location: 3967.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 4,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "4000",
                        PARENT_LEN: "4000",
                    },
                },
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 1257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 1266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "1367",
                        PARENT_LEN: "1267",
                    },
                },
                P2: {
                    Name: "P2",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 1257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 1266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "1367",
                        PARENT_LEN: "1267",
                    },
                },
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 3811,
                    PointLoadData: {
                        P3: {
                            Name: "P3",
                            End: 1,
                            Side: 0,
                            Location: 1289.07,
                            Bracket: "FLUB",
                        },
                        P4: {
                            Name: "P4",
                            End: 1,
                            Side: 0,
                            Location: 2585.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 3857.18,
                            Bracket: "",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "25",
                        PARENT_LEN: "3940",
                    },
                },
                P3: {
                    Name: "P3",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 1257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 1266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "25",
                        PARENT_LEN: "1292",
                    },
                },
                P4: {
                    Name: "P4",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 1257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 1266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "25",
                        PARENT_LEN: "1292",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 3811,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 1,
                            Side: 0,
                            Location: 1289.07,
                            Bracket: "FLUB",
                        },
                        P3: {
                            Name: "P3",
                            End: 2,
                            Side: 0,
                            Location: 1289.07,
                            Bracket: "FLUB",
                        },
                        P2: {
                            Name: "P2",
                            End: 1,
                            Side: 0,
                            Location: 2585.67,
                            Bracket: "FLUB",
                        },
                        P4: {
                            Name: "P4",
                            End: 2,
                            Side: 0,
                            Location: 2585.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 3857.18,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "1342",
                        PARENT_LEN: "3940",
                    },
                },
                R3: {
                    Name: "R3",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 3811,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 2,
                            Side: 0,
                            Location: 1289.07,
                            Bracket: "FLUB",
                        },
                        P5: {
                            Name: "P5",
                            End: 1,
                            Side: 0,
                            Location: 1289.07,
                            Bracket: "FLUB",
                        },
                        P2: {
                            Name: "P2",
                            End: 2,
                            Side: 0,
                            Location: 2585.67,
                            Bracket: "FLUB",
                        },
                        P6: {
                            Name: "P6",
                            End: 1,
                            Side: 0,
                            Location: 2585.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 3857.18,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "2658",
                        PARENT_LEN: "3940",
                    },
                },
                P5: {
                    Name: "P5",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 1257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R3: {
                            Name: "R3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R4: {
                            Name: "R4",
                            End: 2,
                            Side: 0,
                            Location: 1266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "2683",
                        PARENT_LEN: "1292",
                    },
                },
                P6: {
                    Name: "P6",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 1257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R3: {
                            Name: "R3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R4: {
                            Name: "R4",
                            End: 2,
                            Side: 0,
                            Location: 1266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "2683",
                        PARENT_LEN: "1292",
                    },
                },
                R4: {
                    Name: "R4",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 3811,
                    PointLoadData: {
                        P5: {
                            Name: "P5",
                            End: 2,
                            Side: 0,
                            Location: 1289.07,
                            Bracket: "FLUB",
                        },
                        P6: {
                            Name: "P6",
                            End: 2,
                            Side: 0,
                            Location: 2585.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 3857.18,
                            Bracket: "",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "3975",
                        PARENT_LEN: "3940",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2523,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2523,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
            },
        },
    },
    CANL00034: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.580871848579363,
        BeamResults: {
            "P2,": "0.15419115007459=Bending Moment",
            "R1,": "0.323930880858296=Bending Moment",
            "FB2b,": "0.353189789182392=Bending Moment",
            "P1,P2,": "0.15419115007459=Bending Moment",
            "P6,": "0.15419115007459=Bending Moment",
            "R2,": "0.580871848579363=Bending Moment",
            "P3,": "0.15419115007459=Bending Moment",
            "R3,": "0.580871848579363=Bending Moment",
            "FB2a,": "0.159907827374544=Vertical Shear",
            "P5,": "0.15419115007459=Bending Moment",
            "P5,P6,": "0.15419115007459=Bending Moment",
            "FB1,": "0.362151960767942=Bending Moment",
            "FB2,": "0.353189789182392=Bending Moment",
            "P4,": "0.15419115007459=Bending Moment",
            ",": "0.580871848579363=Bending Moment",
            "FB1d,": "0.159808960860944=Vertical Shear",
            "FB1c,": "0.362151960767942=Bending Moment",
            "P1,": "0.15419115007459=Bending Moment",
            "R4,": "0.323930880858296=Bending Moment",
            "FB1a,": "0.159808960860944=Vertical Shear",
            "FB1b,": "0.362151960767942=Bending Moment",
            "P3,P4,": "0.15419115007459=Bending Moment",
            "FB2d,": "0.159907827374544=Vertical Shear",
            "FB2c,": "0.353189789182392=Bending Moment",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C6: "0.328=Deflection (16.4mm)",
            C2: "0.254=Deflection (12.7mm)",
            C1: "0.254=Deflection (12.7mm)",
            C3: "0.254=Deflection (12.7mm)",
            C4: "0.328=Deflection (16.4mm)",
            C5: "0.328=Deflection (16.4mm)",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "",
        AreaMaxResults: {
            0: {
                MaxResult: 0.580871848579363,
                PurlinMax: 0.15419115007459,
                FasciaMax: 0.362151960767942,
                NumRafters: 4,
                NumColumns: 6,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 9,
                ColumnsMax: 0.327895492356321,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 4",
                ColumnsMaxText: "Limiting Member = C4 CR=0.328 - Deflection (16.4mm)",
                RafterMax: 0.580871848579363,
                NumFasciaBeams: 10,
                JoinBeamMax: 0,
                OtherMax: 0.580871848579363,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C6: {
                ref: "C6",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2655,
                total_compression_kn: 5.32323855442386,
                total_tension_kn: -3.15950381850952,
                max_strength: 0.0931432122845014,
                max_deflection_mm: 50,
                max_deflection: 0.327895492356321,
                max_capacity_ratio: 0.327895492356321,
                max_capacity_ratio_limit_state: "Deflection (16.4mm)",
            },
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2445,
                total_compression_kn: 8.14891198154869,
                total_tension_kn: -4.83662685021029,
                max_strength: 0.146040594811503,
                max_deflection_mm: 50,
                max_deflection: 0.25410907551958,
                max_capacity_ratio: 0.25410907551958,
                max_capacity_ratio_limit_state: "Deflection (12.7mm)",
            },
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2445,
                total_compression_kn: 5.46815500189287,
                total_tension_kn: -3.24551613309246,
                max_strength: 0.0952916602408488,
                max_deflection_mm: 50,
                max_deflection: 0.25410907551958,
                max_capacity_ratio: 0.25410907551958,
                max_capacity_ratio_limit_state: "Deflection (12.7mm)",
            },
            C3: {
                ref: "C3",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2445,
                total_compression_kn: 5.46815500189287,
                total_tension_kn: -3.24551613309246,
                max_strength: 0.0952916602408488,
                max_deflection_mm: 50,
                max_deflection: 0.25410907551958,
                max_capacity_ratio: 0.25410907551958,
                max_capacity_ratio_limit_state: "Deflection (12.7mm)",
            },
            C4: {
                ref: "C4",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2655,
                total_compression_kn: 5.32323855442386,
                total_tension_kn: -3.15950381850952,
                max_strength: 0.0931432122845014,
                max_deflection_mm: 50,
                max_deflection: 0.327895492356321,
                max_capacity_ratio: 0.327895492356321,
                max_capacity_ratio_limit_state: "Deflection (16.4mm)",
            },
            C5: {
                ref: "C5",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2655,
                total_compression_kn: 7.87732288969371,
                total_tension_kn: -4.67543047247737,
                max_strength: 0.141948405847352,
                max_deflection_mm: 50,
                max_deflection: 0.327895492356321,
                max_capacity_ratio: 0.327895492356321,
                max_capacity_ratio_limit_state: "Deflection (16.4mm)",
            },
        },
        "BeamResults.TestValueChecksum": 0,
        BeamPointLoadPeakCalcs: [
            {
                BeamName: "R1,",
                BeamType: "Rafter",
                Length: 5886,
                Column: "H",
                PointLoads: [
                    {
                        Name: "P3",
                        Location: 1966,
                    },
                    {
                        Name: "P4",
                        Location: 3951,
                    },
                ],
            },
            {
                BeamName: "R2,",
                BeamType: "Rafter",
                Length: 5886,
                Column: "I",
                PointLoads: [
                    {
                        Name: "P1",
                        Location: 1966,
                    },
                    {
                        Name: "P3",
                        Location: 1966,
                    },
                    {
                        Name: "P2",
                        Location: 3951,
                    },
                    {
                        Name: "P4",
                        Location: 3951,
                    },
                ],
            },
            {
                BeamName: "R3,",
                BeamType: "Rafter",
                Length: 5886,
                Column: "J",
                PointLoads: [
                    {
                        Name: "P1",
                        Location: 1966,
                    },
                    {
                        Name: "P5",
                        Location: 1966,
                    },
                    {
                        Name: "P2",
                        Location: 3951,
                    },
                    {
                        Name: "P6",
                        Location: 3951,
                    },
                ],
            },
            {
                BeamName: "R4,",
                BeamType: "Rafter",
                Length: 5886,
                Column: "K",
                PointLoads: [
                    {
                        Name: "P5",
                        Location: 1966,
                    },
                    {
                        Name: "P6",
                        Location: 3951,
                    },
                ],
            },
        ],
        ProcessedLoadData: {
            Beams: {
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 3266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "3367",
                        PARENT_LEN: "3267",
                    },
                },
                P2: {
                    Name: "P2",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 3266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "3367",
                        PARENT_LEN: "3267",
                    },
                },
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 5886,
                    PointLoadData: {
                        P3: {
                            Name: "P3",
                            End: 1,
                            Side: 0,
                            Location: 1966.52,
                            Bracket: "FLUB",
                        },
                        P4: {
                            Name: "P4",
                            End: 1,
                            Side: 0,
                            Location: 3951.06,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 5910.58,
                            Bracket: "",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "25",
                        PARENT_LEN: "6004",
                    },
                },
                P3: {
                    Name: "P3",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 3266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "25",
                        PARENT_LEN: "3292",
                    },
                },
                P4: {
                    Name: "P4",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 3266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "25",
                        PARENT_LEN: "3292",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 5886,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 1,
                            Side: 0,
                            Location: 1966.52,
                            Bracket: "FLUB",
                        },
                        P3: {
                            Name: "P3",
                            End: 2,
                            Side: 0,
                            Location: 1966.52,
                            Bracket: "FLUB",
                        },
                        P2: {
                            Name: "P2",
                            End: 1,
                            Side: 0,
                            Location: 3951.06,
                            Bracket: "FLUB",
                        },
                        P4: {
                            Name: "P4",
                            End: 2,
                            Side: 0,
                            Location: 3951.06,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 5910.58,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "3342",
                        PARENT_LEN: "6004",
                    },
                },
                R3: {
                    Name: "R3",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 5886,
                    PointLoadData: {
                        P1: {
                            Name: "P1",
                            End: 2,
                            Side: 0,
                            Location: 1966.52,
                            Bracket: "FLUB",
                        },
                        P5: {
                            Name: "P5",
                            End: 1,
                            Side: 0,
                            Location: 1966.52,
                            Bracket: "FLUB",
                        },
                        P2: {
                            Name: "P2",
                            End: 2,
                            Side: 0,
                            Location: 3951.06,
                            Bracket: "FLUB",
                        },
                        P6: {
                            Name: "P6",
                            End: 1,
                            Side: 0,
                            Location: 3951.06,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 5910.58,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "6658",
                        PARENT_LEN: "6004",
                    },
                },
                P5: {
                    Name: "P5",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R3: {
                            Name: "R3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R4: {
                            Name: "R4",
                            End: 2,
                            Side: 0,
                            Location: 3266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "6683",
                        PARENT_LEN: "3292",
                    },
                },
                P6: {
                    Name: "P6",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3257,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        R3: {
                            Name: "R3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        R4: {
                            Name: "R4",
                            End: 2,
                            Side: 0,
                            Location: 3266.67,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "6683",
                        PARENT_LEN: "3292",
                    },
                },
                R4: {
                    Name: "R4",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 5886,
                    PointLoadData: {
                        P5: {
                            Name: "P5",
                            End: 2,
                            Side: 0,
                            Location: 1966.52,
                            Bracket: "FLUB",
                        },
                        P6: {
                            Name: "P6",
                            End: 2,
                            Side: 0,
                            Location: 3951.06,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        FB2: {
                            Name: "FB2",
                            End: 2,
                            Side: 0,
                            Location: 5910.58,
                            Bracket: "",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "9975",
                        PARENT_LEN: "6004",
                    },
                },
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 10000,
                    PointLoadData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 25,
                            Bracket: "",
                        },
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 3341.67,
                            Bracket: "FLUB",
                        },
                        R3: {
                            Name: "R3",
                            End: 1,
                            Side: 0,
                            Location: 6658.33,
                            Bracket: "FLUB",
                        },
                        R4: {
                            Name: "R4",
                            End: 1,
                            Side: 0,
                            Location: 9975,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 245,
                            Bracket: "HCC",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 5000,
                            Bracket: "HCC",
                        },
                        C3: {
                            Name: "C3",
                            End: 2,
                            Side: 0,
                            Location: 9755,
                            Bracket: "HCC",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "10000",
                    },
                },
                FB2: {
                    Name: "FB2",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 10000,
                    PointLoadData: {
                        R4: {
                            Name: "R4",
                            End: 2,
                            Side: 0,
                            Location: 25,
                            Bracket: "",
                        },
                        R3: {
                            Name: "R3",
                            End: 2,
                            Side: 0,
                            Location: 3341.67,
                            Bracket: "FLUB",
                        },
                        R2: {
                            Name: "R2",
                            End: 2,
                            Side: 0,
                            Location: 6658.33,
                            Bracket: "FLUB",
                        },
                        R1: {
                            Name: "R1",
                            End: 2,
                            Side: 0,
                            Location: 9975,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        C4: {
                            Name: "C4",
                            End: 1,
                            Side: 0,
                            Location: 245,
                            Bracket: "HCC",
                        },
                        C5: {
                            Name: "C5",
                            End: 2,
                            Side: 0,
                            Location: 5000,
                            Bracket: "HCC",
                        },
                        C6: {
                            Name: "C6",
                            End: 2,
                            Side: 0,
                            Location: 9755,
                            Bracket: "HCC",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "10000",
                        PARENT_LEN: "10000",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2445,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2445,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C3: {
                    Name: "C3",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2445,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C4: {
                    Name: "C4",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2655,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C5: {
                    Name: "C5",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2655,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C6: {
                    Name: "C6",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2655,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
            },
        },
    },
    COFL00234: {
        AttachmentBracketResults: {
            UCF_1: "1.569=Uplift",
            UCF_3: "0.284=Uplift",
            UCF_2: "0.485=Uplift",
            UCF_5: "0.284=Uplift",
            UCF_4: "2.337=Uplift",
            UCF_7: "1.569=Uplift",
            UCF_6: "0.485=Uplift",
        },
        MaxResultOverAll: 3.69945281022885,
        BeamResults: {
            "EB2f,": "1.19606927263525=Vertical Shear",
            "P12,": "0.454368072162197=Vertical Shear",
            "PR2,PR3,": "2.76110375835281=Bending Moment",
            "P2,": "0.245185728055267=Vertical Shear",
            "EB2b,EB2c,EB2e,": "0.108190500084291=Vertical Shear",
            "P3,": "0.245185728055267=Vertical Shear",
            "EB2d,": "1.67273295922724=Vertical Shear",
            "P9,": "0.0119346210324029=Vertical Shear",
            "EB1b,": "3.69945281022885=Bending Moment",
            "EB1c,": "0.378365317488419=Vertical Shear",
            "PR10,PR4,": "1.45110432980191=Bending Moment",
            ",": "3.69945281022885=Bending Moment",
            "EB4,": "0.480966477253663=Deflection-W UP (-38.5mm)",
            "EB3,": "0.480966477253663=Deflection-W UP (-38.5mm)",
            "EB2,": "1.67273295922724=Vertical Shear",
            "EB1,": "3.69945281022885=Bending Moment",
            "EB2a,": "1.19606927263525=Vertical Shear",
            "P5,": "0.00644015045548544=Vertical Shear",
            "P8,": "0.00644015045548544=Vertical Shear",
            "P5,P6,": "0.00644015045548544=Vertical Shear",
            "EB1a,": "0.378365317488419=Vertical Shear",
            "PR7,PR8,": "0.182571053636198=Vertical Shear",
            "PR5,PR6,": "0.182571053636198=Vertical Shear",
            "P13,": "0.454368072162197=Vertical Shear",
            "P10,": "0.0119346210324029=Vertical Shear",
            "P11,": "0.454368072162197=Vertical Shear",
            "P16,": "0.0119346210324029=Vertical Shear",
            "P7,P8,": "0.00644015045548544=Vertical Shear",
            "P14,": "0.454368072162197=Vertical Shear",
            "P15,": "0.0119346210324029=Vertical Shear",
            "P4,": "0.245185728055267=Vertical Shear",
            "P1,P2,": "0.245185728055267=Vertical Shear",
            "P3,P4,": "0.245185728055267=Vertical Shear",
            "PR9,PR1,": "1.45110432980191=Bending Moment",
            "P1,": "0.245185728055267=Vertical Shear",
            "P6,": "0.00644015045548544=Vertical Shear",
            "P7,": "0.00644015045548544=Vertical Shear",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C1: "0.622=Deflection (31.1mm)",
            C2: "0.622=Deflection (31.1mm)",
        },
        AttachmentBracketResultsDetailed: {
            UCF_1: {
                ref: "UCF_1",
                area: 0,
                type: "UCE",
                max_shear: 0.471190891230922,
                max_shear_kn: 3.69884849616274,
                max_uplift: 1.56936477810739,
                max_uplift_kn: -12.319513508143,
                max_area_capacity: 1.50078405742754,
                area_m2_roofload: 6.7460243381368,
                max_capacity_ratio: 1.56936477810739,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2f",
            },
            UCF_3: {
                ref: "UCF_3",
                area: 0,
                type: "UCE",
                max_shear: 0.0852352765802117,
                max_shear_kn: 0.669096921154662,
                max_uplift: 0.283887578063707,
                max_uplift_kn: -2.2285174878001,
                max_area_capacity: 0.277264484716351,
                area_m2_roofload: 1.2463038588,
                max_capacity_ratio: 0.283887578063707,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2e",
            },
            UCF_2: {
                ref: "UCF_2",
                area: 0,
                type: "UCE",
                max_shear: 0.145654375738533,
                max_shear_kn: 1.14338684954749,
                max_uplift: 0.485121532091012,
                max_uplift_kn: -3.80820402691444,
                max_area_capacity: 0.437089387687858,
                area_m2_roofload: 1.96471679765692,
                max_capacity_ratio: 0.485121532091012,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2f",
            },
            UCF_5: {
                ref: "UCF_5",
                area: 0,
                type: "UCE",
                max_shear: 0.0852431867012484,
                max_shear_kn: 0.6691590156048,
                max_uplift: 0.283913923788076,
                max_uplift_kn: -2.2287243017364,
                max_area_capacity: 0.277290215795328,
                area_m2_roofload: 1.24641952,
                max_capacity_ratio: 0.283913923788076,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2c",
            },
            UCF_4: {
                ref: "UCF_4",
                area: 0,
                type: "UCE",
                max_shear: 0.701593905307995,
                max_shear_kn: 5.50751215666776,
                max_uplift: 2.33675307400111,
                max_uplift_kn: -18.3435116309088,
                max_area_capacity: 2.24973402973974,
                area_m2_roofload: 10.1125544636801,
                max_capacity_ratio: 2.33675307400111,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2d",
            },
            UCF_7: {
                ref: "UCF_7",
                area: 0,
                type: "UCE",
                max_shear: 0.471190891230922,
                max_shear_kn: 3.69884849616274,
                max_uplift: 1.56936477810739,
                max_uplift_kn: -12.319513508143,
                max_area_capacity: 1.50078405742754,
                area_m2_roofload: 6.7460243381368,
                max_capacity_ratio: 1.56936477810739,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2a",
            },
            UCF_6: {
                ref: "UCF_6",
                area: 0,
                type: "UCE",
                max_shear: 0.145654375738533,
                max_shear_kn: 1.14338684954749,
                max_uplift: 0.485121532091012,
                max_uplift_kn: -3.80820402691444,
                max_area_capacity: 0.437089387687858,
                area_m2_roofload: 1.96471679765692,
                max_capacity_ratio: 0.485121532091012,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2a",
            },
        },
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {
            EB2: {
                ref: "UCF_4",
                area: 0,
                type: "UCE",
                max_shear: 0.701593905307995,
                max_shear_kn: 5.50751215666776,
                max_uplift: 2.33675307400111,
                max_uplift_kn: -18.3435116309088,
                max_area_capacity: 2.24973402973974,
                area_m2_roofload: 10.1125544636801,
                max_capacity_ratio: 2.33675307400111,
                max_capacity_ratio_limit_state: "Uplift",
                max_input_member: "EB2d",
            },
        },
        maxResultOverAllText: "",
        AreaMaxResults: {
            0: {
                MaxResult: 3.69945281022885,
                PurlinMax: 0.454368072162197,
                NumRafters: 5,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 20,
                ColumnsMax: 0.62191137447448,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.622 - Deflection (31.1mm)",
                RafterMax: 2.76110375835281,
                NumFasciaBeams: 0,
                EdgeBeamMax: 3.69945281022885,
                JoinBeamMax: 0,
                OtherMax: 3.69945281022885,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 0,
                height: 2550,
                total_compression_kn: 9.34142368325488,
                total_tension_kn: -31.1128707678982,
                max_strength: 0.170351605659285,
                max_deflection_mm: 50,
                max_deflection: 0.62191137447448,
                max_capacity_ratio: 0.62191137447448,
                max_capacity_ratio_limit_state: "Deflection (31.1mm)",
            },
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 0,
                height: 2550,
                total_compression_kn: 9.34142368325488,
                total_tension_kn: -31.1128707678982,
                max_strength: 0.170351605659285,
                max_deflection_mm: 50,
                max_deflection: 0.62191137447448,
                max_capacity_ratio: 0.62191137447448,
                max_capacity_ratio_limit_state: "Deflection (31.1mm)",
            },
        },
        "BeamResults.TestValueChecksum": 0,
        BeamPointLoadPeakCalcs: [
            {
                BeamName: "PR2,PR3,",
                BeamType: "Welded Rafter",
                Length: 7582,
                Column: "Q",
                PointLoads: [
                    {
                        Name: "P11",
                        Location: 1782,
                    },
                    {
                        Name: "P13",
                        Location: 1782,
                    },
                    {
                        Name: "P1",
                        Location: 3628,
                    },
                    {
                        Name: "P3",
                        Location: 3628,
                    },
                    {
                        Name: "P2",
                        Location: 3959,
                    },
                    {
                        Name: "P4",
                        Location: 3959,
                    },
                    {
                        Name: "P12",
                        Location: 5804,
                    },
                    {
                        Name: "P14",
                        Location: 5804,
                    },
                ],
            },
            {
                BeamName: "PR5,PR6,",
                BeamType: "Welded Rafter",
                Length: 7566,
                Column: "R",
                PointLoads: [
                    {
                        Name: "P9",
                        Location: 1774,
                    },
                    {
                        Name: "P5",
                        Location: 3620,
                    },
                    {
                        Name: "P6",
                        Location: 3951,
                    },
                    {
                        Name: "P10",
                        Location: 5796,
                    },
                ],
            },
            {
                BeamName: "PR7,PR8,",
                BeamType: "Welded Rafter",
                Length: 7566,
                Column: "S",
                PointLoads: [
                    {
                        Name: "P15",
                        Location: 1774,
                    },
                    {
                        Name: "P7",
                        Location: 3620,
                    },
                    {
                        Name: "P8",
                        Location: 3951,
                    },
                    {
                        Name: "P16",
                        Location: 5796,
                    },
                ],
            },
            {
                BeamName: "PR9,PR1,",
                BeamType: "Welded Rafter",
                Length: 7539,
                Column: "T",
                PointLoads: [
                    {
                        Name: "P9",
                        Location: 1739,
                    },
                    {
                        Name: "P11",
                        Location: 1739,
                    },
                    {
                        Name: "P1",
                        Location: 3584,
                    },
                    {
                        Name: "P5",
                        Location: 3584,
                    },
                    {
                        Name: "P2",
                        Location: 3916,
                    },
                    {
                        Name: "P6",
                        Location: 3916,
                    },
                    {
                        Name: "P10",
                        Location: 5761,
                    },
                    {
                        Name: "P12",
                        Location: 5761,
                    },
                ],
            },
            {
                BeamName: "PR10,PR4,",
                BeamType: "Welded Rafter",
                Length: 7539,
                Column: "U",
                PointLoads: [
                    {
                        Name: "P13",
                        Location: 1739,
                    },
                    {
                        Name: "P15",
                        Location: 1739,
                    },
                    {
                        Name: "P3",
                        Location: 3584,
                    },
                    {
                        Name: "P7",
                        Location: 3584,
                    },
                    {
                        Name: "P4",
                        Location: 3916,
                    },
                    {
                        Name: "P8",
                        Location: 3916,
                    },
                    {
                        Name: "P14",
                        Location: 5761,
                    },
                    {
                        Name: "P16",
                        Location: 5761,
                    },
                ],
            },
            {
                BeamName: "EB1a,",
                BeamType: "Edge Beam",
                Length: 155,
                Column: "X",
                PointLoads: [
                    {
                        Name: "PR5",
                        Location: 25,
                    },
                    {
                        Name: "EB3",
                        Location: 25,
                    },
                ],
            },
            {
                BeamName: "EB1c,",
                BeamType: "Edge Beam",
                Length: 155,
                Column: "Z",
                PointLoads: [
                    {
                        Name: "PR7",
                        Location: 130,
                    },
                    {
                        Name: "EB4",
                        Location: 130,
                    },
                ],
            },
            {
                BeamName: "EB2a,",
                BeamType: "Edge Beam",
                Length: 1048.33,
                Column: "AA",
                PointLoads: [
                    {
                        Name: "PR8",
                        Location: 25,
                    },
                    {
                        Name: "EB4",
                        Location: 25,
                    },
                    {
                        Name: "PR4",
                        Location: 155,
                    },
                ],
            },
            {
                BeamName: "EB2f,",
                BeamType: "Edge Beam",
                Length: 1048.33,
                Column: "AD",
                PointLoads: [
                    {
                        Name: "PR1",
                        Location: 893,
                    },
                    {
                        Name: "PR6",
                        Location: 1023,
                    },
                    {
                        Name: "EB3",
                        Location: 1023,
                    },
                ],
            },
        ],
        ProcessedLoadData: {
            Beams: {
                PR1: {
                    Name: "PR1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3791,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 1,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P6: {
                            Name: "P6",
                            End: 2,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P10: {
                            Name: "P10",
                            End: 1,
                            Side: 0,
                            Location: 2013.41,
                            Bracket: "FLUB",
                        },
                        P12: {
                            Name: "P12",
                            End: 2,
                            Side: 0,
                            Location: 2013.41,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR9: {
                            Name: "PR9",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "APEX15Z",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 3796.39,
                            Bracket: "RRC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "155",
                        PARENT_LEN: "3796",
                    },
                },
                PR2: {
                    Name: "PR2",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3791,
                    PointLoadData: {
                        P11: {
                            Name: "P11",
                            End: 2,
                            Side: 0,
                            Location: 1782.97,
                            Bracket: "FLUB",
                        },
                        P13: {
                            Name: "P13",
                            End: 1,
                            Side: 0,
                            Location: 1782.97,
                            Bracket: "FLUB",
                        },
                        P1: {
                            Name: "P1",
                            End: 2,
                            Side: 0,
                            Location: 3628.07,
                            Bracket: "FLUB",
                        },
                        P3: {
                            Name: "P3",
                            End: 1,
                            Side: 0,
                            Location: 3628.07,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        EB1: {
                            Name: "EB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "RRC",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 2,
                            Side: 0,
                            Location: 3796.39,
                            Bracket: "APEX15Z",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2880",
                        PARENT_LEN: "3796",
                    },
                },
                PR3: {
                    Name: "PR3",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3791,
                    PointLoadData: {
                        P2: {
                            Name: "P2",
                            End: 2,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P4: {
                            Name: "P4",
                            End: 1,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P12: {
                            Name: "P12",
                            End: 1,
                            Side: 0,
                            Location: 2013.41,
                            Bracket: "FLUB",
                        },
                        P14: {
                            Name: "P14",
                            End: 2,
                            Side: 0,
                            Location: 2013.41,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR2: {
                            Name: "PR2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "APEX15Z",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 3796.39,
                            Bracket: "RRC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2880",
                        PARENT_LEN: "3796",
                    },
                },
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2665,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR9: {
                            Name: "PR9",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 2675,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "180",
                        PARENT_LEN: "2675",
                    },
                },
                P2: {
                    Name: "P2",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2665,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 2,
                            Side: 0,
                            Location: 2675,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "180",
                        PARENT_LEN: "2675",
                    },
                },
                PR4: {
                    Name: "PR4",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3791,
                    PointLoadData: {
                        P4: {
                            Name: "P4",
                            End: 2,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P8: {
                            Name: "P8",
                            End: 1,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P14: {
                            Name: "P14",
                            End: 1,
                            Side: 0,
                            Location: 2013.41,
                            Bracket: "FLUB",
                        },
                        P16: {
                            Name: "P16",
                            End: 2,
                            Side: 0,
                            Location: 2013.41,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR10: {
                            Name: "PR10",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "APEX15Z",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 3796.39,
                            Bracket: "RRC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5605",
                        PARENT_LEN: "3796",
                    },
                },
                P3: {
                    Name: "P3",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2665,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR2: {
                            Name: "PR2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR10: {
                            Name: "PR10",
                            End: 2,
                            Side: 0,
                            Location: 2675,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2905",
                        PARENT_LEN: "2675",
                    },
                },
                P4: {
                    Name: "P4",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2665,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR3: {
                            Name: "PR3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 2675,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2905",
                        PARENT_LEN: "2675",
                    },
                },
                PR5: {
                    Name: "PR5",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3783,
                    PointLoadData: {
                        P9: {
                            Name: "P9",
                            End: 1,
                            Side: 0,
                            Location: 1774.96,
                            Bracket: "FLUB",
                        },
                        P5: {
                            Name: "P5",
                            End: 1,
                            Side: 0,
                            Location: 3620.06,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        EB1: {
                            Name: "EB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "GRBC",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 48.71,
                            Bracket: "GRBC",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 2,
                            Side: 0,
                            Location: 3788.37,
                            Bracket: "APEX15Z",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "25",
                        PARENT_LEN: "3788",
                    },
                },
                PR6: {
                    Name: "PR6",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3783,
                    PointLoadData: {
                        P6: {
                            Name: "P6",
                            End: 1,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P10: {
                            Name: "P10",
                            End: 2,
                            Side: 0,
                            Location: 2013.41,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        PR5: {
                            Name: "PR5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "APEX15Z",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 3788.37,
                            Bracket: "GRBC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "25",
                        PARENT_LEN: "3788",
                    },
                },
                P5: {
                    Name: "P5",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 70,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR5: {
                            Name: "PR5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR9: {
                            Name: "PR9",
                            End: 2,
                            Side: 0,
                            Location: 80,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "50",
                        PARENT_LEN: "80",
                    },
                },
                P6: {
                    Name: "P6",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 70,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR6: {
                            Name: "PR6",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 2,
                            Side: 0,
                            Location: 80,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "50",
                        PARENT_LEN: "80",
                    },
                },
                PR7: {
                    Name: "PR7",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3783,
                    PointLoadData: {
                        P15: {
                            Name: "P15",
                            End: 2,
                            Side: 0,
                            Location: 1774.96,
                            Bracket: "FLUB",
                        },
                        P7: {
                            Name: "P7",
                            End: 2,
                            Side: 0,
                            Location: 3620.06,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        EB1: {
                            Name: "EB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "GRBC",
                        },
                        C2: {
                            Name: "C2",
                            End: 1,
                            Side: 0,
                            Location: 48.71,
                            Bracket: "GRBC",
                        },
                        PR8: {
                            Name: "PR8",
                            End: 2,
                            Side: 0,
                            Location: 3788.37,
                            Bracket: "APEX15Z",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5735",
                        PARENT_LEN: "3788",
                    },
                },
                PR8: {
                    Name: "PR8",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3783,
                    PointLoadData: {
                        P8: {
                            Name: "P8",
                            End: 2,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P16: {
                            Name: "P16",
                            End: 1,
                            Side: 0,
                            Location: 2013.41,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        PR7: {
                            Name: "PR7",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "APEX15Z",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 3788.37,
                            Bracket: "GRBC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5735",
                        PARENT_LEN: "3788",
                    },
                },
                P7: {
                    Name: "P7",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 70,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR10: {
                            Name: "PR10",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR7: {
                            Name: "PR7",
                            End: 2,
                            Side: 0,
                            Location: 80,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5630",
                        PARENT_LEN: "80",
                    },
                },
                P8: {
                    Name: "P8",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 70,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR4: {
                            Name: "PR4",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR8: {
                            Name: "PR8",
                            End: 2,
                            Side: 0,
                            Location: 80,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5630",
                        PARENT_LEN: "80",
                    },
                },
                U1: {
                    Name: "U1",
                    AreaIndex: 0,
                    BeamType: "FL10011",
                    Length: 1640,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "25",
                        PARENT_LEN: "1450",
                    },
                },
                U2: {
                    Name: "U2",
                    AreaIndex: 0,
                    BeamType: "FL10011",
                    Length: 1640,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5735",
                        PARENT_LEN: "1450",
                    },
                },
                EB1: {
                    Name: "EB1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 5760,
                    PointLoadData: {
                        PR5: {
                            Name: "PR5",
                            End: 1,
                            Side: 0,
                            Location: 25,
                            Bracket: "GRBC",
                        },
                        EB3: {
                            Name: "EB3",
                            End: 1,
                            Side: 0,
                            Location: 25,
                            Bracket: "",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 1,
                            Side: 0,
                            Location: 2880,
                            Bracket: "RRC",
                        },
                        PR7: {
                            Name: "PR7",
                            End: 1,
                            Side: 0,
                            Location: 5735,
                            Bracket: "GRBC",
                        },
                        EB4: {
                            Name: "EB4",
                            End: 2,
                            Side: 0,
                            Location: 5735,
                            Bracket: "HCC15",
                        },
                    },
                    NumPointLoads: 5,
                    SupportData: {
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 155,
                            Bracket: "",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 5605,
                            Bracket: "",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "5760",
                    },
                },
                EB2: {
                    Name: "EB2",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 5760,
                    PointLoadData: {
                        PR8: {
                            Name: "PR8",
                            End: 2,
                            Side: 0,
                            Location: 25,
                            Bracket: "GRBC",
                        },
                        EB4: {
                            Name: "EB4",
                            End: 1,
                            Side: 0,
                            Location: 25,
                            Bracket: "",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 155,
                            Bracket: "RRC",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 2,
                            Side: 0,
                            Location: 2880,
                            Bracket: "RRC",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 2,
                            Side: 0,
                            Location: 5605,
                            Bracket: "RRC",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 2,
                            Side: 0,
                            Location: 5735,
                            Bracket: "GRBC",
                        },
                        EB3: {
                            Name: "EB3",
                            End: 2,
                            Side: 0,
                            Location: 5735,
                            Bracket: "HCC15",
                        },
                    },
                    NumPointLoads: 7,
                    SupportData: {
                        UCF_7: {
                            Name: "UCF_7",
                            End: 0,
                            Side: 0,
                            Location: 132.5,
                            Bracket: "",
                        },
                        UCF_6: {
                            Name: "UCF_6",
                            End: 0,
                            Side: 0,
                            Location: 1048.33,
                            Bracket: "",
                        },
                        UCF_5: {
                            Name: "UCF_5",
                            End: 0,
                            Side: 0,
                            Location: 1964.17,
                            Bracket: "",
                        },
                        UCF_4: {
                            Name: "UCF_4",
                            End: 0,
                            Side: 0,
                            Location: 2880,
                            Bracket: "",
                        },
                        UCF_3: {
                            Name: "UCF_3",
                            End: 0,
                            Side: 0,
                            Location: 3795.83,
                            Bracket: "",
                        },
                        UCF_2: {
                            Name: "UCF_2",
                            End: 0,
                            Side: 0,
                            Location: 4711.67,
                            Bracket: "",
                        },
                        UCF_1: {
                            Name: "UCF_1",
                            End: 0,
                            Side: 0,
                            Location: 5627.5,
                            Bracket: "",
                        },
                    },
                    NumSupports: 7,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5760",
                        PARENT_LEN: "5760",
                    },
                },
                EB3: {
                    Name: "EB3",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 6890,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        EB1: {
                            Name: "EB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        EB2: {
                            Name: "EB2",
                            End: 2,
                            Side: 0,
                            Location: 6900,
                            Bracket: "HCC15",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "25",
                        PARENT_LEN: "6900",
                    },
                },
                EB4: {
                    Name: "EB4",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 6890,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        EB2: {
                            Name: "EB2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        EB1: {
                            Name: "EB1",
                            End: 2,
                            Side: 0,
                            Location: 6900,
                            Bracket: "HCC15",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 6900,
                            Bracket: "HCC15",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5735",
                        PARENT_LEN: "6900",
                    },
                },
                P9: {
                    Name: "P9",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 70,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR5: {
                            Name: "PR5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR9: {
                            Name: "PR9",
                            End: 2,
                            Side: 0,
                            Location: 80,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "50",
                        PARENT_LEN: "80",
                    },
                },
                P10: {
                    Name: "P10",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 70,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR6: {
                            Name: "PR6",
                            End: 2,
                            Side: 0,
                            Location: 80,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "130",
                        PARENT_LEN: "80",
                    },
                },
                P11: {
                    Name: "P11",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2665,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR9: {
                            Name: "PR9",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 2675,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "180",
                        PARENT_LEN: "2675",
                    },
                },
                P12: {
                    Name: "P12",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2665,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR3: {
                            Name: "PR3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 2,
                            Side: 0,
                            Location: 2675,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2855",
                        PARENT_LEN: "2675",
                    },
                },
                P13: {
                    Name: "P13",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2665,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR2: {
                            Name: "PR2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR10: {
                            Name: "PR10",
                            End: 2,
                            Side: 0,
                            Location: 2675,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2905",
                        PARENT_LEN: "2675",
                    },
                },
                P14: {
                    Name: "P14",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2665,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR4: {
                            Name: "PR4",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 2,
                            Side: 0,
                            Location: 2675,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5580",
                        PARENT_LEN: "2675",
                    },
                },
                P15: {
                    Name: "P15",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 70,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR10: {
                            Name: "PR10",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR7: {
                            Name: "PR7",
                            End: 2,
                            Side: 0,
                            Location: 80,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5630",
                        PARENT_LEN: "80",
                    },
                },
                P16: {
                    Name: "P16",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 70,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR8: {
                            Name: "PR8",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 80,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5710",
                        PARENT_LEN: "80",
                    },
                },
                PR9: {
                    Name: "PR9",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3748,
                    PointLoadData: {
                        P9: {
                            Name: "P9",
                            End: 2,
                            Side: 0,
                            Location: 1739.68,
                            Bracket: "FLUB",
                        },
                        P11: {
                            Name: "P11",
                            End: 1,
                            Side: 0,
                            Location: 1739.68,
                            Bracket: "FLUB",
                        },
                        P1: {
                            Name: "P1",
                            End: 1,
                            Side: 0,
                            Location: 3584.78,
                            Bracket: "FLUB",
                        },
                        P5: {
                            Name: "P5",
                            End: 2,
                            Side: 0,
                            Location: 3584.78,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 13.42,
                            Bracket: "RRC",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 2,
                            Side: 0,
                            Location: 3753.09,
                            Bracket: "APEX15Z",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "155",
                        PARENT_LEN: "3796",
                    },
                },
                PR10: {
                    Name: "PR10",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 3748,
                    PointLoadData: {
                        P13: {
                            Name: "P13",
                            End: 2,
                            Side: 0,
                            Location: 1739.68,
                            Bracket: "FLUB",
                        },
                        P15: {
                            Name: "P15",
                            End: 1,
                            Side: 0,
                            Location: 1739.68,
                            Bracket: "FLUB",
                        },
                        P3: {
                            Name: "P3",
                            End: 2,
                            Side: 0,
                            Location: 3584.78,
                            Bracket: "FLUB",
                        },
                        P7: {
                            Name: "P7",
                            End: 1,
                            Side: 0,
                            Location: 3584.78,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        C2: {
                            Name: "C2",
                            End: 1,
                            Side: 0,
                            Location: 13.42,
                            Bracket: "RRC",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 3753.09,
                            Bracket: "APEX15Z",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "5605",
                        PARENT_LEN: "3796",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2550,
                    TopBracket: "",
                    GroundConnection: "Bolt to Slab",
                    Embedment: 0,
                    ExternalConnector: "0",
                    BaseConnector: "CON",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2550,
                    TopBracket: "",
                    GroundConnection: "Bolt to Slab",
                    Embedment: 0,
                    ExternalConnector: "0",
                    BaseConnector: "CON",
                },
            },
        },
    },
    VDPL00060: {
        AttachmentBracketResults: {},
        BeamResults: {
            "P2,": "0.0629322684411332=Vertical Shear",
            "P5,": "0.116306177997375=Vertical Shear",
            "PR1,PR2,": "0.299751524335055=Collar Tie Tension",
            "P1,P2,": "0.0629322684411332=Vertical Shear",
            "EB3,": "0.185045951897145=Bending Moment",
            "P7,": "0.000598982237475728=Vertical Shear",
            "P6,": "0.116306177997375=Vertical Shear",
            "P8,": "0.00134771003432039=Vertical Shear",
            "P3,": "0.000598982237475728=Vertical Shear",
            "HR2,": "0.0261374821846921=Vertical Shear",
            "HR3,": "0.025415962941039=Vertical Shear",
            "HR1,": "0.025415962941039=Vertical Shear",
            "P4,": "0.00134771003432039=Vertical Shear",
            ",": "0.520370948819248=Bending Moment",
            "P1,": "0.0629322684411332=Vertical Shear",
            "EB4,": "0.520370948819248=Bending Moment",
            "PR3,PR4,": "0.299751524335055=Collar Tie Tension",
            "EB2,": "0.185045951897145=Bending Moment",
            "EB1,": "0.520004669919848=Bending Moment",
            "HR4,": "0.0261374821846921=Vertical Shear",
        },
        ColumnResults: {
            C2: "0.331=Deflection (16.5mm)",
            C1: "0.331=Deflection (16.5mm)",
            C4: "0.331=Deflection (16.5mm)",
            C3: "0.331=Deflection (16.5mm)",
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "",
        MaxResultOverAll: 0.520370948819248,
        AreaMaxResults: {
            0: {
                MaxResult: 0.520370948819248,
                PurlinMax: 0.116306177997375,
                NumColumns: 4,
                NumRafters: 2,
                HipRafterMax: 0.0261374821846921,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 9,
                ColumnsMax: 0.33095278055779,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.331 - Deflection (16.5mm)",
                RafterMax: 0.299751524335055,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.520370948819248,
                JoinBeamMax: 0,
                OtherMax: 0.520370948819248,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 0,
    },
    VDPL00030: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.310528694471773,
        BeamResults: {
            "P2,": "0.0638924183955276=Vertical Shear",
            "P5,": "0.121769646421521=Vertical Shear",
            "PR1,PR2,": "0.197661990451708=Collar Tie Tension",
            "P1,P2,": "0.0638924183955276=Vertical Shear",
            "EB3,": "0.128784039778549=Bending Moment",
            "P7,": "0.0670535724713948=Vertical Shear",
            "P6,": "0.121769646421521=Vertical Shear",
            "P10,": "0.144318392141663=Vertical Shear",
            "P9,": "0.144318392141663=Vertical Shear",
            "P3,": "0.0670535724713948=Vertical Shear",
            "P8,": "0.0670535724713948=Vertical Shear",
            "EB5,": "0.128784039778549=Bending Moment",
            "HR2,": "0.310528694471773=Bending Moment",
            "HR3,": "0.310528694471773=Bending Moment",
            "HR1,": "0.310528694471773=Bending Moment",
            "P4,": "0.0670535724713948=Vertical Shear",
            ",": "0.310528694471773=Bending Moment",
            "EB6,": "0.263540678817847=Bending Moment",
            "P1,": "0.0638924183955276=Vertical Shear",
            "EB4,": "0.26306183557879=Bending Moment",
            "PR3,PR4,": "0.197661990451708=Collar Tie Tension",
            "EB2,": "0.263540678817847=Bending Moment",
            "EB1,": "0.26306183557879=Bending Moment",
            "HR4,": "0.310528694471773=Bending Moment",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C6: "0.300=Deflection (15.0mm)",
            C2: "0.300=Deflection (15.0mm)",
            C1: "0.300=Deflection (15.0mm)",
            C3: "0.300=Deflection (15.0mm)",
            C4: "0.300=Deflection (15.0mm)",
            C5: "0.300=Deflection (15.0mm)",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "",
        AreaMaxResults: {
            0: {
                MaxResult: 0.310528694471773,
                PurlinMax: 0.144318392141663,
                NumColumns: 6,
                NumRafters: 2,
                HipRafterMax: 0.310528694471773,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 11,
                ColumnsMax: 0.299974922820763,
                RATRETSTR: "-1,-1,-1,-1,-1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.300 - Deflection (15.0mm)",
                RafterMax: 0.197661990451708,
                NumFasciaBeams: 0,
                EdgeBeamMax: 0.263540678817847,
                JoinBeamMax: 0,
                OtherMax: 0.310528694471773,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C6: {
                ref: "C6",
                area: 0,
                type: "Column",
                member_size: "100x100x3.0",
                embedment: 500,
                height: 3150,
                total_compression_kn: 5.15339797190625,
                total_tension_kn: -4.95475965650777,
                max_strength: 0.0409385199889117,
                max_deflection_mm: 50,
                max_deflection: 0.299974922820763,
                max_capacity_ratio: 0.299974922820763,
                max_capacity_ratio_limit_state: "Deflection (15.0mm)",
            },
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "100x100x3.0",
                embedment: 500,
                height: 3150,
                total_compression_kn: 6.63256123431213,
                total_tension_kn: -6.24177306081472,
                max_strength: 0.0532378802107662,
                max_deflection_mm: 50,
                max_deflection: 0.299974922820763,
                max_capacity_ratio: 0.299974922820763,
                max_capacity_ratio_limit_state: "Deflection (15.0mm)",
            },
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "100x100x3.0",
                embedment: 500,
                height: 3150,
                total_compression_kn: 5.14815211834822,
                total_tension_kn: -4.94982288679503,
                max_strength: 0.0408953478495071,
                max_deflection_mm: 50,
                max_deflection: 0.299974922820763,
                max_capacity_ratio: 0.299974922820763,
                max_capacity_ratio_limit_state: "Deflection (15.0mm)",
            },
            C3: {
                ref: "C3",
                area: 0,
                type: "Column",
                member_size: "100x100x3.0",
                embedment: 500,
                height: 3150,
                total_compression_kn: 5.15339797190625,
                total_tension_kn: -4.95475965650777,
                max_strength: 0.0409385199889117,
                max_deflection_mm: 50,
                max_deflection: 0.299974922820763,
                max_capacity_ratio: 0.299974922820763,
                max_capacity_ratio_limit_state: "Deflection (15.0mm)",
            },
            C4: {
                ref: "C4",
                area: 0,
                type: "Column",
                member_size: "100x100x3.0",
                embedment: 500,
                height: 3150,
                total_compression_kn: 5.14815211834822,
                total_tension_kn: -4.94982288679503,
                max_strength: 0.0408953478495071,
                max_deflection_mm: 50,
                max_deflection: 0.299974922820763,
                max_capacity_ratio: 0.299974922820763,
                max_capacity_ratio_limit_state: "Deflection (15.0mm)",
            },
            C5: {
                ref: "C5",
                area: 0,
                type: "Column",
                member_size: "100x100x3.0",
                embedment: 500,
                height: 3150,
                total_compression_kn: 6.63256123431213,
                total_tension_kn: -6.24177306081472,
                max_strength: 0.0532378802107662,
                max_deflection_mm: 50,
                max_deflection: 0.299974922820763,
                max_capacity_ratio: 0.299974922820763,
                max_capacity_ratio_limit_state: "Deflection (15.0mm)",
            },
        },
        "BeamResults.TestValueChecksum": 0,
        BeamPointLoadPeakCalcs: [
            {
                BeamName: "PR1,PR2,",
                BeamType: "Welded Rafter",
                Length: 6542,
                Column: "N",
                PointLoads: [
                    {
                        Name: "P3",
                        Location: 1533,
                    },
                    {
                        Name: "P5",
                        Location: 1533,
                    },
                    {
                        Name: "P1",
                        Location: 3107,
                    },
                    {
                        Name: "HR1",
                        Location: 3251,
                    },
                    {
                        Name: "HR2",
                        Location: 3295,
                    },
                    {
                        Name: "P2",
                        Location: 3439,
                    },
                    {
                        Name: "P4",
                        Location: 5014,
                    },
                    {
                        Name: "P6",
                        Location: 5014,
                    },
                ],
            },
            {
                BeamName: "PR3,PR4,",
                BeamType: "Welded Rafter",
                Length: 6542,
                Column: "O",
                PointLoads: [
                    {
                        Name: "P5",
                        Location: 1533,
                    },
                    {
                        Name: "P7",
                        Location: 1533,
                    },
                    {
                        Name: "P1",
                        Location: 3107,
                    },
                    {
                        Name: "HR3",
                        Location: 3251,
                    },
                    {
                        Name: "HR4",
                        Location: 3295,
                    },
                    {
                        Name: "P2",
                        Location: 3439,
                    },
                    {
                        Name: "P6",
                        Location: 5014,
                    },
                    {
                        Name: "P8",
                        Location: 5014,
                    },
                ],
            },
            {
                BeamName: "HR1,",
                BeamType: "Hip Rafter",
                Length: 4275,
                Column: "R",
                PointLoads: [
                    {
                        Name: "P9",
                        Location: 2019,
                    },
                    {
                        Name: "P3",
                        Location: 2025,
                    },
                ],
            },
            {
                BeamName: "HR2,",
                BeamType: "Hip Rafter",
                Length: 4275,
                Column: "S",
                PointLoads: [
                    {
                        Name: "P9",
                        Location: 2019,
                    },
                    {
                        Name: "P4",
                        Location: 2025,
                    },
                ],
            },
            {
                BeamName: "HR3,",
                BeamType: "Hip Rafter",
                Length: 4275,
                Column: "T",
                PointLoads: [
                    {
                        Name: "P10",
                        Location: 2019,
                    },
                    {
                        Name: "P7",
                        Location: 2025,
                    },
                ],
            },
            {
                BeamName: "HR4,",
                BeamType: "Hip Rafter",
                Length: 4275,
                Column: "U",
                PointLoads: [
                    {
                        Name: "P10",
                        Location: 2019,
                    },
                    {
                        Name: "P8",
                        Location: 2025,
                    },
                ],
            },
            {
                BeamName: "EB3,",
                BeamType: "Edge Beam",
                Length: 5790,
                Column: "X",
                PointLoads: [
                    {
                        Name: "HR4",
                        Location: 0,
                    },
                    {
                        Name: "HR3",
                        Location: 5800,
                    },
                ],
            },
            {
                BeamName: "EB5,",
                BeamType: "Edge Beam",
                Length: 5790,
                Column: "Z",
                PointLoads: [
                    {
                        Name: "HR1",
                        Location: 0,
                    },
                    {
                        Name: "HR2",
                        Location: 5800,
                    },
                ],
            },
        ],
        ProcessedLoadData: {
            Beams: {
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2990,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 2,
                            Side: 0,
                            Location: 3000,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "3000",
                        PARENT_LEN: "3000",
                    },
                },
                P2: {
                    Name: "P2",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2990,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR2: {
                            Name: "PR2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 3000,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "3000",
                        PARENT_LEN: "3000",
                    },
                },
                PR1: {
                    Name: "PR1",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 3271,
                    PointLoadData: {
                        P3: {
                            Name: "P3",
                            End: 2,
                            Side: 0,
                            Location: 1533.08,
                            Bracket: "FLUB",
                        },
                        P5: {
                            Name: "P5",
                            End: 1,
                            Side: 0,
                            Location: 1533.08,
                            Bracket: "FLUB",
                        },
                        P1: {
                            Name: "P1",
                            End: 1,
                            Side: 0,
                            Location: 3107.59,
                            Bracket: "FLUB",
                        },
                        HR1: {
                            Name: "HR1",
                            End: 2,
                            Side: 0,
                            Location: 3251.48,
                            Bracket: "HRU",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        EB1: {
                            Name: "EB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "RRC",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 3275.9,
                            Bracket: "APEX20Z",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2975",
                        PARENT_LEN: "3276",
                    },
                },
                PR2: {
                    Name: "PR2",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 3271,
                    PointLoadData: {
                        HR2: {
                            Name: "HR2",
                            End: 2,
                            Side: 0,
                            Location: 24.42,
                            Bracket: "HRU",
                        },
                        P2: {
                            Name: "P2",
                            End: 1,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P4: {
                            Name: "P4",
                            End: 1,
                            Side: 0,
                            Location: 1742.82,
                            Bracket: "FLUB",
                        },
                        P6: {
                            Name: "P6",
                            End: 2,
                            Side: 0,
                            Location: 1742.82,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "APEX20Z",
                        },
                        EB6: {
                            Name: "EB6",
                            End: 2,
                            Side: 0,
                            Location: 3275.9,
                            Bracket: "RRC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2975",
                        PARENT_LEN: "3276",
                    },
                },
                CT1: {
                    Name: "CT1",
                    AreaIndex: 0,
                    BeamType: "FL10011",
                    Length: 2545,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "2975",
                        PARENT_LEN: "2555",
                    },
                },
                PR3: {
                    Name: "PR3",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 3271,
                    PointLoadData: {
                        P5: {
                            Name: "P5",
                            End: 2,
                            Side: 0,
                            Location: 1533.08,
                            Bracket: "FLUB",
                        },
                        P7: {
                            Name: "P7",
                            End: 1,
                            Side: 0,
                            Location: 1533.08,
                            Bracket: "FLUB",
                        },
                        P1: {
                            Name: "P1",
                            End: 2,
                            Side: 0,
                            Location: 3107.59,
                            Bracket: "FLUB",
                        },
                        HR3: {
                            Name: "HR3",
                            End: 2,
                            Side: 0,
                            Location: 3251.48,
                            Bracket: "HRU",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        EB2: {
                            Name: "EB2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "RRC",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 3275.9,
                            Bracket: "APEX20Z",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "6025",
                        PARENT_LEN: "3276",
                    },
                },
                PR4: {
                    Name: "PR4",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 3271,
                    PointLoadData: {
                        HR4: {
                            Name: "HR4",
                            End: 2,
                            Side: 0,
                            Location: 24.42,
                            Bracket: "HRU",
                        },
                        P2: {
                            Name: "P2",
                            End: 2,
                            Side: 0,
                            Location: 168.31,
                            Bracket: "FLUB",
                        },
                        P6: {
                            Name: "P6",
                            End: 1,
                            Side: 0,
                            Location: 1742.82,
                            Bracket: "FLUB",
                        },
                        P8: {
                            Name: "P8",
                            End: 2,
                            Side: 0,
                            Location: 1742.82,
                            Bracket: "FLUB",
                        },
                    },
                    NumPointLoads: 4,
                    SupportData: {
                        PR3: {
                            Name: "PR3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "APEX20Z",
                        },
                        EB4: {
                            Name: "EB4",
                            End: 2,
                            Side: 0,
                            Location: 3275.9,
                            Bracket: "RRC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "Connect",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "6025",
                        PARENT_LEN: "3276",
                    },
                },
                CT2: {
                    Name: "CT2",
                    AreaIndex: 0,
                    BeamType: "FL10011",
                    Length: 2545,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {},
                    NumSupports: 0,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "6025",
                        PARENT_LEN: "2555",
                    },
                },
                HR1: {
                    Name: "HR1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 4275,
                    PointLoadData: {
                        P9: {
                            Name: "P9",
                            End: 2,
                            Side: 0,
                            Location: 2019.64,
                            Bracket: "HRU",
                        },
                        P3: {
                            Name: "P3",
                            End: 1,
                            Side: 0,
                            Location: 2025.48,
                            Bracket: "HRU",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        EB5: {
                            Name: "EB5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 2,
                            Side: 0,
                            Location: 4284.77,
                            Bracket: "HRU",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-45.14",
                        X: "68",
                        PARENT_LEN: "4285",
                    },
                },
                HR2: {
                    Name: "HR2",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 4275,
                    PointLoadData: {
                        P9: {
                            Name: "P9",
                            End: 1,
                            Side: 0,
                            Location: 2019.64,
                            Bracket: "HRU",
                        },
                        P4: {
                            Name: "P4",
                            End: 2,
                            Side: 0,
                            Location: 2025.48,
                            Bracket: "HRU",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        EB5: {
                            Name: "EB5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        C6: {
                            Name: "C6",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 4284.77,
                            Bracket: "HRU",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "45.14",
                        X: "68",
                        PARENT_LEN: "4285",
                    },
                },
                HR3: {
                    Name: "HR3",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 4275,
                    PointLoadData: {
                        P10: {
                            Name: "P10",
                            End: 1,
                            Side: 0,
                            Location: 2019.64,
                            Bracket: "HRU",
                        },
                        P7: {
                            Name: "P7",
                            End: 2,
                            Side: 0,
                            Location: 2025.48,
                            Bracket: "HRU",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        EB3: {
                            Name: "EB3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        C3: {
                            Name: "C3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 2,
                            Side: 0,
                            Location: 4284.77,
                            Bracket: "HRU",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "45.14",
                        X: "8932",
                        PARENT_LEN: "4285",
                    },
                },
                HR4: {
                    Name: "HR4",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 4275,
                    PointLoadData: {
                        P10: {
                            Name: "P10",
                            End: 2,
                            Side: 0,
                            Location: 2019.64,
                            Bracket: "HRU",
                        },
                        P8: {
                            Name: "P8",
                            End: 1,
                            Side: 0,
                            Location: 2025.48,
                            Bracket: "HRU",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        EB3: {
                            Name: "EB3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        C4: {
                            Name: "C4",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 4284.77,
                            Bracket: "HRU",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-45.14",
                        X: "8932",
                        PARENT_LEN: "4285",
                    },
                },
                P3: {
                    Name: "P3",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 1441,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        HR1: {
                            Name: "HR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "HRU",
                        },
                        PR1: {
                            Name: "PR1",
                            End: 2,
                            Side: 0,
                            Location: 1451.37,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "-44.86",
                        FA_2: "0.00",
                        X: "1499",
                        PARENT_LEN: "1451",
                    },
                },
                P4: {
                    Name: "P4",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 1441,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR2: {
                            Name: "PR2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        HR2: {
                            Name: "HR2",
                            End: 2,
                            Side: 0,
                            Location: 1451.37,
                            Bracket: "HRU",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-44.86",
                        X: "2950",
                        PARENT_LEN: "1451",
                    },
                },
                P5: {
                    Name: "P5",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2990,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR3: {
                            Name: "PR3",
                            End: 2,
                            Side: 0,
                            Location: 3000,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "3000",
                        PARENT_LEN: "3000",
                    },
                },
                P6: {
                    Name: "P6",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2990,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR4: {
                            Name: "PR4",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 3000,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "6000",
                        PARENT_LEN: "3000",
                    },
                },
                P7: {
                    Name: "P7",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 1441,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        PR3: {
                            Name: "PR3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        HR3: {
                            Name: "HR3",
                            End: 2,
                            Side: 0,
                            Location: 1451.37,
                            Bracket: "HRU",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "-44.86",
                        X: "6050",
                        PARENT_LEN: "1451",
                    },
                },
                P8: {
                    Name: "P8",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 1441,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        HR4: {
                            Name: "HR4",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "HRU",
                        },
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 1451.37,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "-44.86",
                        FA_2: "0.00",
                        X: "7501",
                        PARENT_LEN: "1451",
                    },
                },
                P9: {
                    Name: "P9",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2979,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        HR2: {
                            Name: "HR2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "HRU",
                        },
                        HR1: {
                            Name: "HR1",
                            End: 2,
                            Side: 0,
                            Location: 2988.85,
                            Bracket: "HRU",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "-45.14",
                        FA_2: "-45.14",
                        X: "1440",
                        PARENT_LEN: "2989",
                    },
                },
                P10: {
                    Name: "P10",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2979,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        HR3: {
                            Name: "HR3",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "HRU",
                        },
                        HR4: {
                            Name: "HR4",
                            End: 2,
                            Side: 0,
                            Location: 2988.85,
                            Bracket: "HRU",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "-45.14",
                        FA_2: "-45.14",
                        X: "7560",
                        PARENT_LEN: "2989",
                    },
                },
                EB1: {
                    Name: "EB1",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 4340,
                    PointLoadData: {
                        PR1: {
                            Name: "PR1",
                            End: 1,
                            Side: 0,
                            Location: 2875,
                            Bracket: "RRC",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 4350,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "9000",
                    },
                },
                EB2: {
                    Name: "EB2",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 4340,
                    PointLoadData: {
                        PR3: {
                            Name: "PR3",
                            End: 1,
                            Side: 0,
                            Location: 1475,
                            Bracket: "RRC",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        C2: {
                            Name: "C2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        C3: {
                            Name: "C3",
                            End: 2,
                            Side: 0,
                            Location: 4350,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "9000",
                    },
                },
                EB3: {
                    Name: "EB3",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 5790,
                    PointLoadData: {
                        HR4: {
                            Name: "HR4",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        HR3: {
                            Name: "HR3",
                            End: 1,
                            Side: 0,
                            Location: 5800,
                            Bracket: "H",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        C4: {
                            Name: "C4",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        C3: {
                            Name: "C3",
                            End: 2,
                            Side: 0,
                            Location: 5800,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "8975",
                        PARENT_LEN: "5900",
                    },
                },
                EB4: {
                    Name: "EB4",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 4340,
                    PointLoadData: {
                        PR4: {
                            Name: "PR4",
                            End: 2,
                            Side: 0,
                            Location: 2875,
                            Bracket: "RRC",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        C4: {
                            Name: "C4",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        C5: {
                            Name: "C5",
                            End: 2,
                            Side: 0,
                            Location: 4350,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "9000",
                        PARENT_LEN: "9000",
                    },
                },
                EB5: {
                    Name: "EB5",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 5790,
                    PointLoadData: {
                        HR1: {
                            Name: "HR1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "H",
                        },
                        HR2: {
                            Name: "HR2",
                            End: 1,
                            Side: 0,
                            Location: 5800,
                            Bracket: "H",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        C6: {
                            Name: "C6",
                            End: 2,
                            Side: 0,
                            Location: 5800,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "25",
                        PARENT_LEN: "5900",
                    },
                },
                EB6: {
                    Name: "EB6",
                    AreaIndex: 0,
                    BeamType: "FL20020",
                    Length: 4340,
                    PointLoadData: {
                        PR2: {
                            Name: "PR2",
                            End: 2,
                            Side: 0,
                            Location: 1475,
                            Bracket: "RRC",
                        },
                    },
                    NumPointLoads: 1,
                    SupportData: {
                        C5: {
                            Name: "C5",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        C6: {
                            Name: "C6",
                            End: 2,
                            Side: 0,
                            Location: 4350,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Beam",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "9000",
                        PARENT_LEN: "9000",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "SHS 100mm x 3mm",
                    Height: 3150,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "SHS 100mm x 3mm",
                    Height: 3150,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C3: {
                    Name: "C3",
                    AreaIndex: 0,
                    ColumnType: "SHS 100mm x 3mm",
                    Height: 3150,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C4: {
                    Name: "C4",
                    AreaIndex: 0,
                    ColumnType: "SHS 100mm x 3mm",
                    Height: 3150,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C5: {
                    Name: "C5",
                    AreaIndex: 0,
                    ColumnType: "SHS 100mm x 3mm",
                    Height: 3150,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
                C6: {
                    Name: "C6",
                    AreaIndex: 0,
                    ColumnType: "SHS 100mm x 3mm",
                    Height: 3150,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "1",
                    BaseConnector: "",
                },
            },
        },
    },
    COFL00162: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.439874434062836,
        BeamResults: {
            ",": "0.439874434062836=Deflection-W UP (-30.9mm)",
            "FB1b,": "0.439874434062836=Deflection-W UP (-30.9mm)",
            "FB1c,": "0.0534533867635363=Vertical Shear",
            "FB1,": "0.439874434062836=Deflection-W UP (-30.9mm)",
            "FB1a,": "0.0534533867635363=Vertical Shear",
            "R2,": "0.0370293417553398=Vertical Shear",
            "R1,": "0.0370293417553398=Vertical Shear",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C1: "0.172=Deflection (8.6mm)",
            C2: "0.172=Deflection (8.6mm)",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "",
        AreaMaxResults: {
            0: {
                MaxResult: 0.439874434062836,
                FasciaMax: 0.439874434062836,
                NumRafters: 2,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 0,
                ColumnsMax: 0.171908440284653,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C1 CR=0.172 - Deflection (8.6mm)",
                RafterMax: 0.0370293417553398,
                NumFasciaBeams: 4,
                JoinBeamMax: 0,
                OtherMax: 0.439874434062836,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "75x75x2.0",
                embedment: 500,
                height: 2250,
                total_compression_kn: 2.86618671749163,
                total_tension_kn: -2.52791338582644,
                max_strength: 0.0648455885296742,
                max_deflection_mm: 50,
                max_deflection: 0.171908440284653,
                max_capacity_ratio: 0.171908440284653,
                max_capacity_ratio_limit_state: "Deflection (8.6mm)",
            },
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "75x75x2.0",
                embedment: 500,
                height: 2250,
                total_compression_kn: 2.86618671749163,
                total_tension_kn: -2.52791338582644,
                max_strength: 0.0648455885296742,
                max_deflection_mm: 50,
                max_deflection: 0.171908440284653,
                max_capacity_ratio: 0.171908440284653,
                max_capacity_ratio_limit_state: "Deflection (8.6mm)",
            },
        },
        "BeamResults.TestValueChecksum": 0,
        BeamPointLoadPeakCalcs: [],
        ProcessedLoadData: {
            Beams: {
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 6000,
                    PointLoadData: {
                        R1: {
                            Name: "R1",
                            End: 1,
                            Side: 0,
                            Location: 25,
                            Bracket: "",
                        },
                        R2: {
                            Name: "R2",
                            End: 1,
                            Side: 0,
                            Location: 5975,
                            Bracket: "",
                        },
                    },
                    NumPointLoads: 2,
                    SupportData: {
                        C1: {
                            Name: "C1",
                            End: 1,
                            Side: 0,
                            Location: 187.5,
                            Bracket: "HCC",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 5812.5,
                            Bracket: "HCC",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "End Cap",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "6000",
                    },
                },
                R1: {
                    Name: "R1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2936,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        F1: {
                            Name: "F1",
                            End: 2,
                            Side: 0,
                            Location: 2957.04,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Fascia",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "25",
                        PARENT_LEN: "3002",
                    },
                },
                R2: {
                    Name: "R2",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 2936,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        FB1: {
                            Name: "FB1",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "",
                        },
                        F1: {
                            Name: "F1",
                            End: 2,
                            Side: 0,
                            Location: 2957.04,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 2,
                    ExtraData: {
                        END_STATE_1: "To Beam",
                        END_STATE_2: "To Fascia",
                        FA_1: "0.00",
                        FA_2: "-0.00",
                        X: "5975",
                        PARENT_LEN: "3002",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "SHS 75mm x 2mm",
                    Height: 2250,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "SHS 75mm x 2mm",
                    Height: 2250,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
            },
        },
    },
    COFL00008: {
        AttachmentBracketResults: {},
        BeamResults: {
            "FB2b,": "0.35452381620764=Bending Moment",
            "FB1b,": "0.0227070731579725=Vertical Shear",
            "FB2a,": "0.378223243700814=Bending Moment",
            "SF1c,": "0.00908633021762683=Deflection (0.1mm)",
            "FB4d,": "0.343000514151386=Vertical Shear",
            "FB4b,FB4c,": "0.428281088700059=Bending Moment",
            "JB3,": "0.427822585736515=Bending Moment",
            "FB5b,": "0.204697736765852=Bending Moment",
            "R1,": "0.00918926766461662=Vertical Shear",
            "FB5c,": "0.193658980373008=Bending Moment",
            "FB5d,": "0.47453690703832=Deflection-W UP (-1.1mm)",
            "FB2c,": "0.443397785773498=Vertical Shear",
            "SF1,": "0.0477129610675682=Vertical Shear",
            "FB4a,": "0.00970529069134735=Vertical Shear",
            ",": "0.625940483796912=Deflection-W UP (-50.1mm)",
            "FB3c,": "0.0299762102793294=Vertical Shear",
            "SF1b,": "0.0477129610675682=Vertical Shear",
            "FB3d,": "0.0405676959839953=Deflection (0.3mm)",
            "FB5a,": "0.318250216249308=Vertical Shear",
            "FB1,": "0.0227070731579725=Vertical Shear",
            "R1a,": "0.00224377118914649=Vertical Shear",
            "R1b,": "0.00918926766461662=Vertical Shear",
            "JB1,": "0.427822585736515=Bending Moment",
            "FB3a,": "0.625940483796912=Deflection-W UP (-50.1mm)",
            "FB4,": "0.428281088700059=Bending Moment",
            "FB5,": "0.47453690703832=Deflection-W UP (-1.1mm)",
            "FB3b,": "0.403488223518253=Bending Moment",
            "FB2,": "0.443397785773498=Vertical Shear",
            "FB1c,": "0.01026092851757=Deflection (0.1mm)",
            "FB3,": "0.625940483796912=Deflection-W UP (-50.1mm)",
            "JB2,": "0.425855470077597=Bending Moment",
            "FB1a,": "0.0114534461304217=Vertical Shear",
            "SF1a,": "0.00276746867318831=Vertical Shear",
        },
        ColumnResults: {
            C11: "0.727=Deflection (36.4mm)",
            C6: "0.272=Deflection (13.6mm)",
            C2: "0.498=Deflection (24.9mm)",
            C1: "0.498=Deflection (24.9mm)",
            C3: "0.516=Deflection (25.8mm)",
            C9: "0.803=Deflection (40.2mm)",
            C12: "0.498=Deflection (24.9mm)",
            C4: "0.272=Deflection (13.6mm)",
            C8: "0.727=Deflection (36.4mm)",
            C7: "0.822=Deflection (41.1mm)",
            C5: "0.272=Deflection (13.6mm)",
            C10: "0.822=Deflection (41.1mm)",
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "Limiting Member = C7 CR=0.822 - Deflection (41.1mm)",
        MaxResultOverAll: 0.822041595391665,
        AreaMaxResults: {
            0: {
                MaxResult: 0.516124624569416,
                FasciaMax: 0.428281088700059,
                NumRafters: 7,
                NumColumns: 4,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C3 CR=0.516 - Deflection (25.8mm)",
                NumPurlins: 0,
                ColumnsMax: 0.516124624569416,
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                ColumnsMaxText: "Limiting Member = C3 CR=0.516 - Deflection (25.8mm)",
                RafterMax: 0.0477129610675682,
                NumFasciaBeams: 4,
                JoinBeamMax: 0.427822585736515,
                AttachmentBracketsMax: -1,
            },
            1: {
                MaxResult: 0.47453690703832,
                FasciaMax: 0.47453690703832,
                NumRafters: 0,
                NumColumns: 3,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 0,
                ColumnsMax: 0.272289044503093,
                ColumnsMaxText: "Limiting Member = C4 CR=0.272 - Deflection (13.6mm)",
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                NumFasciaBeams: 5,
                JoinBeamMax: 0.425855470077597,
                AttachmentBracketsMax: -1,
            },
            2: {
                MaxResult: 0.822041595391665,
                FasciaMax: 0.443397785773498,
                NumRafters: 0,
                NumColumns: 2,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C7 CR=0.822 - Deflection (41.1mm)",
                NumPurlins: 0,
                ColumnsMax: 0.822041595391665,
                ColumnsMaxText: "Limiting Member = C7 CR=0.822 - Deflection (41.1mm)",
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                NumFasciaBeams: 4,
                JoinBeamMax: 0.427822585736515,
                AttachmentBracketsMax: -1,
            },
            3: {
                MaxResult: 0.80302801105415,
                FasciaMax: 0.625940483796912,
                NumRafters: 0,
                NumColumns: 3,
                AttachmentBracketsMaxText: "",
                MaxResultText: "Limiting Member = C9 CR=0.803 - Deflection (40.2mm)",
                NumPurlins: 0,
                ColumnsMax: 0.80302801105415,
                ColumnsMaxText: "Limiting Member = C9 CR=0.803 - Deflection (40.2mm)",
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 1",
                NumFasciaBeams: 9,
                JoinBeamMax: 0,
                OtherMax: 0.625940483796912,
                AttachmentBracketsMax: -1,
            },
        },
        "BeamResults.TestValueChecksum": 0,
    },
    COFL00154: {
        AttachmentBracketResults: {},
        MaxResultOverAll: 0.430452047222158,
        BeamResults: {
            "P1a,P1b,": "0.430452047222158=Vertical Shear",
            "P1,": "0.430452047222158=Vertical Shear",
            "FB1,": "0.309972538061462=Vertical Shear",
            "FB1a,FB1b,": "0.309972538061462=Vertical Shear",
            ",": "0.430452047222158=Vertical Shear",
        },
        BeamResultsDetailed: {},
        ColumnResults: {
            C2: "0.065=Strength",
            C1: "0.092=Strength",
            C4: "0.045=Strength",
            C3: "0.032=Strength",
        },
        AttachmentBracketResultsDetailed: {},
        Errors: {
            max_beam_column_exceeded: false,
            max_col_column_exceeded: false,
        },
        BeamAttachmentBracketResults: {},
        maxResultOverAllText: "",
        AreaMaxResults: {
            0: {
                MaxResult: 0.430452047222158,
                PurlinMax: 0.430452047222158,
                FasciaMax: 0.309972538061462,
                NumRafters: 0,
                NumColumns: 4,
                AttachmentBracketsMaxText: "",
                MaxResultText: "",
                NumPurlins: 2,
                ColumnsMax: 0.0918167748573923,
                ColumnsMaxText: "Limiting Member = C1 CR=0.092 - Strength",
                RATRETSTR: "-1.0000000,-1.0000000,-1.0000000,-1.0000000,-1.0000000,Type 4",
                NumFasciaBeams: 2,
                JoinBeamMax: 0,
                OtherMax: 0.430452047222158,
                AttachmentBracketsMax: -1,
            },
        },
        ColumnResultsDetailed: {
            C2: {
                ref: "C2",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2161,
                total_compression_kn: 3.81437037124517,
                total_tension_kn: -6.38543428406612,
                max_strength: 0.0650500108995632,
                max_deflection_mm: 50,
                max_deflection: 0.0144721318989594,
                max_capacity_ratio: 0.0650500108995632,
                max_capacity_ratio_limit_state: "Strength",
            },
            C1: {
                ref: "C1",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2293,
                total_compression_kn: 5.29693225546472,
                total_tension_kn: -8.86731217277646,
                max_strength: 0.0918167748573923,
                max_deflection_mm: 50,
                max_deflection: 0.018345504672899,
                max_capacity_ratio: 0.0918167748573923,
                max_capacity_ratio_limit_state: "Strength",
            },
            C4: {
                ref: "C4",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2293,
                total_compression_kn: 2.64846612773236,
                total_tension_kn: -4.43365608638823,
                max_strength: 0.0447563923112156,
                max_deflection_mm: 50,
                max_deflection: 0.018345504672899,
                max_capacity_ratio: 0.0447563923112156,
                max_capacity_ratio_limit_state: "Strength",
            },
            C3: {
                ref: "C3",
                area: 0,
                type: "Column",
                member_size: "90x90x2.0",
                embedment: 500,
                height: 2161,
                total_compression_kn: 1.90718518562258,
                total_tension_kn: -3.19271714203306,
                max_strength: 0.0319711670014292,
                max_deflection_mm: 50,
                max_deflection: 0.0144721318989594,
                max_capacity_ratio: 0.0319711670014292,
                max_capacity_ratio_limit_state: "Strength",
            },
        },
        "BeamResults.TestValueChecksum": 0,
        BeamPointLoadPeakCalcs: [],
        ProcessedLoadData: {
            Beams: {
                P1: {
                    Name: "P1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 5845,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        F2: {
                            Name: "F2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        C1: {
                            Name: "C1",
                            End: 2,
                            Side: 0,
                            Location: 2925,
                            Bracket: "FLUB",
                        },
                        C4: {
                            Name: "C4",
                            End: 2,
                            Side: 0,
                            Location: 5805,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Fascia",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "5850",
                    },
                },
                FB1: {
                    Name: "FB1",
                    AreaIndex: 0,
                    BeamType: "FL15015",
                    Length: 6445,
                    PointLoadData: {},
                    NumPointLoads: 0,
                    SupportData: {
                        W2: {
                            Name: "W2",
                            End: 1,
                            Side: 0,
                            Location: 0,
                            Bracket: "FLUB",
                        },
                        C2: {
                            Name: "C2",
                            End: 2,
                            Side: 0,
                            Location: 3225,
                            Bracket: "FLUB",
                        },
                        C3: {
                            Name: "C3",
                            End: 2,
                            Side: 0,
                            Location: 6405,
                            Bracket: "FLUB",
                        },
                    },
                    NumSupports: 3,
                    ExtraData: {
                        END_STATE_1: "To Wall",
                        END_STATE_2: "End Cap",
                        FA_1: "0.00",
                        FA_2: "0.00",
                        X: "00",
                        PARENT_LEN: "5850",
                    },
                },
            },
            Cols: {
                C1: {
                    Name: "C1",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2293,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C2: {
                    Name: "C2",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2161,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C3: {
                    Name: "C3",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2161,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
                C4: {
                    Name: "C4",
                    AreaIndex: 0,
                    ColumnType: "SHS 90mm x 2mm",
                    Height: 2293,
                    TopBracket: "",
                    GroundConnection: "Concrete In",
                    Embedment: 500,
                    ExternalConnector: "0",
                    BaseConnector: "",
                },
            },
        },
    },
};

export const FIELDERS_BOM_JOBS = {
    FIRC00048: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CD42DS",
            Desc: "C-Dek 310 0.42BMT **H**",
            Use: "",
            Colour: "Surfmist/Surfmist",
            Area: "1",
            Qty: "79 x 1392",
            Length: "1392",
            CodeBase: "CD42DS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CDK42**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1220100B8","Qty":"=Qty*3","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Use":"!=*B/C Fixed*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FG",
            Desc: "Fascia Gutter **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 24197",
            Length: "24197",
            CodeBase: "FG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGF55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"JSTRAP","Use":"Gutter Clip","Qty":"=(Length/900)+1"},{"Code":"SCTF","Qty":"=(Length/900)+1"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGLSE",
            Desc: "Fascia Gutter LH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGRSE",
            Desc: "Fascia Gutter RH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO656Z",
            Desc: "65X65 Pop Square Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "PO656Z",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPP6565ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DP656",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DP656",
            Desc: "65X65 Downpipe ** 1800mm",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 x 1800",
            Length: "1800",
            CodeBase: "DP656",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DP6565**18",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8"},{"Code":"ST656","Qty":"=(Length/1200)"}]}',
            PromptCodes: "Length=1800 AltIndex=DP656_INTERNAL",
            Image_b64: null,
            PromptTextCodes: "Length=1800 AltIndex=DP656_INTERNAL",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL22",
            Desc: "Cen CFL22 C-Dek 310 Barge **H**",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 x 1332 (Cent 310 Deck Barge Capping)",
            Length: "1332",
            CodeBase: "CFL22",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL22**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL47",
            Desc: "Cen CFL47 Barge Cap C-Deck Freespan **H**",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 24197 (Carport 108 Barge Capping)",
            Length: "24197",
            CodeBase: "CFL47",
            CodeAppend: "",
            DescAppend: "(290mm width cut (CFL47))",
            "CL ID": "0",
            Fielders_Code: "CNCFL47**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB108",
            Desc: "Cen Box Beam 108x65x0.95BMT **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 x 6497 (Back Fascia Beam)|2 x 5601 (Back Fascia Beam)|1 x 6685 (Fascia Beam)|1 x 6478 (Fascia Beam)|1 x 5499 (Fascia Beam)|1 x 5429 (Fascia Beam)|1 x 1185 (Left Rafter)|1 x 1185 (Right Rafter)",
            Length: "6497",
            CodeBase: "BB108",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9510865H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "BB65",
            Desc: "Cen Box Beam 65x65x0.95BMT **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "3 x 2979 (Post on Slab (Beam to Side))|3 x 2871 (Post on Slab (Under Beam))",
            Length: "2979",
            CodeBase: "BB65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB956565H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "AltIndex=BB656575",
            Image_b64: null,
            PromptTextCodes: "AltIndex=BB656575",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS65",
            Desc: "Cen 65X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "6 (For Post)",
            Length: "",
            CodeBase: "CBBS65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS26565H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Back Fascia Beam) <removed in production>",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 (For Back Fascia Beam)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK16RHS6565G",
            Desc: "Cen BK16 Galv Internal Slab Conn to suit 65x65 SHS ",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "6 (For Post)",
            Length: "",
            CodeBase: "BK16RHS6565G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK16PS65GA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"4","Colour":"Area.PostColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK210865",
            Desc: "Cen BK2 10865 **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 (For Fascia Beam Fixed to 65mm Post)|1 (For Left Rafter Fixed to 65mm Post)|1 (For Right Rafter Fixed to 65mm Post)",
            Length: "",
            CodeBase: "BK210865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB108**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK25G",
            Desc: "Cen BK25D RSBFD Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "27",
            Length: "",
            CodeBase: "BK25G",
            CodeAppend: "",
            DescAppend: "; Step out 125mm",
            "CL ID": "0",
            Fielders_Code: "CNBK25DGA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BNW1090","Qty":"2"},{"Code":"BNW1060Z","Qty":"2"},{"Code":"BK2164G","Qty":"2"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON510865G",
            Desc: "Cen CON5 10865 300 Beam Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "3 (For Back Fascia Beam)|3 (For Fascia Beam)",
            Length: "",
            CodeBase: "CON510865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON5108GA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Colour":"Area.BeamColour","Qty":"16"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
    ],
    ZAPC00248: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CO42DSS",
            Desc: "Corr S-Rib 0.42BMT DS **H**",
            Use: "",
            Colour: "Paperbark/Paperbark",
            Area: "1",
            Qty: "16 x 1583",
            Length: "1583",
            CodeBase: "CO42DSS",
            CodeAppend: "",
            DescAppend: " <REDIRECTED MEN FROM CO42DS>",
            "CL ID": "0",
            Fielders_Code: "CO42**H**CS",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1245B8100","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*4)+7)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1245B8100","Use":"Roof Fix","Conditions":{"Use":"!=*B/C Fixed*"},"Qty":"=Qty*6","Colour":"Area.RoofSheetColour"}]}',
            PromptCodes: "DISABLED=LSB|GIL|GAW|WAN|NOA|KEW|EMU|NUN|LAU|MAR|MIN|CAM",
            Image_b64: null,
            PromptTextCodes: "DISABLED=LSB|GIL|GAW|WAN|NOA|KEW|EMU|NUN|LAU|MAR|MIN|CAM",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "FCTZ",
            Desc: "FCTZ Gutter Capping (Zinc only)",
            Use: "",
            Colour: "Zinc",
            Area: "1",
            Qty: "3 x 2400 (Gutter Capping/finish @6000mm)",
            Length: "2400",
            CodeBase: "FCTZ",
            CodeAppend: "",
            DescAppend: "(FCTZ)",
            "CL ID": "0",
            Fielders_Code: "FCTL5SZL2400",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "Length=2400 AltIndex=FCTZ_INTERNAL",
            Image_b64: null,
            PromptTextCodes: "Length=2400 AltIndex=FCTZ_INTERNAL",
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FG",
            Desc: "Fascia Gutter **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 x 6000",
            Length: "6000",
            CodeBase: "FG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGF55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"JSTRAP","Use":"Gutter Clip","Qty":"=(Length/900)+1"},{"Code":"SCTF","Qty":"=(Length/900)+1"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGLSE",
            Desc: "Fascia Gutter LH Stop End **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1|1 (Gutter Capping)",
            Length: "",
            CodeBase: "FGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSEL**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGRSE",
            Desc: "Fascia Gutter RH Stop End **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1|1 (Gutter Capping)",
            Length: "",
            CodeBase: "FGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSER**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO90SWZ",
            Desc: "90mm Rnd Pop (Suit Pvc & Metal D/Pipe) Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "PO90SWZ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PVC90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PVC90",
            Desc: "90mm Pvc Stormwater Pipe 6000mm",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "2 x 2220",
            Length: "2220",
            CodeBase: "PVC90",
            CodeAppend: "",
            DescAppend: " (finish 2220mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH6000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"=(Length/1200)","Use":"Downpipe Fix"},{"Code":"FR72","Qty":"4"},{"Code":"ST90","Qty":"2"}]}',
            PromptCodes: "Length=6000",
            Image_b64: null,
            PromptTextCodes: "Length=6000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL01",
            Desc: "Cen CFL01 Barge Cap **H**",
            Use: "",
            Colour: "Paperbark/Paperbark",
            Area: "1",
            Qty: "4 x 1592 (Corrugated - C/Bond D/S 0.42 (No Foot Traffic) Barge Capping)",
            Length: "1592",
            CodeBase: "CFL01",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL01**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL06",
            Desc: "Cen CFL06 Gable Infil Flash **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 x 3445 (Infill Trim Flashing)",
            Length: "3445",
            CodeBase: "CFL06",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL06**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL51",
            Desc: "Cen CFL51 Ridge Cap **H** @@",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 6300",
            Length: "6300",
            CodeBase: "CFL51",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL51**H**@@",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Ridge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Ridge Capping Fix",\n    "Qty" : "=(Length/380) + 2"}\n]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB108",
            Desc: "Cen Box Beam 108x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "3 x 1555 (Portal Rafter (No Post))|3 x 1516 (Portal Rafter (Standard))",
            Length: "1555",
            CodeBase: "BB108",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "2",
            Fielders_Code: "CBB9510865H**",
            "CL DATA": {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "-20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=RNP20108=Rafter no post 20 Deg 108 Section",
                    HolePunchingRecommend: "RNP20108=Rafter no post 20 Deg 108 Section",
                    Section: "1086510",
                    CutLength: "1555",
                    FinishLength: "1495",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Portal Rafter (No Post)`Paperbark - PB``1`3`1555`1495`0.0`20.0`-20.0`0.0`0.0`PUNCH_STYLE=RNP20108=Rafter no post 20 Deg 108 Section`234`1321`0`0`Paperbark` 2`1086510`0`0",
                },
                1: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20108=Portal Rafter 20 Deg 108 section",
                    HolePunchingRecommend: "P20108=Portal Rafter 20 Deg 108 section",
                    Section: "1086510",
                    CutLength: "1516",
                    FinishLength: "1456",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Portal Rafter (Standard)`Paperbark - PB``1`3`1516`1456`0.0`35.0`20.0`0.0`0.0`PUNCH_STYLE=P20108=Portal Rafter 20 Deg 108 section`278`1003`234`114`Paperbark` 1`1086510`0`0",
                },
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "-20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=RNP20108=Rafter no post 20 Deg 108 Section",
                    HolePunchingRecommend: "RNP20108=Rafter no post 20 Deg 108 Section",
                    Section: "1086510",
                    CutLength: "1555",
                    FinishLength: "1495",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Portal Rafter (No Post)`Paperbark - PB``1`3`1555`1495`0.0`20.0`-20.0`0.0`0.0`PUNCH_STYLE=RNP20108=Rafter no post 20 Deg 108 Section`234`1321`0`0`Paperbark` 2`1086510`0`0",
                },
                1: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20108=Portal Rafter 20 Deg 108 section",
                    HolePunchingRecommend: "P20108=Portal Rafter 20 Deg 108 section",
                    Section: "1086510",
                    CutLength: "1516",
                    FinishLength: "1456",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Portal Rafter (Standard)`Paperbark - PB``1`3`1516`1456`0.0`35.0`20.0`0.0`0.0`PUNCH_STYLE=P20108=Portal Rafter 20 Deg 108 section`278`1003`234`114`Paperbark` 1`1086510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 6000 (Attachment Beam (Back))|1 x 6000 (Perimeter Beam (Front))",
            Length: "6000",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB65",
            Desc: "Cen Box Beam 65x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 x 2865 (Gable Infill Beam)|2 x 1000 (Portal Strut)|2 x 6000 (Purlin T1)",
            Length: "2865",
            CodeBase: "BB65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "3",
            Fielders_Code: "CBB956565H**",
            "CL DATA": {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "-70.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "656510",
                    CutLength: "2865",
                    FinishLength: "2835",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB65`Cen Box Beam 65x65x0.95BMT **`Gable Infill Beam`Paperbark - PB``1`2`2865`2835`0.0`-70.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Paperbark` 3`656510`0`0",
                },
                1: {
                    CutPlane: "Front",
                    LeftAngle: "0.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN=NO PUNCHING",
                    HolePunchingRecommend: "PLAIN=NO PUNCHING",
                    Section: "656510",
                    CutLength: "1000",
                    FinishLength: "746",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB65`Cen Box Beam 65x65x0.95BMT **`Portal Strut`Paperbark - PB``1`2`1000`746`0.0`0.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN=NO PUNCHING`0`0`0`0`Paperbark` 4`656510`0`0",
                },
                2: null,
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "AltIndex=BB656575",
            Image_b64: null,
            PromptTextCodes: "AltIndex=BB656575",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "-70.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "656510",
                    CutLength: "2865",
                    FinishLength: "2835",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB65`Cen Box Beam 65x65x0.95BMT **`Gable Infill Beam`Paperbark - PB``1`2`2865`2835`0.0`-70.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Paperbark` 3`656510`0`0",
                },
                1: {
                    CutPlane: "Front",
                    LeftAngle: "0.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN=NO PUNCHING",
                    HolePunchingRecommend: "PLAIN=NO PUNCHING",
                    Section: "656510",
                    CutLength: "1000",
                    FinishLength: "746",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB65`Cen Box Beam 65x65x0.95BMT **`Portal Strut`Paperbark - PB``1`2`1000`746`0.0`0.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN=NO PUNCHING`0`0`0`0`Paperbark` 4`656510`0`0",
                },
                2: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "BB108",
            Desc: "Cen Box Beam 108x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "3 x 3054 (Post in Ground (Standard) (Under Beam))",
            Length: "3054",
            CodeBase: "BB108",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "5",
            Fielders_Code: "CBB9510865H**",
            "CL DATA": {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST108=Post 108 section",
                    HolePunchingRecommend: "POST108=Post 108 section",
                    Section: "1086510",
                    CutLength: "3054",
                    FinishLength: "3024",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Post in Ground (Standard) (Under Beam)`Paperbark - PB``1`3`3054`3024`0.0`35.0`0.0`0.0`0.0`PUNCH_STYLE=POST108=Post 108 section`158`278`2776`0`Paperbark` 5`1086510`0`0",
                },
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST108=Post 108 section",
                    HolePunchingRecommend: "POST108=Post 108 section",
                    Section: "1086510",
                    CutLength: "3054",
                    FinishLength: "3024",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Post in Ground (Standard) (Under Beam)`Paperbark - PB``1`3`3054`3024`0.0`35.0`0.0`0.0`0.0`PUNCH_STYLE=POST108=Post 108 section`158`278`2776`0`Paperbark` 5`1086510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS108",
            Desc: "Cen 108X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "CBBS108",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS210865H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Portal Strut)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK310865-S",
            Desc: "Cen BK3 10865 @@ ** ",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "3 (For Portal Rafter (No Post))",
            Length: "",
            CodeBase: "BK310865",
            CodeAppend: "-S.20DEG UP",
            DescAppend: "20 Degrees Up",
            "CL ID": "1",
            Fielders_Code: "CNBK3CB108@@**",
            "CL DATA": {
                0: {
                    BracketType: "BK3",
                    Angle1: "-20.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK3",
                    Angle1: "-20.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK336565",
            Desc: "Cen BK33 6565 @@ ** ",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "4 (For Gable Infill Beam)",
            Length: "",
            CodeBase: "BK336565",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNBK33C65@@**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8","Colour":"Area.RafterColour"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK36",
            Desc: "Cen BK36 Top Gable End Strut **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Portal Strut)",
            Length: "",
            CodeBase: "BK36",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK36CT**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK38",
            Desc: "Cen BK38 Rafter Bracket Sleeve **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "4",
            Length: "",
            CodeBase: "BK38",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK38**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Use":"BK38 Fix","Qty":"2"},{"Code":"10X90","Qty":"2","Colour":"Area.BeamColour","Use":"BK38 Fix"},{"Code":"TS1232B8100","Qty":"3","Colour":"Area.BeamColour","Use":"BK38 Fix"},{"Code":"BK34RB15G","Conditions":{"Use":"=*15 Degrees*"}},{"Code":"BK34RB175G","Conditions":{"Use":"=*17.5 Degrees*"}},{"Code":"BK34RB20G","Conditions":{"Use":"=*20 Degrees*"}},{"Code":"BK34RB225G","Conditions":{"Use":"=*22.5 Degrees*"}},{"Code":"BK34RB25G","Conditions":{"Use":"=*25 Degrees*"}},{"Code":"BK34RB275G","Conditions":{"Use":"=*27.5 Degrees*"}},{"Code":"BK34RB30G","Conditions":{"Use":"=*30 Degrees*"}}]}',
            PromptCodes: "$$=38.62",
            Image_b64: null,
            PromptTextCodes: "$$=38.62",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK88158",
            Desc: "Cen BK88 158 Box Beam Stop End **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (End Cap for Attachment Beam (Back))|2 (End Cap for Perimeter Beam (Front))",
            Length: "",
            CodeBase: "BK88158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK88158SE**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Use":"Beam End Cap Fix"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON110865G",
            Desc: "Cen CON1 10865 Galv Inground Connector",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "CON110865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON1108GA",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"10X120","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON210865G",
            Desc: "Cen CON2 10865-@@ Ridge Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "3 (For Portal Rafter (No Post))",
            Length: "",
            CodeBase: "CON210865G",
            CodeAppend: "",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNCON2108GA@@",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BHSS1025SL","Use":"Con2 Fix","Qty":"8","Colour":"Plain"},{"Code":"TS1220100B8N","Use":"Con2 Fix","Colour":"Area.RafterColour","Qty":"4"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON310865G",
            Desc: "Cen CON3 10865-@@ Eaves Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "3 (For Portal Rafter (Standard))",
            Length: "",
            CodeBase: "CON310865G",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNCON3108GA@@",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BHSS1025SL","Qty":"8","Colour":"Plain"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.RafterColour","Qty":"2"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "10X90",
            Desc: "Cen Bolt Nut G4.6 10X90 **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "3 (Attachment Beam (Back) Fix)|3 (Perimeter Beam (Front) Fix)",
            Length: "",
            CodeBase: "10X90",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BN1090**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: 'Desc="10x90mm Bolt(s)"',
            Image_b64: null,
            PromptTextCodes: 'Desc="10x90mm Bolt(s)"',
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "TS1495100B8P",
            Desc: "BF 14-10X95 H/H Tek No Neo B8 Plain (Pkt 100)",
            Use: "",
            Colour: "Plain",
            Area: "1",
            Qty: "12 (Purlin T1 Fix)",
            Length: "",
            CodeBase: "TS1495100B8P",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHBF1495N100",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "100",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: 'Desc="14x90 Hex Screw(s)" AltIndex=TS1495,TS1495P',
            Image_b64: null,
            PromptTextCodes: 'Desc="14x90 Hex Screw(s)" AltIndex=TS1495,TS1495P',
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "MISC",
            Code: "COCOVER",
            Desc: "Corrugated Cover Sheet Only (Metal)",
            Use: "",
            Colour: "",
            Area: "",
            Qty: "2 x 1583 (Sheet Cover Sheet)",
            Length: "1583",
            CodeBase: "COCOVER",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PACCSSLM",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "$$=1",
            Image_b64: null,
            PromptTextCodes: "$$=1",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "MISC",
            Code: "FCD2412",
            Desc: "2400 X 1200 6.00mm Fibre Cement Sheet Plain",
            Use: "",
            Colour: "Plain",
            Area: "1",
            Qty: "2 (Infill-Plain Smooth)",
            Length: "",
            CodeBase: "FCD2412",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNFCSH",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TSW1022","Qty":"30","Use":"Infill Fix"},{"Code":"STK05","Qty":"1","Use":"Infill Fix"},{"Code":"BK30G","Qty":"3","Use":"Infill Support","Conditions":{"Use":"=*Infill*"},"Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    FTLC00440: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CO42DSS",
            Desc: "Corr S-Rib 0.42BMT DS **H**",
            Use: "",
            Colour: "Woodland Grey/Paperbark",
            Area: "1",
            Qty: "14 x 2525",
            Length: "2525",
            CodeBase: "CO42DSS",
            CodeAppend: "",
            DescAppend: " <REDIRECTED MEN FROM CO42DS>",
            "CL ID": "0",
            Fielders_Code: "CO42**H**CS",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1245B8100","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*4)+7)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1245B8100","Use":"Roof Fix","Conditions":{"Use":"!=*B/C Fixed*"},"Qty":"=Qty*6","Colour":"Area.RoofSheetColour"}]}',
            PromptCodes: "DISABLED=LSB|GIL|GAW|WAN|NOA|KEW|EMU|NUN|LAU|MAR|MIN|CAM",
            Image_b64: null,
            PromptTextCodes: "DISABLED=LSB|GIL|GAW|WAN|NOA|KEW|EMU|NUN|LAU|MAR|MIN|CAM",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CD42DS",
            Desc: "C-Dek 310 0.42BMT **H**",
            Use: "",
            Colour: "Woodland Grey/Paperbark",
            Area: "2",
            Qty: "19 x 2051 (B/C Fixed)",
            Length: "2051",
            CodeBase: "CD42DS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CDK42**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1220100B8","Qty":"=Qty*3","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Use":"!=*B/C Fixed*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POLYCARBONATE ROOFING",
            Code: "PSCSC",
            Desc: "Ampelite Solasafe Corrugated Polycarbonate Sheet  **",
            Use: "",
            Colour: "Smooth Cream",
            Area: "1",
            Qty: "4 x 2700 (/finish @2525mm)",
            Length: "2700",
            CodeBase: "PSCSC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PCCO**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"CLEARFIX","Qty":"=((Area.NumInternalPurlins*3)+12)*Qty","Colour":"Plain","Conditions":{"Brand":"=Fielders"}},{"Code":"BK30G","Qty":"3","Use":"Infill Support","Conditions":{"Use":"=*Infill*","Brand":"=Fielders"}},{"Code":"CPCB36","Conditions":{"Brand":"=Fielders"},"Qty":"=(((Length/900)+1)*1000)/25000"},{"Code":"FT50MP","Qty":"=((Area.NumInternalPurlins*4)+4)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT45MR","Qty":"=((Area.NumInternalPurlins*2)+4)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"WG","Qty":"=((Area.NumInternalPurlins*6)+4)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FR64","Qty":"=Qty*6","Colour":"Area.BeamColour","Conditions":{"Brand":"=Lysaght","Area.DesignType":"=Flat Roof"}},{"Code":"WASHM","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Area.DesignType":"=Flat Roof"},"Qty":"=Qty*6"},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*9)+2)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT50MP","Qty":"=((Area.NumInternalPurlins*4)+2)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT45MR","Qty":"=((Area.NumInternalPurlins*2)+2)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"WGFG","Qty":"=((Area.NumInternalPurlins*2)+8)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT30M","Qty":"=6*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*9)+2)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT35_WCB","Qty":"=12*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"COFILL","Length":"915","Conditions":{"Brand":"=Lysaght"}}]}',
            PromptCodes:
                "SL=1800(201300)|2100(201300)|2400(201300)|2700(201300)|3000(201300)|3600(201300)|4200(201300)|4800(201300)|5400(201300)|6000(201300)",
            Image_b64: null,
            PromptTextCodes:
                "SL=1800(201300)|2100(201300)|2400(201300)|2700(201300)|3000(201300)|3600(201300)|4200(201300)|4800(201300)|5400(201300)|6000(201300)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POLYCARBONATE ROOFING",
            Code: "PSCD",
            Desc: "C-Dek 310 Polycarbonate (1.50mm Thick) Sheet",
            Use: "",
            Colour: "Opal",
            Area: "2",
            Qty: "2 x 2500 (B/C Fixed/finish @2051mm)",
            Length: "2500",
            CodeBase: "PSCD",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PCSCDK310OP",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"CLEARFIX","Qty":"=((Area.NumInternalPurlins*3)+12)*Qty","Colour":"Plain"},{"Code":"BK30G","Qty":"3","Use":"Infill Support","Conditions":{"Use":"=*Infill*"}}]}',
            PromptCodes:
                "SL=1000(206000)|1500(206000)|2000(206000)|2500(206000)|3000(206000)|3500(206000)|4000(206000)|4500(206000)|5000(206000)|5500(206000)|6000(206000)|6500(206000)|7000(206000)|7500(206000)|8000(206000)",
            Image_b64: null,
            PromptTextCodes:
                "SL=1000(206000)|1500(206000)|2000(206000)|2500(206000)|3000(206000)|3500(206000)|4000(206000)|4500(206000)|5000(206000)|5500(206000)|6000(206000)|6500(206000)|7000(206000)|7500(206000)|8000(206000)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "MSJ",
            Desc: "****** Product Not Found: (Box Gutter) <removed in production>",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "4 (Box Gutter)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FL",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "D115",
            Desc: "115 D/Quad Gutter **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 x 1990",
            Length: "1990",
            CodeBase: "D115",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DQG42115**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"SCTF","Use":"Gutter Clip","Qty":"=(Length/900)+1"},{"Code":"DGUB","Qty":"=(Length/900)+1"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "D115LSE",
            Desc: "115 D/Quad Gutter LH Stop End **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "D115LSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DQG115SEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "D115",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "D115RSE",
            Desc: "115 D/Quad Gutter RH Stop End **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "D115RSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DQG115SER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "D115",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "FL354",
            Desc: "Single sided Flashing 350 X 0.55 ** 4 Bend",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 5800 (A1-Box Gutter)|1 x 4510 (A1-Box Gutter)",
            Length: "5800",
            CodeBase: "FL354",
            CodeAppend: "",
            DescAppend: "200mm",
            "CL ID": "0",
            Fielders_Code: "CF55**3504",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"TS1016100B8",\n    "Qty":"=(2*(Length/1000))+2", \n    "Use":"Box Gutter Fix", \n    "Conditions":{"Use":"=Box Gutter"}}\n]}',
            PromptCodes: "DISABLED=GIL|MEN|MAR|GAW|NOA|MIN|LSB|EMU",
            Image_b64: null,
            PromptTextCodes: "DISABLED=GIL|MEN|MAR|GAW|NOA|MIN|LSB|EMU",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "MSJ",
            Desc: "****** Product Not Found: <removed in production>",
            Use: "",
            Colour: "Woodland Grey",
            Area: "2",
            Qty: "1",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FG",
            Desc: "Fascia Gutter **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "2",
            Qty: "1 x 6460|1 x 2251",
            Length: "6460",
            CodeBase: "FG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGF55**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"JSTRAP","Use":"Gutter Clip","Qty":"=(Length/900)+1"},{"Code":"SCTF","Qty":"=(Length/900)+1"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGLSE",
            Desc: "Fascia Gutter LH Stop End **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "2",
            Qty: "1",
            Length: "",
            CodeBase: "FGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGRSE",
            Desc: "Fascia Gutter RH Stop End **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "2",
            Qty: "1",
            Length: "",
            CodeBase: "FGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO90SWZ",
            Desc: "90mm Rnd Pop (Suit Pvc & Metal D/Pipe) Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "PO90SWZ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PVC90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PVC90",
            Desc: "90mm Pvc Stormwater Pipe 6000mm",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "1 x 2300",
            Length: "2300",
            CodeBase: "PVC90",
            CodeAppend: "",
            DescAppend: " (finish 2300mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH6000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"=(Length/1200)","Use":"Downpipe Fix"},{"Code":"FR72","Qty":"4"},{"Code":"ST90","Qty":"2"}]}',
            PromptCodes: "Length=6000",
            Image_b64: null,
            PromptTextCodes: "Length=6000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO90SWZ",
            Desc: "90mm Rnd Pop (Suit Pvc & Metal D/Pipe) Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "2",
            Qty: "1",
            Length: "",
            CodeBase: "PO90SWZ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PVC90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PVC90",
            Desc: "90mm Pvc Stormwater Pipe 6000mm",
            Use: "",
            Colour: "",
            Area: "2",
            Qty: "1 x 2035",
            Length: "2035",
            CodeBase: "PVC90",
            CodeAppend: "",
            DescAppend: " (finish 2035mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH6000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"=(Length/1200)","Use":"Downpipe Fix"},{"Code":"FR72","Qty":"4"},{"Code":"ST90","Qty":"2"}]}',
            PromptCodes: "Length=6000",
            Image_b64: null,
            PromptTextCodes: "Length=6000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL01",
            Desc: "Cen CFL01 Barge Cap **H**",
            Use: "",
            Colour: "Woodland Grey/Paperbark",
            Area: "1",
            Qty: "4 x 2557 (Corrugated - C/Bond D/S 0.42 (Non-Trafficable) Barge Capping)",
            Length: "2557",
            CodeBase: "CFL01",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL01**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL06",
            Desc: "Cen CFL06 Gable Infil Flash **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 5260 (Infill Trim Flashing)",
            Length: "5260",
            CodeBase: "CFL06",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL06**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL2420",
            Desc: "Cen CFL24 20 degree Freespan Beam Attachment Gloss H**",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "4 x 3218 (Fascia Flashing)",
            Length: "3218",
            CodeBase: "CFL2420",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNCFL2420H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "@@=20",
            Image_b64: null,
            PromptTextCodes: "@@=20",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL40PB",
            Desc: "Cen CFL40 @@ Downlight Flash 65X65 HG Paperbark",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 3218 (A1-Downlight Flashing 40)|1 x 3217 (A1-Downlight Flashing 40)",
            Length: "3218",
            CodeBase: "CFL40PB",
            CodeAppend: "",
            DescAppend: "(CFL40)",
            "CL ID": "0",
            Fielders_Code: "CNCFL40HPB@@",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL51",
            Desc: "Cen CFL51 Ridge Cap **H** @@",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 x 6800",
            Length: "6800",
            CodeBase: "CFL51",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL51**H**@@",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Ridge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Ridge Capping Fix",\n    "Qty" : "=(Length/380) + 2"}\n]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB108",
            Desc: "Cen Box Beam 108x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 4846 (Gable Infill Beam)",
            Length: "4846",
            CodeBase: "BB108",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "7",
            Fielders_Code: "CBB9510865H**",
            "CL DATA": {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "-70.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1086510",
                    CutLength: "4846",
                    FinishLength: "4816",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Gable Infill Beam`Paperbark - PB``1`1`4846`4816`0.0`-70.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Paperbark` 7`1086510`0`0",
                },
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "-70.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1086510",
                    CutLength: "4846",
                    FinishLength: "4816",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Gable Infill Beam`Paperbark - PB``1`1`4846`4816`0.0`-70.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Paperbark` 7`1086510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 6495 (A1-Attachment Beam (Back))|1 x 6500 (A1-Attachment Beam (Front))|1 x 4550 (A1-Attachment Beam (Left))|1 x 2539 (A1-Portal Rafter (No Post))|1 x 2539 (A1-Portal Rafter (No Post))|1 x 2481 (A1-Portal Rafter (Standard))|1 x 2550 (A1-Portal Rafter (Standard))|1 x 2550 (A1-Portal Rafter (Width Attached))|1 x 2550 (A1-Portal Rafter (Width Attached))",
            Length: "6495",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: {
                    CutPlane: "Front",
                    LeftAngle: "-20.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section",
                    HolePunchingRecommend: "RNP20158=Rafter no post 20 Deg 158 Section",
                    Section: "1586510",
                    CutLength: "2539",
                    FinishLength: "2479",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (No Post)`Paperbark - PB``1`1`2539`2479`0.0`-20.0`20.0`0.0`0.0`PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section`253`2286`0`0`Paperbark` 3`1586510`0`0",
                },
                4: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "-20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section",
                    HolePunchingRecommend: "RNP20158=Rafter no post 20 Deg 158 Section",
                    Section: "1586510",
                    CutLength: "2539",
                    FinishLength: "2479",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (No Post)`Paperbark - PB``1`1`2539`2479`0.0`20.0`-20.0`0.0`0.0`PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section`253`2286`0`0`Paperbark` 4`1586510`0`0",
                },
                5: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "2481",
                    FinishLength: "2421",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Paperbark - PB``1`1`2481`2421`0.0`35.0`20.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`1891`253`133`Paperbark` 5`1586510`0`0",
                },
                6: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "35.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "2550",
                    FinishLength: "2490",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Paperbark - PB``1`1`2550`2490`0.0`20.0`35.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`1960`253`133`Paperbark` 6`1586510`0`0",
                },
                7: {
                    CutPlane: "Front",
                    LeftAngle: "70.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "2550",
                    FinishLength: "2490",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Paperbark - PB``1`1`2550`2490`0.0`70.0`20.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`2298`24`0`Paperbark` 1`1586510`0`0",
                },
                8: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "70.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "2550",
                    FinishLength: "2490",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Paperbark - PB``1`1`2550`2490`0.0`20.0`70.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`2298`24`0`Paperbark` 2`1586510`0`0",
                },
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: {
                    CutPlane: "Front",
                    LeftAngle: "-20.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section",
                    HolePunchingRecommend: "RNP20158=Rafter no post 20 Deg 158 Section",
                    Section: "1586510",
                    CutLength: "2539",
                    FinishLength: "2479",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (No Post)`Paperbark - PB``1`1`2539`2479`0.0`-20.0`20.0`0.0`0.0`PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section`253`2286`0`0`Paperbark` 3`1586510`0`0",
                },
                4: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "-20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section",
                    HolePunchingRecommend: "RNP20158=Rafter no post 20 Deg 158 Section",
                    Section: "1586510",
                    CutLength: "2539",
                    FinishLength: "2479",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (No Post)`Paperbark - PB``1`1`2539`2479`0.0`20.0`-20.0`0.0`0.0`PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section`253`2286`0`0`Paperbark` 4`1586510`0`0",
                },
                5: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "2481",
                    FinishLength: "2421",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Paperbark - PB``1`1`2481`2421`0.0`35.0`20.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`1891`253`133`Paperbark` 5`1586510`0`0",
                },
                6: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "35.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "2550",
                    FinishLength: "2490",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Paperbark - PB``1`1`2550`2490`0.0`20.0`35.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`1960`253`133`Paperbark` 6`1586510`0`0",
                },
                7: {
                    CutPlane: "Front",
                    LeftAngle: "70.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "2550",
                    FinishLength: "2490",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Paperbark - PB``1`1`2550`2490`0.0`70.0`20.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`2298`24`0`Paperbark` 1`1586510`0`0",
                },
                8: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "70.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "2550",
                    FinishLength: "2490",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Paperbark - PB``1`1`2550`2490`0.0`20.0`70.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`2298`24`0`Paperbark` 2`1586510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB65",
            Desc: "Cen Box Beam 65x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 1044 (A1-Portal Strut)|1 x 1042 (A1-Portal Strut)|6 x 3143 (A1-Purlin T1)|2 x 3142 (A1-Purlin T1)|2 x 3143 (A1-Ridge Purlin)|2 x 3142 (A1-Ridge Purlin)",
            Length: "1044",
            CodeBase: "BB65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB956565H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "AltIndex=BB656575",
            Image_b64: null,
            PromptTextCodes: "AltIndex=BB656575",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "1 x 6060 (A2-Fascia Beam)|1 x 1916 (A2-Left Rafter)|1 x 1910 (A2-Right Rafter)",
            Length: "6060",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 3204 (A1-Post in Ground (Freespan) (Under Beam))|1 x 3204 (A1-Post in Ground (Freespan) (Under Beam))",
            Length: "3204",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "8",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158F=Post 158 section Freespan",
                    HolePunchingRecommend: "POST158F=Post 158 section Freespan",
                    Section: "1586510",
                    CutLength: "3204",
                    FinishLength: "3174",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Freespan) (Under Beam)`Paperbark - PB`Hand Drill Outside Edge Only: Hole A`1`1`3204`3174`0.0`35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158F=Post 158 section Freespan`315`435`2769`0`Paperbark` 8`1586510`0`0",
                },
                1: {
                    CutPlane: "Front",
                    LeftAngle: "-35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158F=Post 158 section Freespan",
                    HolePunchingRecommend: "POST158F=Post 158 section Freespan",
                    Section: "1586510",
                    CutLength: "3204",
                    FinishLength: "3174",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Freespan) (Under Beam)`Paperbark - PB`Hand Drill Outside Edge Only: Hole A`1`1`3204`3174`0.0`-35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158F=Post 158 section Freespan`315`435`2769`0`Paperbark` 9`1586510`0`0",
                },
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158F=Post 158 section Freespan",
                    HolePunchingRecommend: "POST158F=Post 158 section Freespan",
                    Section: "1586510",
                    CutLength: "3204",
                    FinishLength: "3174",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Freespan) (Under Beam)`Paperbark - PB`Hand Drill Outside Edge Only: Hole A`1`1`3204`3174`0.0`35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158F=Post 158 section Freespan`315`435`2769`0`Paperbark` 8`1586510`0`0",
                },
                1: {
                    CutPlane: "Front",
                    LeftAngle: "-35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158F=Post 158 section Freespan",
                    HolePunchingRecommend: "POST158F=Post 158 section Freespan",
                    Section: "1586510",
                    CutLength: "3204",
                    FinishLength: "3174",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Freespan) (Under Beam)`Paperbark - PB`Hand Drill Outside Edge Only: Hole A`1`1`3204`3174`0.0`-35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158F=Post 158 section Freespan`315`435`2769`0`Paperbark` 9`1586510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS158",
            Desc: "Cen 158X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "CBBS158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS215865H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "BB65",
            Desc: "Cen Box Beam 65x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "2 x 2885 (A2-Post in Ground (Beam to Side))|1 x 2727 (A2-Post in Ground (Under Beam))",
            Length: "2885",
            CodeBase: "BB65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB956565H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "AltIndex=BB656575",
            Image_b64: null,
            PromptTextCodes: "AltIndex=BB656575",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS65",
            Desc: "Cen 65X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "CBBS65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS26565H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK215865",
            Desc: "Cen BK2 15865 **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 (For Attachment Beam (Back) Fixed to 158mm Post)",
            Length: "",
            CodeBase: "BK215865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB158**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (A1-For Portal Strut)|16 (A1-For Purlin T1)|8 (A1-For Ridge Purlin)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK27158",
            Desc: "Cen BK27 15865 Corner Connector **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 (A1-For Attachment Beam (Back))|1 (A1-For Attachment Beam (Front))",
            Length: "",
            CodeBase: "BK27158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK27CC158**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"12"},{}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK315865-S",
            Desc: "Cen BK3 15865 @@ ** ",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Portal Rafter (No Post))",
            Length: "",
            CodeBase: "BK315865",
            CodeAppend: "-S.20DEG UP",
            DescAppend: "20 Degrees Up",
            "CL ID": "1",
            Fielders_Code: "CNBK3CB158@@**",
            "CL DATA": {
                0: {
                    BracketType: "BK3",
                    Angle1: "-20.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK3",
                    Angle1: "-20.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK3310865",
            Desc: "Cen BK33 10865 @@ ** ",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Gable Infill Beam)",
            Length: "",
            CodeBase: "BK3310865",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNBK33C108@@**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"14","Colour":"Area.RafterColour"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK3315865",
            Desc: "Cen BK33 15865 @@ ** ",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Portal Rafter (Width Attached))",
            Length: "",
            CodeBase: "BK3315865",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNBK33C158@@**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"14","Colour":"Area.RafterColour"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK34S25G",
            Desc: "Cen Bk34S RSF Single 25Deg Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "17",
            Length: "",
            CodeBase: "BK34S25G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK34SRSF250GA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BNW1060Z","Use":"BK34 Fix","Qty":"4"},{"Code":"BK2164G","Use":"BK34 Fix","Qty":"2","Conditions":{"DescAppend":"!=*Riser*"}},{"Code":"10X90","Qty":"2","Colour":"Area.BeamColour"}]}',
            PromptCodes: "$$=62.70",
            Image_b64: null,
            PromptTextCodes: "$$=62.70",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK36",
            Desc: "Cen BK36 Top Gable End Strut **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Portal Strut)",
            Length: "",
            CodeBase: "BK36",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK36CT**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK88158",
            Desc: "Cen BK88 158 Box Beam Stop End **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 (End Cap for Attachment Beam (Front))",
            Length: "",
            CodeBase: "BK88158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK88158SE**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Use":"Beam End Cap Fix"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK215865",
            Desc: "Cen BK2 15865 **",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "2 (A2-For Fascia Beam Fixed to 65mm Post)|1 (A2-For Left Rafter)|1 (A2-For Left Rafter Fixed to 65mm Post)|1 (A2-For Right Rafter Fixed to 65mm Post)",
            Length: "",
            CodeBase: "BK215865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB158**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK22L15865",
            Desc: "Cen BK22L-15865 Long Brkt With Stop End **",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "1 (For Right Rafter)",
            Length: "",
            CodeBase: "BK22L15865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK22L158**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "1 (For Post)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26DEG",
            Desc: "BK26 Verandah Fascia Support Brkt Double End Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "2",
            Qty: "7 (Rafter Bracket)",
            Length: "",
            CodeBase: "BK26DEG",
            CodeAppend: "",
            DescAppend: "(fixed to Timber Fascia)",
            "CL ID": "0",
            Fielders_Code: "CNBK26FSGA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BNW1060Z","Use":"Rafter Bracket Fix","Qty":"3","Conditions":{"Brand":"=Fielders"}},{"Code":"BNW1020","Qty":"1","Use":"Steel Fascia Fix","Conditions":{"Brand":"=Fielders","Use":"=*Steel*"}},{"Code":"10X50P","Qty":"1","Use":"Timber Fascia Fix","Conditions":{"Brand":"=Fielders","Use":"=*Timber*"}},{"Code":"FBH60NYG","Qty":"3","Use":"Rafter Bracket Fix","Conditions":{"Brand":"=Lysaght"}},{"Code":"FBH20NYG","Use":"Steel Fascia","Qty":"1","Conditions":{"Brand":"=Lysaght","Use":"=*Steel*"}},{"Code":"FBH5010NYG","Use":"Timber Fascia Fix","Qty":"1","Conditions":{"Brand":"=Lysaght","Use":"=*Timber*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON115865G",
            Desc: "Cen CON1 15865 Galv Inground Connnector",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "CON115865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON1158GA",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"10X170","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON215865G",
            Desc: "Cen CON2 15865-@@ Ridge Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "1 (A1-For Portal Rafter (No Post))|1 (A1-For Portal Rafter (Standard))|1 (A1-For Portal Rafter (Width Attached))",
            Length: "",
            CodeBase: "CON215865G",
            CodeAppend: "",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNCON2158GA@@",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BHSS1025SL","Use":"Con2 Fix","Qty":"8","Colour":"Plain"},{"Code":"TS1220100B8N","Use":"Con2 Fix","Colour":"Area.RafterColour","Qty":"4"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON315865FSG",
            Desc: "Cen CON3 15865-@@ Eaves Con Freespan Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "2 (For Portal Rafter (Standard))",
            Length: "",
            CodeBase: "CON315865FSG",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNCON3158FGA@@",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BHSS1025SL","Qty":"8","Colour":"Plain"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.RafterColour","Qty":"2"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON16565",
            Desc: "Cen CON1 6565 Galv Inground Connector",
            Use: "",
            Colour: "Galvanised",
            Area: "2",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "CON16565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON165GA",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"10X90","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "10X90",
            Desc: "Cen Bolt Nut G4.6 10X90 **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "3 (A1-Attachment Beam (Back) Fix)|3 (A1-Attachment Beam (Front) Fix)",
            Length: "",
            CodeBase: "10X90",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BN1090**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: 'Desc="10x90mm Bolt(s)"',
            Image_b64: null,
            PromptTextCodes: 'Desc="10x90mm Bolt(s)"',
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "MISC",
            Code: "COCOVER",
            Desc: "Corrugated Cover Sheet Only (Metal)",
            Use: "",
            Colour: "",
            Area: "",
            Qty: "2 x 2525 (Sheet Cover Sheet)",
            Length: "2525",
            CodeBase: "COCOVER",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PACCSSLM",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "$$=1",
            Image_b64: null,
            PromptTextCodes: "$$=1",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "MISC",
            Code: "FCD2412",
            Desc: "2400 X 1200 6.00mm Fibre Cement Sheet Plain",
            Use: "",
            Colour: "Plain",
            Area: "1",
            Qty: "2 (Infill-Plain Smooth)",
            Length: "",
            CodeBase: "FCD2412",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNFCSH",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TSW1022","Qty":"30","Use":"Infill Fix"},{"Code":"STK05","Qty":"1","Use":"Infill Fix"},{"Code":"BK30G","Qty":"3","Use":"Infill Support","Conditions":{"Use":"=*Infill*"},"Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "BC5075",
            Desc: "50mm Receiver Channel **",
            Use: "",
            Colour: "Paperbark",
            Area: "",
            Qty: "1 x 7500 (6200mm(Back Channel))|1 x 7500 (1991mm(Back Channel))",
            Length: "7500",
            CodeBase: "BC5075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BKCCDK50H**7500",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "Length=7500",
            Image_b64: null,
            PromptTextCodes: "Length=7500",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "BCC75",
            Desc: "7500LM 25mm Back Channel Corro **",
            Use: "",
            Colour: "Paperbark",
            Area: "",
            Qty: "1 x 7500 (6440mm(Back Channel))|1 x 7500 (6440mm(Back Channel))",
            Length: "7500",
            CodeBase: "BCC75",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BKCSRB25**7500",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "Length=7500",
            Image_b64: null,
            PromptTextCodes: "Length=7500",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
    ],
    FTLC01346: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CD42DS",
            Desc: "C-Dek 310 0.42BMT **H**",
            Use: "",
            Colour: "Monument/Surfmist",
            Area: "1",
            Qty: "1 x 3362|1 x 3323|1 x 3092|1 x 2861|1 x 2630|1 x 2399|1 x 2168|1 x 1937|1 x 1706|11 x 3362 (B/C Fixed)",
            Length: "3362",
            CodeBase: "CD42DS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CDK42**H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1220100B8","Qty":"=Qty*3","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Use":"!=*B/C Fixed*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FG",
            Desc: "Fascia Gutter **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 5950",
            Length: "5950",
            CodeBase: "FG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGF55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"JSTRAP","Use":"Gutter Clip","Qty":"=(Length/900)+1"},{"Code":"SCTF","Qty":"=(Length/900)+1"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGLSE",
            Desc: "Fascia Gutter LH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGRSE",
            Desc: "Fascia Gutter RH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO90SWZ",
            Desc: "90mm Rnd Pop (Suit Pvc & Metal D/Pipe) Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "PO90SWZ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PVC90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PVC90",
            Desc: "90mm Pvc Stormwater Pipe 6000mm",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "1 x 2890",
            Length: "2890",
            CodeBase: "PVC90",
            CodeAppend: "",
            DescAppend: " (finish 2890mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH6000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"=(Length/1200)","Use":"Downpipe Fix"},{"Code":"FR72","Qty":"4"},{"Code":"ST90","Qty":"2"}]}',
            PromptCodes: "Length=6000",
            Image_b64: null,
            PromptTextCodes: "Length=6000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL22",
            Desc: "Cen CFL22 C-Dek 310 Barge **H**",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 3302 (Cent 310 Deck Barge Capping)|1 x 3181 (Cent 310 Deck Barge Capping)|1 x 1401 (Cent 310 Deck Barge Capping)",
            Length: "3302",
            CodeBase: "CFL22",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL22**H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "SLATS",
            Code: "FS70CC",
            Desc: "Fielders Slat 70mm X 0.35 (L/M) Classic Cream",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "15 x 2666 (Slat)",
            Length: "2666",
            CodeBase: "FS70CC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FFS70FDO",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FSR70BK","Qty":"2","Use":"Slat Retainer","Colour":"Plain"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "SLATS",
            Code: "FSS50CC",
            Desc: "Fielders Split Slat 50mm (2Pce) Classic Cream",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 1190 (Slat Split)",
            Length: "1190",
            CodeBase: "FSS50CC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FFSS502PFDONS",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "SLATS",
            Code: "FSS50EBCC",
            Desc: "Fielders Split Slat 50mm End Bracket Classic Cream ",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (Slat Split End Bracket)",
            Length: "",
            CodeBase: "FSS50EBCC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FFSSEB50FDO",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FSS50CC",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "SLATS",
            Code: "PFPMCC",
            Desc: "MkII Panel Fence Post (Spec P/M) Classic Cream",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 1200 (Slat Post)",
            Length: "1200",
            CodeBase: "PFPMCC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FMKIIPFDO",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1016100B8","Qty":"4","Use":"Slat Post Fix"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "SLATS",
            Code: "PFRMCC",
            Desc: "MkII Panel Fence Top/Bot Rail (P/M) Classic Cream",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 2666 (Slat Rail)",
            Length: "2666",
            CodeBase: "PFRMCC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FMKIIRFDO",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Night Sky",
            Area: "1",
            Qty: "1 x 3314 (Cutout Beam A)|1 x 5810 (Fascia Beam)|1 x 3220 (Left Rafter)|1 x 1254 (Right Rafter)",
            Length: "3314",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "1",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: {
                    CutPlane: "Top",
                    LeftAngle: "53.5",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "3314",
                    FinishLength: "3254",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Cutout Beam A`Night Sky - NS``1`1`3314`3254`0.0`0.0`1.0`53.5`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Night Sky` 1`1586510`0`0",
                },
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Top",
                    LeftAngle: "53.5",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "3314",
                    FinishLength: "3254",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Cutout Beam A`Night Sky - NS``1`1`3314`3254`0.0`0.0`1.0`53.5`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Night Sky` 1`1586510`0`0",
                },
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS65",
            Desc: "Cen 65X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Night Sky",
            Area: "1",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "CBBS65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS26565H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS100",
            Desc: "Post Steel 100x100x2mm H**",
            Use: "",
            Colour: "Night Sky",
            Area: "1",
            Qty: "2 x 1800 (Post in Ground (Under Beam))",
            Length: "1800",
            CodeBase: "PS100",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PS100H**4000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "SHS65653",
            Desc: "SHS 65 X 65 X 3.00mm Allgal **",
            Use: "",
            Colour: "Night Sky",
            Area: "1",
            Qty: "1 x 3786 (Post in Ground (Beam to Side))|2 x 3740 (Post in Ground (Beam to Side))",
            Length: "3786",
            CodeBase: "SHS65653",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHS65653**80",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: ECCP 12 1 (For Post)",
            Use: "",
            Colour: "Night Sky",
            Area: "1",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS100",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK215865",
            Desc: "Cen BK2 15865 **",
            Use: "",
            Colour: "Night Sky",
            Area: "1",
            Qty: "2 (For Fascia Beam Fixed to 65mm Post)|1 (For Left Rafter)|1 (For Left Rafter Fixed to 65mm Post)|2 (For Right Rafter Fixed to 65mm Post)",
            Length: "",
            CodeBase: "BK215865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB158**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK46158S",
            Desc: "Cen BK46 15865 Beam To Beam Conn. ** Non Standard",
            Use: "",
            Colour: "Night Sky",
            Area: "1",
            Qty: "2 (For Cutout Beam A)",
            Length: "",
            CodeBase: "BK46158S",
            CodeAppend: ".15865.37DEG RH",
            DescAppend: "158x65 37 Degrees Right Hand",
            "CL ID": "1",
            Fielders_Code: "CNBK46NS158**",
            "CL DATA": {
                0: {
                    BracketType: "BK46",
                    Angle1: "-37.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK46",
                    Angle1: "-37.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "TSW1016B8100",
            Desc: "BF 10-16X16 S/Fix Wafer Head Tek B8 Plain (Pkt 100)",
            Use: "",
            Colour: "Plain",
            Area: "1",
            Qty: "30 (Slat Split Fix)",
            Length: "",
            CodeBase: "TSW1016B8100",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SWBF1016N100",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "100",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: 'Desc="10x16mm Wafer Screw" AltIndex="TSW1016"',
            Image_b64: null,
            PromptTextCodes: 'Desc="10x16mm Wafer Screw" AltIndex="TSW1016"',
            Children: null,
            "Parent Item": "FSS50EBCC",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "BC5075",
            Desc: "50mm Receiver Channel **",
            Use: "",
            Colour: "Surfmist",
            Area: "",
            Qty: "1 x 7500 (3400mm(Back Channel))",
            Length: "7500",
            CodeBase: "BC5075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BKCCDK50H**7500",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "Length=7500",
            Image_b64: null,
            PromptTextCodes: "Length=7500",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    FTNC00199: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CO42",
            Desc: "Corr S-Rib 0.42BMT **",
            Use: "",
            Colour: "Deep Ocean",
            Area: "1",
            Qty: "14 x 3884",
            Length: "3884",
            CodeBase: "CO42",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CO42**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1245B8100","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*4)+7)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1245B8100","Use":"Roof Fix","Qty":"=Qty*6","Colour":"Area.RoofSheetColour","Conditions":{"Use":"!=*B/C Fixed*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POLYCARBONATE ROOFING",
            Code: "PSC",
            Desc: "Ampelite Solasafe Corrugated Polycarbonate Sheet  **",
            Use: "",
            Colour: "Grey",
            Area: "1",
            Qty: "2 x 4200 (/finish @3884mm)",
            Length: "4200",
            CodeBase: "PSC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PCCO**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"CLEARFIX","Qty":"=((Area.NumInternalPurlins*3)+12)*Qty","Colour":"Plain","Conditions":{"Brand":"=Fielders"}},{"Code":"BK30G","Qty":"3","Use":"Infill Support","Conditions":{"Use":"=*Infill*","Brand":"=Fielders"}},{"Code":"CPCB36","Conditions":{"Brand":"=Fielders"},"Qty":"=(((Length/900)+1)*1000)/25000"},{"Code":"FT50MP","Qty":"=((Area.NumInternalPurlins*4)+4)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT45MR","Qty":"=((Area.NumInternalPurlins*2)+4)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"WG","Qty":"=((Area.NumInternalPurlins*6)+4)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FR64","Qty":"=Qty*6","Colour":"Area.BeamColour","Conditions":{"Brand":"=Lysaght","Area.DesignType":"=Flat Roof"}},{"Code":"WASHM","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Area.DesignType":"=Flat Roof"},"Qty":"=Qty*6"},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*9)+2)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT50MP","Qty":"=((Area.NumInternalPurlins*4)+2)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT45MR","Qty":"=((Area.NumInternalPurlins*2)+2)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"WGFG","Qty":"=((Area.NumInternalPurlins*2)+8)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT30M","Qty":"=6*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*9)+2)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT35_WCB","Qty":"=12*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"COFILL","Length":"915","Conditions":{"Brand":"=Lysaght"}}]}',
            PromptCodes:
                "SL=1800(201300)|2100(201300)|2400(201300)|2700(201300)|3000(201300)|3600(201300)|4200(201300)|4800(201300)|5400(201300)|6000(201300)|6300(201300)|7200(201300)|8100(201300)",
            Image_b64: null,
            PromptTextCodes:
                "SL=1800(201300)|2100(201300)|2400(201300)|2700(201300)|3000(201300)|3600(201300)|4200(201300)|4800(201300)|5400(201300)|6000(201300)|6300(201300)|7200(201300)|8100(201300)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POLYCARBONATE ROOFING",
            Code: "TW101050",
            Desc: "Lexan Thermoclear Twinwall Sheeting 10mmx1050mm 2LM **",
            Use: "",
            Colour: "Metallic Grey",
            Area: "1",
            Qty: "4 x 1414 (Infill-Twin Wall 1050 Infill)",
            Length: "1414",
            CodeBase: "TW101050",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PCLTTW1010**20",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TWHB","Use":"Twinwall Fix","Qty":"=(Length/6000)*0.5"},{"Code":"TWST","Use":"Twinwall Fix","Qty":"=Length/25000","Colour":"Plain"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FG",
            Desc: "Fascia Gutter **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "2 x 5705",
            Length: "5705",
            CodeBase: "FG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGF55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"JSTRAP","Use":"Gutter Clip","Qty":"=(Length/900)+1"},{"Code":"SCTF","Qty":"=(Length/900)+1"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGLSE",
            Desc: "Fascia Gutter LH Stop End **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "FGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGRSE",
            Desc: "Fascia Gutter RH Stop End **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "FGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO656Z",
            Desc: "65X65 Pop Square Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "PO656Z",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPP6565ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DP656",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DP656",
            Desc: "65X65 Downpipe ** 1800mm",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "3 x 1800",
            Length: "1800",
            CodeBase: "DP656",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DP6565**18",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8"},{"Code":"ST656","Qty":"=(Length/1200)"}]}',
            PromptCodes: "Length=1800 AltIndex=DP656_INTERNAL",
            Image_b64: null,
            PromptTextCodes: "Length=1800 AltIndex=DP656_INTERNAL",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL01",
            Desc: "Cen CFL01 Barge Cap **H**",
            Use: "",
            Colour: "Deep Ocean/Grey",
            Area: "1",
            Qty: "2 x 3893 (Corrugated - C/Bond 0.42 (No Foot Traffic) Barge Capping)",
            Length: "3893",
            CodeBase: "CFL01",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL01**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL06",
            Desc: "Cen CFL06 Gable Infil Flash **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "1 x 7770 (Infill Trim Flashing)",
            Length: "7770",
            CodeBase: "CFL06",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL06**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "MSJ",
            Desc: "****** Product Not Found: CFL4504 (Downlight Flashing 39)",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "1 x 2820 (Downlight Flashing 39)|1 x 2770 (Downlight Flashing 39)",
            Length: "2820",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: "(CFL39)",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL51",
            Desc: "Cen CFL51 Ridge Cap **H** @@",
            Use: "",
            Colour: "Deep Ocean",
            Area: "1",
            Qty: "1 x 6005",
            Length: "6005",
            CodeBase: "CFL51",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL51**H**@@",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Ridge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Ridge Capping Fix",\n    "Qty" : "=(Length/380) + 2"}\n]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "MSJ",
            Desc: "****** Product Not Found: FL25 (Wall Flashing)",
            Use: "",
            Colour: "Deep Ocean/Grey",
            Area: "1",
            Qty: "2 x 3895 (Wall Flashing)",
            Length: "3895",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB108",
            Desc: "Cen Box Beam 108x65x0.95BMT **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "1 x 7190 (Gable Infill Beam)",
            Length: "7190",
            CodeBase: "BB108",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "5",
            Fielders_Code: "CBB9510865H**",
            "CL DATA": {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "-70.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1086510",
                    CutLength: "7190",
                    FinishLength: "7160",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Gable Infill Beam`Wallaby - WB``1`1`7190`7160`0.0`-70.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Wallaby` 5`1086510`0`0",
                },
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "-70.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1086510",
                    CutLength: "7190",
                    FinishLength: "7160",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Gable Infill Beam`Wallaby - WB``1`1`7190`7160`0.0`-70.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Wallaby` 5`1086510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "1 x 7060 (Attachment Beam (Right))|1 x 5700 (Perimeter Beam (Back))|1 x 5700 (Perimeter Beam (Front))|2 x 3817 (Portal Rafter (Standard))|2 x 3817 (Portal Rafter (Standard))|1 x 3627 (Portal Rafter (Width Attached))|1 x 3627 (Portal Rafter (Width Attached))",
            Length: "7060",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3817",
                    FinishLength: "3757",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Wallaby - WB``1`2`3817`3757`0.0`35.0`20.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`3226`253`133`Wallaby` 1`1586510`0`0",
                },
                4: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "35.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3817",
                    FinishLength: "3757",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Wallaby - WB``1`2`3817`3757`0.0`20.0`35.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`3226`253`133`Wallaby` 2`1586510`0`0",
                },
                5: {
                    CutPlane: "Front",
                    LeftAngle: "70.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3627",
                    FinishLength: "3567",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Wallaby - WB``1`1`3627`3567`0.0`70.0`20.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`3374`0`0`Wallaby` 3`1586510`0`0",
                },
                6: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "70.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3627",
                    FinishLength: "3567",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Wallaby - WB``1`1`3627`3567`0.0`20.0`70.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`3374`0`0`Wallaby` 4`1586510`0`0",
                },
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3817",
                    FinishLength: "3757",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Wallaby - WB``1`2`3817`3757`0.0`35.0`20.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`3226`253`133`Wallaby` 1`1586510`0`0",
                },
                4: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "35.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3817",
                    FinishLength: "3757",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Wallaby - WB``1`2`3817`3757`0.0`20.0`35.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`3226`253`133`Wallaby` 2`1586510`0`0",
                },
                5: {
                    CutPlane: "Front",
                    LeftAngle: "70.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3627",
                    FinishLength: "3567",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Wallaby - WB``1`1`3627`3567`0.0`70.0`20.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`3374`0`0`Wallaby` 3`1586510`0`0",
                },
                6: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "70.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3627",
                    FinishLength: "3567",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Wallaby - WB``1`1`3627`3567`0.0`20.0`70.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`3374`0`0`Wallaby` 4`1586510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB65",
            Desc: "Cen Box Beam 65x65x0.95BMT **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "1 x 7070 (On Top Purlin)|2 x 5705 (On Top Purlin)|1 x 1568 (Portal Strut)|1 x 1496 (Portal Strut)|4 x 5700 (Purlin T1)",
            Length: "7070",
            CodeBase: "BB65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB956565H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "AltIndex=BB656575",
            Image_b64: null,
            PromptTextCodes: "AltIndex=BB656575",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "2 x 2834 (Post in Ground (Standard) (Under Beam))|2 x 2834 (Post in Ground (Standard) (Under Beam))",
            Length: "2834",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "6",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158=Post 158 section",
                    HolePunchingRecommend: "POST158=Post 158 section",
                    Section: "1586510",
                    CutLength: "2834",
                    FinishLength: "2804",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Standard) (Under Beam)`Wallaby - WB``1`2`2834`2804`0.0`35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158=Post 158 section`218`338`2496`0`Wallaby` 6`1586510`0`0",
                },
                1: {
                    CutPlane: "Front",
                    LeftAngle: "-35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158=Post 158 section",
                    HolePunchingRecommend: "POST158=Post 158 section",
                    Section: "1586510",
                    CutLength: "2834",
                    FinishLength: "2804",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Standard) (Under Beam)`Wallaby - WB``1`2`2834`2804`0.0`-35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158=Post 158 section`218`338`2496`0`Wallaby` 7`1586510`0`0",
                },
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158=Post 158 section",
                    HolePunchingRecommend: "POST158=Post 158 section",
                    Section: "1586510",
                    CutLength: "2834",
                    FinishLength: "2804",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Standard) (Under Beam)`Wallaby - WB``1`2`2834`2804`0.0`35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158=Post 158 section`218`338`2496`0`Wallaby` 6`1586510`0`0",
                },
                1: {
                    CutPlane: "Front",
                    LeftAngle: "-35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158=Post 158 section",
                    HolePunchingRecommend: "POST158=Post 158 section",
                    Section: "1586510",
                    CutLength: "2834",
                    FinishLength: "2804",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Standard) (Under Beam)`Wallaby - WB``1`2`2834`2804`0.0`-35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158=Post 158 section`218`338`2496`0`Wallaby` 7`1586510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS158",
            Desc: "Cen 158X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "4 (For Post)",
            Length: "",
            CodeBase: "CBBS158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS215865H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK215865",
            Desc: "Cen BK2 15865 **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "2 (For Attachment Beam (Right))|1 (For Perimeter Beam (Back))|1 (For Perimeter Beam (Front))",
            Length: "",
            CodeBase: "BK215865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB158**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK25G",
            Desc: "Cen BK25D RSBFD Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "9",
            Length: "",
            CodeBase: "BK25G",
            CodeAppend: "",
            DescAppend: "; Height 65mm; Step out 50mm",
            "CL ID": "0",
            Fielders_Code: "CNBK25DGA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BNW1090","Qty":"2"},{"Code":"BNW1060Z","Qty":"2"},{"Code":"BK2164G","Qty":"2"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "2 (For Portal Strut)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK3310865",
            Desc: "Cen BK33 10865 @@ ** ",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "2 (For Gable Infill Beam)",
            Length: "",
            CodeBase: "BK3310865",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNBK33C108@@**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"14","Colour":"Area.RafterColour"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK3315865",
            Desc: "Cen BK33 15865 @@ ** ",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "2 (For Portal Rafter (Width Attached))",
            Length: "",
            CodeBase: "BK3315865",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNBK33C158@@**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"14","Colour":"Area.RafterColour"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK36",
            Desc: "Cen BK36 Top Gable End Strut **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "2 (For Portal Strut)",
            Length: "",
            CodeBase: "BK36",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK36CT**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK88158",
            Desc: "Cen BK88 158 Box Beam Stop End **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "1 (End Cap for Perimeter Beam (Back))|1 (End Cap for Perimeter Beam (Front))",
            Length: "",
            CodeBase: "BK88158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK88158SE**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Use":"Beam End Cap Fix"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK8865",
            Desc: "Cen BK88 65 Box Beam Stop End **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "6 (End Cap for On Top Purlin)",
            Length: "",
            CodeBase: "BK8865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK8865SE**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Use":"Beam End Cap Fix"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON115865G",
            Desc: "Cen CON1 15865 Galv Inground Connnector",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "4 (For Post)",
            Length: "",
            CodeBase: "CON115865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON1158GA",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"10X170","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON215865G",
            Desc: "Cen CON2 15865-@@ Ridge Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "2 (For Portal Rafter (Standard))|1 (For Portal Rafter (Width Attached))",
            Length: "",
            CodeBase: "CON215865G",
            CodeAppend: "",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNCON2158GA@@",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BHSS1025SL","Use":"Con2 Fix","Qty":"8","Colour":"Plain"},{"Code":"TS1220100B8N","Use":"Con2 Fix","Colour":"Area.RafterColour","Qty":"4"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON315865G",
            Desc: "Cen CON3 15865-@@ Eaves Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "4 (For Portal Rafter (Standard))",
            Length: "",
            CodeBase: "CON315865G",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNCON3158GA@@",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BHSS1025SL","Qty":"8","Colour":"Plain"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.RafterColour","Qty":"2"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "10X90",
            Desc: "Cen Bolt Nut G4.6 10X90 **",
            Use: "",
            Colour: "Wallaby",
            Area: "1",
            Qty: "3 (Perimeter Beam (Back) Fix)|3 (Perimeter Beam (Front) Fix)",
            Length: "",
            CodeBase: "10X90",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BN1090**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: 'Desc="10x90mm Bolt(s)"',
            Image_b64: null,
            PromptTextCodes: 'Desc="10x90mm Bolt(s)"',
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "TS1495100B8P",
            Desc: "BF 14-10X95 H/H Tek No Neo B8 Plain (Pkt 100)",
            Use: "",
            Colour: "Plain",
            Area: "1",
            Qty: "13 (On Top Purlin Fix)|24 (Purlin T1 Fix)",
            Length: "",
            CodeBase: "TS1495100B8P",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHBF1495N100",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "100",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: 'Desc="14x90 Hex Screw(s)" AltIndex=TS1495,TS1495P',
            Image_b64: null,
            PromptTextCodes: 'Desc="14x90 Hex Screw(s)" AltIndex=TS1495,TS1495P',
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "MISC",
            Code: "COCOVER",
            Desc: "Corrugated Cover Sheet Only (Metal)",
            Use: "",
            Colour: "",
            Area: "",
            Qty: "2 x 3884 (Sheet Cover Sheet)",
            Length: "3884",
            CodeBase: "COCOVER",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PACCSSLM",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "$$=1",
            Image_b64: null,
            PromptTextCodes: "$$=1",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    FGRC00073: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CO42DSS",
            Desc: "Corr S-Rib 0.42BMT DS **H**",
            Use: "",
            Colour: "Woodland Grey/Paperbark",
            Area: "1",
            Qty: "28 x 4241",
            Length: "4241",
            CodeBase: "CO42DSS",
            CodeAppend: "",
            DescAppend: " <REDIRECTED MEN FROM CO42DS>",
            "CL ID": "0",
            Fielders_Code: "CO42**H**CS",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1245B8100","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*4)+7)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1245B8100","Use":"Roof Fix","Conditions":{"Use":"!=*B/C Fixed*"},"Qty":"=Qty*6","Colour":"Area.RoofSheetColour"}]}',
            PromptCodes: "DISABLED=LSB|GIL|GAW|WAN|NOA|KEW|EMU|NUN|LAU|MAR|MIN|CAM",
            Image_b64: null,
            PromptTextCodes: "DISABLED=LSB|GIL|GAW|WAN|NOA|KEW|EMU|NUN|LAU|MAR|MIN|CAM",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POLYCARBONATE ROOFING",
            Code: "PSCHR1IN",
            Desc: "Ampelite HR1 Corrugated Polycarbonate Sheet **",
            Use: "",
            Colour: "Pearl Ice",
            Area: "1",
            Qty: "7 x 1800 (Infill-Poly HR1 Corrugated Infill/finish @1536mm)|7 x 1800 (Infill-Poly HR1 Corrugated Infill/finish @1409mm)",
            Length: "1800",
            CodeBase: "PSCHR1IN",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PCHR1CO**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1016100B8","Qty":"=10*Qty","Conditions":{"Brand":"=Fielders"},"Colour":"Area.BeamColour"},{"Code":"RI43100","Qty":"=10*Qty","Colour":"Area.BeamColour","Conditions":{"Brand":"=Fielders"}},{"Code":"FT20M","Qty":"=10*Qty","Colour":"Area.BeamColour","Conditions":{"Brand":"=Lysaght"}},{"Code":"FR72","Qty":"=10*Qty","Colour":"Area.BeamColour","Conditions":{"Brand":"=Lysaght"}}]}',
            PromptCodes:
                "SL=1800(204000)|2100(204000)|2400(204000)|2700(204000)|3000(204000)|3600(204000)|4200(204000)|4800(204000)|5400(204000)|6000(204000)|6300(204000)|7200(204000)|8100(204000)",
            Image_b64: null,
            PromptTextCodes:
                "SL=1800(204000)|2100(204000)|2400(204000)|2700(204000)|3000(204000)|3600(204000)|4200(204000)|4800(204000)|5400(204000)|6000(204000)|6300(204000)|7200(204000)|8100(204000)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "MSJ",
            Desc: "****** Product Not Found: (Box Gutter) <removed in production>",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 (Box Gutter)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FL",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "FL354",
            Desc: "Single sided Flashing 350 X 0.55 ** 4 Bend",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 10200 (Box Gutter)",
            Length: "10200",
            CodeBase: "FL354",
            CodeAppend: "",
            DescAppend: "200mm",
            "CL ID": "0",
            Fielders_Code: "CF55**3504",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"TS1016100B8",\n    "Qty":"=(2*(Length/1000))+2", \n    "Use":"Box Gutter Fix", \n    "Conditions":{"Use":"=Box Gutter"}}\n]}',
            PromptCodes: "DISABLED=GIL|MEN|MAR|GAW|NOA|MIN|LSB|EMU",
            Image_b64: null,
            PromptTextCodes: "DISABLED=GIL|MEN|MAR|GAW|NOA|MIN|LSB|EMU",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "OG115SEL",
            Desc: "OG 115 Gutter LH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "OG115SEL",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "OGSEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour","Conditions":{"Brand":"=Fielders"}},{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6","Conditions":{"Brand":"=Lysaght"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "OG115SL",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "OG115SER",
            Desc: "OG 115 Gutter RH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "OG115SER",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "OGSER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour","Conditions":{"Brand":"=Fielders"}},{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6","Conditions":{"Brand":"=Lysaght"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "OG115SL",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "OG115SL",
            Desc: "OG 115 Gutter Slotted 0.42 ",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 10200",
            Length: "10200",
            CodeBase: "OG115SL",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "OGS42**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"OG115OS","Use":"Gutter Clip","Qty":"=(Length/900)+1","Colour":"Plain"},{"Code":"SCTF","Qty":"=(Length/900)+1","Use":"Gutter Clip","Colour":"Plain"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO90SWZ",
            Desc: "90mm Rnd Pop (Suit Pvc & Metal D/Pipe) Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "PO90SWZ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PVC90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PVC90",
            Desc: "90mm Pvc Stormwater Pipe 6000mm",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "2 x 2300",
            Length: "2300",
            CodeBase: "PVC90",
            CodeAppend: "",
            DescAppend: " (finish 2300mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH6000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"=(Length/1200)","Use":"Downpipe Fix"},{"Code":"FR72","Qty":"4"},{"Code":"ST90","Qty":"2"}]}',
            PromptCodes: "Length=6000",
            Image_b64: null,
            PromptTextCodes: "Length=6000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL01",
            Desc: "Cen CFL01 Barge Cap **H**",
            Use: "",
            Colour: "Woodland Grey/Paperbark",
            Area: "1",
            Qty: "4 x 4249 (Corrugated - C/Bond D/S 0.42 (Non-Trafficable) Barge Capping)",
            Length: "4249",
            CodeBase: "CFL01",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL01**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL06",
            Desc: "Cen CFL06 Gable Infil Flash **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 8440 (Infill Trim Flashing)",
            Length: "8440",
            CodeBase: "CFL06",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL06**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL12",
            Desc: "Cen CFL12 Ver Pitch Sect B/Flash **H**",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 7940 (Infill Flashing)",
            Length: "7940",
            CodeBase: "CFL12",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL12**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "MSJ",
            Desc: "****** Product Not Found: CFL4504 (Downlight Flashing 39)",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "4 x 2534 (Downlight Flashing 39)",
            Length: "2534",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: "(CFL39)",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL51",
            Desc: "Cen CFL51 Ridge Cap **H** @@",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 x 10500",
            Length: "10500",
            CodeBase: "CFL51",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL51**H**@@",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Ridge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Ridge Capping Fix",\n    "Qty" : "=(Length/380) + 2"}\n]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB108",
            Desc: "Cen Box Beam 108x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 7860 (Gable Infill Beam)",
            Length: "7860",
            CodeBase: "BB108",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "5",
            Fielders_Code: "CBB9510865H**",
            "CL DATA": {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "-70.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1086510",
                    CutLength: "7860",
                    FinishLength: "7830",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Gable Infill Beam`Paperbark - PB``1`1`7860`7830`0.0`-70.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Paperbark` 5`1086510`0`0",
                },
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "-70.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1086510",
                    CutLength: "7860",
                    FinishLength: "7830",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB108`Cen Box Beam 108x65x0.95BMT **`Gable Infill Beam`Paperbark - PB``1`1`7860`7830`0.0`-70.0`0.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Paperbark` 5`1086510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 5552 (Attachment Beam (Back))|1 x 4648 (Attachment Beam (Back))|1 x 7730 (Attachment Beam (Left))|2 x 5100 (Perimeter Beam (Front))|4 x 4231 (Portal Rafter (No Post))|4 x 4173 (Portal Rafter (Standard))|1 x 3983 (Portal Rafter (Width Attached))|1 x 3983 (Portal Rafter (Width Attached))",
            Length: "5552",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "-20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section",
                    HolePunchingRecommend: "RNP20158=Rafter no post 20 Deg 158 Section",
                    Section: "1586510",
                    CutLength: "4231",
                    FinishLength: "4171",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (No Post)`Paperbark - PB``1`4`4231`4171`0.0`20.0`-20.0`0.0`0.0`PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section`253`3978`0`0`Paperbark` 4`1586510`0`0",
                },
                5: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "4173",
                    FinishLength: "4113",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Paperbark - PB``1`4`4173`4113`0.0`35.0`20.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`3583`253`133`Paperbark` 3`1586510`0`0",
                },
                6: {
                    CutPlane: "Front",
                    LeftAngle: "70.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3983",
                    FinishLength: "3923",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Paperbark - PB``1`1`3983`3923`0.0`70.0`20.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`3731`0`0`Paperbark` 1`1586510`0`0",
                },
                7: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "70.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3983",
                    FinishLength: "3923",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Paperbark - PB``1`1`3983`3923`0.0`20.0`70.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`3731`0`0`Paperbark` 2`1586510`0`0",
                },
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "-20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section",
                    HolePunchingRecommend: "RNP20158=Rafter no post 20 Deg 158 Section",
                    Section: "1586510",
                    CutLength: "4231",
                    FinishLength: "4171",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (No Post)`Paperbark - PB``1`4`4231`4171`0.0`20.0`-20.0`0.0`0.0`PUNCH_STYLE=RNP20158=Rafter no post 20 Deg 158 Section`253`3978`0`0`Paperbark` 4`1586510`0`0",
                },
                5: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section",
                    HolePunchingRecommend: "P20158=Portal Rafter 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "4173",
                    FinishLength: "4113",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Standard)`Paperbark - PB``1`4`4173`4113`0.0`35.0`20.0`0.0`0.0`PUNCH_STYLE=P20158=Portal Rafter 20 Deg 158 section`338`3583`253`133`Paperbark` 3`1586510`0`0",
                },
                6: {
                    CutPlane: "Front",
                    LeftAngle: "70.0",
                    RightAngle: "20.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3983",
                    FinishLength: "3923",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Paperbark - PB``1`1`3983`3923`0.0`70.0`20.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`3731`0`0`Paperbark` 1`1586510`0`0",
                },
                7: {
                    CutPlane: "Front",
                    LeftAngle: "20.0",
                    RightAngle: "70.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    HolePunchingRecommend: "PRWA20158=Portal Rafter Width Attached 20 Deg 158 section",
                    Section: "1586510",
                    CutLength: "3983",
                    FinishLength: "3923",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Portal Rafter (Width Attached)`Paperbark - PB``1`1`3983`3923`0.0`20.0`70.0`0.0`0.0`PUNCH_STYLE=PRWA20158=Portal Rafter Width Attached 20 Deg 158 section`253`3731`0`0`Paperbark` 2`1586510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB65",
            Desc: "Cen Box Beam 65x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 7740 (On Top Purlin)|4 x 5100 (On Top Purlin)|1 x 1690 (Portal Strut)|1 x 1618 (Portal Strut)|16 x 5100 (Purlin T1)",
            Length: "7740",
            CodeBase: "BB65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB956565H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "AltIndex=BB656575",
            Image_b64: null,
            PromptTextCodes: "AltIndex=BB656575",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "4 x 3134 (Post in Ground (Standard) (Under Beam))",
            Length: "3134",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "6",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158=Post 158 section",
                    HolePunchingRecommend: "POST158=Post 158 section",
                    Section: "1586510",
                    CutLength: "3134",
                    FinishLength: "3104",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Standard) (Under Beam)`Paperbark - PB``1`4`3134`3104`0.0`35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158=Post 158 section`218`338`2796`0`Paperbark` 6`1586510`0`0",
                },
            },
            "CL HEADERS":
                "Code`Description`Item Use`Colour`Extra Information`Area`Num`Cut Length`Finish Length`X Rotation`Angle 1`Angle 2`Flat Angle 1`Flat Angle 2`Hole A`Hole B`Hole C`Hole D`Hole E`Colour ID`CL ID`Section`End Angle D1`End Angle D2",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: {
                    CutPlane: "Front",
                    LeftAngle: "35.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=POST158=Post 158 section",
                    HolePunchingRecommend: "POST158=Post 158 section",
                    Section: "1586510",
                    CutLength: "3134",
                    FinishLength: "3104",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Post in Ground (Standard) (Under Beam)`Paperbark - PB``1`4`3134`3104`0.0`35.0`0.0`0.0`0.0`PUNCH_STYLE=POST158=Post 158 section`218`338`2796`0`Paperbark` 6`1586510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS158",
            Desc: "Cen 158X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "4 (For Post)",
            Length: "",
            CodeBase: "CBBS158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS215865H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Portal Strut)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK27158",
            Desc: "Cen BK27 15865 Corner Connector **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 (For Attachment Beam (Back))|1 (For Perimeter Beam (Front))",
            Length: "",
            CodeBase: "BK27158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK27CC158**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"12"},{}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK315865-S",
            Desc: "Cen BK3 15865 @@ ** ",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "4 (For Portal Rafter (No Post))",
            Length: "",
            CodeBase: "BK315865",
            CodeAppend: "-S.20DEG UP",
            DescAppend: "20 Degrees Up",
            "CL ID": "1",
            Fielders_Code: "CNBK3CB158@@**",
            "CL DATA": {
                0: {
                    BracketType: "BK3",
                    Angle1: "-20.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK3",
                    Angle1: "-20.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK3310865",
            Desc: "Cen BK33 10865 @@ ** ",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Gable Infill Beam)",
            Length: "",
            CodeBase: "BK3310865",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNBK33C108@@**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"14","Colour":"Area.RafterColour"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB108",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK3315865",
            Desc: "Cen BK33 15865 @@ ** ",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Portal Rafter (Width Attached))",
            Length: "",
            CodeBase: "BK3315865",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNBK33C158@@**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"14","Colour":"Area.RafterColour"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK34S20G",
            Desc: "Cen BK34S RSF Single 20Deg Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "20",
            Length: "",
            CodeBase: "BK34S20G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK34SRSF200GA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BNW1060Z","Use":"BK34 Fix","Qty":"4"},{"Code":"BK2164G","Use":"BK34 Fix","Qty":"2","Conditions":{"DescAppend":"!=*Riser*"}},{"Code":"10X90","Qty":"2","Colour":"Area.BeamColour"}]}',
            PromptCodes: "$$=62.70",
            Image_b64: null,
            PromptTextCodes: "$$=62.70",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK36",
            Desc: "Cen BK36 Top Gable End Strut **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 (For Portal Strut)",
            Length: "",
            CodeBase: "BK36",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK36CT**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK88158",
            Desc: "Cen BK88 158 Box Beam Stop End **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 (End Cap for Attachment Beam (Back))|1 (End Cap for Perimeter Beam (Front))",
            Length: "",
            CodeBase: "BK88158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK88158SE**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Use":"Beam End Cap Fix"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK8865",
            Desc: "Cen BK88 65 Box Beam Stop End **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "6 (End Cap for On Top Purlin)",
            Length: "",
            CodeBase: "BK8865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK8865SE**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Use":"Beam End Cap Fix"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON115865G",
            Desc: "Cen CON1 15865 Galv Inground Connnector",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "4 (For Post)",
            Length: "",
            CodeBase: "CON115865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON1158GA",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"10X170","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON215865G",
            Desc: "Cen CON2 15865-@@ Ridge Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "4 (For Portal Rafter (No Post))|1 (For Portal Rafter (Width Attached))",
            Length: "",
            CodeBase: "CON215865G",
            CodeAppend: "",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNCON2158GA@@",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BHSS1025SL","Use":"Con2 Fix","Qty":"8","Colour":"Plain"},{"Code":"TS1220100B8N","Use":"Con2 Fix","Colour":"Area.RafterColour","Qty":"4"}]}',
            PromptCodes: "@@=15|20|25|30",
            Image_b64: null,
            PromptTextCodes: "@@=15|20|25|30",
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON315865G",
            Desc: "Cen CON3 15865-@@ Eaves Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "4 (For Portal Rafter (Standard))",
            Length: "",
            CodeBase: "CON315865G",
            CodeAppend: ".20DEG",
            DescAppend: "20 Degrees",
            "CL ID": "0",
            Fielders_Code: "CNCON3158GA@@",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BHSS1025SL","Qty":"8","Colour":"Plain"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.RafterColour","Qty":"2"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON515865G",
            Desc: "Cen CON5 15865 300 Beam Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "1 (For Attachment Beam (Back))|1 (For Perimeter Beam (Front))",
            Length: "",
            CodeBase: "CON515865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON5158GA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Colour":"Area.BeamColour","Qty":"16"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON56565G",
            Desc: "Cen CON5 6565 300 Beam Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "2 (For On Top Purlin)|8 (For Purlin T1)",
            Length: "",
            CodeBase: "CON56565G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON565GA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Colour":"Area.BeamColour","Qty":"16"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "10X90",
            Desc: "Cen Bolt Nut G4.6 10X90 **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "5 (Attachment Beam (Back) Fix)|5 (Perimeter Beam (Front) Fix)",
            Length: "",
            CodeBase: "10X90",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BN1090**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: 'Desc="10x90mm Bolt(s)"',
            Image_b64: null,
            PromptTextCodes: 'Desc="10x90mm Bolt(s)"',
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "TS1495100B8P",
            Desc: "BF 14-10X95 H/H Tek No Neo B8 Plain (Pkt 100)",
            Use: "",
            Colour: "Plain",
            Area: "1",
            Qty: "21 (On Top Purlin Fix)|80 (Purlin T1 Fix)",
            Length: "",
            CodeBase: "TS1495100B8P",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHBF1495N100",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "100",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: 'Desc="14x90 Hex Screw(s)" AltIndex=TS1495,TS1495P',
            Image_b64: null,
            PromptTextCodes: 'Desc="14x90 Hex Screw(s)" AltIndex=TS1495,TS1495P',
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "MISC",
            Code: "COCOVER",
            Desc: "Corrugated Cover Sheet Only (Metal)",
            Use: "",
            Colour: "",
            Area: "",
            Qty: "2 x 4241 (Sheet Cover Sheet)",
            Length: "4241",
            CodeBase: "COCOVER",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PACCSSLM",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "$$=1",
            Image_b64: null,
            PromptTextCodes: "$$=1",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    OLLC01364: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CO42DSS",
            Desc: "Corr S-Rib 0.42BMT DS **H**",
            Use: "",
            Colour: "Classic Cream/Classic Cream",
            Area: "1",
            Qty: "3 x 5450|1 x 5421|1 x 5369|1 x 5265|1 x 5161|1 x 5109",
            Length: "5450",
            CodeBase: "CO42DSS",
            CodeAppend: "",
            DescAppend: " <REDIRECTED MEN FROM CO42DS>",
            "CL ID": "0",
            Fielders_Code: "CO42**H**CS",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1245B8100","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*4)+7)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1245B8100","Use":"Roof Fix","Conditions":{"Use":"!=*B/C Fixed*"},"Qty":"=Qty*6","Colour":"Area.RoofSheetColour"}]}',
            PromptCodes: "DISABLED=LSB|GIL|GAW|WAN|NOA|KEW|EMU|NUN|LAU|MAR|MIN|CAM",
            Image_b64: null,
            PromptTextCodes: "DISABLED=LSB|GIL|GAW|WAN|NOA|KEW|EMU|NUN|LAU|MAR|MIN|CAM",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
            },
        },
        {
            Add: true,
            Category: "POLYCARBONATE ROOFING",
            Code: "PSC",
            Desc: "Ampelite Solasafe Corrugated Polycarbonate Sheet  **",
            Use: "",
            Colour: "Opal",
            Area: "1",
            Qty: "2 x 6000 (/finish @5450mm)|1 x 5400 (/finish @5317mm)|1 x 5400 (/finish @5213mm)",
            Length: "6000",
            CodeBase: "PSC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PCCO**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"CLEARFIX","Qty":"=((Area.NumInternalPurlins*3)+12)*Qty","Colour":"Plain","Conditions":{"Brand":"=Fielders"}},{"Code":"BK30G","Qty":"3","Use":"Infill Support","Conditions":{"Use":"=*Infill*","Brand":"=Fielders"}},{"Code":"CPCB36","Conditions":{"Brand":"=Fielders"},"Qty":"=(((Length/900)+1)*1000)/25000"},{"Code":"FT50MP","Qty":"=((Area.NumInternalPurlins*4)+4)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT45MR","Qty":"=((Area.NumInternalPurlins*2)+4)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"WG","Qty":"=((Area.NumInternalPurlins*6)+4)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FR64","Qty":"=Qty*6","Colour":"Area.BeamColour","Conditions":{"Brand":"=Lysaght","Area.DesignType":"=Flat Roof"}},{"Code":"WASHM","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Area.DesignType":"=Flat Roof"},"Qty":"=Qty*6"},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*9)+2)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT50MP","Qty":"=((Area.NumInternalPurlins*4)+2)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT45MR","Qty":"=((Area.NumInternalPurlins*2)+2)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"WGFG","Qty":"=((Area.NumInternalPurlins*2)+8)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT30M","Qty":"=6*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*9)+2)*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT35_WCB","Qty":"=12*Qty","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"COFILL","Length":"915","Conditions":{"Brand":"=Lysaght"}}]}',
            PromptCodes:
                "SL=1800(201300)|2100(201300)|2400(201300)|2700(201300)|3000(201300)|3600(201300)|4200(201300)|4800(201300)|5400(201300)|6000(201300)|6300(201300)|7200(201300)|8100(201300)",
            Image_b64: null,
            PromptTextCodes:
                "SL=1800(201300)|2100(201300)|2400(201300)|2700(201300)|3000(201300)|3600(201300)|4200(201300)|4800(201300)|5400(201300)|6000(201300)|6300(201300)|7200(201300)|8100(201300)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "DG",
            Desc: "125 D Gutter **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 8690",
            Length: "8690",
            CodeBase: "DG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DG55125**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DGUB125","Use":"Gutter Strap","Qty":"=(Length/900)+2"},{"Code":"SCTF","Use":"Gutter Clip","Qty":"=(Length/900)+2"},{"Code":"RI43100","Qty":"12","Colour":"Area.RoofSheetColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "DGLSE",
            Desc: "125 D Gutter LH Stop End **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "DGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DG125SEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "DGRSE",
            Desc: "125 D Gutter RH Stop End **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "DGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DG125SER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO656Z",
            Desc: "65X65 Pop Square Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "PO656Z",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPP6565ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DP656",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DP656",
            Desc: "65X65 Downpipe ** 1800mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 1800",
            Length: "1800",
            CodeBase: "DP656",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DP6565**18",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8"},{"Code":"ST656","Qty":"=(Length/1200)"}]}',
            PromptCodes: "Length=1800 AltIndex=DP656_INTERNAL",
            Image_b64: null,
            PromptTextCodes: "Length=1800 AltIndex=DP656_INTERNAL",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL01",
            Desc: "Cen CFL01 Barge Cap **H**",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 5390 (Corrugated - C/Bond D/S 0.42 (Non-Trafficable) Barge Capping)|1 x 4796 (Corrugated - C/Bond D/S 0.42 (Non-Trafficable) Barge Capping)",
            Length: "5390",
            CodeBase: "CFL01",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL01**H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL17",
            Desc: "Cen CFL17 Barge (Corro) O/Hang **H**",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 8670 (Corrugated - C/Bond D/S 0.42 (Non-Trafficable) Back OH Barge Capping)",
            Length: "8670",
            CodeBase: "CFL17",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL17**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "MSJ",
            Desc: "****** Product Not Found: CFL24 (Fascia Flashing)",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 8690 (Fascia Flashing)",
            Length: "8690",
            CodeBase: "MSJ",
            CodeAppend: ".6DEG",
            DescAppend: "6 Degrees",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 8530 (Back Fascia Beam)|1 x 8546 (Cutout Beam A)|1 x 4665 (Rafter)|1 x 4371 (Left Rafter)|4 x 4228 (Left Purlin)|1 x 4959 (Right Rafter)|4 x 4228 (Right Purlin)",
            Length: "8530",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
                2: {
                    CutPlane: "Front",
                    LeftAngle: "-6.0",
                    RightAngle: "6.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "4665",
                    FinishLength: "4635",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Intermediate Beam`Classic Cream - CC``1`1`4665`4635`0.0`-6.0`6.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Classic Cream` 1`1586510`0`0",
                },
                3: {
                    CutPlane: "Front",
                    LeftAngle: "-6.0",
                    RightAngle: "6.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "4371",
                    FinishLength: "4341",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Left Intermediate Beam`Classic Cream - CC``1`1`4371`4341`0.0`-6.0`6.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Classic Cream` 2`1586510`0`0",
                },
                4: null,
                5: {
                    CutPlane: "Front",
                    LeftAngle: "-6.0",
                    RightAngle: "6.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "4959",
                    FinishLength: "4929",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Right Intermediate Beam`Classic Cream - CC``1`1`4959`4929`0.0`-6.0`6.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Classic Cream` 3`1586510`0`0",
                },
                6: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "RHS150505G",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: {
                    CutPlane: "Front",
                    LeftAngle: "-6.0",
                    RightAngle: "6.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "4665",
                    FinishLength: "4635",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Intermediate Beam`Classic Cream - CC``1`1`4665`4635`0.0`-6.0`6.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Classic Cream` 1`1586510`0`0",
                },
                3: {
                    CutPlane: "Front",
                    LeftAngle: "-6.0",
                    RightAngle: "6.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "4371",
                    FinishLength: "4341",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Left Intermediate Beam`Classic Cream - CC``1`1`4371`4341`0.0`-6.0`6.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Classic Cream` 2`1586510`0`0",
                },
                4: null,
                5: {
                    CutPlane: "Front",
                    LeftAngle: "-6.0",
                    RightAngle: "6.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "4959",
                    FinishLength: "4929",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Right Intermediate Beam`Classic Cream - CC``1`1`4959`4929`0.0`-6.0`6.0`0.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Classic Cream` 3`1586510`0`0",
                },
                6: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "MSJ.RHS150505G",
            Desc: "RHS 150 X 50 X 5.00mm Allgal (exceeds max stock length of 8000mm)",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "1 x 8530 (Back Fascia Beam)",
            Length: "8530",
            CodeBase: "MSJ.RHS150505G",
            CodeAppend: "",
            DescAppend: " (exceeds max stock length of 8000mm)",
            "CL ID": "0",
            Fielders_Code: "RHS150505GA80",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "Length=8000 DisableNesting=1",
            Image_b64: null,
            PromptTextCodes: "Length=8000 DisableNesting=1",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS65",
            Desc: "Cen 65X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "5 (For Post)",
            Length: "",
            CodeBase: "CBBS65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS26565H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "SHS65653",
            Desc: "SHS 65 X 65 X 3.00mm Allgal **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 3552 (Post in Ground (Beam to Side))|1 x 3082 (Post in Ground (Beam to Side))|1 x 3021 (Post in Ground (Beam to Side))|1 x 2894 (Post in Ground (Under Beam))",
            Length: "3552",
            CodeBase: "SHS65653",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHS65653**80",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK215865",
            Desc: "Cen BK2 15865 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Back Fascia Beam Fixed to 65mm Post)|2 (For Cutout Beam A Fixed to 65mm Post)|8 (For Left Purlin)|8 (For Right Purlin)",
            Length: "",
            CodeBase: "BK215865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB158**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 (For Post)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK315865NSCD-S",
            Desc: "Cen BK3 15865 ** Non Standard",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 (For Rafter)|1 (For Left Rafter Fixed to 65mm Post)|1 (For Right Rafter Fixed to 65mm Post)",
            Length: "",
            CodeBase: "BK315865NSCD",
            CodeAppend: "-S.6DEG DOWN",
            DescAppend: "6 Degrees Down",
            "CL ID": "2",
            Fielders_Code: "CNBK3CB158NS**",
            "CL DATA": {
                0: {
                    BracketType: "BK3",
                    Angle1: "6.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                1: {
                    BracketType: "BK3",
                    Angle1: "6.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                2: {
                    BracketType: "BK3",
                    Angle1: "6.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK3",
                    Angle1: "6.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                1: {
                    BracketType: "BK3",
                    Angle1: "6.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                2: {
                    BracketType: "BK3",
                    Angle1: "6.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK576565",
            Desc: "Cen BK57 Compound Bracket *Non Std* **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 (For Rafter)|1 (For Left Rafter)|1 (For Right Rafter)",
            Length: "",
            CodeBase: "BK5715865",
            CodeAppend: "(TO BEAM)-S.15865.6DEG UP .4DEG RH",
            DescAppend: "158x65 6 Degrees Up 4 Degrees Right Hand",
            "CL ID": "1",
            Fielders_Code: "CNBK57NS65**",
            "CL DATA": {
                0: {
                    BracketType: "BK57",
                    Angle1: "4.00",
                    Angle2: "-6.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                1: {
                    BracketType: "BK57",
                    Angle1: "4.00",
                    Angle2: "-6.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                2: {
                    BracketType: "BK57",
                    Angle1: "4.00",
                    Angle2: "-6.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK57",
                    Angle1: "4.00",
                    Angle2: "-6.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                1: {
                    BracketType: "BK57",
                    Angle1: "4.00",
                    Angle2: "-6.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                2: {
                    BracketType: "BK57",
                    Angle1: "4.00",
                    Angle2: "-6.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "MISC",
            Code: "COCOVER",
            Desc: "Corrugated Cover Sheet Only (Metal)",
            Use: "",
            Colour: "",
            Area: "",
            Qty: "2 x 5450 (Sheet Cover Sheet)",
            Length: "5450",
            CodeBase: "COCOVER",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PACCSSLM",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "$$=1",
            Image_b64: null,
            PromptTextCodes: "$$=1",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    CVSC00227: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CD42DS",
            Desc: "C-Dek 310 0.42BMT **H**",
            Use: "",
            Colour: "Surfmist/Surfmist",
            Area: "1",
            Qty: "1 x 3804|1 x 3744|1 x 3684|1 x 3623|4 x 4849 (B/C Fixed)|1 x 4833 (B/C Fixed)|1 x 4713 (B/C Fixed)|1 x 4652 (B/C Fixed)|1 x 4592 (B/C Fixed)|1 x 4472 (B/C Fixed)|1 x 4411 (B/C Fixed)|1 x 4351 (B/C Fixed)|1 x 4231 (B/C Fixed)|1 x 4170 (B/C Fixed)|1 x 4110 (B/C Fixed)|1 x 3990 (B/C Fixed)",
            Length: "3804",
            CodeBase: "CD42DS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CDK42**H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1220100B8","Qty":"=Qty*3","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Use":"!=*B/C Fixed*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
            },
        },
        {
            Add: true,
            Category: "POLYCARBONATE ROOFING",
            Code: "PSCD",
            Desc: "C-Dek 310 Polycarbonate (1.50mm Thick) Sheet",
            Use: "",
            Colour: "Opal",
            Area: "1",
            Qty: "1 x 5000 (B/C Fixed/finish @4773mm)|1 x 5000 (B/C Fixed/finish @4532mm)|1 x 4500 (B/C Fixed/finish @4291mm)|1 x 4500 (B/C Fixed/finish @4050mm)",
            Length: "5000",
            CodeBase: "PSCD",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PCSCDK310OP",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"CLEARFIX","Qty":"=((Area.NumInternalPurlins*3)+12)*Qty","Colour":"Plain"},{"Code":"BK30G","Qty":"3","Use":"Infill Support","Conditions":{"Use":"=*Infill*"}}]}',
            PromptCodes:
                "SL=1000(206000)|1500(206000)|2000(206000)|2500(206000)|3000(206000)|3500(206000)|4000(206000)|4500(206000)|5000(206000)|5500(206000)|6000(206000)|6500(206000)|7000(206000)|7500(206000)|8000(206000)",
            Image_b64: null,
            PromptTextCodes:
                "SL=1000(206000)|1500(206000)|2000(206000)|2500(206000)|3000(206000)|3500(206000)|4000(206000)|4500(206000)|5000(206000)|5500(206000)|6000(206000)|6500(206000)|7000(206000)|7500(206000)|8000(206000)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGLSE",
            Desc: "Fascia Gutter LH Stop End **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FGS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGRSE",
            Desc: "Fascia Gutter RH Stop End **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FGS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGS",
            Desc: "Fascia Gutter Slotted **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 7131",
            Length: "7131",
            CodeBase: "FGS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGFS55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"JSTRAP","Use":"Gutter Clip","Qty":"=(Length/900)+1"},{"Code":"SCTF","Qty":"=(Length/900)+1"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO656Z",
            Desc: "65X65 Pop Square Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "PO656Z",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPP6565ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DP656",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DP656",
            Desc: "65X65 Downpipe ** 1800mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 1800",
            Length: "1800",
            CodeBase: "DP656",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DP6565**18",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8"},{"Code":"ST656","Qty":"=(Length/1200)"}]}',
            PromptCodes: "Length=1800 AltIndex=DP656_INTERNAL",
            Image_b64: null,
            PromptTextCodes: "Length=1800 AltIndex=DP656_INTERNAL",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL22",
            Desc: "Cen CFL22 C-Dek 310 Barge **H**",
            Use: "",
            Colour: "Surfmist",
            Area: "1",
            Qty: "1 x 4788 (Cent 310 Deck Barge Capping)|1 x 3302 (Cent 310 Deck Barge Capping)|1 x 1250 (Cent 310 Deck Barge Capping)",
            Length: "4788",
            CodeBase: "CFL22",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL22**H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Mangrove",
            Area: "1",
            Qty: "1 x 6978 (Cutout Beam A)|1 x 3393 (Left Rafter)|1 x 1180 (Partial Attachment Beam)|1 x 6860 (Purlin)|1 x 4735 (Right Rafter)",
            Length: "6978",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: {
                    CutPlane: "Top",
                    LeftAngle: "-11.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "3393",
                    FinishLength: "3363",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Left Intermediate Beam`Mangrove - MM``1`1`3393`3363`0.0`-2.0`0.0`-11.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Mangrove` 1`1586510`0`0",
                },
                2: null,
                3: null,
                4: {
                    CutPlane: "Top",
                    LeftAngle: "-11.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "4735",
                    FinishLength: "4705",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Right Intermediate Beam`Mangrove - MM``1`1`4735`4705`0.0`-2.0`2.0`-11.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Mangrove` 2`1586510`0`0",
                },
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: {
                    CutPlane: "Top",
                    LeftAngle: "-11.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "3393",
                    FinishLength: "3363",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Left Intermediate Beam`Mangrove - MM``1`1`3393`3363`0.0`-2.0`0.0`-11.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Mangrove` 1`1586510`0`0",
                },
                2: null,
                3: null,
                4: {
                    CutPlane: "Top",
                    LeftAngle: "-11.0",
                    RightAngle: "0.0",
                    CompoundAngle: "0.0",
                    HolePunching: "PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING",
                    HolePunchingRecommend: "PLAIN_CUT=CUTS with NO PUNCHING",
                    Section: "1586510",
                    CutLength: "4735",
                    FinishLength: "4705",
                    LeftHeelCut: "0",
                    RightHeelCut: "0",
                    "CL DATA":
                        "BB158`Cen Box Beam 158x65x0.95BMT **`Right Intermediate Beam`Mangrove - MM``1`1`4735`4705`0.0`-2.0`2.0`-11.0`0.0`PUNCH_STYLE=PLAIN_CUT=CUTS with NO PUNCHING`0`0`0`0`Mangrove` 2`1586510`0`0",
                },
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "BB65",
            Desc: "Cen Box Beam 65x65x0.95BMT **",
            Use: "",
            Colour: "Mangrove",
            Area: "1",
            Qty: "1 x 3351 (Post in Ground (Beam to Side))|1 x 3235 (Post in Ground (Beam to Side))|1 x 3188 (Post in Ground (Beam to Side))|1 x 3193 (Post in Ground (Under Beam))",
            Length: "3351",
            CodeBase: "BB65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB956565H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "AltIndex=BB656575",
            Image_b64: null,
            PromptTextCodes: "AltIndex=BB656575",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS65",
            Desc: "Cen 65X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Mangrove",
            Area: "1",
            Qty: "4 (For Post)",
            Length: "",
            CodeBase: "CBBS65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS26565H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK215865",
            Desc: "Cen BK2 15865 **",
            Use: "",
            Colour: "Mangrove",
            Area: "1",
            Qty: "2 (For Cutout Beam A Fixed to 65mm Post)|1 (For Left Rafter)|1 (For Partial Attachment Beam Fixed to 65mm Post)|2 (For Purlin)|1 (For Right Rafter)",
            Length: "",
            CodeBase: "BK215865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB158**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Mangrove",
            Area: "1",
            Qty: "1 (For Post)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK46158S",
            Desc: "Cen BK46 15865 Beam To Beam Conn. ** Non Standard",
            Use: "",
            Colour: "Mangrove",
            Area: "1",
            Qty: "1 (For Left Rafter)|1 (For Right Rafter)",
            Length: "",
            CodeBase: "BK46158S",
            CodeAppend: ".15865.79DEG RH",
            DescAppend: "158x65 79 Degrees Right Hand",
            "CL ID": "1",
            Fielders_Code: "CNBK46NS158**",
            "CL DATA": {
                0: {
                    BracketType: "BK46",
                    Angle1: "-79.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                1: {
                    BracketType: "BK46",
                    Angle1: "-79.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK46",
                    Angle1: "-79.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                1: {
                    BracketType: "BK46",
                    Angle1: "-79.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK88158",
            Desc: "Cen BK88 158 Box Beam Stop End **",
            Use: "",
            Colour: "Mangrove",
            Area: "1",
            Qty: "1 (End Cap for Partial Attachment Beam)",
            Length: "",
            CodeBase: "BK88158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK88158SE**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Use":"Beam End Cap Fix"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON16565",
            Desc: "Cen CON1 6565 Galv Inground Connector",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "4 (For Post)",
            Length: "",
            CodeBase: "CON16565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON165GA",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"10X90","Colour":"Area.PostColour","Qty":"2"},{"Code":"TS1220100B8N","Colour":"Area.PostColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB65",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "BC5075",
            Desc: "50mm Receiver Channel **",
            Use: "",
            Colour: "Surfmist",
            Area: "",
            Qty: "1 x 7500 (5750mm(Back Channel))",
            Length: "7500",
            CodeBase: "BC5075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BKCCDK50H**7500",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "Length=7500",
            Image_b64: null,
            PromptTextCodes: "Length=7500",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    FTLC01383: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CD42DS",
            Desc: "C-Dek 310 0.42BMT **H**",
            Use: "",
            Colour: "Monument/Surfmist",
            Area: "1",
            Qty: "47 x 3962 (B/C Fixed)",
            Length: "3962",
            CodeBase: "CD42DS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CDK42**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1220100B8","Qty":"=Qty*3","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Use":"!=*B/C Fixed*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FG",
            Desc: "Fascia Gutter **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 14470",
            Length: "14470",
            CodeBase: "FG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGF55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"JSTRAP","Use":"Gutter Clip","Qty":"=(Length/900)+1"},{"Code":"SCTF","Qty":"=(Length/900)+1"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGLSE",
            Desc: "Fascia Gutter LH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGRSE",
            Desc: "Fascia Gutter RH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO90SWZ",
            Desc: "90mm Rnd Pop (Suit Pvc & Metal D/Pipe) Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "PO90SWZ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PVC90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PVC90",
            Desc: "90mm Pvc Stormwater Pipe 6000mm",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "2 x 2769",
            Length: "2769",
            CodeBase: "PVC90",
            CodeAppend: "",
            DescAppend: " (finish 2769mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH6000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"=(Length/1200)","Use":"Downpipe Fix"},{"Code":"FR72","Qty":"4"},{"Code":"ST90","Qty":"2"}]}',
            PromptCodes: "Length=6000",
            Image_b64: null,
            PromptTextCodes: "Length=6000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL22",
            Desc: "Cen CFL22 C-Dek 310 Barge **H**",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 x 3902 (Cent 310 Deck Barge Capping)",
            Length: "3902",
            CodeBase: "CFL22",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL22**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 x 7153 (Fascia Beam)|1 x 3808 (Left Rafter)|1 x 3808 (Right Rafter)",
            Length: "7153",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS65",
            Desc: "Cen 65X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "CBBS65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS26565H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS90",
            Desc: "Post Shoe to suit 90mm SHS Post",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "CBBS90",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "PS2P9090H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS909035",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "SHS65653",
            Desc: "SHS 65 X 65 X 3.00mm Allgal **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "3 x 3461 (Post in Ground (Under Beam))",
            Length: "3461",
            CodeBase: "SHS65653",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHS65653**80",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "SHS909035",
            Desc: "SHS 89 X 89 X 3.50mm Allgal **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 x 3619 (Post in Ground (Beam to Side))",
            Length: "3619",
            CodeBase: "SHS909035",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHS898935**80",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK215865",
            Desc: "Cen BK2 15865 **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 (For Fascia Beam Fixed to 65mm Post)|1 (For Left Rafter)|1 (For Left Rafter Fixed to 65mm Post)|1 (For Right Rafter)|1 (For Right Rafter Fixed to 65mm Post)",
            Length: "",
            CodeBase: "BK215865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB158**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON515865G",
            Desc: "Cen CON5 15865 300 Beam Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "1 (For Fascia Beam)",
            Length: "",
            CodeBase: "CON515865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON5158GA",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Colour":"Area.BeamColour","Qty":"16"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "BC5075",
            Desc: "50mm Receiver Channel **",
            Use: "",
            Colour: "Surfmist",
            Area: "",
            Qty: "1 x 7500 (6970mm(Back Channel*1*))|1 x 7500 (7500mm(Back Channel*1*))",
            Length: "7500",
            CodeBase: "BC5075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BKCCDK50H**7500",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "Length=7500",
            Image_b64: null,
            PromptTextCodes: "Length=7500",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
    ],
    OLCC00019: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CD42DS",
            Desc: "C-Dek 310 0.42BMT **H**",
            Use: "",
            Colour: "Paperbark/Paperbark",
            Area: "1",
            Qty: "44 x 2361|1 x 2361 (A1-B/C Fixed)",
            Length: "2361",
            CodeBase: "CD42DS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CDK42**H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1220100B8","Qty":"=Qty*3","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Use":"!=*B/C Fixed*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CD42DS",
            Desc: "C-Dek 310 0.42BMT **H**",
            Use: "",
            Colour: "Paperbark/Paperbark",
            Area: "2",
            Qty: "43 x 2361|3 x 2361 (A2-B/C Fixed)",
            Length: "2361",
            CodeBase: "CD42DS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CDK42**H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1220100B8","Qty":"=Qty*3","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Use":"!=*B/C Fixed*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "CD42DS",
            Desc: "C-Dek 310 0.42BMT **H**",
            Use: "",
            Colour: "Paperbark/Paperbark",
            Area: "3",
            Qty: "44 x 2361|1 x 2361 (A3-B/C Fixed)",
            Length: "2361",
            CodeBase: "CD42DS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CDK42**H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Area.RoofSheetColour"},{"Code":"TS1220100B8","Qty":"=Qty*3","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Use":"!=*B/C Fixed*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FG",
            Desc: "Fascia Gutter **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 41834",
            Length: "41834",
            CodeBase: "FG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGF55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"JSTRAP","Use":"Gutter Clip","Qty":"=(Length/900)+1"},{"Code":"SCTF","Qty":"=(Length/900)+1"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGLSE",
            Desc: "Fascia Gutter LH Stop End **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGRSE",
            Desc: "Fascia Gutter RH Stop End **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "FG",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO90SWZ",
            Desc: "90mm Rnd Pop (Suit Pvc & Metal D/Pipe) Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "PO90SWZ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PVC90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PVC90",
            Desc: "90mm Pvc Stormwater Pipe 6000mm",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "1 x 2025",
            Length: "2025",
            CodeBase: "PVC90",
            CodeAppend: "",
            DescAppend: " (finish 2025mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH6000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"=(Length/1200)","Use":"Downpipe Fix"},{"Code":"FR72","Qty":"4"},{"Code":"ST90","Qty":"2"}]}',
            PromptCodes: "Length=6000",
            Image_b64: null,
            PromptTextCodes: "Length=6000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO90SWZ",
            Desc: "90mm Rnd Pop (Suit Pvc & Metal D/Pipe) Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "2",
            Qty: "1",
            Length: "",
            CodeBase: "PO90SWZ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PVC90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PVC90",
            Desc: "90mm Pvc Stormwater Pipe 6000mm",
            Use: "",
            Colour: "",
            Area: "2",
            Qty: "1 x 2025",
            Length: "2025",
            CodeBase: "PVC90",
            CodeAppend: "",
            DescAppend: " (finish 2025mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH6000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"=(Length/1200)","Use":"Downpipe Fix"},{"Code":"FR72","Qty":"4"},{"Code":"ST90","Qty":"2"}]}',
            PromptCodes: "Length=6000",
            Image_b64: null,
            PromptTextCodes: "Length=6000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PO90SWZ",
            Desc: "90mm Rnd Pop (Suit Pvc & Metal D/Pipe) Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "3",
            Qty: "1",
            Length: "",
            CodeBase: "PO90SWZ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"8","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PVC90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "PVC90",
            Desc: "90mm Pvc Stormwater Pipe 6000mm",
            Use: "",
            Colour: "",
            Area: "3",
            Qty: "1 x 2025",
            Length: "2025",
            CodeBase: "PVC90",
            CodeAppend: "",
            DescAppend: " (finish 2025mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH6000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"=(Length/1200)","Use":"Downpipe Fix"},{"Code":"FR72","Qty":"4"},{"Code":"ST90","Qty":"2"}]}',
            PromptCodes: "Length=6000",
            Image_b64: null,
            PromptTextCodes: "Length=6000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL22",
            Desc: "Cen CFL22 C-Dek 310 Barge **H**",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 13928 (A1-Cent 310 Deck Back OH Barge Capping)|1 x 2301 (A1-Cent 310 Deck Barge Capping)",
            Length: "13928",
            CodeBase: "CFL22",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL22**H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL22",
            Desc: "Cen CFL22 C-Dek 310 Barge **H**",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "1 x 13978 (Cent 310 Deck Back OH Barge Capping)",
            Length: "13978",
            CodeBase: "CFL22",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL22**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CFL22",
            Desc: "Cen CFL22 C-Dek 310 Barge **H**",
            Use: "",
            Colour: "Paperbark",
            Area: "3",
            Qty: "1 x 13928 (A3-Cent 310 Deck Back OH Barge Capping)|1 x 2301 (A3-Cent 310 Deck Barge Capping)",
            Length: "13928",
            CodeBase: "CFL22",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCFL22**H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[\n   {"Code":"RI43100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "14"},\n   {"Code":"TS1245B8100",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"!=*No Side Beam*"\n          }},\n   {"Code":"TS1220100B8",\n    "Use":"Barge Capping Fix",\n    "Qty" : "=(Length/500) + 2",\n    "Conditions":{\n          "Desc":"=*No Side Beam*"\n          }}\n]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "2 x 5229 (A1-Back Fascia Beam)|1 x 5159 (A1-Back Fascia Beam)|1 x 6980 (A1-Fascia Beam)|1 x 6910 (A1-Fascia Beam)|1 x 1855 (A1-Left Rafter)",
            Length: "5229",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "2 x 5229 (A2-Back Fascia Beam)|2 x 6989 (A2-Fascia Beam)",
            Length: "5229",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BB158",
            Desc: "Cen Box Beam 158x65x0.95BMT **",
            Use: "",
            Colour: "Paperbark",
            Area: "3",
            Qty: "2 x 5229 (A3-Back Fascia Beam)|1 x 5159 (A3-Back Fascia Beam)|1 x 6948 (A3-Fascia Beam)|1 x 6878 (A3-Fascia Beam)|1 x 1855 (A3-Right Rafter)",
            Length: "5229",
            CodeBase: "BB158",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CBB9515865H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"BK2164G","Qty":"=(Length/600)+1","Conditions":{"Use":"=*Wall Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS65",
            Desc: "Cen 65X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "12 (For Post)",
            Length: "",
            CodeBase: "CBBS65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS26565H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "SHS65653",
            Desc: "SHS 65 X 65 X 3.00mm Allgal **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 x 2945 (A1-Post in Ground (Beam to Side))|1 x 2875 (A1-Post in Ground (Beam to Side))|7 x 2787 (A1-Post in Ground (Under Beam))|3 x 2717 (A1-Post in Ground (Under Beam))",
            Length: "2945",
            CodeBase: "SHS65653",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHS65653**80",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS65",
            Desc: "Cen 65X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "1 (For Post)",
            Length: "",
            CodeBase: "CBBS65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS26565H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "SHS65653",
            Desc: "SHS 65 X 65 X 3.00mm Allgal **",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "1 x 2717 (Post in Ground (Under Beam))",
            Length: "2717",
            CodeBase: "SHS65653",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHS65653**80",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CBBS65",
            Desc: "Cen 65X65 Box Beam Post Shoe Gloss **",
            Use: "",
            Colour: "Paperbark",
            Area: "3",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "CBBS65",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBBPS26565H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "SHS65653",
            Desc: "SHS 65 X 65 X 3.00mm Allgal **",
            Use: "",
            Colour: "Paperbark",
            Area: "3",
            Qty: "1 x 2945 (A3-Post in Ground (Beam to Side))|1 x 2875 (A3-Post in Ground (Beam to Side))|1 x 2717 (A3-Post in Ground (Under Beam))",
            Length: "2945",
            CodeBase: "SHS65653",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SHS65653**80",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: IBLC 23 1 (For Post)",
            Use: "",
            Colour: "Paperbark",
            Area: "2",
            Qty: "1 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: IBLC 23 1 (For Post)",
            Use: "",
            Colour: "Paperbark",
            Area: "3",
            Qty: "1 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK215865",
            Desc: "Cen BK2 15865 **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "1 (A1-For Back Fascia Beam Fixed to 65mm Post)|1 (A1-For Fascia Beam Fixed to 65mm Post)|2 (A1-For Left Rafter Fixed to 65mm Post)",
            Length: "",
            CodeBase: "BK215865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB158**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK26565",
            Desc: "Cen BK2 6565 **",
            Use: "",
            Colour: "Paperbark",
            Area: "1",
            Qty: "10 (For Post)",
            Length: "",
            CodeBase: "BK26565",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB65**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"},{"Code":"TS1220100B8N","Qty":"8","Conditions":{"Use":"=*Post Under Beam*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "SHS65653",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "BK215865",
            Desc: "Cen BK2 15865 **",
            Use: "",
            Colour: "Paperbark",
            Area: "3",
            Qty: "1 (A3-For Back Fascia Beam Fixed to 65mm Post)|1 (A3-For Fascia Beam Fixed to 65mm Post)|2 (A3-For Right Rafter Fixed to 65mm Post)",
            Length: "",
            CodeBase: "BK215865",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNBK2CB158**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON515865G",
            Desc: "Cen CON5 15865 300 Beam Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "3 (A1-For Back Fascia Beam)|1 (A1-For Fascia Beam)",
            Length: "",
            CodeBase: "CON515865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON5158GA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Colour":"Area.BeamColour","Qty":"16"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON515865G",
            Desc: "Cen CON5 15865 300 Beam Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "2",
            Qty: "2 (A2-For Back Fascia Beam)|2 (A2-For Fascia Beam)",
            Length: "",
            CodeBase: "CON515865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON5158GA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Colour":"Area.BeamColour","Qty":"16"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "CON515865G",
            Desc: "Cen CON5 15865 300 Beam Con Galv",
            Use: "",
            Colour: "Galvanised",
            Area: "3",
            Qty: "2 (A3-For Back Fascia Beam)|2 (A3-For Fascia Beam)",
            Length: "",
            CodeBase: "CON515865G",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CNCON5158GA",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"TS1220100B8N","Colour":"Area.BeamColour","Qty":"16"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BB158",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "BC5075",
            Desc: "50mm Receiver Channel **",
            Use: "",
            Colour: "Paperbark",
            Area: "",
            Qty: "1 x 7500 (2301mm(Back Channel)//2301mm(Back Channel)//2301mm(Back Channel))|1 x 7500 (2301mm(Back Channel))",
            Length: "7500",
            CodeBase: "BC5075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "BKCCDK50H**7500",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "Length=7500",
            Image_b64: null,
            PromptTextCodes: "Length=7500",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
    ],
};

export const LYSAGHT_BOM_JOBS = {
    LSBL00222: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS6DS",
            Desc: "Custom Orb 0.42BMT DS",
            Use: "",
            Colour: "Classic Cream/Classic Cream",
            Area: "1",
            Qty: "6 x 4763",
            Length: "4763",
            CodeBase: "RS6DS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "CO42**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT45MR","Use":"Roof Fix","Qty":"=((Area.NumInternalPurlins*5)+5)*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT20MN","Qty":"=Qty*5","Use":"Roof Fix","Conditions":{"Area.DesignType":"=Flat Roof","Use":"!=*B/C Fixed*"},"Colour":"Area.RoofSheetColour"},{"Code":"COFILL","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Length":"915"},{"Code":"FT50_WCE","Qty":"=((Area.NumInternalPurlins*5)+5)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT50_WCE","Qty":"=Qty*5","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FR64","Qty":"=Qty*4","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"},"Use":"Stitching"},{"Code":"FR64","Qty":"=Qty*8","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"},"Use":"Stitching"},{"Code":"FT45MR","Qty":"=((Area.NumInternalPurlins*5)+7)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"FT20MN","Qty":"=Qty*6","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"COFILL","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"},"Length":"915"},{"Code":"FT50_WCE","Qty":"=((Area.NumInternalPurlins*5)+7)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Qty":"=Qty*6","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Code":"FT35_WCB"}]}',
            PromptCodes: "REDIRECT_GIL=RS6DSS",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_GIL=RS6DSS",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "EMGEC",
            Desc: "Emline Gutter Corner External",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "EMGEC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "EMGEC**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"12"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "GSESL",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGLSE",
            Desc: "Fascia Gutter LH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGLSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSEL**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "GUTTER_NOT_FOUND",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "FGRSE",
            Desc: "Fascia Gutter RH Stop End **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "FGRSE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FGSER**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"RI43100","Qty":"6","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "GUTTER_NOT_FOUND",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GSESL",
            Desc: "Emline Gutter 0.42 Slotted **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 5167",
            Length: "5167",
            CodeBase: "GSESL",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "EMGS42**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"EMGGPB","Qty":"=(Length/900)+1","Colour":"Plain"},{"Code":"STUD19Q","Conditions":{"Use":"=*Overhang*","Area.RoofSheet":"!=*Bondor*"},"Colour":"Plain"},{"Code":"FR72","Qty":"=(Length/900)+1","Colour":"Area.RoofSheetColour","Conditions":{"Use":"=*Overhang*","Area.RoofSheet":"!=*Bondor*"}}]}',
            PromptCodes: "MAX_LM=8700 CutExtra=150 ExtraLM=100",
            Image_b64: null,
            PromptTextCodes: "MAX_LM=8700 CutExtra=150 ExtraLM=100",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "MSJ",
            Desc: "****** Product Not Found: GUTTER_NOT_FOUND",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 x 4263",
            Length: "4263",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DP90",
            Desc: "PVC Stormwater Pipe 90mm DIA 3LM",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "1 x 2229",
            Length: "2229",
            CodeBase: "DP90",
            CodeAppend: "",
            DescAppend: " (finish 2229mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH3000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"2"},{"Code":"FR72","Qty":"4","Colour":"Surfmist"},{"Code":"EL9090Q","Qty":"2"}]}',
            PromptCodes: "Length=3000",
            Image_b64: null,
            PromptTextCodes: "Length=3000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL90Z",
            Desc: "Downpipe Outlet Round 90mm Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "OL90Z",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DP90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "LBARGECO",
            Desc: "L Barge Custom Orb **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 4643 (CUSTOM ORB - C/Bond D/S 0.42 (No Foot Traffic) Barge Capping)",
            Length: "4643",
            CodeBase: "LBARGECO",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LLFL61**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=(Length/600)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=(Length/400)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "ExtraLM=165",
            Image_b64: null,
            PromptTextCodes: "ExtraLM=165",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS90N2004000",
            Desc: "Post Steel 90x90x2mm notched FL200 H** 4000mm",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "2 x 3123 (Post in Ground (Notched))",
            Length: "3123",
            CodeBase: "PS90N200",
            CodeAppend: "",
            DescAppend: "Notched (finish 3123mm)",
            "CL ID": "",
            Fielders_Code: "PSN90200H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"PBP90200","Use":"Notched Post Plate","Colour":"Area.PostColour","Qty":"1"},{"Code":"FT150M","Qty":"2","Colour":"Plain","Conditions":{"Use":"!=*Slab*"}}]}',
            PromptCodes: "Length=4000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(209205)|4000(209207)|5000(209209)|6000(209213) SL_EMU=3000(209205)|4000(209207) SL_NUN=3000(209205)|4000(209207) SL_GIL=3000(209205)|4000(209207)|4500(209203) REDIRECT_NUN=PS90N200V",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90N200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB200",
            Desc: "Connector Beam FL200 **",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "4 (For Rafter)|4 (For Left Purlin)|4 (For Purlin)|4 (For Right Purlin)",
            Length: "",
            CodeBase: "FLUB200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB20050H**05",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HCC20",
            Desc: "Beam Corner Connector FL200 **",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "2 (For Back Fascia Beam)|2 (For Fascia Beam)",
            Length: "",
            CodeBase: "HCC20",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHCC20H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS200",
            Desc: "Firmlok 200x2.0mm Hi Gloss ***",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 x 9000 (4000mm(Fascia Beam)//4000mm(Back Fascia Beam))|1 x 9000 (3811mm(Right Rafter)//3811mm(Left Rafter))|1 x 9000 (3811mm(Rafter)//3811mm(Rafter))|1 x 9000 (1257mm(Right Purlin)//1257mm(Right Purlin)//1257mm(Purlin)//1257mm(Purlin)//1257mm(Left Purlin)//1257mm(Left Purlin))",
            Length: "9000",
            CodeBase: "BS200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "FL20020H**####",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes:
                "SL=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_DUB=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_EMU=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_KEW=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) REDIRECT_GIL=BS200L REDIRECT_NUN=BS200L",
            Image_b64: null,
            PromptTextCodes:
                "SL=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_DUB=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_EMU=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_KEW=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) REDIRECT_GIL=BS200L REDIRECT_NUN=BS200L",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
    ],
    VDPL00030: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS3",
            Desc: "Spandek 0.42BMT **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "9 x 3312|8 x 3285|10 x 3285",
            Length: "3312",
            CodeBase: "RS3",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SD42**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*4)+8)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT20MN","Qty":"=Qty*4","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FR64","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"},"Qty":"=((Length/2000)+1)*Qty","Use":"Stitching"},{"Code":"WGFG","Qty":"=((Length/2000)+1)*Qty","Colour":"Plain","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FR64","Qty":"=((Length/1200)+1)*Qty","Use":"Stitching","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"WGFG","Qty":"=((Length/1200)+1)*Qty","Use":"Stitching","Colour":"Plain","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"RCFILL3","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Use":"Profile Foam","Length":"800"},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*4)+8)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT50_WCB","Qty":"=Qty*4","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT65MR","Qty":"=5*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT45MR","Qty":"=(Area.NumInternalPurlins*4)*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT20MN","Qty":"=5*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL3","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"},"Length":"800"},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*4)+5)*Qty","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT35_WCB","Qty":"=5*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GQ",
            Desc: "Quad Gutter Hi-Front 115 .42mm **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 9530|2 x 6530",
            Length: "9530",
            CodeBase: "GQ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "QGHF115**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"QIGPB","Qty":"=(Length/900)+1","Use":"Gutter Clip","Conditions":{"POP":"=LSB"}},{"Code":"QS15","Qty":"=(Length/900)+1","Use":"Gutter Clip","Conditions":{"POP":"=EMU"}},{"Code":"QS15","Qty":"=(Length/900)+1","Use":"Gutter Clip","Conditions":{"POP":"=NUN"}},{"Code":"FLRQ","Use":"Nord Flashing","Colour":"Area.GutterColour","Conditions":{"Area.DesignType":"=Flat Roof","Area.RoofSheet":"=*Flatdek*"}}]}',
            PromptCodes: "MAX_LM=8700 CutExtra=150 ExtraLM=100",
            Image_b64: null,
            PromptTextCodes: "MAX_LM=8700 CutExtra=150 ExtraLM=100",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "QEC",
            Desc: "Gutter Quad Profile No1 (High Front) - External Corner",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "4",
            Length: "",
            CodeBase: "QEC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "QGHF115CEC**90",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Qty":"12","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "GQ",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL10075Z",
            Desc: "Downpipe Outlet 100 x 75 Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "OL10075Z",
            CodeAppend: "",
            DescAppend: " <REDIRECTED NUN FROM OL10075>",
            "CL ID": "0",
            Fielders_Code: "DPP10075ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR64M","Qty":"6","Colour":"Plain"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100751800",
            Desc: "Downpipe .40mm 100x75 Steel ** 1800mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 1800",
            Length: "1800",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=1800",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100752400",
            Desc: "Downpipe .40mm 100x75 Steel ** 2400mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 2400",
            Length: "2400",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=2400",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CRIDGE",
            Desc: "Contemporary Ridge Cap",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "4 x 4809|1 x 3300",
            Length: "4809",
            CodeBase: "CRIDGE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LLFL08**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Length/600)+1)*2","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=((Length/400)+1)*2","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS100L",
            Desc: "Firmlok 100x1.1mm Hi Gloss **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 2545 (Collar Tie)",
            Length: "2545",
            CodeBase: "BS100L",
            CodeAppend: "",
            DescAppend: " <REDIRECTED NUN FROM BS100>",
            "CL ID": "",
            Fielders_Code: "FL10011H**NS",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 4275 (Hip Rafter)|2 x 4275 (Hip Rafter)",
            Length: "4275",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 2990 (Purlin HL3)|2 x 1441 (Purlin HL3 LH)",
            Length: "2990",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 1441 (Purlin HL3 RH)|2 x 2979 (Purlin HW3)",
            Length: "1441",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 2990 (Ridge Purlin)",
            Length: "2990",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: " <REDIRECTED NUN FROM BS150>",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS200L",
            Desc: "Firmlok 200x2.0mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 5790 (Attachment Beam (Left))|1 x 5790 (Attachment Beam (Right))",
            Length: "5790",
            CodeBase: "BS200L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL20020H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS200L",
            Desc: "Firmlok 200x2.0mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 4340 (Perimeter Beam (Back))|2 x 4340 (Perimeter Beam (Front))",
            Length: "4340",
            CodeBase: "BS200L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL20020H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS200L",
            Desc: "Firmlok 200x2.0mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 3293 (Gable Rafter (No Post w Collar Tie))|2 x 3293 (Gable Rafter (No Post w Collar Tie))",
            Length: "3293",
            CodeBase: "BS200L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL20020H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS100T34000",
            Desc: "Post Steel 100x100x3mm ** 4000mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "6 x 3750 (Post in Ground (Freespan) (Beam to Side))",
            Length: "3750",
            CodeBase: "PS100T3",
            CodeAppend: "",
            DescAppend: " (finish 3750mm)",
            "CL ID": "",
            Fielders_Code: "PS1003H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT150M","Qty":"2","Colour":"Plain","Conditions":{"Use":"!=*Slab*"}},{"Code":"FBH160NYG","Qty":"2","Use":"Post Behind Fix","Conditions":{"Use":"=*Behind Beam*"}},{"Code":"FBH11010NYG","Qty":"1","Use":"Post Beam Side Fix","Conditions":{"Use":"=*Beam to Side*"}}]}',
            PromptCodes: "Length=4000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(181033)|4000(181034)|5000(181035)|6000(181036) SL_NUN=3000(181033)|4000(181034) SL_GIL=4000(181034) SL_WAN=4000(181034) SL_EMU=4000(181034)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HRU15R",
            Desc: "Hip Rafter Single Purlin Connector Right FL150 H**",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Purlin HL3 LH)",
            Length: "",
            CodeBase: "HRU15R",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHRU15RH**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HRU15L",
            Desc: "Hip Rafter Single Purlin Connector Left FL150 H**",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Purlin HL3 RH)",
            Length: "",
            CodeBase: "HRU15L",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHRU15LH**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"8","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HRU15",
            Desc: 'Hip Rafter "U" Connector FL150 H**',
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Purlin HW3)|2 (For Purlin HW3)",
            Length: "",
            CodeBase: "HRU15",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHRU15H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"18","Colour":"Area.BeamColour","Use":"Tek"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "6 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS100T3",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "CTC10",
            Desc: "Collar Tie Connector FL100 H**",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "4 (For Collar Tie)",
            Length: "",
            CodeBase: "CTC10",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHICTC10H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"14","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS100",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB150",
            Desc: "Connector Beam FL150 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "4 (For Purlin HL3)|2 (For Purlin HL3 LH)|2 (For Purlin HL3 RH)|4 (For Ridge Purlin)",
            Length: "",
            CodeBase: "FLUB150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB15050H**05",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Use":"Teks","Colour":"Area.BeamColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB200",
            Desc: "Connector Beam FL200 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Attachment Beam (Left) Fixed to 100mm Post)|2 (For Attachment Beam (Right) Fixed to 100mm Post)|4 (For Perimeter Beam (Back) Fixed to 100mm Post)|4 (For Perimeter Beam (Front) Fixed to 100mm Post)",
            Length: "",
            CodeBase: "FLUB200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB20050H**05",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "H150C",
            Desc: "Hip to Corner Connector FL150 H**",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "4 (For Hip Rafter)",
            Length: "",
            CodeBase: "H150C",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "2",
            Fielders_Code: "LHIH150CH**",
            "CL DATA": {
                0: {
                    BracketType: "BK10",
                    Angle1: "45.00",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"12","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK10",
                    Angle1: "45.00",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HRU15(TO BEAM)-S",
            Desc: 'Hip Rafter "U" Connector FL150 H**',
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Hip Rafter)",
            Length: "",
            CodeBase: "HRU15",
            CodeAppend: "(TO BEAM)-S.15050.16DEG DOWN .45DEG LH",
            DescAppend: "150x50 16 Degrees Down 45 Degrees Left Hand",
            "CL ID": "3",
            Fielders_Code: "LHIHRU15H**",
            "CL DATA": {
                0: {
                    BracketType: "BK57",
                    Angle1: "-45.00",
                    Angle2: "16.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"18","Colour":"Area.BeamColour","Use":"Tek"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK57",
                    Angle1: "-45.00",
                    Angle2: "16.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HRU15(TO BEAM)-S",
            Desc: 'Hip Rafter "U" Connector FL150 H**',
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Hip Rafter)",
            Length: "",
            CodeBase: "HRU15",
            CodeAppend: "(TO BEAM)-S.15050.16DEG DOWN .45DEG RH",
            DescAppend: "150x50 16 Degrees Down 45 Degrees Right Hand",
            "CL ID": "4",
            Fielders_Code: "LHIHRU15H**",
            "CL DATA": {
                0: {
                    BracketType: "BK57",
                    Angle1: "45.00",
                    Angle2: "16.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"18","Colour":"Area.BeamColour","Use":"Tek"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK57",
                    Angle1: "45.00",
                    Angle2: "16.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "RRC20P-S",
            Desc: "Rafter To Rail Connector For FL200 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "4 (For Gable Rafter (No Post w Collar Tie))",
            Length: "",
            CodeBase: "RRC20P",
            CodeAppend: "-S.23DEG UP",
            DescAppend: "22.5 Degrees Up",
            "CL ID": "1",
            Fielders_Code: "LHIRRC20PH**",
            "CL DATA": {
                0: {
                    BracketType: "BK3",
                    Angle1: "-23.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH70NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"!=*Fixed*"}},{"Code":"FBH11010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*90*"}},{"Code":"FBH11010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*100*"}},{"Code":"FBH13010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*125*"}},{"Code":"FBH150NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*140*"}},{"Code":"FBH160NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*150*"}},{"Code":"FBH190NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*175*"}},{"Code":"FT32MS","Qty":"4","Use":"Teks","Colour":"Area.BeamColour"},{"Code":"FT20M","Qty":"6","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK3",
                    Angle1: "-23.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "APEX20Z",
            Desc: "Firmlok Apex Connector 200mm Zinc",
            Use: "",
            Colour: "Zinc",
            Area: "1",
            Qty: "2 (For Gable Rafter (No Post w Collar Tie))",
            Length: "",
            CodeBase: "APEX20Z",
            CodeAppend: "",
            DescAppend: "22.5 Degrees",
            "CL ID": "0",
            Fielders_Code: "FLAB200ZL225",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"24","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
    ],
    COFL00234: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "SSIP50",
            Desc: "Bondor Solarspan Plain 50mm Thick Insulated Panel ****",
            Use: "",
            Colour: "Manor Red/Classic Cream",
            Area: "1",
            Qty: "7 x 3848 (; Left to Right)|7 x 3848 (; Right to Left)",
            Length: "3848",
            CodeBase: "SSIP50",
            CodeAppend: "",
            DescAppend: "Cut back foam 60mm for Fascia Flashing",
            "CL ID": "0",
            Fielders_Code: "IRSS50****",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"SSTS14125","Use":"Roof Fix","Qty":"=(Qty*4)+5","Conditions":{"Brand":"=Fielders","Job.WindZone":"=NOT CYCLONIC"},"Colour":"Area.RoofSheetColour"},{"Code":"FT125_WCE","Qty":"=(Qty*4)+5","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC"},"Use":"Roof Fix"},{"Code":"SSTS14125","Qty":"=Qty*4","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Fielders","Use":"!=*B/C Fixed*","Job.WindZone":"=NOT CYCLONIC"},"Use":"Roof Fix"},{"Code":"FT125_WCE","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Use":"!=*B/C Fixed*","Job.WindZone":"=NOT CYCLONIC"},"Qty":"=Qty*4","Use":"Roof Fix"},{"Code":"RC8FILL","Colour":"Plain","Conditions":{"Brand":"=Lysaght","Use":"=*B/C Fixed*"},"Length":"1000"},{"Code":"SSTS14125","Qty":"=(Qty*8)+5","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Fielders","Job.WindZone":"=CYCLONIC"}},{"Code":"FT125_WCE","Qty":"=(Qty*8)+5","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC"}},{"Code":"SSTS14125","Qty":"=Qty*8","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Fielders","Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"}},{"Code":"FT125_WCE","Qty":"=Qty*8","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"}},{"Code":"RC8FILL","Length":"1000","Conditions":{"Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "MIN_LM=1800 ReverseColCode=1",
            Image_b64: null,
            PromptTextCodes: "MIN_LM=1800 ReverseColCode=1",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GS",
            Desc: "Sheerline Gutter .55mm",
            Use: "",
            Colour: "Pale Eucalypt",
            Area: "1",
            Qty: "1 x 6020",
            Length: "6020",
            CodeBase: "GS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SG55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=(Length/900)+1","Colour":"Area.RoofSheetColour"},{"Code":"STRAP20","Qty":"=(Length/900)+1","Colour":"Plain"}]}',
            PromptCodes: "REDIRECT_NUN=GSV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=GSV",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL10075",
            Desc: "Pop 100 x 75 Zincalume/90mm Round",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "OL10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPUZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "REDIRECT_NUN=OL10075Z",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=OL10075Z",
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100752400",
            Desc: "Downpipe .40mm 100x75 Steel ** 2400mm",
            Use: "",
            Colour: "Pale Eucalypt",
            Area: "1",
            Qty: "1 x 2292",
            Length: "2292",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: " (finish 2292mm)",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=2400",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CRIDGE",
            Desc: "Contemporary Ridge Cap",
            Use: "",
            Colour: "Manor Red",
            Area: "1",
            Qty: "1 x 6320",
            Length: "6320",
            CodeBase: "CRIDGE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LLFL08**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Length/600)+1)*2","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=((Length/400)+1)*2","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "IP50FOFG",
            Desc: "Gable Insulated Panel Fascia Overhang Flashing to suit 50mm Panel **",
            Use: "",
            Colour: "Pale Eucalypt",
            Area: "1",
            Qty: "1 x 6020 (SolarSpan 50 (Non-trafficable) - CYCLONIC SPANS IP50FOFG Flashing)",
            Length: "6020",
            CodeBase: "IP50FOFG",
            CodeAppend: ".22DEG",
            DescAppend: "22 Degrees",
            "CL ID": "0",
            Fielders_Code: "IPGOF50**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"RI43100","Qty":"=((Length/600)*2)+4","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Fielders","Job.WindZone":"=NOT CYCLONIC"}},{"Code":"RI43100","Qty":"=((Length/450)*2)+4","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Fielders","Job.WindZone":"=CYCLONIC"}},{"Code":"FR72","Qty":"=((Length/600)*2)+4","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FR72","Qty":"=((Length/450)*2)+4","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "MAX_LM=6200 ExtraLM=200",
            Image_b64: null,
            PromptTextCodes: "MAX_LM=6200 ExtraLM=200",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "IP50SBF5R",
            Desc: "Insulated Panel Side Barge Flashing to suit 5 Rib 50mm Panel **",
            Use: "",
            Colour: "Manor Red",
            Area: "1",
            Qty: "4 x 3873 (SolarSpan 50 (Non-trafficable) - CYCLONIC SPANS Barge Capping)",
            Length: "3873",
            CodeBase: "IP50SBF5R",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "IP5RSBF50**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"TS1220100B8","Qty":"=(Length/600)+2","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Fielders","Job.WindZone":"=NOT CYCLONIC"}},{"Code":"RI43100","Qty":"=(Length/600)+2","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Fielders","Job.WindZone":"=NOT CYCLONIC"}},{"Code":"TS1220100B8","Qty":"=(Length/450)+2","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Fielders","Job.WindZone":"=CYCLONIC"}},{"Code":"RI43100","Qty":"=(Length/450)+2","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Fielders","Job.WindZone":"=CYCLONIC"}},{"Code":"FT20MN","Qty":"=(Length/600)+2","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FR72","Qty":"=(Length/600)+2","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=(Length/450)+2","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC"}},{"Code":"FR72","Qty":"=(Length/450)+2","Colour":"Area.FlashingColour","Conditions":{"Brand":"=Lysaght","Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "MAX_LM=6200 ExtraLM=200",
            Image_b64: null,
            PromptTextCodes: "MAX_LM=6200 ExtraLM=200",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "CON90",
            Desc: "Connector Post 90mm Aluminium",
            Use: "",
            Colour: "Galvanised",
            Area: "1",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "CON90",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHICON90",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"SA7510G","Qty":"2","Colour":"Plain"},{"Code":"FT20M","Qty":"4","Use":"Teks","Colour":"Area.PostColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90N150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS90N1503000",
            Desc: "Post Steel 90x90x2mm notched FL150 H** 3000mm",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 x 2650 (Post on Slab (Freespan) (Notched))",
            Length: "2650",
            CodeBase: "PS90N150",
            CodeAppend: "",
            DescAppend: "Notched (finish 2650mm)",
            "CL ID": "",
            Fielders_Code: "PSN90150H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"PBP90150","Use":"Notched Post Plate","Colour":"Area.PostColour","Qty":"1"},{"Code":"FT150M","Qty":"2","Conditions":{"Use":"!=*Slab*"},"Colour":"Plain"}]}',
            PromptCodes: "Length=3000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(209155)|4000(209157)|5000(209160)|6000(209162) SL_EMU=3000(209155)|4000(209157) SL_NUN=3000(209155)|4000(209157) REDIRECT_NUN=PS90N150V REDIRECT_GIL=PS90N200",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90N150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "CON100G",
            Desc: "Vertical Strut Apex Connector FL100 H**",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 (For Infill Strut)",
            Length: "",
            CodeBase: "CON100G",
            CodeAppend: "",
            DescAppend: " <swapped from BK36>",
            "CL ID": "0",
            Fielders_Code: "LHICON100GH**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"6","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS100",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB100",
            Desc: "Connector Beam FL100 **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 (For Infill Strut)",
            Length: "",
            CodeBase: "FLUB100",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB10050H**05",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS100",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB150",
            Desc: "Connector Beam FL150 **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "16 (For Purlin T1)|16 (For Ridge Purlin)",
            Length: "",
            CodeBase: "FLUB150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB15050H**05",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Use":"Teks","Colour":"Area.BeamColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "GRBC15",
            Desc: "Gable Rafter Beam Connector FL150 **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "4 (For Gable Rafter (Width Attached))",
            Length: "",
            CodeBase: "GRBC15",
            CodeAppend: ".22DEG",
            DescAppend: "22.5 Degrees",
            "CL ID": "0",
            Fielders_Code: "LHIGRBC15H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FWH22","Qty":"5","Colour":"Area.RafterColour"},{"Code":"FT20M","Qty":"5","Colour":"Area.RafterColour"},{"Code":"FT30M","Qty":"8","Colour":"Plain"},{"Code":"FBH160NYG","Qty":"1","Colour":"Plain","Conditions":{"Area.FasciaBeam":"=FL15015"}},{"Code":"FBH220NYG","Qty":"1","Colour":"Plain","Conditions":{"Area.FasciaBeam":"=FL20020"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HCC15",
            Desc: "Beam Corner Connector FL150 **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "2 (For Attachment Beam (Left))|2 (For Attachment Beam (Right))",
            Length: "",
            CodeBase: "HCC15",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHCC15H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"9","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "RRC15-S",
            Desc: "Beam Connector Rafter to Side Rail FL150 H**",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "4 (For Gable Rafter)|2 (For Gable Rafter Fixed to 90mm Post)",
            Length: "",
            CodeBase: "RRC15",
            CodeAppend: "-S.22DEG UP",
            DescAppend: "22 Degrees Up",
            "CL ID": "1",
            Fielders_Code: "LHIRRC15H**",
            "CL DATA": {
                0: {
                    BracketType: "BK3",
                    Angle1: "-22.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                1: {
                    BracketType: "BK3",
                    Angle1: "-22.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket `Width `Depth `Angle 1 `Angle 2 `Angle 3 `Colour ID `Num `BL ID `Length 1 `Length 2 `ftt `Bracket Name `Drawing Name `Material `Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"!=*Fixed*"}},{"Code":"FBH9010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*75*"}},{"Code":"FBH11010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*90*"}},{"Code":"FBH11010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*100*"}},{"Code":"FBH13010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*125*"}},{"Code":"FBH150NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*140*"}},{"Code":"FBH160NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*150*"}},{"Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*175*"},"Code":"FBH190NYG"},{"Code":"FT20M","Qty":"10","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK3",
                    Angle1: "-22.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
                1: {
                    BracketType: "BK3",
                    Angle1: "-22.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "UCF",
            Desc: 'Universal Connector Bracket "F" **',
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "7 (Fixed to Fascia (22.5 Degrees); Height 65mm; Step out 125mm)",
            Length: "",
            CodeBase: "UCF",
            CodeAppend: ".22DEG",
            DescAppend: "22 Degrees",
            "CL ID": "0",
            Fielders_Code: "LHIUCFH**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT75MR","Colour":"Area.BeamColour"},{"Code":"FT32MS","Colour":"Area.BeamColour"},{"Code":"UCEG","Colour":"Plain","Conditions":{"Use":"=*Fascia*"}},{"Code":"UCL","Colour":"Area.BeamColour","Conditions":{"Use":"=*Wall*"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "APEX15Z",
            Desc: "Firmlok Apex Connector 150mm Zinc",
            Use: "",
            Colour: "Zinc",
            Area: "1",
            Qty: "3 (For Gable Rafter)|2 (For Gable Rafter (Width Attached))",
            Length: "",
            CodeBase: "APEX15Z",
            CodeAppend: "",
            DescAppend: "22.5 Degrees",
            "CL ID": "0",
            Fielders_Code: "FLAB150ZL225",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"24","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS100",
            Desc: "Firmlok 100x1.1mm Hi Gloss **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 4000 (1640mm(Infill Strut)//1640mm(Infill Strut))",
            Length: "4000",
            CodeBase: "BS100",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "FL10011H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes:
                "SL=4000(100113)|5000(100113)|6100(100113)|9000(100113) SL_DUB=3000(100113)|4000(100113)|5000(100113)|6100(100113)|7500(100113)|9000(100113) SL_EMU=4000(100113)|5000(100113)|6100(100113)|7500(100113) SL_KEW=4000(100113)|5000(100113)|6100(100113)|7500(100113)|9000(100113) REDIRECT_GIL=BS100L REDIRECT_NUN=BS100L",
            Image_b64: null,
            PromptTextCodes:
                "SL=4000(100113)|5000(100113)|6100(100113)|9000(100113) SL_DUB=3000(100113)|4000(100113)|5000(100113)|6100(100113)|7500(100113)|9000(100113) SL_EMU=4000(100113)|5000(100113)|6100(100113)|7500(100113) SL_KEW=4000(100113)|5000(100113)|6100(100113)|7500(100113)|9000(100113) REDIRECT_GIL=BS100L REDIRECT_NUN=BS100L",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150",
            Desc: "Firmlok 150x1.5mm Hi Gloss H**",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 4000 (2665mm(Purlin T1))|1 x 4000 (3834mm(Gable Rafter))|1 x 4000 (3834mm(Gable Rafter))|1 x 4000 (3834mm(Gable Rafter))|1 x 4000 (3834mm(Gable Rafter))|1 x 4000 (3988mm(Gable Rafter (Width Attached)))|1 x 4000 (3988mm(Gable Rafter (Width Attached)))|1 x 4000 (3988mm(Gable Rafter (Width Attached)))|1 x 4000 (3988mm(Gable Rafter (Width Attached)))|1 x 7500 (6890mm(Attachment Beam (Left)))|1 x 7500 (3791mm(Gable Rafter)//2665mm(Ridge Purlin))|1 x 7500 (3791mm(Gable Rafter)//2665mm(Ridge Purlin))|1 x 9000 (70mm(Ridge Purlin)//70mm(Ridge Purlin)//70mm(Ridge Purlin)//70mm(Ridge Purlin)//70mm(Purlin T1)//70mm(Purlin T1)//70mm(Purlin T1)//70mm(Purlin T1)//6890mm(Attachment Beam (Right)))|1 x 9000 (5760mm(Perimeter Beam (Front))//2665mm(Ridge Purlin))|1 x 9000 (5760mm(Attachment Beam (Back))//2665mm(Ridge Purlin))|1 x 9000 (2665mm(Purlin T1)//2665mm(Purlin T1)//2665mm(Purlin T1))",
            Length: "4000",
            CodeBase: "BS150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "FL15015H**####",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Image_b64: null,
            PromptTextCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
            },
        },
        {
            Add: null,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GSSEP",
            Desc: "Sheerline Gutter Stop Ends ** (pair) ",
            Use: "",
            Colour: "Pale Eucalypt",
            Area: "",
            Qty: "1",
            Length: "",
            CodeBase: null,
            CodeAppend: null,
            DescAppend: " (1xGSSEL,1xGSSER)",
            "CL ID": null,
            Fielders_Code: "SGSEP**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": null,
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    VDPL00040: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS3",
            Desc: "Spandek 0.42BMT **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "8 x 5063 (B/C Fixed)",
            Length: "5063",
            CodeBase: "RS3",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SD42**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*4)+8)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT20MN","Qty":"=Qty*4","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FR64","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"},"Qty":"=((Length/2000)+1)*Qty","Use":"Stitching"},{"Code":"WGFG","Qty":"=((Length/2000)+1)*Qty","Colour":"Plain","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FR64","Qty":"=((Length/1200)+1)*Qty","Use":"Stitching","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"WGFG","Qty":"=((Length/1200)+1)*Qty","Use":"Stitching","Colour":"Plain","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"RCFILL3","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Use":"Profile Foam","Length":"800"},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*4)+8)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT50_WCB","Qty":"=Qty*4","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT65MR","Qty":"=5*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT45MR","Qty":"=(Area.NumInternalPurlins*4)*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT20MN","Qty":"=5*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL3","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"},"Length":"800"},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*4)+5)*Qty","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT35_WCB","Qty":"=5*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "RCRS3USH",
            Desc: "Spandek Receiver Channel 1.2 mm Shale Grey",
            Use: "",
            Colour: "Shale Grey",
            Area: "",
            Qty: "1 x 5000 (Back Channel)",
            Length: "5000",
            CodeBase: "RCRS3USH",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SDRCU12SH####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR64","Qty":"50"},{"Code":"RCFOAM2","Qty":"=Length/6100","Colour":"Plain"},{"Code":"SA7510G","Qty":"=(Length/600)+1","Use":"Brick Wall","Conditions":{"Use":"=*Brick*"}},{"Code":"CS7510G","Qty":"=(Length/600)+1","Use":"Timber Wall","Conditions":{"Use":"=*Timber Frame*"}}]}',
            PromptCodes:
                "SL_LSB=4500(50165)|6100(50165) SL_EMU=4500(50165)|5500(50165)|6100(50165) REDIRECT_GIL=BC3075",
            Image_b64: null,
            PromptTextCodes:
                "SL_LSB=4500(50165)|6100(50165) SL_EMU=4500(50165)|5500(50165)|6100(50165) REDIRECT_GIL=BC3075",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GSV",
            Desc: "Sheerline Gutter .42mm **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 5000",
            Length: "5000",
            CodeBase: "GSV",
            CodeAppend: "",
            DescAppend: " <REDIRECTED NUN FROM GS>",
            "CL ID": "0",
            Fielders_Code: "SG42**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=(Length/900)+1","Colour":"Area.RoofSheetColour"},{"Code":"STRAP20","Qty":"=(Length/900)+1","Colour":"Plain"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GSSEL",
            Desc: "Sheerline Gutter Stop End **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "GSSEL",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SGSEFA**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "PAIR_EMU=GSSEP",
            Image_b64: null,
            PromptTextCodes: "PAIR_EMU=GSSEP",
            Children: null,
            "Parent Item": "GS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GSSER",
            Desc: "Sheerline Gutter Stop Ends **  ",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "GSSER",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SGSEFAP**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "PAIR_EMU=GSSEP",
            Image_b64: null,
            PromptTextCodes: "PAIR_EMU=GSSEP",
            Children: null,
            "Parent Item": "GS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL10075Z",
            Desc: "Downpipe Outlet 100 x 75 Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "OL10075Z",
            CodeAppend: "",
            DescAppend: " <REDIRECTED NUN FROM OL10075>",
            "CL ID": "0",
            Fielders_Code: "DPP10075ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR64M","Qty":"6","Colour":"Plain"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100752400",
            Desc: "Downpipe .40mm 100x75 Steel ** 2400mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 2051",
            Length: "2051",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: " (finish 2051mm)",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=2400",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "LBARGESD",
            Desc: "L Barge Spandek **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 5003 (SPANDEK 0.42 (No Foot Traffic) Barge Capping)",
            Length: "5003",
            CodeBase: "LBARGESD",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LLFL63**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=(Length/600)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=(Length/400)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "ExtraLM=165",
            Image_b64: null,
            PromptTextCodes: "ExtraLM=165",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 5000 (Fascia Beam)|1 x 4887 (Left Rafter)",
            Length: "5000",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 4890 (Purlin)|1 x 4887 (Right Rafter)",
            Length: "4890",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 5000 (Wall Beam Fixed to Blank)",
            Length: "5000",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: " <REDIRECTED NUN FROM BS150>",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS90N150V3000",
            Desc: "Post Steel 90x90x2mm ** (notch for FL150 on-site) 3000mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 2901 (Post in Ground (Notched))",
            Length: "2901",
            CodeBase: "PS90N150V",
            CodeAppend: "",
            DescAppend: "Notched <REDIRECTED NUN FROM PS90N150> (finish 2901mm)",
            "CL ID": "",
            Fielders_Code: "PSN90150H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"PBP90150","Use":"Notched Post Plate","Colour":"Area.PostColour","Qty":"1"},{"Code":"FT150M","Qty":"2","Conditions":{"Use":"!=*Slab*"},"Colour":"Plain"}]}',
            PromptCodes: "Length=3000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(209155)|4000(209157)|5000(209160)|6000(209162) SL_EMU=3000(209155)|4000(209157) SL_NUN=3000(209155)|4000(209157)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90N150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB150",
            Desc: "Connector Beam FL150 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Purlin)",
            Length: "",
            CodeBase: "FLUB150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB15050H**05",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Use":"Teks","Colour":"Area.BeamColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HCC15",
            Desc: "Beam Corner Connector FL150 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Fascia Beam)|2 (For Wall Beam Fixed to Blank)",
            Length: "",
            CodeBase: "HCC15",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHCC15H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"9","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
    ],
    VDPL00060: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS3",
            Desc: "Spandek 0.42BMT **",
            Use: "",
            Colour: "Basalt",
            Area: "1",
            Qty: "18 x 1656|10 x 3285",
            Length: "1656",
            CodeBase: "RS3",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SD42**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*4)+8)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT20MN","Qty":"=Qty*4","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FR64","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"},"Qty":"=((Length/2000)+1)*Qty","Use":"Stitching"},{"Code":"WGFG","Qty":"=((Length/2000)+1)*Qty","Colour":"Plain","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FR64","Qty":"=((Length/1200)+1)*Qty","Use":"Stitching","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"WGFG","Qty":"=((Length/1200)+1)*Qty","Use":"Stitching","Colour":"Plain","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"RCFILL3","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Use":"Profile Foam","Length":"800"},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*4)+8)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Flat Roof"}},{"Code":"FT50_WCB","Qty":"=Qty*4","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT65MR","Qty":"=5*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT45MR","Qty":"=(Area.NumInternalPurlins*4)*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT20MN","Qty":"=5*Qty","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL3","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"},"Length":"800"},{"Code":"FT50_WCB","Qty":"=((Area.NumInternalPurlins*4)+5)*Qty","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"FT35_WCB","Qty":"=5*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GQ",
            Desc: "Quad Gutter Hi-Front 115 .42mm **",
            Use: "",
            Colour: "Basalt",
            Area: "1",
            Qty: "4 x 6530",
            Length: "6530",
            CodeBase: "GQ",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "QGHF115**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"QIGPB","Qty":"=(Length/900)+1","Use":"Gutter Clip","Conditions":{"POP":"=LSB"}},{"Code":"QS15","Qty":"=(Length/900)+1","Use":"Gutter Clip","Conditions":{"POP":"=EMU"}},{"Code":"QS15","Qty":"=(Length/900)+1","Use":"Gutter Clip","Conditions":{"POP":"=NUN"}},{"Code":"FLRQ","Use":"Nord Flashing","Colour":"Area.GutterColour","Conditions":{"Area.DesignType":"=Flat Roof","Area.RoofSheet":"=*Flatdek*"}}]}',
            PromptCodes: "MAX_LM=8700 CutExtra=150 ExtraLM=100",
            Image_b64: null,
            PromptTextCodes: "MAX_LM=8700 CutExtra=150 ExtraLM=100",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "QEC",
            Desc: "Gutter Quad Profile No1 (High Front) - External Corner",
            Use: "",
            Colour: "Basalt",
            Area: "1",
            Qty: "4",
            Length: "",
            CodeBase: "QEC",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "QGHF115CEC**90",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Qty":"12","Colour":"Area.GutterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "GQ",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DP90",
            Desc: "PVC Stormwater Pipe 90mm DIA 3LM",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "2 x 2600",
            Length: "2600",
            CodeBase: "DP90",
            CodeAppend: "",
            DescAppend: " (finish 2600mm)",
            "CL ID": "0",
            Fielders_Code: "PVCSP90WH3000",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP90S","Qty":"2"},{"Code":"FR72","Qty":"4","Colour":"Surfmist"},{"Code":"EL9090Q","Qty":"2"}]}',
            PromptCodes: "Length=3000",
            Image_b64: null,
            PromptTextCodes: "Length=3000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL90Z",
            Desc: "Downpipe Outlet Round 90mm Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "OL90Z",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPR90ZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DP90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "RA751",
            Desc: "Dutch Flashing 1",
            Use: "",
            Colour: "Basalt",
            Area: "1",
            Qty: "2 x 3150 (Dutch Gable Flashing A)",
            Length: "3150",
            CodeBase: "RA751",
            CodeAppend: "",
            DescAppend: " <swapped from CFL04>",
            "CL ID": "0",
            Fielders_Code: "LLFL26**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FWH22","Qty":"=(Length/250)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FR64","Qty":"=(Length/250)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FWH22","Qty":"=(Length/150)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"FR64","Qty":"=(Length/150)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "RA752",
            Desc: "Dutch Flashing 2",
            Use: "",
            Colour: "Basalt",
            Area: "1",
            Qty: "2 x 3150 (Dutch Gable Flashing B)",
            Length: "3150",
            CodeBase: "RA752",
            CodeAppend: "",
            DescAppend: " <swapped from CFL05>",
            "CL ID": "0",
            Fielders_Code: "LLFL27**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FWH22","Qty":"=(Length/250)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FR64","Qty":"=(Length/250)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FWH22","Qty":"=(Length/150)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"FR64","Qty":"=(Length/150)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CRIDGE",
            Desc: "Contemporary Ridge Cap",
            Use: "",
            Colour: "Basalt",
            Area: "1",
            Qty: "1 x 3360|4 x 2555",
            Length: "3360",
            CodeBase: "CRIDGE",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LLFL08**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Length/600)+1)*2","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=((Length/400)+1)*2","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "LBARGESD",
            Desc: "L Barge Spandek **",
            Use: "",
            Colour: "Basalt",
            Area: "1",
            Qty: "4 x 1654 (SPANDEK 0.42 (No Foot Traffic) Barge Capping)",
            Length: "1654",
            CodeBase: "LBARGESD",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LLFL63**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=(Length/600)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=(Length/400)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "ExtraLM=165",
            Image_b64: null,
            PromptTextCodes: "ExtraLM=165",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS100L",
            Desc: "Firmlok 100x1.1mm Hi Gloss **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "2 x 2806 (Collar Tie)",
            Length: "2806",
            CodeBase: "BS100L",
            CodeAppend: "",
            DescAppend: " <REDIRECTED NUN FROM BS100>",
            "CL ID": "",
            Fielders_Code: "FL10011H**NS",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "2 x 2090 (Hip Rafter)|2 x 2090 (Hip Rafter)",
            Length: "2090",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "2 x 3293 (Gable Rafter (No Post w Collar Tie))|2 x 3293 (Gable Rafter (No Post w Collar Tie))",
            Length: "3293",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "2 x 2940 (Purlin T3)|2 x 21 (Purlin T3 LH)",
            Length: "2940",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150L",
            Desc: "Firmlok 150x1.5mm Hi Gloss ***",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "2 x 21 (Purlin T3 RH)|2 x 2940 (Ridge Purlin)",
            Length: "21",
            CodeBase: "BS150L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL15015H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS200L",
            Desc: "Firmlok 200x2.0mm Hi Gloss ***",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 x 5810 (Attachment Beam (Left))|1 x 5810 (Attachment Beam (Right))",
            Length: "5810",
            CodeBase: "BS200L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL20020H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS200L",
            Desc: "Firmlok 200x2.0mm Hi Gloss ***",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 x 5810 (Perimeter Beam (Back))|1 x 5810 (Perimeter Beam (Front))",
            Length: "5810",
            CodeBase: "BS200L",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "FL20020H**NS",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS904000",
            Desc: "Post Steel 90x90x2mm ** 4000mm",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "4 x 3450 (Post in Ground (Freespan) (Beam to Side))",
            Length: "3450",
            CodeBase: "PS90",
            CodeAppend: "",
            DescAppend: " (finish 3450mm)",
            "CL ID": "",
            Fielders_Code: "CPPN90H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT150M","Qty":"2","Conditions":{"Use":"!=*Slab*"},"Colour":"Plain"},{"Code":"FBH150NYG","Qty":"2","Use":"Post Behind Fix","Conditions":{"Use":"=*Behind Beam*"}},{"Code":"FBH11010NYG","Qty":"1","Use":"Post Beam Side Fix","Conditions":{"Use":"=*Beam to Side*"}}]}',
            PromptCodes: "Length=4000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(19989)|4000(24025) SL_EMU=2400(19988)|3000(19989)|4000(24025) SL_NUN=3000(19989)|4000(24025) SL_GIL=3000(19989)|4000(24025)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "DHRCR15",
            Desc: "Dutch/Hip Rafter Connector Right FL150 Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "2 (For Hip Rafter)",
            Length: "",
            CodeBase: "DHRCR15",
            CodeAppend: "",
            DescAppend: "Left Hand",
            "CL ID": "0",
            Fielders_Code: "LHIDHRCR15",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20MP","Qty":"8","Use":"Teks","Colour":"Plain"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "DHRCL15",
            Desc: "Dutch/Hip Rafter Connector Left FL150 Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "2 (For Hip Rafter)",
            Length: "",
            CodeBase: "DHRCL15",
            CodeAppend: "",
            DescAppend: "Right Hand",
            "CL ID": "0",
            Fielders_Code: "LHIDHRCL15",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20MP","Qty":"8","Use":"Teks","Colour":"Plain"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HRU15R",
            Desc: "Hip Rafter Single Purlin Connector Right FL150 H**",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "2 (For Purlin T3 LH)",
            Length: "",
            CodeBase: "HRU15R",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHRU15RH**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HRU15L",
            Desc: "Hip Rafter Single Purlin Connector Left FL150 H**",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "2 (For Purlin T3 RH)",
            Length: "",
            CodeBase: "HRU15L",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHRU15LH**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"8","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "CTC10",
            Desc: "Collar Tie Connector FL100 H**",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "4 (For Collar Tie)",
            Length: "",
            CodeBase: "CTC10",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHICTC10H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"14","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS100",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB150",
            Desc: "Connector Beam FL150 **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "4 (For Purlin T3)|2 (For Purlin T3 LH)|2 (For Purlin T3 RH)|4 (For Ridge Purlin)",
            Length: "",
            CodeBase: "FLUB150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB15050H**05",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Use":"Teks","Colour":"Area.BeamColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB200",
            Desc: "Connector Beam FL200 **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "2 (For Attachment Beam (Left) Fixed to 90mm Post)|2 (For Attachment Beam (Right) Fixed to 90mm Post)|2 (For Perimeter Beam (Back) Fixed to 90mm Post)|2 (For Perimeter Beam (Front) Fixed to 90mm Post)",
            Length: "",
            CodeBase: "FLUB200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB20050H**05",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
                3: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "H150C",
            Desc: "Hip to Corner Connector FL150 H**",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "4 (For Hip Rafter)",
            Length: "",
            CodeBase: "H150C",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "2",
            Fielders_Code: "LHIH150CH**",
            "CL DATA": {
                0: {
                    BracketType: "BK10",
                    Angle1: "45.00",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"12","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK10",
                    Angle1: "45.00",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "RRC15-S",
            Desc: "Beam Connector Rafter to Side Rail FL150 H**",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "4 (For Gable Rafter (No Post w Collar Tie))",
            Length: "",
            CodeBase: "RRC15",
            CodeAppend: "-S.23DEG UP",
            DescAppend: "22.5 Degrees Up",
            "CL ID": "1",
            Fielders_Code: "LHIRRC15H**",
            "CL DATA": {
                0: {
                    BracketType: "BK3",
                    Angle1: "-23.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"!=*Fixed*"}},{"Code":"FBH9010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*75*"}},{"Code":"FBH11010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*90*"}},{"Code":"FBH11010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*100*"}},{"Code":"FBH13010NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*125*"}},{"Code":"FBH150NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*140*"}},{"Code":"FBH160NYG","Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*150*"}},{"Use":"Hexhead Bolt","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*175*"},"Code":"FBH190NYG"},{"Code":"FT20M","Qty":"10","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK3",
                    Angle1: "-23.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "CONNECTORS",
            Code: "APEX15Z",
            Desc: "Firmlok Apex Connector 150mm Zinc",
            Use: "",
            Colour: "Zinc",
            Area: "1",
            Qty: "2 (For Gable Rafter (No Post w Collar Tie))",
            Length: "",
            CodeBase: "APEX15Z",
            CodeAppend: "",
            DescAppend: "22.5 Degrees",
            "CL ID": "0",
            Fielders_Code: "FLAB150ZL225",
            "CL DATA": {},
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"24","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {},
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "WG",
            Desc: "Washer Grommet for Polycarbonate 22OD",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "4 (For Post)",
            Length: "",
            CodeBase: "WG",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "LHIWGPC220D",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "MISC",
            Code: "ASSC12",
            Desc: "Acrylic Sheet 3mm Clear 1220x2440",
            Use: "",
            Colour: "Clear",
            Area: "1",
            Qty: "2 (Infill-Acrylic Flat LLD)",
            Length: "",
            CodeBase: "ASSC12",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "ACS12202440",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=20*Qty","Colour":"Area.BeamColour","Use":"Infill Fix"},{"Code":"PJ40","Qty":"1","Colour":"Plain"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    CANL00034: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS5",
            Desc: "Flatdek 0.42BMT **H**",
            Use: "",
            Colour: "Monument/Thredbo White",
            Area: "1",
            Qty: "40 x 6064",
            Length: "6064",
            CodeBase: "RS5",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FD42**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*2)+3)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=Qty*2","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT35_WCB","Qty":"=((Area.NumInternalPurlins*3)+3)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"FT35_WCB","Qty":"=Qty*3","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"}},{"Code":"FT45MR","Qty":"=Qty*2","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GS",
            Desc: "Sheerline Gutter .55mm",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 10000",
            Length: "10000",
            CodeBase: "GS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SG55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=(Length/900)+1","Colour":"Area.RoofSheetColour"},{"Code":"STRAP20","Qty":"=(Length/900)+1","Colour":"Plain"}]}',
            PromptCodes: "REDIRECT_NUN=GSV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=GSV",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DP80",
            Desc: "Downpipe Round 80mm PVC 3LM Lengths",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 2195",
            Length: "2195",
            CodeBase: "DP80",
            CodeAppend: "",
            DescAppend: " (finish 2195mm)",
            "CL ID": "0",
            Fielders_Code: "HIDPR80PVC**30",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"DP80SQ","Qty":"2"},{"Code":"FR72","Qty":"4"},{"Code":"EL8090","Qty":"2"}]}',
            PromptCodes: "Length=3000",
            Image_b64: null,
            PromptTextCodes: "Length=3000",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL80",
            Desc: "Downpipe Outlet 80mm Dia PVC **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "OL80",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "HIDPSP80PVC**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DP80",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "LBARGEFD",
            Desc: "L Barge Flatdek **",
            Use: "",
            Colour: "Monument",
            Area: "1",
            Qty: "1 x 10000 (FLATDEK (Non-Trafficable) Barge Capping)|2 x 6004 (FLATDEK (Non-Trafficable) Barge Capping)",
            Length: "10000",
            CodeBase: "LBARGEFD",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LLFL59**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=(Length/600)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=(Length/400)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "ExtraLM=165",
            Image_b64: null,
            PromptTextCodes: "ExtraLM=165",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS904000",
            Desc: "Post Steel 90x90x2mm ** 4000mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "3 x 3255 (Post in Ground (Behind Beam))|3 x 3045 (Post in Ground (Behind Beam))",
            Length: "3255",
            CodeBase: "PS90",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "CPPN90H**####",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT150M","Qty":"2","Conditions":{"Use":"!=*Slab*"},"Colour":"Plain"},{"Code":"FBH150NYG","Qty":"2","Use":"Post Behind Fix","Conditions":{"Use":"=*Behind Beam*"}},{"Code":"FBH11010NYG","Qty":"1","Use":"Post Beam Side Fix","Conditions":{"Use":"=*Beam to Side*"}}]}',
            PromptCodes: "Length=4000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(19989)|4000(24025) SL_EMU=2400(19988)|3000(19989)|4000(24025) SL_NUN=3000(19989)|4000(24025) SL_GIL=3000(19989)|4000(24025)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "6 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB150",
            Desc: "Connector Beam FL150 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "4 (For Left Purlin)|4 (For Purlin)|4 (For Right Purlin)",
            Length: "",
            CodeBase: "FLUB150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB15050H**05",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Use":"Teks","Colour":"Area.BeamColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB200",
            Desc: "Connector Beam FL200 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "4 (For Rafter)",
            Length: "",
            CodeBase: "FLUB200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB20050H**05",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HCC20",
            Desc: "Beam Corner Connector FL200 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Back Fascia Beam)|2 (For Fascia Beam)",
            Length: "",
            CodeBase: "HCC20",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHCC20H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "IBJ200",
            Desc: "Firmlok 200 Internal Beam Joiner Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1 (For Back Fascia Beam)|1 (For Fascia Beam)",
            Length: "",
            CodeBase: "IBJ200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIIBJ200",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"FWH22","Qty":"22","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200Z","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FT20MP","Qty":"10","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FWH22P","Qty":"22","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150",
            Desc: "Firmlok 150x1.5mm Hi Gloss H**",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 7500 (3257mm(Right Purlin)//3257mm(Right Purlin))|1 x 7500 (3257mm(Purlin)//3257mm(Purlin))|1 x 7500 (3257mm(Left Purlin)//3257mm(Left Purlin))",
            Length: "7500",
            CodeBase: "BS150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "FL15015H**####",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Image_b64: null,
            PromptTextCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS200",
            Desc: "Firmlok 200x2.0mm Hi Gloss ***",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 5000 (4850mm(Back Fascia Beam))|1 x 5000 (4850mm(Fascia Beam))|1 x 6100 (5886mm(Right Rafter))|1 x 6100 (5886mm(Left Rafter))|1 x 6100 (5886mm(Rafter))|1 x 6100 (5886mm(Rafter))|1 x 6100 (5150mm(Fascia Beam))|1 x 6100 (5150mm(Back Fascia Beam))",
            Length: "5000",
            CodeBase: "BS200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "FL20020H**####",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes:
                "SL=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_DUB=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_EMU=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_KEW=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) REDIRECT_GIL=BS200L REDIRECT_NUN=BS200L",
            Image_b64: null,
            PromptTextCodes:
                "SL=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_DUB=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_EMU=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_KEW=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) REDIRECT_GIL=BS200L REDIRECT_NUN=BS200L",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
            },
        },
        {
            Add: null,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GSSEP",
            Desc: "Sheerline Gutter Stop Ends ** (pair) ",
            Use: "",
            Colour: "Monument",
            Area: "",
            Qty: "1",
            Length: "",
            CodeBase: null,
            CodeAppend: null,
            DescAppend: " (1xGSSEL,1xGSSER)",
            "CL ID": null,
            Fielders_Code: "SGSEP**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": null,
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    COFL00162: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS5",
            Desc: "Flatdek 0.42BMT **H**",
            Use: "",
            Colour: "Classic Cream/Classic Cream",
            Area: "1",
            Qty: "24 x 3062 (B/C Fixed)",
            Length: "3062",
            CodeBase: "RS5",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FD42**H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*2)+3)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=Qty*2","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT35_WCB","Qty":"=((Area.NumInternalPurlins*3)+3)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"FT35_WCB","Qty":"=Qty*3","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"}},{"Code":"FT45MR","Qty":"=Qty*2","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GS",
            Desc: "Sheerline Gutter .55mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 6000",
            Length: "6000",
            CodeBase: "GS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SG55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=(Length/900)+1","Colour":"Area.RoofSheetColour"},{"Code":"STRAP20","Qty":"=(Length/900)+1","Colour":"Plain"}]}',
            PromptCodes: "REDIRECT_NUN=GSV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=GSV",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL10075",
            Desc: "Pop 100 x 75 Zincalume/90mm Round",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "OL10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPUZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "REDIRECT_NUN=OL10075Z",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=OL10075Z",
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100752400",
            Desc: "Downpipe .40mm 100x75 Steel ** 2400mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 2000",
            Length: "2000",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: " (finish 2000mm)",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=2400",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "LBARGEFD",
            Desc: "L Barge Flatdek **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 3002 (FLATDEK (No Foot Traffic) Barge Capping)",
            Length: "3002",
            CodeBase: "LBARGEFD",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LLFL59**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=(Length/600)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=(Length/400)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "ExtraLM=165",
            Image_b64: null,
            PromptTextCodes: "ExtraLM=165",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS75N1503000",
            Desc: "Post Steel 75x75x2mm notched for FL150 ** 3000mm",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 x 2850 (Post in Ground (Notched))",
            Length: "2850",
            CodeBase: "PS75N150",
            CodeAppend: "",
            DescAppend: "Notched (finish 2850mm)",
            "CL ID": "",
            Fielders_Code: "PSN75150H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT150M","Qty":"2","Conditions":{"Use":"!=*Slab*"},"Colour":"Plain"},{"Code":"PBP75150","Qty":"1","Colour":"Area.PostColour","Use":"Notched Post Plate"}]}',
            PromptCodes: "Length=3000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(207155)|4000(207157)|5000(207159)|6000(207161) SL_EMU=3000(207155)|4000(207157) SL_NUN=3000(207155)|4000(207157) REDIRECT_NUN=PS75N150V REDIRECT_GIL=PS75N200",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS75N150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "CON110",
            Desc: "Connector Aluminium Fascia 125x50x125",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "7 (Rafter Bracket)",
            Length: "",
            CodeBase: "CON110",
            CodeAppend: "",
            DescAppend: "(fixed to Timber Fascia)",
            "CL ID": "0",
            Fielders_Code: "LHICON110",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH5010NYG","Use":"Timber Fascia Fix","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*Timber*"}},{"Code":"FT50T","Qty":"3","Use":"Teks","Colour":"Plain"},{"Code":"FBH3010NYG","Qty":"1","Conditions":{"Use":"=*Steel*"},"Use":"Steel Fascia Fix"},{"Code":"FT45M","Qty":"1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB150L",
            Desc: "Connector Beam FL150 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 (For Left Rafter)|1 (For Right Rafter)",
            Length: "",
            CodeBase: "FLUB150L",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB15050H**05",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"},{"Code":"RCPL45Z","Qty":"1","Colour":"Plain"},{"Code":"STUD19B","Colour":"Plain","Qty":"1","Length":"1200"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HCC15",
            Desc: "Beam Corner Connector FL150 **",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "2 (For Fascia Beam)",
            Length: "",
            CodeBase: "HCC15",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHCC15H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"9","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "RCHANNEL",
            Desc: "Flatdek Receiver Channel **",
            Use: "",
            Colour: "Classic Cream",
            Area: "",
            Qty: "1 x 6100 (6000mm(Back Channel))",
            Length: "6100",
            CodeBase: "RCHANNEL",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FDRCH**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "SL_LSB=4500(50125)|6100(50125) SL_EMU=6100(50125) REDIRECT_GIL=BC5075 REDIRECT_NUN=BC5061",
            Image_b64: null,
            PromptTextCodes:
                "SL_LSB=4500(50125)|6100(50125) SL_EMU=6100(50125) REDIRECT_GIL=BC5075 REDIRECT_NUN=BC5061",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150",
            Desc: "Firmlok 150x1.5mm Hi Gloss H**",
            Use: "",
            Colour: "Classic Cream",
            Area: "1",
            Qty: "1 x 6100 (2936mm(Right Rafter)//2936mm(Left Rafter))|1 x 6100 (6000mm(Fascia Beam))",
            Length: "6100",
            CodeBase: "BS150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "FL15015H**####",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Image_b64: null,
            PromptTextCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: null,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GSSEP",
            Desc: "Sheerline Gutter Stop Ends ** (pair) ",
            Use: "",
            Colour: "Classic Cream",
            Area: "",
            Qty: "1",
            Length: "",
            CodeBase: null,
            CodeAppend: null,
            DescAppend: " (1xGSSEL,1xGSSER)",
            "CL ID": null,
            Fielders_Code: "SGSEP**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": null,
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
    COFL00008: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS5",
            Desc: "Flatdek 0.42BMT **H**",
            Use: "",
            Colour: "Manor Red/Classic Cream",
            Area: "1",
            Qty: "1 x 4480|1 x 4176|1 x 3871|1 x 3567|1 x 3263|1 x 2958|1 x 2654|1 x 2349|1 x 2045|1 x 1741|1 x 1436|27 x 4563 (A1-B/C Fixed)|1 x 4553 (A1-B/C Fixed)|1 x 4177 (A1-B/C Fixed)|1 x 3802 (A1-B/C Fixed)|1 x 3427 (A1-B/C Fixed)|1 x 3052 (A1-B/C Fixed)|1 x 2677 (A1-B/C Fixed)|1 x 2301 (A1-B/C Fixed)|1 x 1926 (A1-B/C Fixed)|1 x 1551 (A1-B/C Fixed)|1 x 1176 (A1-B/C Fixed)|2 x 1000 (A1-B/C Fixed)",
            Length: "4480",
            CodeBase: "RS5",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FD42**H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
                16: null,
                17: null,
                18: null,
                19: null,
                20: null,
                21: null,
                22: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*2)+3)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=Qty*2","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT35_WCB","Qty":"=((Area.NumInternalPurlins*3)+3)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"FT35_WCB","Qty":"=Qty*3","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"}},{"Code":"FT45MR","Qty":"=Qty*2","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
                16: null,
                17: null,
                18: null,
                19: null,
                20: null,
                21: null,
                22: null,
            },
        },
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS5",
            Desc: "Flatdek 0.42BMT **H**",
            Use: "",
            Colour: "Manor Red/Classic Cream",
            Area: "2",
            Qty: "1 x 1000|33 x 3062 (A2-B/C Fixed)|1 x 3055 (A2-B/C Fixed)|1 x 3035 (A2-B/C Fixed)|1 x 2888 (A2-B/C Fixed)|1 x 2868 (A2-B/C Fixed)|1 x 2722 (A2-B/C Fixed)|1 x 2702 (A2-B/C Fixed)|1 x 2555 (A2-B/C Fixed)|1 x 2535 (A2-B/C Fixed)|1 x 2388 (A2-B/C Fixed)|1 x 2368 (A2-B/C Fixed)|1 x 2221 (A2-B/C Fixed)|1 x 2201 (A2-B/C Fixed)|1 x 2054 (A2-B/C Fixed)|1 x 2034 (A2-B/C Fixed)|1 x 1888 (A2-B/C Fixed)|1 x 1868 (A2-B/C Fixed)|1 x 1721 (A2-B/C Fixed)|1 x 1701 (A2-B/C Fixed)|1 x 1554 (A2-B/C Fixed)|1 x 1534 (A2-B/C Fixed)|1 x 1387 (A2-B/C Fixed)|1 x 1367 (A2-B/C Fixed)|1 x 1221 (A2-B/C Fixed)|1 x 1201 (A2-B/C Fixed)|1 x 1054 (A2-B/C Fixed)|1 x 1034 (A2-B/C Fixed)|8 x 1000 (A2-B/C Fixed)",
            Length: "1000",
            CodeBase: "RS5",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FD42**H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
                16: null,
                17: null,
                18: null,
                19: null,
                20: null,
                21: null,
                22: null,
                23: null,
                24: null,
                25: null,
                26: null,
                27: null,
                28: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*2)+3)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=Qty*2","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT35_WCB","Qty":"=((Area.NumInternalPurlins*3)+3)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"FT35_WCB","Qty":"=Qty*3","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"}},{"Code":"FT45MR","Qty":"=Qty*2","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
                16: null,
                17: null,
                18: null,
                19: null,
                20: null,
                21: null,
                22: null,
                23: null,
                24: null,
                25: null,
                26: null,
                27: null,
                28: null,
            },
        },
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS5",
            Desc: "Flatdek 0.42BMT **H**",
            Use: "",
            Colour: "Manor Red/Classic Cream",
            Area: "3",
            Qty: "27 x 4563 (A3-B/C Fixed)|1 x 4523 (A3-B/C Fixed)|1 x 4328 (A3-B/C Fixed)|1 x 4147 (A3-B/C Fixed)|1 x 3952 (A3-B/C Fixed)|1 x 3772 (A3-B/C Fixed)|1 x 3577 (A3-B/C Fixed)|1 x 3397 (A3-B/C Fixed)|1 x 3202 (A3-B/C Fixed)|1 x 3022 (A3-B/C Fixed)|1 x 2827 (A3-B/C Fixed)|1 x 2646 (A3-B/C Fixed)|1 x 2451 (A3-B/C Fixed)|1 x 2271 (A3-B/C Fixed)|1 x 2076 (A3-B/C Fixed)|1 x 1896 (A3-B/C Fixed)|1 x 1701 (A3-B/C Fixed)|1 x 1521 (A3-B/C Fixed)|1 x 1326 (A3-B/C Fixed)|1 x 1146 (A3-B/C Fixed)|4 x 1000 (A3-B/C Fixed)",
            Length: "4563",
            CodeBase: "RS5",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FD42**H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
                16: null,
                17: null,
                18: null,
                19: null,
                20: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*2)+3)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=Qty*2","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT35_WCB","Qty":"=((Area.NumInternalPurlins*3)+3)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"FT35_WCB","Qty":"=Qty*3","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"}},{"Code":"FT45MR","Qty":"=Qty*2","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
                16: null,
                17: null,
                18: null,
                19: null,
                20: null,
            },
        },
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS5",
            Desc: "Flatdek 0.42BMT **H**",
            Use: "",
            Colour: "Manor Red/Classic Cream",
            Area: "4",
            Qty: "2 x 3062|1 x 2960|1 x 2794|1 x 2627|1 x 2460|1 x 2293|1 x 2127|1 x 1960|1 x 1793|1 x 1626|1 x 1460|1 x 1293|1 x 1126|6 x 1000|32 x 3062 (A4-B/C Fixed)|1 x 3035 (A4-B/C Fixed)|1 x 2868 (A4-B/C Fixed)|1 x 2702 (A4-B/C Fixed)|1 x 2535 (A4-B/C Fixed)|1 x 2368 (A4-B/C Fixed)|1 x 2201 (A4-B/C Fixed)|1 x 2034 (A4-B/C Fixed)|1 x 1868 (A4-B/C Fixed)|1 x 1701 (A4-B/C Fixed)|1 x 1534 (A4-B/C Fixed)|1 x 1367 (A4-B/C Fixed)|1 x 1201 (A4-B/C Fixed)|1 x 1034 (A4-B/C Fixed)|3 x 1000 (A4-B/C Fixed)",
            Length: "3062",
            CodeBase: "RS5",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FD42**H**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
                16: null,
                17: null,
                18: null,
                19: null,
                20: null,
                21: null,
                22: null,
                23: null,
                24: null,
                25: null,
                26: null,
                27: null,
                28: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*2)+3)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=Qty*2","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT35_WCB","Qty":"=((Area.NumInternalPurlins*3)+3)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"FT35_WCB","Qty":"=Qty*3","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"}},{"Code":"FT45MR","Qty":"=Qty*2","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
                12: null,
                13: null,
                14: null,
                15: null,
                16: null,
                17: null,
                18: null,
                19: null,
                20: null,
                21: null,
                22: null,
                23: null,
                24: null,
                25: null,
                26: null,
                27: null,
                28: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES (various finish lengths)",
            Code: "MSJ",
            Desc: "****** Product Not Found: <removed in production>",
            Use: "",
            Colour: "Surfmist",
            Area: "1",
            Qty: "1|1",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: ".141DEG",
            DescAppend: "(various finish lengths)",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "GS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "MSJ",
            Desc: "****** Product Not Found: <removed in production>",
            Use: "",
            Colour: "Surfmist",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: ".6DEG",
            DescAppend: "6 Degrees <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "GS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GS",
            Desc: "Sheerline Gutter .55mm",
            Use: "",
            Colour: "Surfmist",
            Area: "1",
            Qty: "1 x 12729|1 x 6388|1 x 1477",
            Length: "12729",
            CodeBase: "GS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SG55**",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=(Length/900)+1","Colour":"Area.RoofSheetColour"},{"Code":"STRAP20","Qty":"=(Length/900)+1","Colour":"Plain"}]}',
            PromptCodes: "REDIRECT_NUN=GSV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=GSV",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "EXG",
            Desc: "External Sheerline Gutter Corner 90deg **",
            Use: "",
            Colour: "Surfmist",
            Area: "2",
            Qty: "1",
            Length: "",
            CodeBase: "EXG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SGEC90**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"12"}]}',
            PromptCodes: "REDIRECT_NUN=EXGV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=EXGV",
            Children: null,
            "Parent Item": "GS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GS",
            Desc: "Sheerline Gutter .55mm",
            Use: "",
            Colour: "Surfmist",
            Area: "2",
            Qty: "1 x 17124",
            Length: "17124",
            CodeBase: "GS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SG55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=(Length/900)+1","Colour":"Area.RoofSheetColour"},{"Code":"STRAP20","Qty":"=(Length/900)+1","Colour":"Plain"}]}',
            PromptCodes: "REDIRECT_NUN=GSV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=GSV",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "EXG",
            Desc: "External Sheerline Gutter Corner 90deg **",
            Use: "",
            Colour: "Surfmist",
            Area: "3",
            Qty: "1",
            Length: "",
            CodeBase: "EXG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SGEC90**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"12"}]}',
            PromptCodes: "REDIRECT_NUN=EXGV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=EXGV",
            Children: null,
            "Parent Item": "GS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GS",
            Desc: "Sheerline Gutter .55mm",
            Use: "",
            Colour: "Surfmist",
            Area: "3",
            Qty: "1 x 12824",
            Length: "12824",
            CodeBase: "GS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SG55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=(Length/900)+1","Colour":"Area.RoofSheetColour"},{"Code":"STRAP20","Qty":"=(Length/900)+1","Colour":"Plain"}]}',
            PromptCodes: "REDIRECT_NUN=GSV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=GSV",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "MSJ",
            Desc: "****** Product Not Found: <removed in production>",
            Use: "",
            Colour: "Surfmist",
            Area: "4",
            Qty: "1",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: ".34DEG",
            DescAppend: "34 Degrees <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "GS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "EXG",
            Desc: "External Sheerline Gutter Corner 90deg **",
            Use: "",
            Colour: "Surfmist",
            Area: "4",
            Qty: "1",
            Length: "",
            CodeBase: "EXG",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SGEC90**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"12"}]}',
            PromptCodes: "REDIRECT_NUN=EXGV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=EXGV",
            Children: null,
            "Parent Item": "GS",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GS",
            Desc: "Sheerline Gutter .55mm",
            Use: "",
            Colour: "Surfmist",
            Area: "4",
            Qty: "1 x 17267|1 x 7253",
            Length: "17267",
            CodeBase: "GS",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SG55**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=(Length/900)+1","Colour":"Area.RoofSheetColour"},{"Code":"STRAP20","Qty":"=(Length/900)+1","Colour":"Plain"}]}',
            PromptCodes: "REDIRECT_NUN=GSV",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=GSV",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL10075",
            Desc: "Pop 100 x 75 Zincalume/90mm Round",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "2",
            Length: "",
            CodeBase: "OL10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPUZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "REDIRECT_NUN=OL10075Z",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=OL10075Z",
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL10075",
            Desc: "Pop 100 x 75 Zincalume/90mm Round",
            Use: "",
            Colour: "Zincalume",
            Area: "2",
            Qty: "1",
            Length: "",
            CodeBase: "OL10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPUZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "REDIRECT_NUN=OL10075Z",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=OL10075Z",
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL10075",
            Desc: "Pop 100 x 75 Zincalume/90mm Round",
            Use: "",
            Colour: "Zincalume",
            Area: "3",
            Qty: "2",
            Length: "",
            CodeBase: "OL10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPUZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "REDIRECT_NUN=OL10075Z",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=OL10075Z",
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL10075",
            Desc: "Pop 100 x 75 Zincalume/90mm Round",
            Use: "",
            Colour: "Zincalume",
            Area: "4",
            Qty: "1",
            Length: "",
            CodeBase: "OL10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPUZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "REDIRECT_NUN=OL10075Z",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=OL10075Z",
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100752400",
            Desc: "Downpipe .40mm 100x75 Steel ** 2400mm",
            Use: "",
            Colour: "Surfmist",
            Area: "1",
            Qty: "2 x 2248",
            Length: "2248",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: " (finish 2248mm)",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=2400",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100752400",
            Desc: "Downpipe .40mm 100x75 Steel ** 2400mm",
            Use: "",
            Colour: "Surfmist",
            Area: "2",
            Qty: "1 x 2300",
            Length: "2300",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: " (finish 2300mm)",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=2400",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100752400",
            Desc: "Downpipe .40mm 100x75 Steel ** 2400mm",
            Use: "",
            Colour: "Surfmist",
            Area: "3",
            Qty: "1 x 2300|1 x 2248",
            Length: "2300",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: " (finish 2300mm)",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=2400",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100752400",
            Desc: "Downpipe .40mm 100x75 Steel ** 2400mm",
            Use: "",
            Colour: "Surfmist",
            Area: "4",
            Qty: "1 x 2300",
            Length: "2300",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: " (finish 2300mm)",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=2400",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "HR",
            Desc: "Ridge Capping Hip",
            Use: "",
            Colour: "Manor Red",
            Area: "1",
            Qty: "1 x 5711",
            Length: "5711",
            CodeBase: "HR",
            CodeAppend: "",
            DescAppend: " <swapped from CFL13>",
            "CL ID": "0",
            Fielders_Code: "LLFL23**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Length/600)+1)*2","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=((Length/400)+1)*2","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "HR",
            Desc: "Ridge Capping Hip",
            Use: "",
            Colour: "Manor Red",
            Area: "2",
            Qty: "1 x 5709",
            Length: "5709",
            CodeBase: "HR",
            CodeAppend: "",
            DescAppend: " <swapped from CFL13>",
            "CL ID": "0",
            Fielders_Code: "LLFL23**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Length/600)+1)*2","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=((Length/400)+1)*2","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "HR",
            Desc: "Ridge Capping Hip",
            Use: "",
            Colour: "Manor Red",
            Area: "3",
            Qty: "1 x 5711",
            Length: "5711",
            CodeBase: "HR",
            CodeAppend: "",
            DescAppend: " <swapped from CFL13>",
            "CL ID": "0",
            Fielders_Code: "LLFL23**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Length/600)+1)*2","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=((Length/400)+1)*2","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS90N2004000",
            Desc: "Post Steel 90x90x2mm notched FL200 H** 4000mm",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 x 3128 (A1-Post in Ground (Notched))|3 x 3098 (A1-Post in Ground (Notched))",
            Length: "3128",
            CodeBase: "PS90N200",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "PSN90200H**####",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"PBP90200","Use":"Notched Post Plate","Colour":"Area.PostColour","Qty":"1"},{"Code":"FT150M","Qty":"2","Colour":"Plain","Conditions":{"Use":"!=*Slab*"}}]}',
            PromptCodes: "Length=4000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(209205)|4000(209207)|5000(209209)|6000(209213) SL_EMU=3000(209205)|4000(209207) SL_NUN=3000(209205)|4000(209207) SL_GIL=3000(209205)|4000(209207)|4500(209203) REDIRECT_NUN=PS90N200V",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS90N2004000",
            Desc: "Post Steel 90x90x2mm notched FL200 H** 4000mm",
            Use: "",
            Colour: "Thredbo White",
            Area: "2",
            Qty: "3 x 3150 (Post in Ground (Notched))",
            Length: "3150",
            CodeBase: "PS90N200",
            CodeAppend: "",
            DescAppend: "Notched (finish 3150mm)",
            "CL ID": "",
            Fielders_Code: "PSN90200H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"PBP90200","Use":"Notched Post Plate","Colour":"Area.PostColour","Qty":"1"},{"Code":"FT150M","Qty":"2","Colour":"Plain","Conditions":{"Use":"!=*Slab*"}}]}',
            PromptCodes: "Length=4000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(209205)|4000(209207)|5000(209209)|6000(209213) SL_EMU=3000(209205)|4000(209207) SL_NUN=3000(209205)|4000(209207) SL_GIL=3000(209205)|4000(209207)|4500(209203) REDIRECT_NUN=PS90N200V",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS90N2004000",
            Desc: "Post Steel 90x90x2mm notched FL200 H** 4000mm",
            Use: "",
            Colour: "Thredbo White",
            Area: "3",
            Qty: "2 x 3098 (Post in Ground (Notched))",
            Length: "3098",
            CodeBase: "PS90N200",
            CodeAppend: "",
            DescAppend: "Notched (finish 3098mm)",
            "CL ID": "",
            Fielders_Code: "PSN90200H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"PBP90200","Use":"Notched Post Plate","Colour":"Area.PostColour","Qty":"1"},{"Code":"FT150M","Qty":"2","Colour":"Plain","Conditions":{"Use":"!=*Slab*"}}]}',
            PromptCodes: "Length=4000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(209205)|4000(209207)|5000(209209)|6000(209213) SL_EMU=3000(209205)|4000(209207) SL_NUN=3000(209205)|4000(209207) SL_GIL=3000(209205)|4000(209207)|4500(209203) REDIRECT_NUN=PS90N200V",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS90N2004000",
            Desc: "Post Steel 90x90x2mm notched FL200 H** 4000mm",
            Use: "",
            Colour: "Thredbo White",
            Area: "4",
            Qty: "2 x 3150 (Post in Ground (Notched))",
            Length: "3150",
            CodeBase: "PS90N200",
            CodeAppend: "",
            DescAppend: "Notched (finish 3150mm)",
            "CL ID": "",
            Fielders_Code: "PSN90200H**####",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"PBP90200","Use":"Notched Post Plate","Colour":"Area.PostColour","Qty":"1"},{"Code":"FT150M","Qty":"2","Colour":"Plain","Conditions":{"Use":"!=*Slab*"}}]}',
            PromptCodes: "Length=4000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(209205)|4000(209207)|5000(209209)|6000(209213) SL_EMU=3000(209205)|4000(209207) SL_NUN=3000(209205)|4000(209207) SL_GIL=3000(209205)|4000(209207)|4500(209203) REDIRECT_NUN=PS90N200V",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "CONB150SPR",
            Desc: "Splayed RH beam connector for FL150 Special Angle **",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 (For Left Rafter)",
            Length: "",
            CodeBase: "CONB150SPR",
            CodeAppend: ".15050.39DEG LH",
            DescAppend: "150x50 39 Degrees Left Hand",
            "CL ID": "4",
            Fielders_Code: "LHICON150SPRH**",
            "CL DATA": {
                0: {
                    BracketType: "BK46",
                    Angle1: "39.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Colour":"Plain"},{"Code":"FT20M","Qty":"6","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK46",
                    Angle1: "39.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "CONB200SPR",
            Desc: "Splayed RH beam connector for FL200 Special Angle **",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 (For Cutout Beam A)",
            Length: "",
            CodeBase: "CONB200SPR",
            CodeAppend: ".20050.51DEG LH",
            DescAppend: "200x50 51 Degrees Left Hand",
            "CL ID": "3",
            Fielders_Code: "LHICON200SPRH**",
            "CL DATA": {
                0: {
                    BracketType: "BK46",
                    Angle1: "51.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Colour":"Plain"},{"Code":"FT20M","Qty":"6","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK46",
                    Angle1: "51.00",
                    Angle2: "0.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "H150C",
            Desc: "Hip to Corner Connector FL150 H**",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 (For Multiple Area Beam)",
            Length: "",
            CodeBase: "H150C",
            CodeAppend: ".15050.90DEG JOIN .57DEG LH",
            DescAppend: "150x50 90 Degrees Join 57 Degrees Left Hand",
            "CL ID": "1",
            Fielders_Code: "LHIH150CH**",
            "CL DATA": {
                0: {
                    BracketType: "BK10",
                    Angle1: "56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"12","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK10",
                    Angle1: "56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: HCUC 20 0NS (For Multiple Area Beam)",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 (For Multiple Area Beam)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: ".15050.90DEG JOIN .57DEG RH",
            DescAppend: "150x50 90 Degrees Join 57 Degrees Right Hand",
            "CL ID": "2",
            Fielders_Code: "",
            "CL DATA": {
                0: {
                    BracketType: "BK44",
                    Angle1: "-56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK44",
                    Angle1: "-56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "H150C",
            Desc: "Hip to Corner Connector FL150 H**",
            Use: "",
            Colour: "Thredbo White",
            Area: "2",
            Qty: "1 (For Multiple Area Beam)",
            Length: "",
            CodeBase: "H150C",
            CodeAppend: ".15050.90DEG JOIN .34DEG LH",
            DescAppend: "150x50 90 Degrees Join 34 Degrees Left Hand",
            "CL ID": "5",
            Fielders_Code: "LHIH150CH**",
            "CL DATA": {
                0: {
                    BracketType: "BK10",
                    Angle1: "33.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"12","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK10",
                    Angle1: "33.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: HCUC 20 0NS (For Multiple Area Beam)",
            Use: "",
            Colour: "Thredbo White",
            Area: "2",
            Qty: "1 (For Multiple Area Beam)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: ".15050.90DEG JOIN .57DEG LH",
            DescAppend: "150x50 90 Degrees Join 57 Degrees Left Hand",
            "CL ID": "6",
            Fielders_Code: "",
            "CL DATA": {
                0: {
                    BracketType: "BK44",
                    Angle1: "56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK44",
                    Angle1: "56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "H150C",
            Desc: "Hip to Corner Connector FL150 H**",
            Use: "",
            Colour: "Thredbo White",
            Area: "3",
            Qty: "1 (For Multiple Area Beam)",
            Length: "",
            CodeBase: "H150C",
            CodeAppend: ".15050.90DEG JOIN .57DEG LH",
            DescAppend: "150x50 90 Degrees Join 57 Degrees Left Hand",
            "CL ID": "1",
            Fielders_Code: "LHIH150CH**",
            "CL DATA": {
                0: {
                    BracketType: "BK10",
                    Angle1: "56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"12","Use":"Teks","Colour":"Area.RafterColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK10",
                    Angle1: "56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: HCUC 20 0NS (For Multiple Area Beam)",
            Use: "",
            Colour: "Thredbo White",
            Area: "3",
            Qty: "1 (For Multiple Area Beam)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: ".15050.90DEG JOIN .57DEG RH",
            DescAppend: "150x50 90 Degrees Join 57 Degrees Right Hand",
            "CL ID": "2",
            Fielders_Code: "",
            "CL DATA": {
                0: {
                    BracketType: "BK44",
                    Angle1: "-56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
            "CL HEADERS":
                "Bracket`Width`Depth`Angle 1`Angle 2`Angle 3`Colour ID`Num`BL ID`Length 1`Length 2`ftt`Bracket Name`Drawing Name`Material`Auto Extend Tabs",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: {
                    BracketType: "BK44",
                    Angle1: "-56.50",
                    Angle2: "90.00",
                    RotationAngle: "0.00",
                    TopTabLength: "0.00",
                    SideTabLength: "0.00",
                    ftt: "0",
                },
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "4 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90N200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Thredbo White",
            Area: "2",
            Qty: "3 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90N200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Thredbo White",
            Area: "3",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90N200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "MSJ",
            Desc: "****** Product Not Found: (For Post) <removed in production>",
            Use: "",
            Colour: "Thredbo White",
            Area: "4",
            Qty: "2 (For Post)",
            Length: "",
            CodeBase: "MSJ",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90N200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB150",
            Desc: "Connector Beam FL150 **",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 (For Left Rafter)",
            Length: "",
            CodeBase: "FLUB150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB15050H**05",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Use":"Teks","Colour":"Area.BeamColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB200",
            Desc: "Connector Beam FL200 **",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 (End Cap for Cutout Beam A)",
            Length: "",
            CodeBase: "FLUB200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB20050H**05",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HCC20",
            Desc: "Beam Corner Connector FL200 **",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "2 (For Fascia Beam)",
            Length: "",
            CodeBase: "HCC20",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHCC20H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "IBJ200",
            Desc: "Firmlok 200 Internal Beam Joiner Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1 (For Fascia Beam)",
            Length: "",
            CodeBase: "IBJ200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIIBJ200",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"FWH22","Qty":"22","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200Z","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FT20MP","Qty":"10","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FWH22P","Qty":"22","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HCC20",
            Desc: "Beam Corner Connector FL200 **",
            Use: "",
            Colour: "Thredbo White",
            Area: "2",
            Qty: "1 (For Fascia Beam)",
            Length: "",
            CodeBase: "HCC20",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHCC20H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "IBJ200",
            Desc: "Firmlok 200 Internal Beam Joiner Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "2",
            Qty: "2 (For Fascia Beam)",
            Length: "",
            CodeBase: "IBJ200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIIBJ200",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"FWH22","Qty":"22","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200Z","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FT20MP","Qty":"10","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FWH22P","Qty":"22","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "HCC20",
            Desc: "Beam Corner Connector FL200 **",
            Use: "",
            Colour: "Thredbo White",
            Area: "3",
            Qty: "1 (For Fascia Beam)",
            Length: "",
            CodeBase: "HCC20",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIHCC20H**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Use":"Tek","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "IBJ200",
            Desc: "Firmlok 200 Internal Beam Joiner Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "3",
            Qty: "1 (For Fascia Beam)",
            Length: "",
            CodeBase: "IBJ200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIIBJ200",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"FWH22","Qty":"22","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200Z","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FT20MP","Qty":"10","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FWH22P","Qty":"22","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB200",
            Desc: "Connector Beam FL200 **",
            Use: "",
            Colour: "Thredbo White",
            Area: "4",
            Qty: "1 (End Cap for Fascia Beam)",
            Length: "",
            CodeBase: "FLUB200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB20050H**05",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "IBJ200",
            Desc: "Firmlok 200 Internal Beam Joiner Zincalume",
            Use: "",
            Colour: "Zincalume",
            Area: "4",
            Qty: "1 (A4-For Cutout Beam A)|1 (A4-For Fascia Beam)",
            Length: "",
            CodeBase: "IBJ200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "LHIIBJ200",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20M","Qty":"10","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"FWH22","Qty":"22","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"!=Zincalume"}},{"Code":"JBS200Z","Colour":"Area.BeamColour","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FT20MP","Qty":"10","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}},{"Code":"FWH22P","Qty":"22","Colour":"Plain","Conditions":{"Area.BeamColour":"=Zincalume"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS200",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "RCHANNEL",
            Desc: "Flatdek Receiver Channel **",
            Use: "",
            Colour: "Classic Cream",
            Area: "",
            Qty: "1 x 6100 (5411mm(Back Channel)//200mm(Back Channel*4*)//200mm(Back Channel*3*))|1 x 6100 (5411mm(Back Channel))|1 x 6100 (5411mm(Back Channel))|1 x 6100 (5409mm(Back Channel))|1 x 6100 (5409mm(Back Channel))|1 x 6100 (5409mm(Back Channel))|1 x 6100 (1500mm(Back Channel*2*)//1500mm(Back Channel*1*))|1 x 6100 (6100mm(Back Channel*1*))|1 x 6100 (6100mm(Back Channel*2*))|1 x 6100 (6100mm(Back Channel*3*))|1 x 6100 (6100mm(Back Channel*4*))",
            Length: "6100",
            CodeBase: "RCHANNEL",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FDRCH**####",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "SL_LSB=4500(50125)|6100(50125) SL_EMU=6100(50125) REDIRECT_GIL=BC5075 REDIRECT_NUN=BC5061",
            Image_b64: null,
            PromptTextCodes:
                "SL_LSB=4500(50125)|6100(50125) SL_EMU=6100(50125) REDIRECT_GIL=BC5075 REDIRECT_NUN=BC5061",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150",
            Desc: "Firmlok 150x1.5mm Hi Gloss H**",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 x 6100 (5293mm(A1-Multiple Area Beam))|1 x 6100 (5292mm(A2-Multiple Area Beam))|1 x 7500 (766mm(A1-Left Rafter)//5293mm(A3-Multiple Area Beam))",
            Length: "6100",
            CodeBase: "BS150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "FL15015H**####",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Image_b64: null,
            PromptTextCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS200",
            Desc: "Firmlok 200x2.0mm Hi Gloss ***",
            Use: "",
            Colour: "Thredbo White",
            Area: "1",
            Qty: "1 x 5000 (4757mm(A1-Cutout Beam A))|1 x 6100 (5787mm(A2-Fascia Beam))|1 x 6100 (5382mm(A2-Fascia Beam))|1 x 6100 (5377mm(A2-Fascia Beam))|1 x 6100 (5970mm(A3-Fascia Beam))|1 x 6100 (6000mm(A1-Fascia Beam))|1 x 7500 (6300mm(A1-Fascia Beam))|1 x 7500 (6275mm(A3-Fascia Beam))|1 x 9000 (8420mm(A4-Fascia Beam))|1 x 9000 (8417mm(A4-Cutout Beam A))|1 x 9000 (8125mm(A4-Fascia Beam))|1 x 9000 (8072mm(A4-Cutout Beam A))",
            Length: "5000",
            CodeBase: "BS200",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "FL20020H**####",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes:
                "SL=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_DUB=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_EMU=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_KEW=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) REDIRECT_GIL=BS200L REDIRECT_NUN=BS200L",
            Image_b64: null,
            PromptTextCodes:
                "SL=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_DUB=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_EMU=5000(200203)|6100(200203)|7500(200203)|9000(200203) SL_KEW=4000(200203)|5000(200203)|6100(200203)|7500(200203)|9000(200203) REDIRECT_GIL=BS200L REDIRECT_NUN=BS200L",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null,
                7: null,
                8: null,
                9: null,
                10: null,
                11: null,
            },
        },
    ],
    COFL00154: [
        {
            Add: true,
            Category: "STEEL ROOFING",
            Code: "RS5",
            Desc: "Flatdek 0.42BMT **H**",
            Use: "",
            Colour: "Woodland Grey/Thredbo White",
            Area: "1",
            Qty: "18 x 8065 (B/C Fixed)|4 x 5063 (B/C Fixed)",
            Length: "8065",
            CodeBase: "RS5",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FD42**H**",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=((Area.NumInternalPurlins*2)+3)*Qty","Use":"Roof Fix","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=Qty*2","Use":"Roof Fix","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*","Area.DesignType":"=Flat Roof"},"Colour":"Area.RoofSheetColour"},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Use":"=*B/C Fixed*","Area.DesignType":"=Flat Roof"}},{"Code":"FT35_WCB","Qty":"=((Area.NumInternalPurlins*3)+3)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"}},{"Code":"FT35_WCB","Qty":"=Qty*3","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"}},{"Code":"FT45MR","Qty":"=Qty*2","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Area.DesignType":"=Gable Hip Roof"}},{"Code":"RCFILL","Colour":"Plain","Conditions":{"Area.DesignType":"=Gable Hip Roof"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "FIBREGLASS ROOFING",
            Code: "RFG5",
            Desc: "Flatdek Wonderglass Sheet 2400GSM Opal",
            Use: "",
            Colour: "Opal",
            Area: "1",
            Qty: "2 x 8065 (B/C Fixed)",
            Length: "8065",
            CodeBase: "RFG5",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "TSWGFD24OP",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT30M","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Use":"Fibreglass Roof Sheeting","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"WGFG","Use":"Fibreglass Roof Sheet","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Plain","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*"},"Colour":"Area.RoofSheetColour","Code":"FT30M","Qty":"=Qty*3","Use":"Fibreglass Roof Sheet"},{"Code":"WGFG","Qty":"=Qty*3","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC","Use":"!=*B/C Fixed*"},"Use":"Fibreglass Roof Sheet"},{"Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=NOT CYCLONIC"},"Code":"FT30M","Qty":"=(Length/1000)*2","Use":"Stitching"},{"Code":"WGFG","Qty":"=(Length/1000)*2","Colour":"Plain","Conditions":{"Job.WindZone":"=NOT CYCLONIC"},"Use":"Stitching"},{"Code":"FT35_WCB","Qty":"=((Area.NumInternalPurlins*3)+4)*Qty","Colour":"Area.RoofSheetColour","Conditions":{"Job.WindZone":"=CYCLONIC"},"Use":"Fibreglass Roof Sheet"},{"Code":"FT35_WCB","Qty":"=Qty*3","Conditions":{"Job.WindZone":"=CYCLONIC","Use":"!=*B/C Fixed*"},"Use":"Fibreglass Roof Sheet","Colour":"Plain"},{"Code":"FT35_WCB","Qty":"=(Length/1000)*2","Conditions":{"Job.WindZone":"=CYCLONIC"},"Use":"Stitching","Colour":"Area.RoofSheetColour"},{"Code":"RCFILL","Colour":"Plain"}]}',
            PromptCodes: "REDIRECT_LSB=RFG5Q",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_LSB=RFG5Q",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GSRET",
            Desc: "Sheerline Gutter .55mm (Roof sheet fixed) **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 x 5850",
            Length: "5850",
            CodeBase: "GSRET",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "SG55**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FR72","Qty":"=(Length/600)+1","Colour":"Area.RoofSheetColour"}]}',
            PromptCodes: "REDIRECT_NUN=GSVR",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=GSVR",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "ELOS10075",
            Desc: "Downpipe Offset for 100 x 75 Steel **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "ELOS10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPO10075**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Qty":"6"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "OL10075",
            Desc: "Pop 100 x 75 Zincalume/90mm Round",
            Use: "",
            Colour: "Zincalume",
            Area: "1",
            Qty: "1",
            Length: "",
            CodeBase: "OL10075",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "DPPUZL",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"FR72","Colour":"Area.GutterColour","Qty":"6"}]}',
            PromptCodes: "REDIRECT_NUN=OL10075Z",
            Image_b64: null,
            PromptTextCodes: "REDIRECT_NUN=OL10075Z",
            Children: null,
            "Parent Item": "DPS10075",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "DOWNPIPES & ACCESSORIES",
            Code: "DPS100752400",
            Desc: "Downpipe .40mm 100x75 Steel ** 2400mm",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 x 1896",
            Length: "1896",
            CodeBase: "DPS10075",
            CodeAppend: "",
            DescAppend: " (finish 1896mm)",
            "CL ID": "",
            Fielders_Code: "DP4010075**##",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: '{"AncillaryParts":[{"Code":"AS10075","Qty":"2"}]}',
            PromptCodes: "Length=2400",
            Image_b64: null,
            PromptTextCodes: "SL=1800(410711)|2400(410721) SL_GIL=1800(410711)",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "FLASHING",
            Code: "CBARGEFD",
            Desc: "C Barge Flatdek",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 x 8005 (FLATDEK (No Foot Traffic) Barge Capping Carport Overhang)",
            Length: "8005",
            CodeBase: "CBARGEFD",
            CodeAppend: "",
            DescAppend: "(No Side Beam)",
            "CL ID": "0",
            Fielders_Code: "LLFL45**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FT20MN","Qty":"=(Length/600)+1","Conditions":{"Job.WindZone":"=NOT CYCLONIC"}},{"Code":"FT20MN","Qty":"=(Length/400)+1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "ExtraLM=165",
            Image_b64: null,
            PromptTextCodes: "ExtraLM=165",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "POSTS",
            Code: "PS90N1503000",
            Desc: "Post Steel 90x90x2mm notched FL150 H** 3000mm",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "2 x 2893 (Post in Ground (Notched))|2 x 2761 (Post in Ground (Notched))",
            Length: "2893",
            CodeBase: "PS90N150",
            CodeAppend: "",
            DescAppend: "(various finish lengths)",
            "CL ID": "",
            Fielders_Code: "PSN90150H**####",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"PBP90150","Use":"Notched Post Plate","Colour":"Area.PostColour","Qty":"1"},{"Code":"FT150M","Qty":"2","Conditions":{"Use":"!=*Slab*"},"Colour":"Plain"}]}',
            PromptCodes: "Length=3000",
            Image_b64: null,
            PromptTextCodes:
                "DisableNesting=1 SL=3000(209155)|4000(209157)|5000(209160)|6000(209162) SL_EMU=3000(209155)|4000(209157) SL_NUN=3000(209155)|4000(209157) REDIRECT_NUN=PS90N150V REDIRECT_GIL=PS90N200",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "CON110",
            Desc: "Connector Aluminium Fascia 125x50x125",
            Use: "",
            Colour: "",
            Area: "1",
            Qty: "18 (Rafter Bracket)",
            Length: "",
            CodeBase: "CON110",
            CodeAppend: "",
            DescAppend: "(fixed to Metal Fascia)",
            "CL ID": "0",
            Fielders_Code: "LHICON110",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH5010NYG","Use":"Timber Fascia Fix","Qty":"1","Colour":"Plain","Conditions":{"Use":"=*Timber*"}},{"Code":"FT50T","Qty":"3","Use":"Teks","Colour":"Plain"},{"Code":"FBH3010NYG","Qty":"1","Conditions":{"Use":"=*Steel*"},"Use":"Steel Fascia Fix"},{"Code":"FT45M","Qty":"1","Conditions":{"Job.WindZone":"=CYCLONIC"}}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB150",
            Desc: "Connector Beam FL150 **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 (End Cap for Fascia Beam)|1 (End Cap for Purlin)|1 (For Fascia Beam)",
            Length: "",
            CodeBase: "FLUB150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB15050H**05",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Use":"Teks","Colour":"Area.BeamColour","Qty":"8"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BRACKETS",
            Code: "FLUB150L",
            Desc: "Connector Beam FL150 **",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 (For Purlin)",
            Length: "",
            CodeBase: "FLUB150L",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FLUB15050H**05",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts:
                '{"AncillaryParts":[{"Code":"FBH60NYG","Use":"Bolt","Qty":"1","Conditions":{"Use":"!=*End*"},"Colour":"Plain"},{"Code":"FT20M","Qty":"8","Use":"Teks","Colour":"Area.BeamColour"},{"Code":"RCPL45Z","Qty":"1","Colour":"Plain"},{"Code":"STUD19B","Colour":"Plain","Qty":"1","Length":"1200"}]}',
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "BS150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            BracketData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "HARDWARE",
            Code: "WG",
            Desc: "Washer Grommet for Polycarbonate 22OD",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "4 (For Post)",
            Length: "",
            CodeBase: "WG",
            CodeAppend: "",
            DescAppend: " <removed in production>",
            "CL ID": "0",
            Fielders_Code: "LHIWGPC220D",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: "",
            PromptCodes: "",
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": "PS90N150",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
        {
            Add: true,
            Category: "BACK CHANNEL",
            Code: "RCHANNEL",
            Desc: "Flatdek Receiver Channel **",
            Use: "",
            Colour: "Thredbo White",
            Area: "",
            Qty: "1 x 6100 (5003mm(Back Channel))|1 x 6100 (4850mm(Back Channel)//1000mm(Back Channel))|1 x 6100 (3002mm(Back Channel))",
            Length: "6100",
            CodeBase: "RCHANNEL",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "0",
            Fielders_Code: "FDRCH**####",
            "CL DATA": {
                0: null,
                1: null,
                2: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: "SL_LSB=4500(50125)|6100(50125) SL_EMU=6100(50125) REDIRECT_GIL=BC5075 REDIRECT_NUN=BC5061",
            Image_b64: null,
            PromptTextCodes:
                "SL_LSB=4500(50125)|6100(50125) SL_EMU=6100(50125) REDIRECT_GIL=BC5075 REDIRECT_NUN=BC5061",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
                2: null,
            },
        },
        {
            Add: true,
            Category: "BEAMS",
            Code: "BS150",
            Desc: "Firmlok 150x1.5mm Hi Gloss H**",
            Use: "",
            Colour: "Woodland Grey",
            Area: "1",
            Qty: "1 x 6100 (5845mm(Purlin))|1 x 7500 (6445mm(Fascia Beam))",
            Length: "6100",
            CodeBase: "BS150",
            CodeAppend: "",
            DescAppend: "",
            "CL ID": "",
            Fielders_Code: "FL15015H**####",
            "CL DATA": {
                0: null,
                1: null,
            },
            "CL HEADERS": "",
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "LM",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Image_b64: null,
            PromptTextCodes:
                "SL=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_DUB=3000(150153)|4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_EMU=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) SL_KEW=4000(150153)|5000(150153)|6100(150153)|7500(150153)|9000(150153) REDIRECT_GIL=BS150L REDIRECT_NUN=BS150L",
            Children: null,
            "Parent Item": "",
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
                1: null,
            },
        },
        {
            Add: null,
            Category: "GUTTERS & ACCESSORIES",
            Code: "GSSEP",
            Desc: "Sheerline Gutter Stop Ends ** (pair) ",
            Use: "",
            Colour: "Woodland Grey",
            Area: "",
            Qty: "1",
            Length: "",
            CodeBase: null,
            CodeAppend: null,
            DescAppend: " (1xGSSEL,1xGSSER)",
            "CL ID": null,
            Fielders_Code: "SGSEP**",
            "CL DATA": {
                0: null,
            },
            "CL HEADERS": null,
            Locked: false,
            SubTotalCost: null,
            UnitCost: null,
            Unit: "EA",
            MarkupFactor: null,
            AncillaryParts: null,
            PromptCodes: null,
            Image_b64: null,
            PromptTextCodes: null,
            Children: null,
            "Parent Item": null,
            ExtraData: null,
            Conditions: null,
            FixedItemLength: null,
            CuttingData: {
                0: null,
            },
        },
    ],
};
